'use strict';

// Declare app level module which depends on views, and components
angular.module('myApp', [
        'ngAnimate',
        'ui.bootstrap',
        'ui.router',
        'smart-table',
        'angular-scroll-animate',
        'duScroll',
        'ngSanitize',
    
        'myApp.profile',
        'myApp.theme',
        'myApp.pages'
    ])
    .controller("IndexCtrl", IndexController)
    .directive("baseBody", baseBody);

function IndexController ($scope, $window, $document, $log, $rootScope, $state, $q) {
    $scope.showPopover = false;
    $scope.showGoTop = false;

    var scrollEvent = function () {
        if(angular.element($window).scrollTop() > 600){
            $q.when().then(function () {
                $scope.showGoTop = true;
                // console.info('aaaaa = ' + angular.element($window).scrollTop());
            });
        } else {
            $q.when().then(function () {
                $scope.showGoTop = false;
                // console.info('sddfff = ' + angular.element($window).scrollTop());
            });
        }
    }

    angular.element($window).bind("scroll", scrollEvent);

    $scope.goTop = function () {
        // $window.scrollTo(0, 0);
        // $document.scrollTop(0, 2000);
        $document.scrollTo(0,0, 500);
    }

    $scope.$on('$destroy', function () {
        angular.element($window).unbind("scroll",scrollEvent);
    });

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        makeMinHeight($state.current.unfixHeader);
    });

    function makeMinHeight(unfix_header) {
        if ($state.current.name == 'download') {
            return;
        }
        $scope.windowH = document.documentElement.clientHeight - (unfix_header ? 200 : 86);
        var xxxdata = $scope.windowH + "px";
        $scope.myCSSObj = {
            "min-height": xxxdata
        };
        // console.info('windowH = ' + $scope.windowH + ', min-height = ' + $scope.myCSSObj);
    }

    // ** On resize
    window.onresize = function () {
        $q.when().then(function () {
            $rootScope.$emit("OnWindowResize", '');
            makeMinHeight(false);
        });
    };

    //** Destroy
    $scope.$on('$destory', function () {
        window.off('resize')
    });


    $rootScope.$watch(function(){
        MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
        return true;
    });
}

function baseBody($state) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                backgroundCheck();
            });

            var backgroundCheck = function () {
                // console.info("backgroundCheck: " + $state.current.name + ": " + $state.current.darkBackground);
                if($state.current.darkBackground)
                {
                    element.addClass("dark-body");
                }
                else
                {
                    element.removeClass("dark-body");
                }
            };
            // element.bind("resize", function () {
            //     console.info('11111111111');
            // });
        }
    };
}
/**
 * Created by wangshuo on 2017/2/16.
 */

angular.module('myApp.profile', [])
    .service('ProfileService', ProfileService)
    .service('TokenService', TokenService)
    .service('TokenCheckService', TokenCheckService)
    .service('TokenRefreshService', TokenRefreshService)
    .factory('TokenInjector', TokenInjector)
    .config(InjectorConfig)
    .service('EncryptService', EncryptService);

function ProfileService($location) {
    this.VERSION = "V1.0.7";
    this.DEBUG_MODE = false;
    this.SERVER_HOST = this.DEBUG_MODE ? 'http://192.168.15.106:8080/xntrader/' : '/xntrader/';
    this.WEBSOCKET_HOST = this.DEBUG_MODE ? 'ws://192.168.15.106:9000/traderelay/ws' : '/traderelay/ws';
    this.TRADE_SERVER_HOST = this.DEBUG_MODE ? 'http://192.168.15.106:8081/traderelay/' : '/traderelay/';
    // this.CALC_SERVER_HOST = this.DEBUG_MODE ? 'http://192.168.15.165:8082/statistics/' : '/statistics/';
    // this.SERVER_HOST = '/smart/';

    this.SERVICE_OPEN_LESSON_GROUPS_QUERY = this.SERVER_HOST + 'courses/open_lesson_groups';
    this.SERVICE_OPEN_LESSONS = this.SERVER_HOST + 'courses/open_lessons/';
    this.SERVICE_OPEN_LESSONS_QUERY = this.SERVICE_OPEN_LESSONS + 'collections';

    this.USER_SERVICE = this.SERVER_HOST + 'users/';

    this.GOT_PASSWORD_SERVICE = this.USER_SERVICE + 'password/';

    this.TOKEN_SERVICE = this.SERVER_HOST + 'auth/token/';

    this.AUTH_CODE_SERVICE = this.SERVER_HOST + 'auth/auth_codes/';
    this.AUTH_MSG_SERVICE = this.SERVER_HOST + 'auth/mns_auth_codes/';

    this.SERVICE_NAVIGATION_PIC = this.SERVER_HOST + "resources/navpics/";
    this.SERVICE_NAVIGATION_PIC_QUERY = this.SERVICE_NAVIGATION_PIC + "collections/";
    this.SERVICE_JOB_PAGE = this.SERVER_HOST + "resources/jobs/";
    this.SERVICE_JOB_PAGE_QUERY = this.SERVICE_JOB_PAGE + "collections/";
    this.SERVICE_POSTER_PAGE = this.SERVER_HOST + "resources/posters/";
    this.SERVICE_POSTER_PAGE_QUERY = this.SERVICE_POSTER_PAGE + "collections/";
    this.SERVICE_ADVERT_PAGE = this.SERVER_HOST + "resources/adverts/";
    this.SERVICE_RULE = this.SERVER_HOST + "resources/rules/";

    this.SERVICE_WIKI = this.SERVER_HOST + "turtle/dictionaries/";
    this.SERVICE_WIKI_QUERY = this.SERVICE_WIKI + "collections/";

    this.SERVICE_FORUM = this.SERVER_HOST + "turtle/questions/";
    this.SERVICE_FORUM_QUERY = this.SERVICE_FORUM + "collections/";


    this.SERVICE_TRADE = this.TRADE_SERVER_HOST + "trade/";

    this.SERVICE_DIARY = this.SERVER_HOST + "trade/diary/diaries/";
    this.SERVICE_DIARY_QUERY = this.SERVICE_DIARY + "collections/";
    this.SERVICE_MISTAKE = this.SERVER_HOST + "trade/mistakes/";

    this.FORUM_IMAGE_QUESTION_PATH = this.SERVER_HOST + 'resources/ckeditors/images?type=Images&path=turtle_question';
    this.FORUM_IMAGE_ANSWER_PATH = this.SERVER_HOST + 'resources/ckeditors/images?type=Images&path=turtle_answer';
    this.FORUM_IMAGE_TRADE_DIARY_PATH = this.SERVER_HOST + 'resources/ckeditors/images?type=Images&path=trade_diary';

    // this.SERVICE_CALC_SURVEY = this.CALC_SERVER_HOST + 'survey/';
    // this.SERVICE_CALC_TRADE = this.CALC_SERVER_HOST + 'trade/';
    //
    // this.SERVICE_SCORE = this.CALC_SERVER_HOST + "credits/";
    // this.SERVICE_SCORE_QUERY = this.SERVICE_SCORE + "collections/";

    this.CKEDITOR_FORUM_QUESTION_OPTIONS = {
        language: 'zh-CN',
        entities: false,
        filebrowserImageUploadUrl: this.FORUM_IMAGE_QUESTION_PATH,
        readOnly: true
        // forcePasteAsPlainText: true,
        // pasteFromWordRemoveFontStyles: false,
        // pasteFromWordRemoveStyles: false,
        // allowedContent: true,
        // extraAllowedContent: 'p(mso*,Normal)',
        // pasteFilter: "plain-text",
    };

    this.CKEDITOR_FORUM_ANSWER_OPTIONS = {
        language: 'zh-CN',
        entities: false,
        filebrowserImageUploadUrl: this.FORUM_IMAGE_ANSWER_PATH,
        readOnly: true
    };

    this.CKEDITOR_TRADE_DIARY_OPTIONS = {
        language: 'zh-CN',
        entities: false,
        filebrowserImageUploadUrl: this.FORUM_IMAGE_TRADE_DIARY_PATH,
        readOnly: true
    };

    this.PopEnabled = true;

    this.getSocketUrl = function () {
        if (this.DEBUG_MODE) {
            return this.WEBSOCKET_HOST;
        }
        else {
            return ($location.protocol() == "https" ? "wss://" : "ws://") + $location.host() + ":" + $location.port() + this.WEBSOCKET_HOST;
        }
    };
}

function TokenService($window, $rootScope) {

    var ctrl = this;

    this.STATUS_STRING = {
        STATUS_VISITOR: 0,//游客
        // STATUS_REQUESTING: 1,//未完成注册
        // STATUS_REJECT: 2,
        STATUS_USER: 10,
        STATUS_STOPPED: 20
    };

    this.currentTime = {
        VideoName: '',
        CurrentTime: 0
    };

    this.saveVideoCurrentTime = function (videoname, currenttime) {
        this.currentTime.VideoName = videoname;
        this.currentTime.CurrentTime = currenttime;
        $window.localStorage.setItem("videocurrenttime", JSON.stringify(this.currentTime));
    };

    this.getVideoCurrentTime = function () {
        var xx = JSON.parse($window.localStorage.getItem("videocurrenttime"));
        return xx;
    };

    //登录
    //会进行LoginStatusChanged通知。
    this.login = function (response_data) {
        this.user.loginFlag = true;
        this.user.userId = response_data.userId;
        this.user.nickName = response_data.nickName;
        this.user.phoneNumber = response_data.phoneNumber;
        this.user.timestamp = new Date().getTime();
        this.user.expirePeriod = response_data.expirePeriod;
        this.user.token = response_data.token;
        this.user.refreshToken = response_data.refreshToken;
        this.user.sign = response_data.sign;
        this.user.headPicUrl = response_data.headPicUrl;
        $window.localStorage.setItem("token", JSON.stringify(this.user));
        console.info("TokenService: login: post LoginStatusChanged login event...");
        $rootScope.$emit("LoginStatusChanged", "login");
    };

    //登出
    //会进行LoginStatusChanged通知
    this.logout = function () {
        this.user = {
            loginFlag: false,
            userId: 0,
            nickName: "",
            phoneNumber: "",
            timestamp: new Date().getTime(),
            expirePeriod: 0,
            token: "",
            refreshToken: "",
            sign: "",
            headPicUrl: ""
        };
        $window.localStorage.removeItem("token");
        console.info("TokenService: logout: post LoginStatusChanged logout event...");
        $rootScope.$emit("LoginStatusChanged", "logout");
    };

    this.refreshUserStatus = function (user_status) {
        this.refresh();
        if (this.isLogin()) {
            this.user.userStatus = user_status;
            $window.localStorage.setItem("token", JSON.stringify(this.user));
            $rootScope.$emit("LoginStatusChanged", "change");
        }
    };

    //登录判断
    this.checkLogin = function () {
        // console.info("TokenService: checkLogin..");
        this.refresh();
        return this.user && this.user.loginFlag;
    };

    //是否登录
    this.isLogin = function () {
        return this.user && this.user.loginFlag;
    };

    this.checkTokenRefresh = function () {
        //做时间判断，来决定是否需要进行Token刷新。通常我们设置超时时间的一半就要进行刷新
        if (ctrl.isLogin() == false) {
            return;
        }
        var last_timestamp = ctrl.user.timestamp;
        var this_time = new Date().getTime();
        var expire = ctrl.user.expirePeriod;
        if (this_time - last_timestamp >= expire) {
            console.info("TokenService: checkTokenRefresh: Token is expired, logout.");
            ctrl.logout();
            return;
        }
        if (this_time - last_timestamp >= expire / 2) {
            console.info("TokenService: checkTokenRefresh: post RefreshTokenCommand.");
            $rootScope.$emit("RefreshTokenCommand", "true");
        }
    };

    // this.isTokenNeedRefresh = function () {
    //     if (ctrl.isLogin() == false) {
    //         return false;
    //     }
    //     var last_timestamp = ctrl.user.timestamp;
    //     var this_time = new Date().getTime();
    //     var expire = ctrl.user.expirePeriod;
    //     if (this_time - last_timestamp >= expire) {
    //         return false;
    //     }
    //     if (this_time - last_timestamp >= expire / 2) {
    //         return true;
    //     }
    // };

    //刷新Token
    this.refresh = function () {
        // console.info("TokenService: refresh..");
        var last_login = this.isLogin();
        //加载缓存
        var token_data = $window.localStorage.getItem("token");
        //为空，表示注销状态
        if (token_data == null) {
            this.user = {
                loginFlag: false,
                userId: 0,
                nickName: "",
                phoneNumber: "",
                timestamp: new Date().getTime(),
                expirePeriod: 0,
                token: "",
                refreshToken: "",
                sign: "",
                headPicUrl: ""
            };
            //如果之前是登录上的，则注销通知
            if (last_login == true) {
                $rootScope.$emit("LoginStatusChanged", "logout");
            }
        }
        else {
            //解析
            try {
                this.user = JSON.parse($window.localStorage.getItem("token"));
                //解析成功，检测Token是否需要刷新
                this.checkTokenRefresh();
            }
                //如果失败，则注销
            catch (e) {
                console.info("TokenService: refresh throws ex...");
                this.user = {
                    loginFlag: false,
                    userId: 0,
                    nickName: "",
                    phoneNumber: "",
                    timestamp: new Date().getTime(),
                    expirePeriod: 0,
                    token: "",
                    refreshToken: "",
                    sign: "",
                    headPicUrl: ""
                };
                $window.localStorage.removeItem("token");
                if (last_login == true) {
                    $rootScope.$emit("LoginStatusChanged", "logout");
                }
            }
        }
    };
    //页面发生跳转的时候，需要进行刷新处理
    // $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    //     ctrl.refresh();
    // });
    this.refresh();
}

function TokenCheckService($state, TokenService)  {
    this.checkLogin = function () {
        if (TokenService.checkLogin() == false) {
            $state.go('user.login', '', {location: 'replace'});
            return false;
        }
        // else if (TokenService.user.userStatus == TokenService.STATUS_STRING.STATUS_VISITOR) {
        //     $state.go('user.personalStyle', '', {location: 'replace'});
        //     return false;
        // }
        return true;
    };
}

function TokenRefreshService($rootScope, $http, TokenService, ProfileService) {
    var ctrl = this;
    ctrl.isRefreshing = false;
    //刷新Token
    this.refreshToken = function () {
        if (ctrl.isRefreshing) {
            return;
        }
        console.info("TokenRefreshService: refreshToken......");
        ctrl.isRefreshing = true;
        if (TokenService.isLogin()) {
            //进行一次刷新Token
            $http.put(ProfileService.TOKEN_SERVICE + TokenService.user.refreshToken, null).then(function (response) {
                //刷新成功
                TokenService.login(response.data);
            }).catch(function (response) {
                //刷新失败
                //如果是401，表示无法授权了，则需要重新登录
                if (response.status == 401) {
                    TokenService.logout();
                }
                //403表示禁止，说明用户被禁用，则退出登录
                else if (response.status == 403) {
                    TokenService.logout();
                }
            }).finally(function () {
                ctrl.isRefreshing = false;
            });
        }
        else {
            ctrl.isRefreshing = false;
        }
    };

    //当超时的时候，会非常频繁的收到该消息。这时候，我们需要做到只更新一次就好
    $rootScope.$on("RefreshTokenCommand", function (event, msg) {
        // console.info("TokenRefreshService: On RefreshTokenCommand...............");
        ctrl.refreshToken();
    });
}

function TokenInjector(TokenService, ProfileService) {
    var tokenInjector =
    {
        request: function (config) {
            // if (TokenService.isLogin() == true) {
            //     config.headers['Authorization'] = TokenService.user.token;
            //     if (startWith(config.url, ProfileService.TOKEN_SERVICE) == false) {
            //         TokenService.checkTokenRefresh();
            //     }
            // }
            if (TokenService.checkLogin() == true) {
                config.headers['Authorization'] = TokenService.user.token;
            }
            return config;
        }
    };

    var startWith = function (orig, str) {
        var reg = new RegExp("^" + str);
        return reg.test(orig);
    };

    return tokenInjector;
}

function InjectorConfig($httpProvider) {
    $httpProvider.interceptors.push('TokenInjector');
}

//验证服务
function EncryptService() {

    var hexcase = 0;
    /*   hex   output   format.   0   -   lowercase;   1   -   uppercase                 */
    var b64pad = "";
    /*   base-64   pad   character.   "="   for   strict   RFC   compliance       */
    var chrsz = 8;
    /*   bits   per   input   character.   8   -   ASCII;   16   -   Unicode             */

    this.encryptPassword = function (s) {
        return binb2b64(core_sha1(str2binb(s), s.length * chrsz));
    };

    /*
     *   Calculate   the   SHA-1   of   an   array   of   big-endian   words,   and   a   bit   length
     */
    function core_sha1(x, len) {
        /*   append   padding   */
        x[len >> 5] |= 0x80 << (24 - len % 32);
        x[((len + 64 >> 9) << 4) + 15] = len;

        var w = Array(80);
        var a = 1732584193;
        var b = -271733879;
        var c = -1732584194;
        var d = 271733878;
        var e = -1009589776;

        for (var i = 0; i < x.length; i += 16) {
            var olda = a;
            var oldb = b;
            var oldc = c;
            var oldd = d;
            var olde = e;

            for (var j = 0; j < 80; j++) {
                if (j < 16) w[j] = x[i + j];
                else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
                var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)), safe_add(safe_add(e, w[j]), sha1_kt(j)));
                e = d;
                d = c;
                c = rol(b, 30);
                b = a;
                a = t;
            }

            a = safe_add(a, olda);
            b = safe_add(b, oldb);
            c = safe_add(c, oldc);
            d = safe_add(d, oldd);
            e = safe_add(e, olde);
        }
        return Array(a, b, c, d, e);

    }

    /*
     *   Add   integers,   wrapping   at   2^32.   This   uses   16-bit   operations   internally
     *   to   work   around   bugs   in   some   JS   interpreters.
     */
    function safe_add(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF);
        var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xFFFF);
    }

    /*
     *   Bitwise   rotate   a   32-bit   number   to   the   left.
     */
    function rol(num, cnt) {
        return (num << cnt) | (num >>> (32 - cnt));
    }

    /*
     *   Convert   an   8-bit   or   16-bit   string   to   an   array   of   big-endian   words
     *   In   8-bit   function,   characters   >255   have   their   hi-byte   silently   ignored.
     */
    function str2binb(str) {
        var bin = Array();
        var mask = (1 << chrsz) - 1;
        for (var i = 0; i < str.length * chrsz; i += chrsz)
            bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (24 - i % 32);
        return bin;
    }


    /*
     *   Perform   the   appropriate   triplet   combination   function   for   the   current
     *   iteration
     */
    function sha1_ft(t, b, c, d) {
        if (t < 20) return (b & c) | ((~b) & d);
        if (t < 40) return b ^ c ^ d;
        if (t < 60) return (b & c) | (b & d) | (c & d);
        return b ^ c ^ d;
    }

    /*
     *   Determine   the   appropriate   additive   constant   for   the   current   iteration
     */
    function sha1_kt(t) {
        return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 : (t < 60) ? -1894007588 : -899497514;
    }

    /*
     *   Convert   an   array   of   big-endian   words   to   a   base-64   string
     */
    function binb2b64(binarray) {
        var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var str = "";
        for (var i = 0; i < binarray.length * 4; i += 3) {
            var triplet = (((binarray[i >> 2] >> 8 * (3 - i % 4)) & 0xFF) << 16) | (((binarray[i + 1 >> 2] >> 8 * (3 - (i + 1) % 4)) & 0xFF) << 8) | ((binarray[i + 2 >> 2] >> 8 * (3 - (i + 2) % 4)) & 0xFF);
            for (var j = 0; j < 4; j++) {
                if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
                else str += tab.charAt((triplet >> 6 * (3 - j)) & 0x3F);
            }
        }
        // edit by zmmgiser
        var rest = binarray.length % 3;
        if (rest == 1)
            str += "==";
        if (rest == 2)
            str += "=";
        return str;
    }
}



(function (root, factory) {
    // AMD
    if (typeof define === 'function' && define.amd) define(['angular'], factory);
    // Global
    else factory(angular);
}(this, function (angular) {

    angular
        .module('ckeditor', [])
        .directive('ckeditor', ['$parse', ckeditorDirective]);
        // .directive('placeholder', ['$parse', '$timeout', placeholderDirective]);

    // Polyfill setImmediate function.
    var setImmediate = window && window.setImmediate ? window.setImmediate : function (fn) {
        setTimeout(fn, 0);
    };

    /**
     * CKEditor directive.
     *
     * @example
     * <div ckeditor="options" ng-model="content" ready="onReady()"></div>
     */

    function ckeditorDirective($parse) {
        return {
            restrict: 'A',
            require: ['ckeditor', 'ngModel'],
            // scope: {
            //     ready: "="
            // },
            controller: [
                '$scope',
                '$element',
                '$attrs',
                '$parse',
                '$q',
                ckeditorController
            ],
            link: function (scope, element, attrs, ctrls) {
                // get needed controllers
                var controller = ctrls[0]; // our own, see below
                var ngModelController = ctrls[1];

                // Initialize the editor content when it is ready.
                controller.ready().then(function initialize() {
                    // Sync view on specific events.
                    ['dataReady', 'input', 'change', 'blur', 'saveSnapshot'].forEach(function (event) {
                        controller.onCKEvent(event, function syncView() {
                            ngModelController.$setViewValue(controller.instance.getData() || '');
                        });
                    });

                    controller.instance.setReadOnly(!!attrs.readonly);
                    attrs.$observe('readonly', function (readonly) {
                        controller.instance.setReadOnly(!!readonly);
                    });

                    // Defer the ready handler calling to ensure that the editor is
                    // completely ready and populated with data.
                    setImmediate(function () {
                        scope.onCKEditorReady(controller.instance);
                        // $parse(attrs.ready)(scope);
                    });
                });

                // Set editor data when view data change.
                ngModelController.$render = function syncEditor() {
                    controller.ready().then(function () {
                        // "noSnapshot" prevent recording an undo snapshot
                        controller.instance.setData(ngModelController.$viewValue || '', {
                            noSnapshot: true,
                            callback: function () {
                                // Amends the top of the undo stack with the current DOM changes
                                // ie: merge snapshot with the first empty one
                                // http://docs.ckeditor.com/#!/api/CKEDITOR.editor-event-updateSnapshot
                                controller.instance.fire('updateSnapshot');
                            }
                        });
                    });
                };

                scope.$on('$destroy', function () {
                    unregisterTopToolbar();
                });

                var registerTopToolbar = function () {
                    // console.info("registerTopToolbar....");
                    window.addEventListener('scroll', onWindowScroll, false);
                };

                var unregisterTopToolbar = function () {
                    // console.info("unregisterTopToolbar....");
                    window.removeEventListener('scroll', onWindowScroll);
                };

                var onWindowScroll = function () {
                    var content = document.getElementsByClassName('cke_contents').item(0);
                    var toolbar = document.getElementsByClassName('cke_top').item(0);
                    var editor = document.getElementsByClassName('cke').item(0);
                    var inner = document.getElementsByClassName('cke_inner').item(0);
                    var scrollvalue = document.documentElement.scrollTop > document.body.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;

                    toolbar.style.width = content.offsetWidth + "px";
                    toolbar.style.top = "0px";
                    toolbar.style.left = "0px";
                    toolbar.style.right = "0px";
                    toolbar.style.margin = "0 auto";
                    toolbar.style.boxSizing = "border-box";

                    if (toolbar.offsetTop <= scrollvalue) {
                        toolbar.style.position = "fixed";
                        content.style.paddingTop = toolbar.offsetHeight + "px";
                    }

                    if (editor.offsetTop > scrollvalue && (editor.offsetTop + editor.offsetHeight) >= (scrollvalue + toolbar.offsetHeight)) {
                        toolbar.style.position = "relative";
                        content.style.paddingTop = "0px";
                    }

                    if ((editor.offsetTop + editor.offsetHeight) < (scrollvalue + toolbar.offsetHeight)) {
                        toolbar.style.position = "absolute";
                        toolbar.style.top = "calc(100% - " + toolbar.offsetHeight + "px)";
                        inner.style.position = "relative";
                    }
                };

                registerTopToolbar();
            }
        };
    }

    /**
     * CKEditor controller.
     */

    function ckeditorController($scope, $element, $attrs, $parse, $q) {
        var config = $parse($attrs.ckeditor)($scope) || {};
        var editorElement = $element[0];
        var instance;
        var readyDeferred = $q.defer(); // a deferred to be resolved when the editor is ready

        // Create editor instance.
        if (editorElement.hasAttribute('contenteditable') &&
            editorElement.getAttribute('contenteditable').toLowerCase() == 'true') {
            instance = this.instance = CKEDITOR.inline(editorElement, config);
        }
        else {
            instance = this.instance = CKEDITOR.replace(editorElement, config);
        }

        /**
         * Listen on events of a given type.
         * This make all event asynchronous and wrapped in $scope.$apply.
         *
         * @param {String} event
         * @param {Function} listener
         * @returns {Function} Deregistration function for this listener.
         */

        this.onCKEvent = function (event, listener) {
            instance.on(event, asyncListener);

            function asyncListener() {
                var args = arguments;
                setImmediate(function () {
                    applyListener.apply(null, args);
                });
            }

            function applyListener() {
                var args = arguments;
                $scope.$apply(function () {
                    listener.apply(null, args);
                });
            }

            // Return the deregistration function
            return function $off() {
                instance.removeListener(event, applyListener);
            };
        };

        this.onCKEvent('instanceReady', function () {
            readyDeferred.resolve(true);
        });

        /**
         * Check if the editor if ready.
         *
         * @returns {Promise}
         */
        this.ready = function ready() {
            return readyDeferred.promise;
        };

        // Destroy editor when the scope is destroyed.
        $scope.$on('$destroy', function onDestroy() {
            // do not delete too fast or pending events will throw errors
            readyDeferred.promise.then(function () {
                instance.destroy(false);
            });
        });
    }

    function placeholderDirective($parse, $timeout) {
        return {
            restrict: 'A',
            require: ['ckeditor'],
            link: function (scope, element, attrs, ctrls) {
                var ckeditor = ctrls[0];
                if (! ckeditor) return ;

                var placeholder = attrs.placeholder;
                var className = 'placeholder';

                // Initialize placeholder.
                ckeditor.ready().then(function initialize() {
                    // Listen events.
                    ckeditor.instance.on('blur', show);
                    ckeditor.instance.on('key', hide);
                    ckeditor.instance.on('focus', hide);

                    // Since placeholder is fake data,
                    // the getData should be intercepted to send nothing.
                    ckeditor.instance.on('getData', function (event) {
                        if (isActive()) event.data.dataValue = '';
                    });

                    // And of course the placeholder must be removed
                    // if data is set.
                    ckeditor.instance.on('setData', function (event) {
                        if (event.data.dataValue) hide();
                        // If active, plan an other show.
                        else if(isActive()) $timeout(show);
                    });

                    // assist focusing when using contenteditable
                    // thank you http://stackoverflow.com/q/9093424/587407
                    element.focus(function() {
                        // focus assist is needed only after a placeholder disappeared.
                        // The placeholder, if any, is already removed at this stage.
                        // We know there was one when there is no text :
                        if (element.text()) return; // no placeholder was here, no need to assist focus.

                        if (document.createRange && window.getSelection) {
                            var range = document.createRange();
                            range.selectNodeContents(this);
                            var sel = window.getSelection();
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                    });

                    // Try to display placeholder.
                    $timeout(show);
                });

                /**
                 * Display the placeholder.
                 */

                function show() {
                    // Otherwise, `ckeditor.instance.getData()` might throw an error.
                    window.getSelection().removeAllRanges();

                    // If there is data, we don't show the placeholder.
                    if (ckeditor.instance.getData()) return ;

                    ckeditor.instance.container.addClass(className);
                    ckeditor.instance.container.setHtml('<div contenteditable="false">' + placeholder  + '</div>');
                }

                /**
                 * Hide the placeholder.
                 */

                function hide() {
                    // If not active, do nothing.
                    if (! isActive()) return ;

                    ckeditor.instance.container.removeClass(className);
                    ckeditor.instance.container.setHtml('');
                }

                /**
                 * Check if the placeholder is active or not.
                 *
                 * @returns {Boolean}
                 */

                function isActive() {
                    return ckeditor.instance.container.hasClass(className);
                }
            }
        };
    }
}));

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "\u4e0a\u5348",
      "\u4e0b\u5348"
    ],
    "DAY": [
      "\u661f\u671f\u65e5",
      "\u661f\u671f\u4e00",
      "\u661f\u671f\u4e8c",
      "\u661f\u671f\u4e09",
      "\u661f\u671f\u56db",
      "\u661f\u671f\u4e94",
      "\u661f\u671f\u516d"
    ],
    "ERANAMES": [
      "\u516c\u5143\u524d",
      "\u516c\u5143"
    ],
    "ERAS": [
      "\u516c\u5143\u524d",
      "\u516c\u5143"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "\u4e00\u6708",
      "\u4e8c\u6708",
      "\u4e09\u6708",
      "\u56db\u6708",
      "\u4e94\u6708",
      "\u516d\u6708",
      "\u4e03\u6708",
      "\u516b\u6708",
      "\u4e5d\u6708",
      "\u5341\u6708",
      "\u5341\u4e00\u6708",
      "\u5341\u4e8c\u6708"
    ],
    "SHORTDAY": [
      "\u5468\u65e5",
      "\u5468\u4e00",
      "\u5468\u4e8c",
      "\u5468\u4e09",
      "\u5468\u56db",
      "\u5468\u4e94",
      "\u5468\u516d"
    ],
    "SHORTMONTH": [
      "1\u6708",
      "2\u6708",
      "3\u6708",
      "4\u6708",
      "5\u6708",
      "6\u6708",
      "7\u6708",
      "8\u6708",
      "9\u6708",
      "10\u6708",
      "11\u6708",
      "12\u6708"
    ],
    "STANDALONEMONTH": [
      "\u4e00\u6708",
      "\u4e8c\u6708",
      "\u4e09\u6708",
      "\u56db\u6708",
      "\u4e94\u6708",
      "\u516d\u6708",
      "\u4e03\u6708",
      "\u516b\u6708",
      "\u4e5d\u6708",
      "\u5341\u6708",
      "\u5341\u4e00\u6708",
      "\u5341\u4e8c\u6708"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
    "longDate": "y\u5e74M\u6708d\u65e5",
    "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
    "mediumDate": "y\u5e74M\u6708d\u65e5",
    "mediumTime": "ah:mm:ss",
    "short": "y/M/d ah:mm",
    "shortDate": "y/M/d",
    "shortTime": "ah:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u00a5",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "zh-cn",
  "localeID": "zh_CN",
  "pluralCat": function(n, opt_precision) {  return PLURAL_CATEGORY.OTHER;}
});
}]);

'use strict';
angular.module('angular-scroll-animate', []);// Source: src/angular-scroll-animate.js
/**
 * @ngdoc directive
 * @name angular-scroll-animate.directive:when-visible
 * @restrict A
 * @param {string} when-not-visible function to execute when element is scrolled into viewport
 * @param {string=} when-not-visible function to execute when element is scrolled out of viewport
 * @param {delayPercent=} percentage (of px) to delay animate when visible transition.
 * @param {bindScrollTo=} override default scroll event binding to another parent container.
 *
 * @description
 * Allows method hooks into the detection of when an element is scrolled into or out of view.
 *
 * @example
 * <example module="angular-scroll-animate">
 *   <file name="index.html">
 *     <div ng-controller="ExampleCtrl">
 *       <div class="car" when-visible="animateIn" when-not-visible="animateOut">Broom</div>
 *     </div>
 *   </file>
 *   <file name="controller.js">
 *   angular.module('example', []).controller('ExampleCtrl', function($scope) {
 *
 *     $scope.animateIn = function($el) {
 *       $el.removeClass('hidden');
 *       $el.addClass('fadeIn');
 *     };
 *
 *     $scope.animateOut = function($el) {
 *      $el.addClass('hidden');
 *       $el.removeClassClass('fadeIn');
 *     };
 *   });
 *
 *   </file>
 *   <file name="animations.css">
 *     .hidden { visibility: hidden; }
 *     .fadeIn { transition: all 300ms ease-in 2s; }
 *   </file>
 * </example>
 */
angular.module('angular-scroll-animate', []).directive('whenVisible', ['$document', '$window',
    function ($document, $window) {

        var determineWhereElementIsInViewport =
            function ($el, viewportHeight, whenVisibleAnimate, whenNotVisibleAnimate, delayPercent, scope) {

                var elementBounds = $el[0].getBoundingClientRect();

                var panelTop = elementBounds.top;
                var panelBottom = elementBounds.bottom;

                // pixel buffer until deciding to show the element
                var delayPx = delayPercent * elementBounds.height;

                var bottomVisible = (panelBottom - delayPx > 0) && (panelBottom < viewportHeight);
                var topVisible = (panelTop + delayPx <= viewportHeight) && (panelTop > 0);

                // console.info("determineWhereElementIsInViewport: " + "elementBounds = " + elementBounds.height + " " + bottomVisible + ", " + topVisible);

                if ($el.data('scroll-hidden') && bottomVisible || topVisible) {
                    $el.removeClass('scroll-hidden');
                    if (whenVisibleAnimate) {
                        $el.addClass('animation ' + whenVisibleAnimate);
                    }
                    // whenVisibleFn($el, scope);
                    $el.data('scroll-hidden', false);
                }

                // scrolled out from scrolling down or up
                else if (!($el.data('scroll-hidden')) && (panelBottom < 0 || panelTop > viewportHeight)) {
                    // whenNotVisibleFn($el, scope);
                    $el.addClass('scroll-hidden');
                    if (whenNotVisibleAnimate) {
                        $el.addClass('animation ' + whenNotVisibleAnimate);
                    }
                    $el.data('scroll-hidden', true);
                }
            };

        return {
            restrict: 'A',
            scope: {
                whenVisible: '@',
                whenNotVisible: '@?',
                delayPercent: '=?',
                bindScrollTo: '@?'
            },

            controller: ['$scope', function (scope) {
                // if (!scope.whenVisible || !angular.isFunction(scope.whenVisible())) {
                //   throw new Error('Directive: angular-scroll-animate \'when-visible\' attribute must specify a function.');
                // }
                //
                // if (scope.whenNotVisible && !angular.isFunction(scope.whenNotVisible())) {
                //   throw new Error('Directive: angular-scroll-animate \'when-not-visible\' attribute must specify a function.');
                // }
                // else if (!scope.whenNotVisible) {
                //   scope.whenNotVisible = function() {
                //     return angular.noop;
                //   };
                // }

                if (scope.delayPercent) {

                    var delayPercent = parseFloat(scope.delayPercent);

                    if (!angular.isNumber(delayPercent) || (delayPercent < 0 || delayPercent > 1)) {
                        throw new Error('Directive: angular-scroll-animate \'delay-percent\' attribute must be a decimal fraction between 0 and 1.');
                    }
                }
            }],

            link: function (scope, el, attributes) {

                var delayPercent = attributes.delayPercent || 0.25; // lower = more eager to hide / show, higher = less eager
                var document = $document[0].documentElement;
                var checkPending = false;

                var updateVisibility = function () {
                    determineWhereElementIsInViewport(el, document.clientHeight /* viewportHeight */,
                        scope.whenVisible, scope.whenNotVisible, delayPercent, scope);

                    checkPending = false;
                };

                var onScroll = function () {

                    if (!checkPending) {
                        checkPending = true;

                        /* globals requestAnimationFrame */
                        requestAnimationFrame(updateVisibility);
                    }
                };

                var documentListenerEvents = 'scroll';

                /* allows overflow:auto on container element to animate for Safari browsers */
                if (attributes.bindScrollTo) {
                    angular.element($document[0].querySelector(attributes.bindScrollTo)).on(documentListenerEvents, onScroll);
                }

                /* always bind to document scroll as well - works for overflow: auto on Chrome, Firefox browsers */
                $document.on(documentListenerEvents, onScroll);

                scope.$on('$destroy', function () {
                    $document.off(documentListenerEvents, onScroll);
                });

                var $elWindow = angular.element($window);
                var windowListenerEvents = 'resize orientationchange';
                $elWindow.on(windowListenerEvents, onScroll);

                scope.$on('$destroy', function () {
                    $elWindow.off(windowListenerEvents, onScroll);
                });

                // initialise
                el.data('scroll-hidden', true);
                scope.$evalAsync(onScroll);
            }
        };
    }]);

(function() {
    "use strict";
    (function() {
        var ngSimditor = angular.module('angular-simditor', []);
        ngSimditor.constant('simditorConfig', {
        	placeholder: '这里输入文字...',
        	toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'color', '|', 'ol', 'ul', 'blockquote', 'code', 'table', '|', 'link', 'image', 'hr', '|', 'indent', 'outdent', 'alignment'],
        	pasteImage: true,
        	defaultImage: '',
        	upload: {
                url: '/upload'
            },
            allowedTags: ['br', 'a', 'img', 'b', 'strong', 'i', 'u', 'font', 'p', 'ul', 'ol', 'li', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'hr', 'div', 'script', 'style']
		});
        ngSimditor.directive('ngSimditor', ['$timeout', 'simditorConfig', function($timeout, simditorConfig) {
            // Runs during compile
            return {
                // name: '',
                // priority: 1,
                // terminal: true,
                scope: {
                    content: '='
                }, // {} = isolate, true = child, false/undefined = no change
                // controller: function($scope, $element, $attrs, $transclude) {},
                // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
                restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
                template: '<textarea data-autosave="editor-content" autofocus></textarea>',
                // templateUrl: '',
                replace: true,
                // transclude: true,
                // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
                link: function($scope, iElm, iAttrs, controller) {
                    var editor = new Simditor(
                        angular.extend({textarea: iElm}, simditorConfig)
                    );

                    var nowContent = '';

                    $scope.$watch('content', function(value, old){
                        if(typeof value !== 'undefined' && value != nowContent){
                            editor.setValue(value);
                        }
                    });

                    editor.on('valuechanged', function(e){
                        if($scope.content != editor.getValue()){
                            $timeout(function(){
                                $scope.content = nowContent = editor.getValue();
                            });
                        }
                    });
                }
            };
        }]);
    })();
}).call(this);

/**
 * highcharts-ng
 * @version v1.1.0 - 2017-03-27
 * @link https://github.com/pablojim/highcharts-ng
 * @author Barry Fitzgerald <>
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){
  module.exports = 'highcharts-ng';
}

(function () {
  'use strict';
  /*global angular: false*/
  // var Highcharts = null;
  //
  // if (window && window.Highcharts) {
  //   Highcharts = window.Highcharts;
  // } else if (module && module.exports === 'highcharts-ng') {
  //       Highcharts = require('highcharts');
  // }


  angular.module('highcharts-ng', [])
    .component('highchart', {
        bindings: {
            config: '<',
            changeDetection: '<'
          },
          controller: HighChartNGController
    });

  HighChartNGController.$inject = ['$element', '$timeout'];

  function HighChartNGController($element, $timeout) {
    var seriesId = 0;
    var ctrl = this;
    var prevConfig = {};
    var mergedConfig = {};
    var detector = ctrl.changeDetection || angular.equals;
    this.$onInit = function() {
      ctrl.config.getChartObj = function(){
        return ctrl.chart;
      };
      prevConfig = angular.merge({}, ctrl.config);
      mergedConfig = getMergedOptions($element, ctrl.config, seriesId);
      ctrl.chart = new Highcharts[getChartType(mergedConfig)](mergedConfig);

      // Fix resizing bug
      // https://github.com/pablojim/highcharts-ng/issues/550
      var originalWidth = $element[0].clientWidth;
      var originalHeight = $element[0].clientHeight;
      $timeout(function() {
        if ($element[0].clientWidth !== originalWidth || $element[0].clientHeight !== originalHeight) {
          ctrl.chart.reflow();
        }
      }, 0, false);
    };

    this.$doCheck = function() {
      if(!detector(ctrl.config, prevConfig)) {
        prevConfig = angular.merge({}, ctrl.config);
        mergedConfig = getMergedOptions($element, ctrl.config, seriesId);
        var ids = ensureIds(mergedConfig.series, seriesId);
        if (mergedConfig.series) {
          //Remove any missing series
          for (var i = ctrl.chart.series.length - 1; i >= 0; i--) {
            var s = ctrl.chart.series[i];
            if (s.options.id !== 'highcharts-navigator-series' && ids.indexOf(s.options.id) < 0) {
              s.remove(false);
            }
          }
          // Add any new series
          angular.forEach(ctrl.config.series, function(s) {
            if (!ctrl.chart.get(s.id)) {
              ctrl.chart.addSeries(s);
            }
          });
        }
        ctrl.chart.update(mergedConfig, true);
      }
    };

    this.$onDestroy = function() {
        if (ctrl.chart) {
          try{
            ctrl.chart.destroy();
          }catch(ex){
            // fail silently as highcharts will throw exception if element doesn't exist
          }

          $timeout(function(){
            $element.remove();
          }, 0);
        }
      };
    }

  function getMergedOptions(element, config, seriesId) {
    var mergedOptions = {};

    var defaultOptions = {
      chart: {
        events: {}
      },
      title: {},
      subtitle: {},
      series: [],
      credits: {},
      plotOptions: {},
      navigator: {},
    };

    if (config) {
      //check all series and axis ids are set
      if(config.series) {
        ensureIds(config.series, seriesId);
      }

      mergedOptions = angular.merge(defaultOptions, config);
    } else {
      mergedOptions = defaultOptions;
    }
    mergedOptions.chart.renderTo = element[0];

    //check chart type is set
    return mergedOptions;
  }

  var chartTypeMap = {
    'stock': 'StockChart',
    'map':   'Map',
    'chart': 'Chart'
  };

  function getChartType(config) {
    if (config === undefined || config.chartType === undefined) return 'Chart';
    return chartTypeMap[('' + config.chartType).toLowerCase()];
  }

  function ensureIds(series, seriesId) {
    var ids = [];
    angular.forEach(series, function(s) {
      if (!angular.isDefined(s.id)) {
        s.id = 'series-' + seriesId++;
      }
      ids.push(s.id);
    });
    return ids;
  }

}());

(function () {
    'use strict';

    angular.module('myApp.theme.components', [
        'myApp.theme.components.modal'
    ]);
})();
(function () {
    
    'use strict';

    angular.module('myApp.theme.components')
        .directive('pageFooter', pageFooter)
        .directive('pageBottomFooter', pageBottomFooter);

    /** @ngInject */
    function pageFooter() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageFooter/pageFooter.html'
        };
    }


    function pageBottomFooter($window, $state) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    pageHiddenCheck();
                });
                var pageHiddenCheck = function () {

                    if ($state.current.name == 'simulation.trade') {
                        element.removeClass("hidden-header");
                    } else if($state.current.hiddenHeader) {
                        element.addClass("hidden-header");
                    }
                    else {
                        element.removeClass("hidden-header");
                    }

                    if ($state.current.name == 'download') {
                        element.addClass("hidden-header");
                    }

                    if($state.current.name == 'simulation.trade'){
                        element.addClass('min-width-simulation');
                    } else {
                        element.removeClass('min-width-simulation');
                    }
                };
            }
        };
    }
})();
(function () {

    'use strict';

    angular.module('myApp.theme.components')
        .directive('pageTop', pageTop)
        .directive('pageTopHeader', pageTopHeader)
        .directive('myTarget', mytarget);

    function mytarget() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var href = element.href;
                if(true) {  // replace with your condition
                    element.attr("target", "_blank");
                }
            }
        };
    };

    /** @ngInject */
    function pageTop($window) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            link: function (scope, element, attrs) {
                // scope.$watch(function () {
                //     return {
                //         clientHeight: document.documentElement.clientHeight,
                //         scrollHeight: document.documentElement.scrollHeight
                //     };
                // }, function (height_info) {
                //     console.info("height_changed: " + height_info.clientHeight + ", " + height_info.scrollHeight);
                //     checkOverflow(height_info.clientHeight, height_info.scrollHeight);
                // }, true);
                //
                // angular.element($window).bind("resize", function () {
                //     console.info("resize: " + document.documentElement.clientHeight + ", " + document.documentElement.scrollHeight);
                //     checkOverflow(document.documentElement.clientHeight, document.documentElement.scrollHeight);
                // });
                //
                // var checkOverflow = function (client_height, scroll_height) {
                //     if (client_height < scroll_height) {
                //         element.addClass("relative-right-scroll");
                //     }
                //     else {
                //         element.removeClass("relative-right-scroll");
                //     }
                // };
            }
        };
    }

    function pageTopHeader($window, $state, $document, $q) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                scope.$watch('$viewContentLoaded', function () {
                    pageTopChange();
                });

                scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    pageHiddenCheck();
                    pageTopChange();
                });

                angular.element($window).bind("scroll", function () {
                    pageTopChange();
                });

                angular.element($window).bind("resize", function () {
                    pageTopChange();
                });

                var pageTopChange = function () {
                    if ($state.current.name != "main") {
                        if ($state.current.name == 'download' || $state.current.name == 'paper') {
                            element.addClass("hidden-header");
                        }

                        if ($state.current.name == 'lessoncontent' && angular.element($window).scrollTop() > 80) {
                            element.addClass("hidden-header");
                            return;
                        }
                        if ($state.current.name == 'lessoncontent') {
                            element.removeClass("hidden-header");
                        }
                        element.addClass("fixed-header-on");
                        return;
                    }
                    if (element.find(".navbar.fixed").length > 0) {
                        if (angular.element($window).scrollTop() > 24 || angular.element($window).width() <= 768) {
                            console.info("add fixed-header-on..");
                            element.addClass("fixed-header-on");
                        } else {
                            element.removeClass("fixed-header-on");
                        }
                    }
                };

                var pageHiddenCheck = function () {
                    if ($state.current.hiddenHeader) {
                        element.addClass("hidden-header");
                    }
                    else {
                        element.removeClass("hidden-header");
                    }
                    if ($state.current.unfixHeader) {
                        console.info("unfixHeader.........");
                        var nav_element = element.find("nav");
                        for (var i = 0; i < nav_element.length; i++) {
                            var nav_item = element.find(nav_element[i]);
                            nav_item.removeClass("navbar-fixed-top");
                        }
                    }
                    else {
                        var nav_element = element.find("nav");
                        for (var i = 0; i < nav_element.length; i++) {
                            var nav_item = element.find(nav_element[i]);
                            nav_item.addClass("navbar-fixed-top");
                        }
                    }
                };
            }
        };
    }
})();

(function () {

    'use strict';

    angular.module('myApp.theme.components')
        .controller('pageTopCtrl', pageTopCtrl)
        .run(['$anchorScroll', function ($anchorScroll) {
            // $anchorScroll.yOffset = 100;
        }]);

    /** @ngInject */
    function pageTopCtrl($scope, $window, $rootScope, $document, $state, $http, $timeout, ProfileService, TokenService, TokenRefreshService) {
        $scope.dynamicPopover = {
            content: '注册后会提供丰富的课程培训体系!',
            templateUrl: 'app/theme/components/pageTop/popovermsg.html',
            title: 'Title'
        };

        $scope.headImgUrl = 'images/turtle/default_header.png';
        // $scope.getHeadImgUrl = function () {
        //     if (TokenService.isLogin() == false)
        //         return;
        //     // if(TokenService.user.userId == $scope.oldUserId)
        //     //     return;
        //     // $scope.oldUserId = TokenService.user.userId;
        //     $log.info('start get user head picture');
        //     $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + '/head_url').then(function (response) {
        //         $scope.headImgUrl = response.data ? response.data : 'images/turtle/default_header.png';
        //     }).catch(function () {
        //         $log.info('get user head picture failed');
        //     });
        // };

        // $scope.getHeadImgUrl();

        $scope.getTurtleClass = function () {
            {
                active: activeState == 'turtle'
            }
            if ($scope.activeState && $scope.activeState.start)
                return "";
        };

        $scope.menuClick = function () {
            // $window.scrollTo(0, 0);
            $document.scrollTo(0, 0, 500);
        }

        $scope.turtleClick = function () {
            $rootScope.$emit("turtleMemuClick", '');
        }

        $scope.placement = {
            options: [
                'top',
                'top-left',
                'top-right',
                'bottom',
                'bottom-left',
                'bottom-right',
                'left',
                'left-top',
                'left-bottom',
                'right',
                'right-top',
                'right-bottom'
            ],
            selected: 'right'
        };

        $scope.logined = false;
        // $scope.userStatus = 0;
        $scope.activeState = 0;

        $scope.getUserName = function () {
            return TokenService.user.nickName;
        };

        $scope.logout = function () {
            TokenService.logout();
            $state.go("main");
        };

        $scope.goStudy = function () {
            if ($state.current.name == "main") {
                $state.go("main", '');
            }
            else {
                $state.go("main", '');
            }
        };

        $scope.gotoJob = function (anchor_index) {
            $state.go("resources.jobs", {anchor: "" + anchor_index});
        };

        $scope.continueRegister = function () {
            // $scope.popoverIsOpen = false;
            // $state.go("user.personalStyle");
            $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + "/character_status").then(function (response) {
                var character_status = response.data;
                $state.go("user.personalStyle");
            });
        };

        //
        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            console.info("to state: " + toState.name);
            $scope.activeState = toState.name;
        });


        $rootScope.$on("LoginStatusChanged", function (event, msg) {
            console.info("On LoginStatusChanged...............");
            refreshLoginStatus();
        });

        // $scope.isRegistering = function () {
        //     return $scope.logined && $scope.userStatus == TokenService.STATUS_STRING.STATUS_VISITOR;
        // };

        var refreshLoginStatus = function () {
            if (TokenService.isLogin() == true) {
                $scope.logined = true;
                // $scope.userStatus = TokenService.user.userStatus;
                $scope.headImgUrl = TokenService.user.headPicUrl ? TokenService.user.headPicUrl : 'images/turtle/default_header.png';
            }
            else {
                $scope.logined = false;
                // $scope.userStatus = 0;
                $scope.headImgUrl = 'images/turtle/default_header.png';
            }
        }

        refreshLoginStatus();

        TokenRefreshService.refreshToken();
    }
})();
(function () {
    
    'use strict';

    var app = angular.module('myApp.theme.components.modal', ['angularFileUpload', 'ngImgCrop'])
        .controller('ConfirmModalCtrl', ConfirmModalCtrl)
        .controller('InformModalCtrl', InformModalCtrl)
        .service('modalService', ['$uibModal',
            function ($uibModal) {

                var modalInformOptions = {
                    closeButtonText: '取消',
                    actionButtonText: '确定',
                    headerText: '注意',
                    bodyText: '请确认？',
                    alertStyle: 'primary'
                };

                //消息对话框
                var modalInformDefaults = {
                    backdrop: true,
                    keyboard: true,
                    // modalFade: true,
                    controller: 'InformModalCtrl',
                    templateUrl: 'app/theme/components/modal/informModal.html',
                    resolve: {
                        modalOptions: null
                    }
                };


                this.showInformModal = function (customModalDefaults, customModalOptions) {
                    if (!customModalDefaults) customModalDefaults = {};
                    customModalDefaults.backdrop = 'static';
                    return this.showInform(customModalDefaults, customModalOptions);
                };

                this.showInform = function (customModalDefaults, customModalOptions) {
                    //Create temp objects to work with since we're in a singleton service
                    var tempModalDefaults = {};
                    var tempModalOptions = {};

                    //Map angular-ui modal custom defaults to modal defaults defined in service
                    angular.extend(tempModalDefaults, modalInformDefaults, customModalDefaults);

                    //Map modal.html $scope custom properties to defaults defined in service
                    angular.extend(tempModalOptions, modalInformOptions, customModalOptions);

                    tempModalDefaults.resolve.modalOptions = tempModalOptions;

                    return $uibModal.open(tempModalDefaults).result;
                };


                //确认对话框
                var modalConfirmDefaults = {
                    backdrop: true,
                    keyboard: true,
                    // modalFade: true,
                    controller: 'ConfirmModalCtrl',
                    templateUrl: 'app/theme/components/modal/confirmModal.html',
                    resolve: {
                        modalOptions: null
                    }
                };

                var modalConfirmOptions = {
                    closeButtonText: '取消',
                    actionButtonText: '确定',
                    headerText: '注意',
                    bodyText: '',
                    alertStyle: 'primary'
                };

                this.showConfirmModal = function (customModalDefaults, customModalOptions) {
                    if (!customModalDefaults) customModalDefaults = {};
                    customModalDefaults.backdrop = 'static';
                    return this.showConfirm(customModalDefaults, customModalOptions);
                };

                this.showConfirm = function (customModalDefaults, customModalOptions) {
                    //Create temp objects to work with since we're in a singleton service
                    var tempModalDefaults = {};
                    var tempModalOptions = {};

                    //Map angular-ui modal custom defaults to modal defaults defined in service
                    angular.extend(tempModalDefaults, modalConfirmDefaults, customModalDefaults);

                    //Map modal.html $scope custom properties to defaults defined in service
                    angular.extend(tempModalOptions, modalConfirmOptions, customModalOptions);

                    tempModalDefaults.resolve.modalOptions = tempModalOptions;

                    return $uibModal.open(tempModalDefaults).result;
                };
            }
        ]);

    function ConfirmModalCtrl($scope, $uibModalInstance, modalOptions) {
        $scope.modalOptions = modalOptions;
        $scope.modalOptions.ok = function (result) {
            result = 'ok test';
            $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function (result) {
            result = 'cancel test';
            $uibModalInstance.dismiss(result);
        };
    }

    function InformModalCtrl($scope, $uibModalInstance, modalOptions) {
        $scope.modalOptions = modalOptions;
        $scope.modalOptions.ok = function (result) {
            // $uibModalInstance.close(result);
            $uibModalInstance.dismiss('cancel');
        };
        $scope.modalOptions.close = function (result) {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';

    angular.module('myApp.theme', [
        'ngAnimate',
        'ui.bootstrap',
        'myApp.theme.components'
    ]);
})();

(function () {
    'use strict';

    angular.module('myApp.pages.bigData.scoreData.details', [
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('bigData.scoreDetails', {
                url: '/score_details/{id}?fromDate/toDate/start',
                templateUrl: 'app/pages/bigData/scoreData/details/scoreDetails.html',
                controller: 'ScoreDetailsCtrl',
                title: '个人积分明细',
                needLogin: true,
                darkBackground: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.resources.jobs.details', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('resources.jobDetails', {
                url: '/page_details/{src}/{type}/{id}',
                templateUrl: 'app/pages/resources/jobs/details/details.html',
                controller: 'JobDetailsCtrl',
                title: '招聘',
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.simulation.diary.edit', [
            "oc.lazyLoad",
            'ckeditor'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation.diaryEdit', {
                url: '/diary_edit/{id}/?fromDate/toDate/start/',
                templateUrl: 'app/pages/simulation/diary/edit/diaryEdit.html',
                controller: 'DiaryEditCtrl',
                title: '交易日志详情',
                needLogin: true,
                hiddenHeader: false,
                resolve: {
                    loadCKEditor: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load('ckeditor/ckeditor.js');
                    }]
                }
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.simulation.mistake.edit', [
            "oc.lazyLoad"
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation.mistakeEdit', {
                url: '/mistake_edit/{id}/?fromDate/toDate/start/',
                templateUrl: 'app/pages/simulation/mistake/edit/mistakeEdit.html',
                controller: 'MistakeEditCtrl',
                title: '过失单详情',
                needLogin: true,
                hiddenHeader: false,
                // resolve: {
                //     loadCKEditor: ['$ocLazyLoad', function($ocLazyLoad) {
                //         return $ocLazyLoad.load('ckeditor/ckeditor.js');
                //     }]
                // }
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.turtle.forum.details', ['nsPopover'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('turtle.forumDetails', {
                url: '/forum_details/{id}?filter/from_sort/from_start/sort/start',
                templateUrl: 'app/pages/turtle/forum/details/details.html',
                controller: 'ForumDetailsCtrl',
                title: '问题页面',
                darkBackground: true,
                unfixHeader: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.turtle.wiki.details', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('turtle.wikiDetails', {
                url: '/wiki_details/{start}/{id}/{groupId}/{filter}',
                templateUrl: 'app/pages/turtle/wiki/details/details.html',
                controller: 'WikiDetailsCtrl',
                title: '词典详情',
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.turtle.forum.write', [
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('turtle.forumWrite', {
                url: '/forum_write/{id}?filter/sort/start',
                templateUrl: 'app/pages/turtle/forum/write/write.html',
                controller: 'WriteCtrl',
                title: '写文章',
                hiddenHeader: true,
                needLogin: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages', [
            'myApp.pages.main',
            'myApp.pages.aboutUs',
            'myApp.pages.user',
            'myApp.pages.resources',
            // 'myApp.pages.mystudy',
            // 'myApp.pages.publesson',
            // 'myApp.pages.lessoncontent',
            // 'myApp.pages.myExam',
            // 'myApp.pages.turtle',
            // 'myApp.pages.goOnline',
            'myApp.pages.simulation',
            // 'myApp.pages.bigData'
            'myApp.pages.download',
            'myApp.pages.exam',
            'myApp.pages.activity',
            'myApp.pages.xmActivity'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider) {
        $urlRouterProvider.otherwise('/main');
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.activity', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('activity', {
                url: '/activity',
                templateUrl: 'app/pages/activity/activity.html',
                controller: 'ActivityCtrl',
                title: '活动'
            })
            .state('activityDetails', {
                url: '/activityDetails',
                templateUrl: 'app/pages/activity/activityDetails.html',
                controller: 'ActivityCtrl',
                title: '活动详情'
            })
            .state('activityTradeDetails', {
                url: '/activityTradeDetails',
                templateUrl: 'app/pages/activity/activityTradeDetails.html',
                controller: 'ActivityCtrl',
                title: '交易详情'
            })
            .state('activityPrize', {
                url: '/activityPrize',
                templateUrl: 'app/pages/activity/activityPrize.html',
                controller: 'ActivityCtrl',
                title: '奖品设置'
            });

    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.aboutUs', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('aboutUs', {
                url: '/about_us',
                templateUrl: 'app/pages/aboutUs/aboutUs.html',
                controller: 'AboutUsCtrl',
                title: '关于我们'
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.download', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('download', {
                url: '/download',
                templateUrl: 'app/pages/download/download.html',
                controller: 'DownloadCtrl',
                title: '下载APP'
                // unfixHeader: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.bigData', [
            'oc.lazyLoad',
            "highcharts-ng",
            'myApp.pages.bigData.tradeData',
            'myApp.pages.bigData.scoreData'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('bigData', {
                url: '/big_data',
                template: '<ui-view autoscroll="true"></ui-view>',
                abstract: true,
                title: '数据分析',
                resolve: { // Any property in resolve should return a promise and is executed before the view is loaded
                    loadCKEditor: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load({name:'highstock',files:['highcharts/highstock.js']});
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.exam', [
        'myApp.pages.exam.paper',
        'myApp.pages.exam.result'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('exam', {
                url: '/exam',
                templateUrl: 'app/pages/exam/exam.html',
                controller: 'ExamCtrl',
                title: '测评中心',
                needLogin: true,
                darkBackground: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.goOnline', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('goOnline', {
                url: '/goOnline',
                templateUrl: 'app/pages/goingOnline/goingOnline.html',
                controller: 'goOnlineCtrl',
                title: '上线中'
            });
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.myExam', []).config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('myExam', {
                url: '/myExam/{groupid}/{lessonid}/{mode}/{yposition}',
                templateUrl: 'app/pages/lessons/examPage.html',
                controller: 'myExamCtrl',
                title: '课程',
                darkBackground: true,
                needLogin: true
            });
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.lessoncontent', ['uiSwitch']).directive('pdf', function($sce) {
            return {
                restrict: 'E',
                link: function(scope, element, attrs) {
                    scope.$watch(attrs.src, function () {
                        var url = scope.$eval(attrs.src);
                        if(url != ""){
                            var indexi = scope.mediaurlscope.oriUrl.lastIndexOf('/');
                            var u1 = scope.mediaurlscope.oriUrl.substring(0, indexi+1);
                            var u2 = scope.mediaurlscope.oriUrl.substring(indexi+1);
                            var u3 = window.encodeURIComponent(u2);
                            // console.info('u1 = ' + u1 + ',  u2 = ' + u2 + ', u3 = ' + u3);
                            var u4 = u1 + u3;
                            // console.info('u4 = ' + u4);
                            var finalUrl = $sce.trustAsResourceUrl(u4);
                            element.replaceWith('<object width="100%" height="900px" type="application/pdf" data="' + finalUrl + '#toolbar=1">'+
                                "<br><p>未安装Adobe Reader或浏览器不支持PDF<a href="+ finalUrl +">&nbsp&nbsp<strong>点击下载</strong></a>&nbsp&nbsp&nbsp或&nbsp&nbsp&nbsp<a href='http://get.adobe.com/reader/' target='_blank'><strong>点击安装Adobe Reader</strong></a>.</p>"+
                                '<embed src='+url+' type="application/pdf" />' + '</object>');
                        }
                        // element.replaceWith('<object width="100%" height="900px" type="application/pdf" data="' + url + '">'+
                        //     "<br><p>未安装Adobe Reader或浏览器不支持PDF<a href="+ scope.mediaurlscope.url +">&nbsp&nbsp<strong>点击下载</strong></a>&nbsp&nbsp&nbsp或&nbsp&nbsp&nbsp<a href='http://get.adobe.com/reader/' target='_blank'><strong>点击安装Adobe Reader</strong></a>.</p>"+
                        //     '<embed src='+url+' type="application/pdf" />' + '</object>');
                        //     element.replaceWith('<object width="100%" height="900px" type="application/pdf" data="' + scope.mediaurlscope.url + '#toolbar=1">'+
                        //         "<br><p>未安装Adobe Reader或浏览器不支持PDF&nbsp&nbsp&nbsp<a href='http://get.adobe.com/reader/' target='_blank'><strong>点击安装Adobe Reader</strong></a>.</p>"+
                        //         '<embed src='+url+' type="application/pdf" />' + '</object>');
                    })
                }
            };
        })
        .directive('ngRightClick', function ($parse) {
            return function (scope, element, attrs) {
                element.bind('contextmenu', function (event) {
                    console.info("right click....");
                    scope.$apply(function () {
                        event.preventDefault();
                    });
                });
            };
        }).config(routeConfig)

        .directive('currentVideoPlayTime', function () {
            var linker = function (scope, element, attrs) {
                // console.info('currenttime = ' + scope.currentplaytime.currenttime);
                // element[0].currentTime = scope.currentplaytime.currenttime;
                // element.bind('timeupdate', function () {
                //     scope.currentplaytime.currenttime = element[0].currentTime;
                //     scope.saveTime();
                //     // console.info('currentPlayTime = ' + scope.currentplaytime.ddf);
                // });
            };

            return {
                restrict:'A',
                // scope:{
                //     currentplaytime:'=',
                //     savePlay:'&savePlayTime'
                // },
                scope:false,//共享scope
                link:linker
            }
        })
        .directive('dynamicUrl', function ($sce) {
            var mylinker = function (scope, element, attrs) {
                var currentElement = element;
                scope.$watch('testObj.playUrl', function (val) {
                    // console.info("media   dkfjkllllll....");
                    // console.info("mediaHD:" + scope.videoPlayUrl.hdUrl);
                    var html = '';
                    if(val){
                        var indexi = scope.videoPlayUrl.hdOriUrl.lastIndexOf('/');
                        var u1 = scope.videoPlayUrl.hdOriUrl.substring(0, indexi+1);
                        var u2 = scope.videoPlayUrl.hdOriUrl.substring(indexi+1);
                        var u3 = window.encodeURIComponent(u2);
                        // console.info('u1 = ' + u1 + ',  u2 = ' + u2 + ', u3 = ' + u3);
                        var u4 = u1 + u3;
                        // console.info('u4 = ' + u4);
                        var finalUrl = $sce.trustAsResourceUrl(u4);
                        // html = "<video width='100%' controls autoplay ng-right-click  current-video-play-time dynamic-url><source src='" + scope.videoPlayUrl.hdUrl + "'></video>";
                        html = "<video width='100%' controls autoplay ng-right-click  current-video-play-time dynamic-url><source src='" + finalUrl + "'></video>";
                        // attrs.$set('src', 'http://vod.chinalof.com.cn/Act-ss-mp4-sd/礼一交易体系概述 00_06_22-00_08_41.mp4');
                    } else {
                        var indexi = scope.videoPlayUrl.sdOriUrl.lastIndexOf('/');
                        var u1 = scope.videoPlayUrl.sdOriUrl.substring(0, indexi+1);
                        var u2 = scope.videoPlayUrl.sdOriUrl.substring(indexi+1);
                        var u3 = window.encodeURIComponent(u2);
                        // console.info('u1 = ' + u1 + ',  u2 = ' + u2 + ', u3 = ' + u3);
                        var u4 = u1 + u3;
                        // console.info('u4 = ' + u4);
                        var finalUrl = $sce.trustAsResourceUrl(u4);
                        // html = "<video width='100%' controls autoplay ng-right-click  current-video-play-time dynamic-url><source src='" + scope.videoPlayUrl.sdUrl + "'></video>";
                        html = "<video width='100%' controls autoplay ng-right-click  current-video-play-time dynamic-url><source src='" + finalUrl + "'></video>";
                    }
                    var replacementElement = angular.element(html);
                    currentElement.replaceWith(replacementElement);
                    currentElement = replacementElement;
                    // currentElement[0].currentTime = scope.currentplaytime.currenttime;
                    scope.videoPlayUrl.reLoaded = true;
                    currentElement.bind('canplay', function () {
                        if(scope.videoPlayUrl.reLoaded){
                            scope.videoPlayUrl.reLoaded = false;
                            currentElement[0].currentTime = scope.currentplaytime.currenttime;
                        }
                    });
                    currentElement.bind('timeupdate', function () {
                        // console.info('currentPlayTimexx = dddddddddd');
                        // if(scope.videoPlayUrl.reLoaded){
                        //     scope.videoPlayUrl.reLoaded = false;
                        //     currentElement[0].currentTime = scope.currentplaytime.currenttime;
                        // }
                        scope.currentplaytime.currenttime = currentElement[0].currentTime;
                        scope.saveTime();
                        // console.info('currentPlayTimexx = ' + scope.currentplaytime.currenttime);
                    });
                    currentElement.bind('contextmenu', function (event) {
                        // console.info("right click....");
                        scope.$apply(function () {
                            event.preventDefault();
                        });
                    });
                });
            }
            return {
                restrict: 'A',
                scope:false,
                link: mylinker
            };
        });

    function routeConfig($stateProvider) {
        $stateProvider
            .state('lessoncontent', {
                url: '/lessoncontent/{webtype}/{lessontype}/{currentpage}/{lessonid}/{sectionid}/{courseid}/{yposition}',
                templateUrl: 'app/pages/lessons/lessonContent.html',
                controller: 'LessonContentCtrl',
                title: '课程',
                darkBackground: true,
                needLogin: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.mystudy', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('mystudy', {
                url: '/mystudy?groupId/currentPage/mode/yPosition',
                templateUrl: 'app/pages/lessons/mystudy.html',
                controller: 'MystudyCtrl',
                title: '我的学习',
                needLogin: true
            });
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.publesson', [])
        .config(routeConfig);

    function routeConfig($stateProvider) {
        $stateProvider
            .state('publesson', {
                url: '/publesson?groupId/currentPage/yPosition',
                templateUrl: 'app/pages/lessons/pubLesson.html',
                controller: 'PubLessonCtrl',
                title: '公开课'
            });
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.main', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/pages/main/main.html',
                controller: 'MainCtrl',
                title: '主页面'
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.resources', [
            'myApp.pages.resources.jobs',
            "myApp.pages.resources.ruleDetails"
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('resources', {
                url: '/resources',
                template: '<ui-view autoscroll-body-top></ui-view>',
                abstract: true,
                title: '资源'
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.simulation', [
            'myApp.pages.simulation.trade',
            'myApp.pages.simulation.diary',
            'myApp.pages.simulation.mistake',
            'myApp.pages.simulation.mark',
            'oc.lazyLoad',
            "highcharts-ng"
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation', {
                url: '/simulation',
                template: '<ui-view autoscroll="true"></ui-view>',
                abstract: true,
                title: '模拟交易',
                resolve: { // Any property in resolve should return a promise and is executed before the view is loaded
                    loadCKEditor: ['$ocLazyLoad', function($ocLazyLoad) {
                        // you can lazy load files for an existing module
                        // return $ocLazyLoad.load({name:'highstock',files:['highcharts/highstock.js','highcharts/modules/exporting.src.js']});
                        return $ocLazyLoad.load({name:'highstock',files:['highcharts/highstock.js']});
                        // $ocLazyLoad.load('https://cdn.bootcss.com/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML');
                    }]
                }
            });
    }
})();
(function () {

    'use strict';

    angular.module('myApp.pages.turtle', [
            'myApp.pages.turtle.wiki',
            'myApp.pages.turtle.forum',
            "oc.lazyLoad"
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('turtle', {
                url: '/turtle',
                template: '<ui-view autoscroll="false"></ui-view>',
                abstract: true,
                title: '小牛园地',
                resolve: { // Any property in resolve should return a promise and is executed before the view is loaded
                    loadCKEditor: ['$ocLazyLoad', function($ocLazyLoad) {
                        // you can lazy load files for an existing module
                        return $ocLazyLoad.load('ckeditor/ckeditor.js');
                        // $ocLazyLoad.load('https://cdn.bootcss.com/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML');
                    }]
                }
            });

    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user', [
            'myApp.pages.user.login',
            'myApp.pages.user.register',
            'myApp.pages.user.getPassword',
            'myApp.pages.user.personalStyle',
            'myApp.pages.user.interview',
            'myApp.pages.user.edit'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user', {
                url: '/user',
                template: '<ui-view autoscroll="true"></ui-view>',
                abstract: true,
                title: '用户'
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.xmActivity', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('xmActivity', {
                url: '/xmActivity',
                templateUrl: 'app/pages/xmActivity/activity.html',
                controller: 'XmActivityCtrl',
                title: '活动'
            })
            .state('xmActivityDetails', {
                url: '/xmActivityDetails',
                templateUrl: 'app/pages/xmActivity/activityDetails.html',
                controller: 'XmActivityCtrl',
                title: '活动详情'
            })
            .state('xmActivityTradeDetails', {
                url: '/xmActivityTradeDetails',
                templateUrl: 'app/pages/xmActivity/activityTradeDetails.html',
                controller: 'XmActivityCtrl',
                title: '交易详情'
            });

    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.bigData.scoreData', [
            'myApp.pages.bigData.scoreData.details'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('bigData.scoreData', {
                url: '/score_data?fromDate/toDate/start',
                templateUrl: 'app/pages/bigData/scoreData/scoreData.html',
                controller: 'ScoreDataCtrl',
                title: '个人积分查询',
                needLogin: true,
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.bigData.tradeData', [
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('bigData.tradeData', {
                url: '/trade_data',
                templateUrl: 'app/pages/bigData/tradeData/tradeData.html',
                controller: 'TradeDataCtrl',
                title: '交易数据统计分析',
                needLogin: true,
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.exam.paper', [
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('paper', {
                url: '/exam/{id}/paper',
                templateUrl: 'app/pages/exam/paper/paper.html',
                controller: 'PaperCtrl',
                title: '测评中心',
                needLogin: true,
                hiddenHeader: false
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.exam.result', [
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('exam_result', {
                url: '/exam/{id}/result',
                templateUrl: 'app/pages/exam/result/examResult.html',
                controller: 'ExamResultCtrl',
                title: '测评中心',
                needLogin: true,
                hiddenHeader: false
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.resources.jobs', [
            'myApp.pages.resources.jobs.details'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('resources.jobs', {
                url: '/jobs?{anchor}',
                templateUrl: 'app/pages/resources/jobs/jobs.html',
                controller: 'JobsCtrl',
                title: '招聘'
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.resources.ruleDetails', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('resources.ruleDetails', {
                url: '/rule_details/{type}',
                templateUrl: 'app/pages/resources/ruleDetails/ruleDetails.html',
                controller: 'RuleDetailsCtrl',
                title: '规则中心',
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.simulation.diary', [
        'myApp.pages.simulation.diary.edit'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation.diary', {
                url: '/diary?fromDate/toDate/start',
                templateUrl: 'app/pages/simulation/diary/diary.html',
                controller: 'DiaryCtrl',
                title: '交易日志',
                needLogin: true,
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.simulation.mistake', [
        'myApp.pages.simulation.mistake.edit'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation.mistake', {
                url: '/mistake?fromDate/toDate/start',
                templateUrl: 'app/pages/simulation/mistake/mistake.html',
                controller: 'MistakeCtrl',
                title: '过失单',
                needLogin: true,
                darkBackground: true
            });
    }
})();

/**
 * Created by Administrator on 2017/6/2.
 */
(function () {
    'use strict';

    angular.module('myApp.pages.simulation.mark', [
            'ui.select'
        ])
        .config(routeConfig)
        .directive('dynamicHeight', function () {
        var mylinker = function (scope, element, attrs) {
            scope.$watch('myStyles.height', function (val) {
                var ss = 'height:' + val + 'px';
                element.attr('style', ss);
            });
        }
        return {
            restrict: 'A',
            transclude: true,
            scope:false,
            link: mylinker
        };
    });

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation.mark', {
                url: '/mark',
                templateUrl: 'app/pages/simulation/mark/mark.html',
                controller: 'MarkCtrl',
                title: '交易标记',
                hiddenHeader: false,
                needLogin: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.simulation.trade', [
            'ui.select'
        ])
        .config(routeConfig)
        .directive('dynamicStepPrice', function () {
        var mylinker = function (scope, element, attrs) {
            scope.$watch('stepPrice.price', function (val) {
                element.attr('step', val);
            });
        }
        return {
            restrict: 'A',
            transclude: true,
            scope:false,
            link: mylinker
        };
    });

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('simulation.trade', {
                url: '/trade',
                templateUrl: 'app/pages/simulation/trade/trade.html',
                controller: 'TradeCtrl',
                title: '下单',
                hiddenHeader: true,
                needLogin: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.turtle.forum', [
            'ckeditor',
            'myApp.pages.turtle.forum.write',
            'myApp.pages.turtle.forum.details'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('turtle.forum', {
                url: '/forum?filter/sort/start',
                templateUrl: 'app/pages/turtle/forum/forum.html',
                controller: 'ForumCtrl',
                title: '小牛问答',
                darkBackground: true
            });
    }
})();


(function () {

    'use strict';

    angular.module('myApp.pages.user.getPassword', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user.getPassword', {
                url: '/get_password/{type}',
                templateUrl: 'app/pages/user/getPassword/getPassword.html',
                controller: 'GetPasswordCtrl',
                title: '找回密码',
                hiddenHeader: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.turtle.wiki', [
            'myApp.pages.turtle.wiki.details'
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('turtle.wiki', {
                url: '/wiki?groupId/filter/start',
                templateUrl: 'app/pages/turtle/wiki/wiki.html',
                controller: 'WikiCtrl',
                title: '小牛词典',
                darkBackground: true
            });
    }
})();


(function () {
    'use strict';

    angular.module('myApp.pages.user.edit', ['angularFileUpload', 'ngImgCrop'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user.edit', {
                url: '/edit',
                templateUrl: 'app/pages/user/edit/edit.html',
                controller: 'EditCtrl',
                title: '修改个人信息',
                hiddenHeader: true
            });
    }
})();


(function () {

    'use strict';

    angular.module('myApp.pages.user.login', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user.login', {
                url: '/login?phone',
                templateUrl: 'app/pages/user/login/login.html',
                controller: 'LoginCtrl',
                title: '登录',
                hiddenHeader: true
            });
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.personalStyle', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user.personalStyle', {
                url: '/personal_style',
                templateUrl: 'app/pages/user/personalStyle/personalStyle.html',
                controller: 'PersonalStyleCtrl',
                title: '性格色彩测试',
                hiddenHeader: true
            });
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.interview', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user.interview', {
                url: '/interview',
                templateUrl: 'app/pages/user/interview/interview.html',
                controller: 'InterviewCtrl',
                title: '面试',
                hiddenHeader: true
            });
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.register', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('user.register', {
                url: '/register',
                templateUrl: 'app/pages/user/register/register.html',
                controller: 'RegisterCtrl',
                title: '注册',
                hiddenHeader: true
            });
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.activity')
        .controller('ActivityCtrl', ActivityCtrl)
        .controller('JoinCtrl', JoinCtrl);

    function ActivityCtrl($scope, $http, $state, $sce, ProfileService, $interval, TokenCheckService, TokenService, $uibModal, modalService) {
        var ctrl = $scope;
        ctrl.getCompetitionDetails = function () {
            var url = $state.href("activityDetails", {});
            window.open(url, '_blank');
        };

        ctrl.getTradeDetails = function () {
            var url = $state.href("activityTradeDetails", {});
            window.open(url, '_blank');
        };

        ctrl.getPrize = function () {
            var url = $state.href("activityPrize", {});
            window.open(url, '_blank');
        };

        ctrl.navigations = {
            active: 0,
            interval: 5000,
            noWrapSlides: false,
            displayed: []
        };
        ctrl.navigations.displayed.push({
            id: 0,
            image: "images/activity/prize.png"
        });
        // ctrl.navigations.displayed.push({
        //     id: 1,
        //     image: "images/activity/prize1.png"
        // });

        //轮播图模块
        // ctrl.navigations = {
        //     active: 0,
        //     interval: 5000,
        //     noWrapSlides: false,
        //     displayed: []
        // };
        // ctrl.navigationDisplayed = [];
        // ctrl.navigations.displayed.push({
        //     id: 0,
        //     image: "images/main_banner.png",
        //     noLink: 1,
        //     linkUrl: ""
        // });
        // ctrl.navigations.displayed.push({
        //     id: 1,
        //     image: "images/summber_competition.png",
        //     noLink: 0,
        //     linkUrl: ""
        // });

        ctrl.joinSrc = "images/activity/join.png";
        ctrl.university = {
            id : 0,
            name: ""
        };
        var getData = function () {
            if (TokenService.user.userId == 0) {
                return;
            }
            $http.get(ProfileService.SERVER_HOST + "users/" + TokenService.user.userId + "/university").
            then(function (response) {
                $scope.university = response.data;
                if($scope.university.id != 0)
                {
                    if($scope.university.regionType == 1)
                    {
                        ctrl.joinSrc = "images/activity/joined.png";
                    }
                    else
                    {
                        ctrl.joinSrc = "images/activity/joinedOther.png";
                    }
                }
            }).
            catch(function (response) {
            });
        }
        getData();

        ctrl.join = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            else
            {
                if($scope.university.id != 0)
                {
                    // if($scope.university.regionType != 1)
                    // {
                    //     modalService.showInform({}, {headerText: "已报名", bodyText:"您已经在其他地区报过名，禁止重复参赛"});
                    // }
                    return;
                }
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: true,
                    templateUrl: 'app/pages/activity/selectUniversity.html',
                    controller: 'JoinCtrl',
                    //sm md lg
                    size: 'sm',
                    resolve: {
                        modalOptions:{
                            closeButtonText: '取消',
                            actionButtonText: '确定',
                            headerText: '选择您所在高校',
                            bodyText: '',
                            alertStyle: 'primary'
                        }
                    }
                });

                modalInstance.result.then(function (selectedItem) {
                    getData();
                }, function () {
                });
            }
        }

    }

    function JoinCtrl($scope, $uibModalInstance, $http,$log, modalOptions, modalService, TokenService, ProfileService) {
        $scope.selectedUniversity =
        {
            id: 0,
            name: ""
        };
        $scope.universities = [];

        var getData = function () {
            $http.get(ProfileService.SERVER_HOST + "users/universities?type=1").
            then(function (response) {
                $log.info("查询成功...");
                $scope.universities = response.data;
            }).
            catch(function (response) {
                $log.info('查询失败...');
            });
        }
        getData();
        
        $scope.selectUniversity = function (university) {
            $scope.selectedUniversity = university;
        }

        $scope.modalOptions = modalOptions;

        $scope.modalOptions.ok = function (result) {
            result = 'ok';

            var confirmModalOptions = {
                closeButtonText: '取消',
                actionButtonText: '确认',
                bodyText: "请您确认您所选的高校：<font color='red'>" + $scope.selectedUniversity.name + "</font>，确认后不可修改",
                alertStyle: 'warning'
            };
            modalService.showConfirmModal({}, confirmModalOptions).then(function (result) {
                $http.post(ProfileService.SERVER_HOST + "users/" + TokenService.user.userId + "/university", $scope.selectedUniversity).then(function (response) {
                    $uibModalInstance.close(result);
                }).catch(function (response) {
                    modalService.showInform({}, {bodyText: '选择所属高校失败：' + response.data.error + "!"});
                });
            });
        };
        $scope.modalOptions.close = function (result) {
            result = 'cancel';
            $uibModalInstance.dismiss(result);
        };
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.aboutUs')
        .controller('AboutUsCtrl', AboutUsCtrl);

    function AboutUsCtrl($scope, $http, $sce, ProfileService) {
        $scope.aboutSlider = {
            active: 0,
            interval: 5000,
            noWrapSlides: false,
            displayed: [{id: 0, image: "images/about/slider2.jpg"}]
        };

        var ctrl = $scope;
        ctrl.showItem = {
            id: 0,
            title: "",
            content: ""
        };

        var getData = function () {
            $http.get(ProfileService.SERVICE_RULE + "company").
            then(function (response) {
                ctrl.showItem.id = response.data.id;
                ctrl.showItem.title = response.data.title;
                ctrl.showItem.content = $sce.trustAsHtml(response.data.content);
            }).
            catch(function (response) {
            });
        };
        getData();
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.download')
        .controller('DownloadCtrl', DownloadCtrl);

    function DownloadCtrl($scope, $http, $state, $stateParams, ProfileService, TokenCheckService, modalService) {
        var ctrl = $scope;
        ctrl.androidUrl = "";
        ctrl.iosUrl = "";
        
        var getDownloadUrl = function () {
            $http.get(ProfileService.SERVER_HOST + "resources/app/download").then(function (response) {
                ctrl.androidUrl = response.data.androidUrl;
                ctrl.iosUrl = response.data.iosUrl;
            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法获取App下载路径！")});
            });
        };
        getDownloadUrl();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.exam')
        .controller('ExamCtrl', ExamCtrl);

    function ExamCtrl($scope, $filter, $stateParams, $state, $http, $interval, modalService, ProfileService, TokenCheckService) {
        var ctrl = $scope;
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.firstLoad = true;
        ctrl.displayed = [];

        $scope.timer = null;

        var StartStatus = {
            UnStarted : 1,
            Starting : 2,
            End : 3
        };

        //单页数量
        ctrl.itemsByPage = 20;
        //总数量
        ctrl.totalItemCount = 0;


        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(start) {
            for (var i = 0; i < ctrl.displayed.length; i++) {
                ctrl.displayed[i].index = start + i + 1;
            }
        }
        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            ctrl.getData();
        };

        $scope.getData = function (reset_page) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            if (reset_page) {
                ctrl.tableState.pagination.start = 0;
            }
            var pagination = ctrl.tableState.pagination;
            var queryArgs = {
                start: pagination.start || 0,
                number: ctrl.itemsByPage
            };
            ctrl.firstLoad = false;

            $http.get(ProfileService.SERVER_HOST + "exams/collections?start=" +
                queryArgs.start + "&number=" + queryArgs.number).then(function (response) {
                ctrl.displayed = response.data.items;
                ctrl.totalItemCount = response.data.totalCount;
                pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
                addIndex(queryArgs.start);

                ctrl.timer = $interval(
                    function() {
                        setStartLeftSeconds();
                    },
                    1000
                );

            }).catch(function (response) {
                ctrl.displayed = [];
                pagination.numberOfPages = 1;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
                modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载考试信息！")});
            });
        };

        ctrl.getStartBtnLink = function (id, startStatus, userFinished)
        {
            var href = $state.href('paper', {
                id: id
            });
            if(startStatus == StartStatus.UnStarted)
            {
                return "";
            }
            else if(startStatus == StartStatus.Starting)
            {
                if(userFinished == 1)
                {
                    //用户已经交卷
                    return "";
                }
                else
                {
                    return href;
                }

            }
            else
            {
                return "";
            }
        };

        ctrl.getStartBtnStyle = function (startStatus, userFinished)
        {
            if(startStatus == StartStatus.UnStarted)
            {
                return {'background-color': '#0C263E', cursor: 'default'};
            }
            else if(startStatus == StartStatus.Starting)
            {
                if(userFinished == 1)
                {
                    return {cursor: 'default'};
                }
            }
            else
            {
                return {'background-color': '#86939F', cursor: 'default'};
            }
        };

        ctrl.getStartBtnName = function (startStatus, startLeftSeconds, userFinished) {
            if(startStatus == StartStatus.UnStarted)
            {
                if(startLeftSeconds <= 5 * 60)
                {
                    return startLeftSeconds + "s";
                }
                else
                {
                    return "未开始";
                }
            }
            else if(startStatus == StartStatus.Starting)
            {
                if(userFinished == 1)
                {
                    return "已交卷";
                }
                else
                {
                    return "进入";
                }
            }
            else
            {
                return "已结束";
            }
        };

        ctrl.getScore = function (startStatus, score, scorePeriod) {
            if(startStatus == StartStatus.UnStarted)
            {
                return "--";
            }
            else if(startStatus == StartStatus.Starting)
            {
                if(scorePeriod != 0)
                {
                    //已经提交了试卷的允许马上看到自己的分数
                    return score;
                }
                return "--";
            }
            else
            {
                return score;
            }
        };

        //设置考场的状态
        var setStartLeftSeconds = function () {
           for(var i in ctrl.displayed)
           {
               //调查问卷不处理
               if(ctrl.displayed[i].type == 2)
               {
                   continue;
               }
               ctrl.displayed[i].startLeftSeconds -= 1;
               if(ctrl.displayed[i].startLeftSeconds > 0)
               {
                   ctrl.displayed[i].startStatus = StartStatus.UnStarted;
               }
               else
               {
                   if((ctrl.displayed[i].startLeftSeconds + ctrl.displayed[i].scorePeriod * 60) > 0)
                   {
                       ctrl.displayed[i].startStatus = StartStatus.Starting;
                   }
                   else
                   {
                       ctrl.displayed[i].startStatus = StartStatus.End;
                   }
               }
           }
        };

        ctrl.getExamResultLink = function (id, startStatus) {
            if(startStatus == StartStatus.UnStarted)
            {
                return "";
            }
            else if(startStatus == StartStatus.Starting)
            {
                return "";
            }
            else
            {
                var href = $state.href('exam_result', {
                    id: id
                });
                return href;
            }
        };

        $scope.$on('$destroy',function(){
            if($scope.timer != null)
            {
                $interval.cancel($scope.timer);
            }
        })

    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.goOnline')
        .controller('goOnlineCtrl', goOnlineCtrl);

    function goOnlineCtrl($scope, $stateParams, $window, $location, $log, $http, $state, $timeout, ProfileService, TokenService, modalService, EncryptService) {

    }
})();
(function () {

    'use strict';

    angular.module('myApp.pages.myExam')
        .controller('myExamCtrl', MyExamCtrl);

    function MyExamCtrl($scope, $stateParams, $window, $log, $http, $state, ProfileService, TokenService, modalService, TokenCheckService) {
        var ctrl = $scope;
        $scope.groupid = $stateParams.groupid;
        $scope.lessonid = $stateParams.lessonid;
        $scope.isViewMode = $stateParams.mode == 'view' ? true : false;
        $scope.yposition = $stateParams.yposition;
        $window.scrollTo(0, 0);
        ctrl.displayedExam = {
            id: '', username: '', lessonName: '', totalScore: '', score: '', createTime: '', examPeriod: '',
            answers: [{
                correct: '',
                answer: '',
                id: '',
                type: '',
                score: '',
                repA:false,
                repB:false,
                repC:false,
                repD:false,
                ask: {content: '', answerA: '', answerB: '', answerC: '', answerD: ''}
            }]
        };

        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        $scope.goBack = function () {
            $state.go('mystudy', {
                groupId: $scope.groupid,
                currentPage: 0,
                mode: $stateParams.mode,
                yPosition: $scope.yposition
            });
            // $state.go('mystudy', {groupId:$scope.lessontype,currentPage:$scope.currentpage, mode:'view', yPosition:$scope.yposition});
        }

        ctrl.getCheck = function (answer, xx, type) {//
            return false;
        }

        $scope.isAllCompleted = function () {
            var ret = true;
            ctrl.displayedExam.answers.forEach(function (answer) {
                if(!answer.repA && !answer.repB && !answer.repC && !answer.repD)
                    ret = false;
            })
            return ret;
        }


        $scope.commit = function () {
            var myanswer = {answers: []};
            ctrl.displayedExam.answers.forEach(function (answer) {
                var xx = 0;
                xx += answer.repA ? 1 : 0;
                xx += answer.repB ? 2 : 0;
                xx += answer.repC ? 4 : 0;
                xx += answer.repD ? 8 : 0;
                myanswer.answers.push({answer:xx});
                // myanswer.answers.push({answer: answer.answer});
            });
            $log.info('');
            $http.put(ProfileService.USER_SERVICE + TokenService.user.userId + "/courses/" + $scope.groupid + "/lessons/" + $scope.lessonid + "/exam", myanswer).then(function (response) {
                ctrl.displayedExam = response.data;
                $state.go('mystudy', {groupId: $scope.groupid, currentPage: 0});
            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '提交失败：' + response.data.error + "!"});
                // $state.go('mystudy', {groupId: $scope.groupid, currentPage: 0});
            });
        }

        $scope.close = function () {
            $scope.goBack();
            // $state.go('mystudy', {groupId:$scope.groupid,currentPage:0});
        }

        $scope.isAnswered = function (answer) {
            if(answer.repA || answer.repB || answer.repC || answer.repD)
                return true;
            else
                return false;
        }

        $scope.getCheckColor = function (val, correct, answer) {
            if ($scope.isViewMode) {
                if (correct == answer) {
                    return {"color": "black", cursor: 'pointer', "font-weight": "normal", readonly: true};
                } else {
                    if (val)
                        return {"color": "red", cursor: 'pointer', readonly: true};
                    else
                        return {"color": "black", cursor: 'pointer', "font-weight": "normal", readonly: true};
                }
            } else {
                if (val)
                    return {"color": "red", "font-weight": "bold", cursor: 'pointer', readonly: true};
                else
                    return {"color": "black", "font-weight": "normal", cursor: 'pointer', readonly: true};
            }
        }

        $scope.getAnswerStr = function (val) {
            var ret = '';
            if ((val & 1) > 0)
                ret += 'A';
            if ((val & 2) > 0)
                ret += 'B';
            if ((val & 4) > 0)
                ret += 'C';
            if ((val & 8) > 0)
                ret += 'D';
            return ret;
        }

        $scope.answerClick = function (type, val, answerId)
        {
            for(var i in ctrl.displayedExam.answers){
                var xx = ctrl.displayedExam.answers[i];
                if(xx.id == answerId){
                    if(type == 1){
                        if(val == 1){
                            xx.repB = false;
                        } else if(val == 2){
                            xx.repA = false;
                        }
                    }
                    break;
                }
            }
        }

        ctrl.getData = function () {
            var testd1 = 17;
            var data1 = testd1 & 2;
            var data2 = testd1 & 16;
            if ($scope.isViewMode) {
                $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + "/courses/" + $scope.groupid + "/lessons/" + $scope.lessonid + "/exam_result").then(function (response) {
                    ctrl.displayedExam = response.data;
                    ctrl.displayedExam.answers.forEach(function (question) {
                        question.repA = (parseInt(question.answer)&1) > 0 ? true : false;
                        question.repB = (parseInt(question.answer)&2) > 0 ? true : false;
                        question.repC = (parseInt(question.answer)&4) > 0 ? true : false;
                        question.repD = (parseInt(question.answer)&8) > 0 ? true : false;
                    });
                }).catch(function (response) {
                    // modalService.showInform({}, {bodyText: '失败：' + response.statusText + "!"});
                });
                return;
            }
            $http.post(ProfileService.USER_SERVICE + TokenService.user.userId + "/courses/" + $scope.groupid + "/lessons/" + $scope.lessonid + "/exam", "").then(function (response) {
                ctrl.displayedExam = response.data;
                ctrl.displayedExam.answers.forEach(function (question) {
                    question.answer = 0;
                    question.correct = 0;
                    question.repA = false;
                    question.repB = false;
                    question.repC = false;
                    question.repD = false;
                });
            }).catch(function (response) {
                //409表示已经有了，则直接GET
                if (response.status == 409) {
                    $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + "/courses/" + $scope.groupid + "/lessons/" + $scope.lessonid + "/exam").then(function (response) {
                        ctrl.displayedExam = response.data;
                        ctrl.displayedExam.answers.forEach(function (question) {
                            question.answer = 0;
                            question.correct = 0;
                            question.repA = false;
                            question.repB = false;
                            question.repC = false;
                            question.repD = false;
                        });
                    }).catch(function (response) {
                        // modalService.showInform({}, {bodyText: '提交失败：' + response.data.error + "!"});
                    });
                }
                else {
                    // modalService.showInform({}, {bodyText: '提交失败：' + response.data.error + "!"});
                }
            });
        };
        ctrl.getData();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.lessoncontent').controller('LessonContentCtrl', LessonContentCtrl);

    function LessonContentCtrl($scope, $sce, $document, $stateParams, $http, $state, ProfileService, TokenService, TokenCheckService) {
        $scope.webtype = $stateParams.webtype;
        $scope.lessontype = $stateParams.lessontype;
        $scope.currentpage = $stateParams.currentpage;
        $scope.lessonid = $stateParams.lessonid;
        $scope.sectionid = $stateParams.sectionid;
        $scope.courseid = $stateParams.courseid;
        $scope.yposition = $stateParams.yposition;
        $scope.currentplaytime = {currenttime: 0, videoname: ''};

        $scope.highDefinition = true;
        $scope.currentPlayUrl = '';

        // $scope.$watch('highDefinition', function (val) {
        //     console.log('switch highDefinition : ' + val);
        // });

        $scope.testObj = {playUrl: $scope.highDefinition};
        $scope.videoPlayUrl = {sdUrl: '', hdUrl: '', reLoaded: true, sdOriUrl:'', hdOriUrl:''};
        
        if ($scope.courseid != 'open') {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
        }

        $scope.highChange = function () {
            $scope.highDefinition = !$scope.highDefinition;
            $scope.testObj.playUrl = $scope.highDefinition;
            // $log.info($scope.highDefinition);
            $scope.currentPlayUrl = $scope.highDefinition ? $scope.mediaData.mediaUrl : $scope.mediaData.mediaSdUrl;
            $scope.mediaData.mediaUrl = $scope.currentPlayUrl;
        }

        $scope.getPlayUrl = function () {
            return $sce.trustAsResourceUrl($scope.currentPlayUrl);
        }

        $document.scrollTo(0, 0, 400);
        $scope.saveTime = function () {
            // $log.info('save play time = ' + $scope.currentplaytime.currenttime);
            $scope.displayedPlayTime = $scope.currentplaytime.currenttime;
            TokenService.saveVideoCurrentTime($scope.mediaData.title, $scope.currentplaytime.currenttime);
        }

        // $scope.getMediaUrl = function () {
        //     return $scope.highDefinition ? $scope.mediaData.mediaUrl : $scope.mediaData.mediaSdUrl;
        // }

        $scope.mediaData = {
            // title:"11", mediaType:0, mediaUrl:"",mediaSdUrl:''  mediaSdUrl标清
        };
        $scope.mediaUrl = $scope.mediaData.mediaUrl;
        $scope.mediaurlscope = {url: '', oriUrl:''};

        $scope.lesson = {
            // updateTime:"",id:1,name:"证券基础知识",orderId:1,
            // sections:[{
            //     id:5,lessonId:1,mediaName:"1-160521014039.pdf",mediaType:0,mediaUrl:"http://doc.chinalof.com.cn/test_resources/1-160521014039.pdf",name:"111",period:2
            // }],totalPeriod:3
        }

        $scope.goBack = function () {
            if ($scope.webtype == 'openLesson') {
                $state.go('publesson', {
                    groupId: $scope.lessontype,
                    currentPage: $scope.currentpage,
                    yPosition: $scope.yposition
                });
            } else {
                $state.go('mystudy', {
                    groupId: $scope.lessontype,
                    currentPage: $scope.currentpage,
                    mode: 'view',
                    yPosition: $scope.yposition
                });
            }
        }

        var url_t = ProfileService.SERVICE_OPEN_LESSONS + $scope.lessonid;
        if ($scope.webtype == 'openLesson')//公开课
        {
            url_t = ProfileService.SERVICE_OPEN_LESSONS + $scope.lessonid;
            $http.put(ProfileService.SERVER_HOST + 'courses/open_lessons/' + $scope.lessonid + '/sections/' + $scope.sectionid + '/clicks', '').then(function (response) {
                $scope.getLesson();
            }).catch(function (response) {
                $scope.getLesson();
            });
        }
        else {
            url_t = ProfileService.USER_SERVICE + TokenService.user.userId + '/courses/' + $scope.lessontype + '/lessons/' + $scope.lessonid;
            $http.put(ProfileService.USER_SERVICE + TokenService.user.userId + '/courses/' + $scope.courseid + '/lessons/' + $scope.lessonid + '/sections/' + $scope.sectionid + '/clicks', null).then(function () {
                $scope.getLesson();
            }).catch(function () {
                $scope.getLesson();
            })
        }
        $scope.getLesson = function () {
            $http.get(url_t, '').then(function (response) {
                $scope.lesson = response.data;
                for (var section in response.data.sections) {
                    var xx = response.data.sections[section];
                    if ($scope.sectionid == xx.id) {
                        if (xx.mediaType == '1') {//视频
                            $scope.videoPlayUrl.sdUrl = $sce.trustAsResourceUrl(xx.mediaSdUrl);
                            $scope.videoPlayUrl.sdOriUrl = xx.mediaSdUrl;
                            $scope.videoPlayUrl.hdUrl = $sce.trustAsResourceUrl(xx.mediaUrl);
                            $scope.videoPlayUrl.hdOriUrl = xx.mediaUrl;
                            $scope.mediaData.mediaSdUrl = xx.mediaSdUrl;
                            // $scope.mediaData.mediaUrl = $sce.trustAsResourceUrl(xx.mediaUrl);
                        }
                        // $scope.mediaData.mediaUrl = xx.mediaUrl;
                        $scope.mediaData.title = xx.name;
                        $scope.mediaData.mediaType = xx.mediaType;
                        $scope.mediaData.mediaUrl = $sce.trustAsResourceUrl(xx.mediaUrl);

                        $scope.mediaUrl = $scope.mediaData.mediaUrl;
                        console.info("url: " + $scope.mediaUrl);
                        $scope.currentPlayUrl = xx.mediaSdUrl;
                        // $scope.mediaUrl = "app/pages/lessons/11.pdf";
                        // $scope.mediaData.title = $scope.lesson.name;
                        $scope.mediaurlscope.url = $scope.mediaData.mediaUrl;
                        $scope.mediaurlscope.oriUrl = xx.mediaUrl;
                        $scope.currentplaytime.videoname = $scope.mediaData.title;
                        var xx = TokenService.getVideoCurrentTime();
                        if (xx != null && xx != '' && xx.VideoName == $scope.mediaData.title) {
                            $scope.currentplaytime.currenttime = xx.CurrentTime;
                        }
                        break;
                    }
                }
            }).catch(function (response) {
                $scope.mediaData.title = '';
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.mystudy')
        .controller('MystudyCtrl', MystudyCtrl)
        .directive("myStudyScroll", function ($window) {
            return function (scope, element, attrs) {
                angular.element($window).bind("scroll", function () {
                    // console.log('scroll = ' + this.pageYOffset);
                    // scope.scrollChange();
                    // scope.$apply();
                });
            };
        });

    function MystudyCtrl($scope, $stateParams, $window, $location, $log, $http, $state, $timeout, ProfileService, TokenService, TokenCheckService) {

        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        // if (TokenService.isLogin() == false) {
        //     $state.go('user.login', '', {location: 'replace'});
        //     return;
        // }
        // if (TokenService.isLogin() == true && TokenService.user.userStatus == TokenService.STATUS_STRING.STATUS_VISITOR) {
        //     $state.go('user.personalStyle', '', {location: 'replace'});
        //     return;
        // }

        $scope.urlCourseId = $stateParams.groupId;//课程体系
        $scope.urlCurrentPage = $stateParams.currentPage;//页面
        $scope.isViewReturn = $stateParams.mode == 'view' ? true : false;
        $scope.yPosition = $stateParams.yPosition == null ? 0 : parseInt($stateParams.yPosition);
        $scope.firstLoad = true;
        $scope.getClassPic = function (class_type) {
            if (class_type == '0')//文档
                return "images/home/word.png";
            if (class_type == "1")//视频内容
                return "images/home/video.png";
            if (class_type == "2")//word文档
                return "images/home/word.png";
        }
        $scope.userCourses = [
            // {courseId:'',name:'',status:0}
        ];//status:0未开始；1开始；2通过；3未通过
        $scope.currentCourseId = '';
        $scope.currentLessons = {
            // courseId:'',name:'',status:'',score:'',totalScore:'',period:'',totalPeriod:'',
            // lessons:[
            //     {id:'',name:'',examFlag:'',linkUrl:'',score:'',totalScore:'',period:'',
            //         sections:[{id:'', name:'',mediaUrl:'',mediaType:'', clicks:''}]
            //     }
            // ]
        };

        $scope.scrollChange = function () {
            $state.current.reloadOnSearch = false;
            $location.search('yPosition', $window.pageYOffset);
            $scope.yPosition = $window.pageYOffset;
        }

        $scope.isLessonExamed = function (lessonId) {
            for (var i in $scope.currentLessons.lessons) {
                var lesson = $scope.currentLessons.lessons[i];
                if (lesson.id == lessonId) {
                    if (lesson.examFlag == 2)
                        return true;
                    else
                        return false;
                }
            }
            return false;
        }

        $scope.refreshCourseStatus = function (courseId, status) {
            for (var i in $scope.userCourses) {
                if ($scope.userCourses[i].courseId == courseId) {
                    $scope.userCourses[i].status = status;
                    break;
                }
            }
        }

        $scope.getCourseTitle = function (courseId) {
            for (var i in $scope.userCourses) {
                if ($scope.userCourses[i].courseId == courseId) {
                    var status = $scope.userCourses[i].status;
                    var statuStr = '';
                    if (status == 0)
                        statuStr = '(未开始)';
                    else if (status == 1)
                        statuStr = '(进行中)';
                    else if (status == 2)
                        statuStr = '(已通过)';
                    else if (status == 3)
                        statuStr = '(未通过)';
                    else
                        statuStr = '(未知)';
                    return $scope.userCourses[i].name + statuStr;
                }
            }
            return 'null';
        };

        $scope.getCourseProgress = function () {
            if ($scope.currentLessons.status == 0)
                return '未开始';
            else if ($scope.currentLessons.status == 1)
                return '进行中';
            else if ($scope.currentLessons.status == 2)
                return '已通过';
            else if ($scope.currentLessons.status == 3)
                return '未通过';
            else
                return '未知';
        };

        $scope.getCourseClass = function (courseId) {
            return {active: courseId == $scope.currentCourseId ? true : false};
        }

        $scope.getAction = function (examFlag) {
            if (examFlag == 0)//未开始课程，不能考试
                return '未考试';
            else if (examFlag == 1)//允许进行考试
                return '未考试';
            else if (examFlag == 2)//允许查看考试结果试卷
                return '查看成绩';
        }

        $scope.courseSelect = function (courseId, createFlag) {
            $scope.currentCourseId = courseId;
            $state.current.reloadOnSearch = false;
            $location.search('groupId', courseId);
            $location.search('currentPage', 0);
            if (createFlag) {//创建课程
                $scope.createCourse(courseId);
                return;
            }
            $scope.getCourse(courseId);
        }

        $scope.goStudy = function (lessonid, sectionid, examFlag) {
            if (examFlag == 0) {
                // modalService.showInform({}, {bodyText: '此课程未开始学习！'});
                return;
            }
            // $scope.scrollChange();
            $state.go('lessoncontent', {
                webtype: 'personalLesson',
                lessontype: $scope.currentCourseId,
                currentpage: '0',
                lessonid: lessonid,
                sectionid: sectionid,
                yposition: $scope.yPosition,
                courseid: $scope.currentCourseId
            });
        }

        $scope.getStudyUrl = function (lessonid, sectionid, examFlag) {
            //'/lessoncontent/{webtype}/{lessontype}/{currentpage}/{lessonid}/{sectionid}/{courseid}/{yposition}',
            if (examFlag == 0)
                return '';
            var urls = '/#/lessoncontent/personalLesson/' + $scope.currentCourseId + '/0/' + lessonid + '/' + sectionid + '/' + $scope.currentCourseId + '/' + $scope.yPosition;
            return urls;
        }

        $scope.goExam = function (lessonid, examFlag) {
            if (examFlag == 0)
                return;
            if ($scope.isLessonExamed(lessonid) == false)
            // $scope.scrollChange();
                $state.go('myExam', {
                    groupid: $scope.currentCourseId,
                    lessonid: lessonid,
                    mode: 'exam',
                    yposition: $scope.yPosition
                });
        };

        $scope.viewExam = function (lessonid, examFlag) {
            if (examFlag == 0)
                return;
            if ($scope.isLessonExamed(lessonid) == true)
            // $scope.scrollChange();
                $state.go('myExam', {
                    groupid: $scope.currentCourseId,
                    lessonid: lessonid,
                    mode: 'view',
                    yposition: $scope.yPosition
                });
        };


        $scope.getLinkStyle = function (examFlag) {
            if (examFlag == 0)
                return {color: 'gray'};
            else
                return {cursor: 'pointer'};
        }

        $scope.callbackPubListen = function (tableState) {
            $log.info("CustomersCtrl: callServer...");
            $scope.tableState = tableState;
            tableState.pagination.numberOfPages = 8;
        };

        $scope.getUserCourses = function () {
            $http.put(ProfileService.USER_SERVICE + TokenService.user.userId + '/courses', null).then(function (response) {
                $scope.userCourses = response.data;
                if ($scope.urlCourseId != null && $scope.firstLoad && $scope.isViewReturn) {
                    $scope.firstLoad = false;
                    $scope.courseSelect($scope.urlCourseId, false);
                    return;
                }//else{
                var begined = false;
                var indexxx = -1;
                for (var x in $scope.userCourses) {
                    var k = $scope.userCourses[x];
                    if (k.status == 1) { //进行中，直接跳至该课程
                        $scope.courseSelect(k.courseId, false);
                        begined = true;
                        return;
                    }
                    else if (k.status == 0 && indexxx == -1) {
                        indexxx = x;
                    }
                }
                if (!begined && indexxx >= 0)//若课程已完成，自动开始下一课程
                {
                    $scope.courseSelect($scope.userCourses[indexxx].courseId, true);
                }
                else if ($scope.urlCourseId != null && $scope.firstLoad) {
                    $scope.firstLoad = false;
                    $scope.courseSelect($scope.urlCourseId, false);
                } else if ($scope.userCourses.length > 0) {
                    $scope.courseSelect($scope.userCourses[0].courseId, false);
                }
                // }
            }).catch(function (response) {
                $log.error('获取用户课程体系失败');
            });
        }

        $scope.getUserCourses();

        $scope.createCourse = function (courseId) {
            $http.post(ProfileService.USER_SERVICE + TokenService.user.userId + '/courses', {courseId: courseId}).then(function (response) {
                $scope.currentLessons = response.data;
                $scope.refreshCourseStatus(response.data.courseId, response.data.status);
            }).catch(function (response) {
                $log.error(response.data);
                $scope.getCourse(courseId);
            });
        }

        $scope.getCourse = function (courseId) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + '/courses/' + courseId, null).then(function (response) {
                $scope.currentLessons = response.data;
                $timeout(function () {
                    $window.scrollTo(0, $scope.yPosition);
                }, 100);
            }).catch(function (response) {
                $log.error(response.data);
            });
        }

        $scope.getLessonContainerClass = function (lesson) {
            if (lesson.examFlag == 2) {
                return "lesson-completed";
            }
            else if (lesson.examFlag == 1) {
                return "lesson-normal";
            }
            else {
                return "lesson-disabled";
            }
        };

        // $scope.getLessonClass = function (lesson) {
        //     if (lesson.examFlag == 2) {
        //         return "lesson";
        //     }
        //     else if (lesson.examFlag == 1) {
        //         return "cover";
        //     }
        //     else {
        //         return "cover-disabled";
        //     }
        // };


        $scope.isCourseShowing = function (course) {
            //如果总项目
            var cur_index = -1;
            var active_index = -1;
            //遍历查找group
            for (var i = 0; i < $scope.userCourses.length; i++) {
                var tmp_course = $scope.userCourses[i];
                if (tmp_course == course) {
                    cur_index = i;
                }
                if (tmp_course.courseId == $scope.currentCourseId) {
                    active_index = i;
                }
            }
            // console.info("cur_index = " + cur_index + ", active_index = " + active_index);
            if (active_index == 0) {
                if (cur_index <= 2) {
                    return true;
                }
            }
            else if (active_index == $scope.userCourses.length - 1) {
                if (cur_index >= $scope.userCourses.length - 3) {
                    return true;
                }
            }
            else {
                if (cur_index == active_index || cur_index == active_index - 1 || cur_index == active_index + 1) {
                    return true;
                }
            }
            return false;
        };

        $scope.isLeftCourseShowing = function () {
            return $scope.userCourses.length > 0 && $scope.userCourses[0].courseId != $scope.currentCourseId;
        };

        $scope.isRightCourseShowing = function () {
            return $scope.userCourses.length > 0 && $scope.userCourses[$scope.userCourses.length - 1].courseId != $scope.currentCourseId;
        };

        $scope.courseCursorLeft = function () {
            if ($scope.userCourses.length > 0 && $scope.userCourses[0].courseId != $scope.currentCourseId) {
                for (var i = 0; i < $scope.userCourses.length; i++) {
                    if ($scope.userCourses[i].courseId == $scope.currentCourseId) {
                        $scope.courseSelect($scope.userCourses[i - 1].courseId, false);
                        return;
                    }
                }
            }
        };

        $scope.courseCursorRight = function () {
            if ($scope.userCourses.length > 0 && $scope.userCourses[$scope.userCourses.length - 1].courseId != $scope.currentCourseId) {
                for (var i = 0; i < $scope.userCourses.length; i++) {
                    if ($scope.userCourses[i].courseId == $scope.currentCourseId) {
                        $scope.courseSelect($scope.userCourses[i + 1].courseId, false);
                        return;
                    }
                }
            }
        };

        $scope.getCourseContainerClass = function () {
            if ($scope.userCourses.length <= 1) {
                return "li-container1";
            }
            else if ($scope.userCourses.length == 2) {
                return "li-container2";
            }
            else {
                return "li-container3";
            }
        };

        $scope.getCoverImage = function (lesson, section) {
            if ($scope.currentLessons.status == 0 || lesson.examFlag == 0) {
                return {};
            }
            if (section.mediaType == 0) {
                return {'background-image': 'url(images/class/icon-pdf.png)'};
            } else {
                return {'background-image': 'url(images/class/icon-play.png)'};
            }
        };

        $scope.getCoverText = function (lesson) {
            if ($scope.currentLessons.status == 0 || lesson.examFlag == 0) {
                return "未开始学习";
            }
            else {
                return "";
            }
        };

        var TOTAL_BG_SIZE = 1;

        $scope.getBackgroundImage = function (section) {
            if (section.mediaType == 0) {
                return "images/class/doc_bg_" + hashRing(section.name, TOTAL_BG_SIZE) + ".jpg";
            }
            else {
                return "images/class/video_bg.jpg";
            }
        };

        function hashRing(str, ring) {
            var hash_value = hashCode(str);
            return Math.abs(hash_value) % ring;
        }

        function isNull(str) {
            return str == null || str.value == "";
        }

        /**
         * java String hashCode 的实现
         * @param strKey
         * @return intValue
         */
        function hashCode(strKey) {
            var hash = 0;
            if (!isNull(strKey)) {
                for (var i = 0; i < strKey.length; i++) {
                    hash = hash * 31 + strKey.charCodeAt(i);
                    hash = intValue(hash);
                }
            }
            return hash;
        }

        /**
         * 将js页面的number类型转换为java的int类型
         * @param num
         * @return intValue
         */
        function intValue(num) {
            var MAX_VALUE = 0x7fffffff;
            var MIN_VALUE = -0x80000000;
            if (num > MAX_VALUE || num < MIN_VALUE) {
                return num &= 0xFFFFFFFF;
            }
            return num;
        }
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.publesson')
        .controller('PubLessonCtrl', PubLessonCtrl)
        .directive("myScroll", function ($window) {
            return function(scope, element, attrs) {
                angular.element($window).bind("scroll", function() {
                    // console.log('scroll = ' + this.pageYOffset);
                    // scope.scrollChange();
                    // scope.$apply();
                });
            };
        });

    function PubLessonCtrl($scope, $rootScope, $window, $location, $timeout, $anchorScroll, $stateParams, $log, $http, $state, ProfileService, TokenService, modalService, EncryptService) {
        $log.info('refresh open lessons ');
        $scope.lessontype = $stateParams.groupId;
        $scope.currentpage = $stateParams.currentPage;
        $scope.yPosition = $stateParams.yPosition == null?0:parseInt($stateParams.yPosition);
        $scope.totalCount = 0;


        $scope.tableState = {};
        $scope.getClassPic = function (class_type) {
            if (class_type == '0')//文档
                return "images/home/word.png";
            if (class_type == "1")//视频内容
                return "images/home/video.png";
            if (class_type == "2")//word文档
                return "images/home/word.png";
        }

        $scope.numPerPage = 8;

        $scope.getIndex = function (index_i) {
            var rets = index_i + parseInt($scope.tableState.pagination.start);
            return rets;
        }
        var ctrl = $scope;

        ctrl.currentGroupId = '';//当前公开课组
        $scope.isfirstload = true;

        $scope.publicListens = [{
            lessons: [{
                id: '',
                name: '',
                updateTime: '',
                groupId:'',
                orderId: '',
                totalPeriod: '',
                sections: [{
                    id: '',
                    name: '',
                    picUrl: '',
                    clicks:'',
                    mediaUrl: '',
                    mediaType: '',
                    mediaName: '',
                    period: '',
                    lessonId: ''
                }]
            }], totalCount: ''
        }];
        $scope.callbackPubListen = function (tableState) {
            $log.info("CustomersCtrl: callServer...");
            $scope.tableState = tableState;
            // tableState.pagination.numberOfPages = 5;
            if ($scope.isfirstload && $scope.currentpage != null) {
                tableState.pagination.start = $scope.currentpage;
                ctrl.currentGroupId = $scope.lessontype;
            } else {
                $state.current.reloadOnSearch = false;
                // $location.search('groupId', ctrl.currentGroupId);
                $location.search('currentPage', tableState.pagination.start);
            }
            $scope.isfirstload = false;
            $scope.currentpage = tableState.pagination.start;
            // setPage(2);
            $scope.getOpenLessions();
        };

        function getPageCount(total) {
            return Math.ceil(total / ctrl.numPerPage);
        }

        ctrl.getOpenLessions = function () {
            // ctrl.navigations.isLoading = true;
            var pagination = ctrl.tableState.pagination;
            if(pagination == null)
                return;
            var sort = ctrl.tableState.sort;
            var queryArgs = {
                start: pagination != null ? pagination.start : 0,
                number: $scope.numPerPage,
                // sortby: sort.predicate || 'id',
                sortby: 'orderId',
                // order: sort.reverse ? 'asc' : 'desc',
                order: 'asc',
                groupId: ctrl.currentGroupId
            };


            $http.post(ProfileService.SERVICE_OPEN_LESSONS_QUERY, queryArgs).then(function (response) {
                $scope.publicListens = [];
                $scope.publicListens = response.data;
                $scope.totalCount = response.data.totalCount;
                $scope.tableState.pagination.numberOfPages = getPageCount(response.data.totalCount);
                $timeout(function () {
                    $window.scrollTo(0, $scope.yPosition);
                }, 100);

                // selectPage(2);
            }).catch(function (response) {
            });
        };
        
        $scope.getLessonUrl = function (lessonid, sectionid) {
            //'/lessoncontent/{webtype}/{lessontype}/{currentpage}/{lessonid}/{sectionid}/{courseid}/{yposition}',
            var urls = '/#/lessoncontent/openLesson/'+ ctrl.currentGroupId + '/' +$scope.currentpage + '/' + lessonid + '/' + sectionid + '/open/' + $scope.yPosition;
            return urls;
        }

        $scope.goLesson = function (lessonid, sectionid) {
            // $scope.scrollChange();
            $state.go('lessoncontent', {
                webtype: 'openLesson',
                lessontype: ctrl.currentGroupId,
                currentpage: $scope.currentpage,
                lessonid: lessonid,
                sectionid: sectionid,
                courseid:'open',
                yposition:$scope.yPosition
            });
        }

        ctrl.getClassM = function (id) {
            return {active: ctrl.currentGroupId == id ? true : false};
        }

        ctrl.groupCheck = function (id) {
            ctrl.currentGroupId = id;
            if($scope.tableState != null && $scope.tableState.pagination != null)
                $scope.tableState.pagination.start = 0;
            $state.current.reloadOnSearch = false;
            $location.search('groupId', ctrl.currentGroupId);
            $location.search('currentPage', 0);
            ctrl.getOpenLessions();
        }

        ctrl.scrollChange = function () {
            $state.current.reloadOnSearch = false;
            $location.search('yPosition', $window.pageYOffset);
            $scope.yPosition = $window.pageYOffset;
        }

        ctrl.lessonGroups = [
            // {id:'1',name:'海龟交易基础',createTime:'2017-03-21'},
        ];
        ctrl.getLessonGroups = function () {
            $http.get(ProfileService.SERVICE_OPEN_LESSON_GROUPS_QUERY, '').then(function (response) {
                ctrl.lessonGroups = response.data;
                if ($scope.lessontype == null && ctrl.lessonGroups.length > 0) {
                    ctrl.groupCheck(ctrl.lessonGroups[0].id);
                }
                // selectPage(2);
            }).catch(function (response) {
            });
        }
        ctrl.getLessonGroups();


        ctrl.isGroupShowing = function (group) {
            //如果总项目
            var cur_group_index = -1;
            var active_group_index = -1;
            //遍历查找group
            for(var i = 0; i < ctrl.lessonGroups.length; i++)
            {
                var tmp_group = ctrl.lessonGroups[i];
                if(tmp_group == group)
                {
                    cur_group_index = i;
                }
                if(tmp_group.id == ctrl.currentGroupId)
                {
                    active_group_index = i;
                }
            }
            // console.info("cur_group_index = " + cur_group_index + ", active_group_index = " + active_group_index);
            //如果选中项为第一项，则选中项的后两项都能显示
            //如果选中项为最后一项，则选中项的前2项都能显示
            //如果选中项为中间项，则选中项的左右都能显示
            if(active_group_index == 0)
            {
                if(cur_group_index <= 2)
                {
                    return true;
                }
            }
            else if(active_group_index == ctrl.lessonGroups.length - 1)
            {
                if(cur_group_index >= ctrl.lessonGroups.length - 3)
                {
                    return true;
                }
            }
            else
            {
                if(cur_group_index == active_group_index || cur_group_index == active_group_index - 1 || cur_group_index == active_group_index + 1)
                {
                    return true;
                }
            }
            return false;
        };

        ctrl.isLeftGroupShowing = function () {
            return ctrl.lessonGroups.length > 0 && ctrl.lessonGroups[0].id != ctrl.currentGroupId;
        };

        ctrl.isRightGroupShowing = function () {
            return ctrl.lessonGroups.length > 0 && ctrl.lessonGroups[ctrl.lessonGroups.length - 1].id != ctrl.currentGroupId;
        };

        ctrl.groupCursorLeft = function () {
            if(ctrl.lessonGroups.length > 0 && ctrl.lessonGroups[0].id != ctrl.currentGroupId)
            {
                for(var i = 0; i < ctrl.lessonGroups.length; i++)
                {
                    var tmp_group = ctrl.lessonGroups[i];
                    if(tmp_group.id == ctrl.currentGroupId)
                    {
                        ctrl.groupCheck(ctrl.lessonGroups[i - 1].id);
                        return;
                    }
                }
            }
        };

        ctrl.groupCursorRight = function () {
            if(ctrl.lessonGroups.length > 0 && ctrl.lessonGroups[ctrl.lessonGroups.length - 1].id != ctrl.currentGroupId)
            {
                for(var i = 0; i < ctrl.lessonGroups.length; i++)
                {
                    var tmp_group = ctrl.lessonGroups[i];
                    if(tmp_group.id == ctrl.currentGroupId)
                    {
                        ctrl.groupCheck(ctrl.lessonGroups[i + 1].id);
                        return;
                    }
                }
            }
        };

        ctrl.getGroupContainerClass = function () {
            if(ctrl.lessonGroups.length <= 1)
            {
                return "li-container1";
            }
            else if(ctrl.lessonGroups.length == 2)
            {
                return "li-container2";
            }
            else
            {
                return "li-container3";
            }
        };

        var TOTAL_BG_SIZE = 1;

        $scope.getBackgroundImage = function (section) {
            if (section.mediaType == 0) {
                return "images/class/doc_bg_" + hashRing(section.name, TOTAL_BG_SIZE) + ".jpg";
            }
            else {
                return "images/class/video_bg.jpg";
            }
        };

        ctrl.getCoverImage = function (section) {
            if(section.mediaType == 0){
                return {'background-image': 'url(images/class/icon-pdf.png)'};
            } else {
                return {'background-image': 'url(images/class/icon-play.png)'};
            }
        }

        function hashRing(str, ring) {
            var hash_value = hashCode(str);
            return Math.abs(hash_value) % ring;
        }

        function isNull(str){
            return str == null || str.value == "";
        }

        /**
         * java String hashCode 的实现
         * @param strKey
         * @return intValue
         */
        function hashCode(strKey)
        {
            var hash = 0;
            if(!isNull(strKey))
            {
                for (var i = 0; i < strKey.length; i++)
                {
                    hash = hash * 31 + strKey.charCodeAt(i);
                    hash = intValue(hash);
                }
            }
            return hash;
        }

        /**
         * 将js页面的number类型转换为java的int类型
         * @param num
         * @return intValue
         */
        function intValue(num)
        {
            var MAX_VALUE = 0x7fffffff;
            var MIN_VALUE = -0x80000000;
            if(num > MAX_VALUE || num < MIN_VALUE)
            {
                return num &= 0xFFFFFFFF;
            }
            return num;
        }
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.main')
        .controller('MainCtrl', MainCtrl);

    function MainCtrl($scope, $sce, $window, $http, modalService, $state, $location, $timeout, $anchorScroll, ProfileService, TokenService) {
        $scope.logined = TokenService.isLogin();

        var ctrl = $scope;
        //轮播图模块
        ctrl.navigations = {
            active: 0,
            interval: 5000,
            noWrapSlides: false,
            displayed: [
                {
                    id: 0,
                    image: "images/main_banner.png",
                    noLink: 1,
                    linkUrl: ""
                }
                // {
                //     id: 1,
                //     image: "images/activity/summber_competition.png",
                //     noLink: 0,
                //     linkUrl: ""
                // }
                // {
                //     id: 2,
                //     image: "images/activity/summber_competition_xiamen.png",
                //     noLink: 0,
                //     linkUrl: ""
                // }
            ]
        };
        // ctrl.navigationDisplayed = [];
        // ctrl.navigations.displayed.push({
        //     id: 0,
        //     image: "images/main_banner.png",
        //     noLink: 1,
        //     linkUrl: ""
        // });
        // ctrl.navigations.displayed.push({
        //     id: 1,
        //     image: "images/summber_competition.png",
        //     noLink: 0,
        //     linkUrl: ""
        // });
        
        ctrl.getSlideHerf = function (id) {
            if(id == 1)
            {
                var url = $state.href("activity", {});
                window.open(url, '_blank');
            }
            // if(id == 2)
            // {
            //     var url = $state.href("xmActivity", {});
            //     window.open(url, '_blank');
            // }
        };

        $window.scrollTo(0,0);

        ctrl.goFirm = function () {//实盘交易
            modalService.showInform(
                {
                    size: "md"
                },
                {
                    headerText: '提示',
                    bodyText: "您当前无实盘交易权限！"
                }).then(function () {
            }).catch(function () {
            })
        }

        // ctrl.getNavData = function () {
        //     ctrl.navigations.isLoading = true;
        //     var queryArgs = {
        //         start: 0,
        //         number: 8,
        //         sortby: 'orderId',
        //         order: 'desc'
        //     };
        //
        //     $http.post(ProfileService.SERVICE_NAVIGATION_PIC_QUERY, queryArgs).then(function (response) {
        //         ctrl.navigations.displayed = [];
        //         for (var i = 0; i < response.data.navPics.length; i++) {
        //             var tmp_nav = response.data.navPics[i];
        //             var tmp_content = tmp_nav.content.replace(new RegExp("\n", "g"), "<br>");
        //             ctrl.navigations.displayed.push({
        //                 id: i,
        //                 title: tmp_nav.name,
        //                 content: $sce.trustAsHtml(tmp_content),
        //                 image: tmp_nav.url,
        //                 noLink: tmp_nav.linkType  == 0,
        //                 linkUrl: "#/resources/page_details/main/" + tmp_nav.linkType + "/" + tmp_nav.linkId
        //             });
        //         }
        //         ctrl.navigations.isLoading = false;
        //         ctrl.navigations.isFailed = false;
        //     }).catch(function (response) {
        //         ctrl.navigations.displayed = [];
        //         ctrl.navigations.isLoading = false;
        //         ctrl.navigations.isFailed = true;
        //     });
        // };

        // $scope.getNavData();
        //
        // $location.hash("main-slider");
        // $anchorScroll();

        // var gotoAnchor = function () {
        //     if ($stateParams.anchor == "2") {
        //         $location.hash('bottom');
        //         $anchorScroll();
        //     }
        // };
        //
        // $timeout(function () {
        //     gotoAnchor();
        // }, 100);

        $scope.model = {
            name: 'Tabs'
        };

    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.xmActivity')
        .controller('XmActivityCtrl', XmActivityCtrl)
        .controller('XmJoinCtrl', XmJoinCtrl);

    function XmActivityCtrl($scope, $http, $state, $sce, ProfileService, $interval, TokenCheckService, TokenService, $uibModal, modalService) {
        var ctrl = $scope;
        ctrl.getCompetitionDetails = function () {
            var url = $state.href("xmActivityDetails", {});
            window.open(url, '_blank');
        };

        ctrl.getTradeDetails = function () {
            var url = $state.href("xmActivityTradeDetails", {});
            window.open(url, '_blank');
        };

        ctrl.getPrize = function () {
            var url = $state.href("xmActivityPrize", {});
            window.open(url, '_blank');
        };

        ctrl.navigations = {
            active: 0,
            interval: 5000,
            noWrapSlides: false,
            displayed: [
                {id: 0, image: "images/activity/xmPrize1.png"},
                {id: 1, image: "images/activity/xmPrize2.png"},
                {id: 2, image: "images/activity/xmPrize3.png"},
                {id: 3, image: "images/activity/xmPrize4.png"}
            ]
        };
        // ctrl.navigations.displayed.push({
        //     id: 0,
        //     image: "images/activity/prize.png"
        // });
        // ctrl.navigations.displayed.push({
        //     id: 1,
        //     image: "images/activity/prize1.png"
        // });

        //轮播图模块
        // ctrl.navigations = {
        //     active: 0,
        //     interval: 5000,
        //     noWrapSlides: false,
        //     displayed: []
        // };
        // ctrl.navigationDisplayed = [];
        // ctrl.navigations.displayed.push({
        //     id: 0,
        //     image: "images/main_banner.png",
        //     noLink: 1,
        //     linkUrl: ""
        // });
        // ctrl.navigations.displayed.push({
        //     id: 1,
        //     image: "images/summber_competition.png",
        //     noLink: 0,
        //     linkUrl: ""
        // });

        ctrl.joinSrc = "images/activity/xmJoin.png";
        ctrl.university = {
            id : 0,
            name: ""
        };
        var getData = function () {
            if (TokenService.user.userId == 0) {
                return;
            }
            $http.get(ProfileService.SERVER_HOST + "users/" + TokenService.user.userId + "/university").
            then(function (response) {
                $scope.university = response.data;
                if($scope.university.id != 0)
                {
                    if($scope.university.regionType == 2)
                    {
                        ctrl.joinSrc = "images/activity/joined.png";
                    }
                    else
                    {
                        ctrl.joinSrc = "images/activity/joinedOther.png";
                    }
                }
            }).
            catch(function (response) {
            });
        }
        getData();

        ctrl.join = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            else
            {
                if($scope.university.id != 0)
                {
                    // if($scope.university.regionType != 2)
                    // {
                    //     modalService.showInform({}, {headerText: "已报名", bodyText:"您已经在其他地区报过名，禁止重复参赛"});
                    // }
                    return;
                }
                var modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    keyboard: true,
                    templateUrl: 'app/pages/activity/selectUniversity.html',
                    controller: 'XmJoinCtrl',
                    //sm md lg
                    size: 'sm',
                    resolve: {
                        modalOptions:{
                            closeButtonText: '取消',
                            actionButtonText: '确定',
                            headerText: '选择您所在高校',
                            bodyText: '',
                            alertStyle: 'primary'
                        }
                    }
                });

                modalInstance.result.then(function (selectedItem) {
                    getData();
                }, function () {
                });
            }
        }

    }

    function XmJoinCtrl($scope, $uibModalInstance, $http,$log, modalOptions, modalService, TokenService, ProfileService) {
        $scope.selectedUniversity =
        {
            id: 0,
            name: ""
        };
        $scope.universities = [];

        var getData = function () {
            $http.get(ProfileService.SERVER_HOST + "users/universities?type=2").
            then(function (response) {
                $log.info("查询成功...");
                $scope.universities = response.data;
            }).
            catch(function (response) {
                $log.info('查询失败...');
            });
        }
        getData();
        
        $scope.selectUniversity = function (university) {
            $scope.selectedUniversity = university;
        }

        $scope.modalOptions = modalOptions;

        $scope.modalOptions.ok = function (result) {
            result = 'ok';

            var confirmModalOptions = {
                closeButtonText: '取消',
                actionButtonText: '确认',
                bodyText: "请您确认您所选的高校：<font color='red'>" + $scope.selectedUniversity.name + "</font>，确认后不可修改",
                alertStyle: 'warning'
            };
            modalService.showConfirmModal({}, confirmModalOptions).then(function (result) {
                $http.post(ProfileService.SERVER_HOST + "users/" + TokenService.user.userId + "/university", $scope.selectedUniversity).then(function (response) {
                    $uibModalInstance.close(result);
                }).catch(function (response) {
                    modalService.showInform({}, {bodyText: '选择所属高校失败：' + response.data.error + "!"});
                });
            });
        };
        $scope.modalOptions.close = function (result) {
            result = 'cancel';
            $uibModalInstance.dismiss(result);
        };
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.bigData.scoreData')
        .controller('ScoreDataCtrl', ScoreDataCtrl);

    function ScoreDataCtrl($scope, $stateParams, $state, $http, $filter, ProfileService, TokenCheckService) {
        var ctrl = $scope;

        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.firstLoad = true;
        ctrl.displayed = [];
        //单页数量
        ctrl.itemsByPage = 30;
        //总数量
        ctrl.totalItemCount = 0;

        var stringToDate = function (str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2]);
        };

        ctrl.filterArgs = {
            dateOptions: {
                startingDay: 1,
                showWeeks: false
            },
            dateFormat: "yyyy-MM-dd",
            openFromPicker: false,
            fromDate: $stateParams.fromDate ? stringToDate($stateParams.fromDate) : new Date(new Date() - 30 * 24 * 60 * 60 * 1000),
            openToPicker: false,
            toDate: $stateParams.toDate ? stringToDate($stateParams.toDate) : new Date(),
            altDateInputFormats: ['yyyy-M!-d!']
        };

        ctrl.searchArgs = {
            fromDate: ctrl.filterArgs.fromDate,
            toDate: ctrl.filterArgs.toDate
        };

        ctrl.displayedData = {
            scoreData: []
        };

        ctrl.openFromPicker = function () {
            ctrl.filterArgs.openFromPicker = true;
        };

        ctrl.openToPicker = function () {
            ctrl.filterArgs.openToPicker = true;
        };

        ctrl.onToDateChanged = function () {
            if (ctrl.filterArgs.toDate < ctrl.filterArgs.fromDate) {
                ctrl.filterArgs.fromDate = ctrl.filterArgs.toDate;
            }
        };

        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(start) {
            for (var i = 0; i < ctrl.displayed.length; i++) {
                ctrl.displayed[i].index = start + i + 1;
            }
        }

        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            ctrl.getData();
        };

        $scope.getData = function (reset_page) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            if (reset_page) {
                ctrl.tableState.pagination.start = 0;
                ctrl.searchArgs.fromDate = ctrl.filterArgs.fromDate;
                ctrl.searchArgs.toDate = ctrl.filterArgs.toDate;
            }
            var pagination = ctrl.tableState.pagination;
            var sort = ctrl.tableState.sort;
            var queryArgs = {
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: 'createDate',
                order: 'desc',
                fromDate: $filter('date')(ctrl.filterArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.filterArgs.toDate, 'yyyy-MM-dd')
            };

            $state.go($state.current.name, {
                fromDate: queryArgs.fromDate,
                toDate: queryArgs.toDate,
                start: pagination.start
            }, {
                notify: false,
                location: ctrl.firstLoad ? "replace" : true,
                inherit: true
            });
            ctrl.firstLoad = false;

            $http.get(ProfileService.SERVICE_SCORE_QUERY + "?start=" +
                queryArgs.start + "&number=" + queryArgs.number +
                "&sortby=" + queryArgs.sortby + "&order=" + queryArgs.order +
                "&from_date=" + queryArgs.fromDate + "&to_date=" + queryArgs.toDate).then(function (response) {
                ctrl.displayed = response.data.userCredits;
                ctrl.totalItemCount = response.data.totalCount;
                pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
                addIndex(queryArgs.start);
            }).catch(function (response) {
                ctrl.displayed = [];
                pagination.numberOfPages = 1;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        ctrl.getValueStyle = function (value) {
            return {color: value >= 0 ? '#c52d2f' : '#088205'};
        };

        ctrl.getItemHref = function (item) {
            return $state.href('bigData.scoreDetails', {
                id: item.id,
                fromDate: $filter('date')(ctrl.filterArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.filterArgs.toDate, 'yyyy-MM-dd'),
                start: ctrl.tableState ? ctrl.tableState.pagination.start : 0
            });
        };

        ctrl.getGobackHref = function () {
            return $state.href('bigData.tradeData', {});
        };
    }
})();
(function () {

    'use strict';

    angular.module('myApp.pages.bigData.tradeData')
        .controller('TradeDataCtrl', TradeDataCtrl);

    function TradeDataCtrl($scope, $http, $filter, ProfileService, TokenCheckService, TokenService, $q) {
        var ctrl = $scope;

        //流程上，我们先加载概况，如果加载失败，则不会有下面的列表
        //加载概况标志
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.errorMessage = "";

        ctrl.displayedTotal = {
            surveyData: {}, //score, rank, date, codeSurveys, codes
            displayedTotalCode: []
        };

        ctrl.filterArgs = {
            selectCode: "",
            supportCodes: [],
            selectPeriod: "",
            supportPeriods: [],
            dateOptions: {
                startingDay: 1,
                dateDisabled: disabledDate,
                // class: 'datepicker'
                showWeeks: false

            },
            dateFormat: "yyyy-MM-dd",
            openPicker: false,
            selectDate: new Date(),
            altDateInputFormats: ['yyyy-M!-d!']
        };

        Date.prototype.yyyymmdd = function() {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            return [this.getFullYear(),'-',
                (mm>9 ? '' : '0') + mm,'-',
                (dd>9 ? '' : '0') + dd
            ].join('');
        };

        function disabledDate(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }


        ctrl.searchArgs = {
            selectCode: "",
            type: 1,
            date: ""
        };

        ctrl.openPicker = function () {
            ctrl.filterArgs.openPicker = true;
        };

        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        var parseTotalCode = function () {
            ctrl.displayedTotal.displayedTotalCode = [];
            //如果无记录，则生成一条未配置的记录
            if (!ctrl.displayedTotal.surveyData.codeSurveys || ctrl.displayedTotal.surveyData.codeSurveys.length == 0) {
                ctrl.displayedTotal.displayedTotalCode.push({
                    firstCode: true,
                    rowSpan: 1,
                    target: ctrl.displayedTotal.surveyData,
                    code: "----",
                    profitRate: "----",
                    profitAmount: "----"
                });
            }
            else {
                var first_code = true;
                for (var code_id = 0; code_id < ctrl.displayedTotal.surveyData.codeSurveys.length; code_id++) {
                    var code = ctrl.displayedTotal.surveyData.codeSurveys[code_id];
                    ctrl.displayedTotal.displayedTotalCode.push({
                        firstCode: first_code,
                        rowSpan: ctrl.displayedTotal.surveyData.codeSurveys.length,
                        target: ctrl.displayedTotal.surveyData,
                        code: code.code,
                        profitRate: code.tradeFlag == 1 ? code.profitRate : "----",
                        profitAmount: code.tradeFlag == 1 ? code.profitAmount : "----"
                    });
                    first_code = false;
                }
            }
        };

        var makeFilters = function () {
            // ctrl.filterArgs.supportCodes = ["sh600000", "sh600015", "sh150270"];
            // ctrl.filterArgs.selectCode = ctrl.filterArgs.supportCodes[0];
            ctrl.filterArgs.supportPeriods = ["日", "周", "月", "季", "年", "所有"];
            ctrl.filterArgs.selectPeriod = ctrl.filterArgs.supportPeriods[0];

            ctrl.filterArgs.selectDate = new Date();
            //生成当日查询条件。我们选择当日有交易的第一只股票，如果没有，则选择历史第一只
            ctrl.filterArgs.supportCodes = ctrl.displayedTotal.surveyData.codes ? ctrl.displayedTotal.surveyData.codes : [];
            ctrl.filterArgs.selectCode = null;
            if (ctrl.filterArgs.supportCodes.length > 0) {
                ctrl.filterArgs.selectCode = ctrl.filterArgs.supportCodes[0];
            }
            var tmp_code = "";
            for (var i = 0; i < ctrl.displayedTotal.surveyData.codeSurveys.length; i++) {
                if (ctrl.displayedTotal.surveyData.codeSurveys[i].tradeFlag == 1) {
                    tmp_code = ctrl.displayedTotal.surveyData.codeSurveys[i].code;
                    break;
                }
            }
            if (tmp_code) {
                for (var i = 0; i < ctrl.filterArgs.supportCodes.length; i++) {
                    if (ctrl.filterArgs.supportCodes[i].code == tmp_code) {
                        ctrl.filterArgs.selectCode = ctrl.filterArgs.supportCodes[i];
                    }
                }
            }
            ctrl.onSelectPeriodChanged();
            ctrl.onSelectCodeChanged();
        };

        $scope.onSelectPeriodChanged = function () {
            if (ctrl.filterArgs.selectPeriod == ctrl.filterArgs.supportPeriods[0]) {
                ctrl.filterArgs.dateOptions.minMode = "day";
                ctrl.filterArgs.dateOptions.datepickerMode = "day";
                ctrl.filterArgs.dateOptions.customClass = null;
            }
            else if (ctrl.filterArgs.selectPeriod == ctrl.filterArgs.supportPeriods[1]) {
                ctrl.filterArgs.dateOptions.minMode = "day";
                ctrl.filterArgs.dateOptions.datepickerMode = "day";
                ctrl.filterArgs.dateOptions.customClass = getWeekPickerClass;
            }
            else if (ctrl.filterArgs.selectPeriod == ctrl.filterArgs.supportPeriods[2]) {
                ctrl.filterArgs.dateOptions.minMode = "month";
                ctrl.filterArgs.dateOptions.datepickerMode = "month";
                ctrl.filterArgs.dateOptions.customClass = null;
            }
            else if (ctrl.filterArgs.selectPeriod == ctrl.filterArgs.supportPeriods[3]) {
                ctrl.filterArgs.dateOptions.minMode = "month";
                ctrl.filterArgs.dateOptions.datepickerMode = "month";
                ctrl.filterArgs.dateOptions.customClass = getSeasonPickerClass;
            }
            else if (ctrl.filterArgs.selectPeriod == ctrl.filterArgs.supportPeriods[4]) {
                ctrl.filterArgs.dateOptions.minMode = "year";
                ctrl.filterArgs.dateOptions.datepickerMode = "year";
                ctrl.filterArgs.dateOptions.customClass = null;
            }
            else {
                ctrl.filterArgs.dateOptions.minMode = "day";
                ctrl.filterArgs.dateOptions.datepickerMode = "day";
                ctrl.filterArgs.dateOptions.customClass = null;
            }
        };

        var getWeekPickerClass = function (data) {
            //一天的毫秒数
            var millisecond = 1000 * 60 * 60 * 24;
            var date = data.date;
            var mode = data.mode;
            if (mode == 'day') {
                //返回date是一周中的某一天
                var week = date.getDay();
                //返回date是一个月中的某一天
                var month = date.getDate();
                //减去的天数
                var minusDay = week != 0 ? week - 1 : 6;
                var tmp_date = new Date(date.getTime() - (millisecond * minusDay));

                week = ctrl.filterArgs.selectDate.getDay();
                month = ctrl.filterArgs.selectDate.getDate();
                minusDay = week != 0 ? week - 1 : 6;
                var tmp_select_date = new Date(ctrl.filterArgs.selectDate.getTime() - (millisecond * minusDay));

                if (tmp_date.getTime() == tmp_select_date.getTime()) {
                    return 'range-selected';
                }
            }
            return '';
        };

        var getSeasonPickerClass = function (data) {
            var date = data.date;
            var mode = data.mode;
            if (mode == 'month') {
                if (date.getYear() == ctrl.filterArgs.selectDate.getYear() && parseInt(ctrl.filterArgs.selectDate.getMonth() / 3) == parseInt(date.getMonth() / 3)) {
                    return 'range-selected';
                }
            }
            return '';
        };

        $scope.onSelectCodeChanged = function () {
            ctrl.filterArgs.dateOptions.minDate = stringToDate(ctrl.filterArgs.selectCode.firstTradeDay);
            ctrl.filterArgs.dateOptions.maxDate = stringToDate(ctrl.filterArgs.selectCode.lastTradeDay);
            ctrl.filterArgs.selectDate = ctrl.filterArgs.dateOptions.maxDate;
        };

        $scope.getData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isFailed = false;
            ctrl.isLoading = true;
            $http.get(ProfileService.SERVICE_CALC_SURVEY).then(function (response) {
                ctrl.displayedTotal.surveyData = response.data;
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                ctrl.displayedTotal.surveyData = {};
                ctrl.isLoading = false;
                ctrl.isFailed = true;
                ctrl.errorMessage = ((response.data && response.data.error) ? response.data.error : "");
            }).finally(function () {
                parseTotalCode();
                makeFilters();
                ctrl.getDetailData();
                // $scope.getMarkData();
            });

        };
        $scope.getData();

        ctrl.navIndex = 0;

        ctrl.displayedNavigation = [
            {index: 0, title: "交易概况"},
            {index: 1, title: "盈利能力"},
            {index: 2, title: "风控能力"},
            {index: 3, title: "交易能力"},
            {index: 4, title: "交易标记"}
        ];

        ctrl.getNavClass = function (index) {
            return {active: ctrl.navIndex == index};
        };

        ctrl.selectNavigation = function (index) {
            ctrl.navIndex = index;
        };

        ctrl.headImgUrl = TokenService.user.headPicUrl ? TokenService.user.headPicUrl : 'images/turtle/default_header.png';
        //交易数据
        ctrl.displayedData = {
            isLoading: false,
            isFailed: false,
            errorMessage: "",
            detail: {},
            // detail: {
            //     code: "150172",
            //     firstTradeDay: "2017-05-18",
            //     profitRate: 11.1,
            //     rank: 21,
            //     profitAmount: 1777.21,
            //     matchAmount: 24531.12,
            //     posMarketValue: 51126.12,
            //     yearProfitRate: 372.12,
            //     loseWinRate: 0.20,
            //     winRate: 63,
            //     turnoverRate: 40.00,
            //     totalWinDays: 53,
            //     totalLoseDays: 27,
            //     maxWinDays: 23,
            //     maxLoseDays: 3,
            //     changeVolume: -200,
            //     avgWinDuration: 13.0,
            //     avgLoseDuration: 21.0,
            //     sharpRate: 270.12,
            //     profitVar: 0.022,
            //     drawDown: 23.21,
            //     orderCount: 100,
            //     cancelCount: 20,
            //     matchCount: 80,
            //     winAmount: 1300,
            //     loseAmount: 100,
            //
            //     chart: [], //{date: "2017-05-18", user : [profitRate, profitAmount, matchAmount, winRate, turnoverRate, orderCount], avg: [xxxxx]}
            //
            //     //收益率整体统计数据
            //     profitRateBar: {}, //{level: [], count: []}
            //     profitAmountBar: {},
            //     winRateBar: {},
            //     turnoverRateBar: {},
            //     winDaysBar: {},
            //     loseDaysBar: {},
            //     orderCountBar: {}
            // },

            lineChartProfitRate: {},
            lineChartProfitAmount: {},
            lineChartMatchAmount: {},
            lineChartWinRate: {},
            lineChartTurnoverRate: {},
            lineChartOrderCount: {},


            barChartProfitRate: {}, //收益率
            barChartProfitAmount: {}, //收益金额
            barChartMatchAmount: {}, //成交金额
            barChartWinRate: {}, //胜率
            barChartTurnoverRate: {}, //周转率
            barChartWinDays: {}, //盈利天数
            barChartLoseDays: {}, //亏损天数
            barChartOrderCount: {} //下单笔数
        };

        ctrl.getValueStyle = function (value) {
            return {color: value > 0 ? '#c52d2f' : '#088205'};
        };

        ctrl.getRatioValueStyle = function (value) {
            return {color: value < 1 ? '#c52d2f' : '#088205'};
        };

        ctrl.getPercentageValueStyle = function (value) {
            return {color: (value * 100) > 50 ? '#c52d2f' : '#088205'};
        };

        ctrl.getEqualValueStyle = function (value, target) {
            return {color: value == target ? '#c52d2f' : '#088205'};
        };

        var convertToLineChartSeries = function (data_dict, key, index, multiple, digit) {
            var result_dict = [];
            var tmp_digit = 1;
            for(var i = 0; i < digit; i++)
            {
                tmp_digit *= 10;
            }
            for (var i = 0; i < data_dict.length; i++) {
                var tmp_y = multiple ? (data_dict[i][key][index] * multiple) : data_dict[i][key][index];
                tmp_y = Math.round(tmp_y * tmp_digit) / tmp_digit;
                var chart_value = [tmp_y, data_dict[i].date];
                result_dict.push(chart_value);
            }
            return result_dict;
        };

        var makeLineChart = function (title, y_text, suffix, index, digit) {
            if (!ctrl.displayedData.detail.chart) {
                return {};
            }
            if(!digit)
            {
                digit = 2;
            }
            return {
                title: {
                    text: title,
                    x: -20
                },
                xAxis: {
                    labels: {
                        formatter: function () {
                            if (ctrl.displayedData.detail.chart[this.value]) {
                                return ctrl.displayedData.detail.chart[this.value].date;
                            }
                            else {
                                return "";
                            }
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: y_text
                    },
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#808080'
                    }]
                },
                tooltip: {
                    valueSuffix: suffix,
                    shared: true,
                    headerFormat: '<span style="font-size: 12px; line-height: 18px">日期：{point.point.date}</span><br/>'
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle',
                    borderWidth: 0
                },
                credits: {
                    enabled: false
                },
                series: [{
                    keys: ['y', 'date'],
                    name: '个人数据',
                    data: convertToLineChartSeries(ctrl.displayedData.detail.chart, "user", index, suffix == "%" ? 100 : 1, digit)
                }, {
                    keys: ['y', 'date'],
                    name: '人均数据',
                    data: convertToLineChartSeries(ctrl.displayedData.detail.chart, "avg", index, suffix == "%" ? 100 : 1, digit),
                    color: '#c52d2f'
                }]
            };
        };

        var convertToBarChartRange = function (resource_data, personal_value, suffix, digit) {
            var result_dict = [];
            var personal_location = "";
            for (var i = 0; i < resource_data.levels.length; i++) {
                var range_value = resource_data.levels[i];
                if (suffix == "%") {
                    range_value = $filter('number')(range_value * 100, digit) + "%";
                }
                if (i == 0) {
                    range_value = "<= " + range_value;
                    if (personal_value <= resource_data.levels[0]) {
                        personal_location = range_value;
                    }
                }
                else if (i == resource_data.levels.length - 1) {
                    var pre_value = resource_data.levels[i - 1];
                    if (suffix == "%") {
                        pre_value = $filter('number')(pre_value * 100, digit) + "%";
                    }
                    range_value = "> " + pre_value;
                    if (personal_value > resource_data.levels[i - 1]) {
                        personal_location = range_value;
                    }
                }
                else {
                    var pre_value = resource_data.levels[i - 1];
                    if (suffix == "%") {
                        pre_value = $filter('number')(pre_value * 100, digit) + "%";
                    }
                    //下一个值为-1，表示当前区间已经是最后一个
                    if (resource_data.counts[i + 1] == -1) {
                        range_value = "> " + pre_value;
                        if (personal_value > resource_data.levels[i - 1]) {
                            personal_location = range_value;
                        }
                    }
                    else {
                        range_value = pre_value + " ~ " + range_value;
                        if (personal_value > resource_data.levels[i - 1] && personal_value <= resource_data.levels[i]) {
                            personal_location = range_value;
                        }
                    }
                }
                result_dict.push(range_value);
                if (i < resource_data.levels.length - 1 && resource_data.counts[i + 1] == -1) {
                    break;
                }
            }
            return [result_dict, personal_location];
        };

        var convertToBarChartSeriesData = function (resource_data) {
            var count_dict = [];
            var result_dict = []; //'y', 'count', 'total'
            var total_count = 0;
            for (var i = 0; i < resource_data.levels.length; i++) {
                var cur_count = resource_data.counts[i];
                if (cur_count >= 0) {
                    total_count += cur_count;
                    count_dict.push(cur_count);
                }
                if (i < resource_data.levels.length - 1 && resource_data.counts[i + 1] == -1) {
                    break;
                }
            }
            //转换成比例
            for (var i = 0; i < count_dict.length; i++) {
                var cur_count = count_dict[i];
                result_dict.push([total_count > 0 ? (cur_count * 100 / total_count) : 0, cur_count, total_count]);
            }
            return result_dict;
        };

        var makeBarChart = function (title, suffix, bar_data, personal_value, digit) {
            if (!bar_data) {
                return {};
            }
            if(!digit)
            {
                digit = 2;
            }
            var range_data = convertToBarChartRange(bar_data, personal_value, suffix, digit);
            return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: title
                },
                xAxis: {
                    categories: range_data[0],
                    title: {
                        text: null
                    },
                    reversed: false
                },
                yAxis: {
                    min: 0,
                    title: {
                        // text: "比例 (%)",
                        text: "",
                        align: 'high'
                    },
                    labels: {
                        overflow: 'justify',
                        formatter: function () {
                            // return $filter('number')(this.value, 2) + "%";
                            return "";
                        }
                    }
                },
                tooltip: {
                    valueSuffix: "%",
                    useHTML: true,
                    // backgroundColor: "rgba(255,255,255,1)",
                    formatter: function () {
                        var s = '<b>区间: ' + this.x + '</b>';
                        s = s + "<br/>数量: " + this.point.count + " / " + this.point.total;
                        s = s + "<br/>" + this.series.name + ": " + $filter('number')(this.y, 2) + "%";
                        if (range_data[1] == this.x) {
                            var cur_value = personal_value;
                            if (suffix == "%") {
                                cur_value = $filter('number')(cur_value * 100, digit) + "%";
                            }
                            s = s + "<br/>你在这里，为 " + cur_value;
                        }
                        return ("<div class='tooltip-body'>" + s + "</div>");
                    }
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true,
                            useHTML: true,
                            zIndex: 0,
                            formatter: function () {
                                var cur_html = "<span style='line-height: 32px'>" + $filter('number')(this.y, 2) + "%</span>";
                                // var cur_html = "";
                                if (range_data[1] == this.x) {
                                    cur_html = cur_html + "<img src=" + ctrl.headImgUrl + " style='border-radius: 50%; max-height: 32px; margin-left: 4px'/>";
                                }
                                return cur_html;
                            }
                        }
                    }
                },
                legend: {
                    enabled: false
                },
                // labels: {
                //     x: "50%",
                //     y: "50%",
                //     style: {
                //         "text-anchor": "middle",
                //         "color": "#aaa",
                //         "fontSize": '36px',
                //         "fontWeight": 'bold',
                //         // "text-align": "center"
                //     },
                //     items: [{
                //         html: '小牛实习生'
                //     }]
                // },
                credits: {
                    enabled: false
                    // href: "",
                    // position: {
                    //     align: "center",
                    //     verticalAlign: "middle"
                    // },
                    // style: {
                    //     "cursor": "none",
                    //     "fontSize": "36px",
                    //     "z-index": "-1"
                    // }
                },
                series: [{
                    keys: ['y', 'count', 'total'],
                    name: "比例",
                    data: convertToBarChartSeriesData(bar_data)
                }]
            };
        };

        //生成交折线对比图
        var createCharts = function () {

            ctrl.displayedData.lineChartProfitRate = makeLineChart("收益率折线对比图", "收益率 (%)", "%", 0, 3);
            ctrl.displayedData.lineChartProfitAmount = makeLineChart("操作盈亏折线对比图", "操作盈亏 (元)", "元", 1);
            ctrl.displayedData.lineChartMatchAmount = makeLineChart("成交金额折线对比图", "成交金额 (元)", "元", 2);
            ctrl.displayedData.lineChartWinRate = makeLineChart("胜率折线对比图", "胜率 (%)", "%", 3);
            ctrl.displayedData.lineChartTurnoverRate = makeLineChart("周转率折线对比图", "周转率 (%)", "%", 4);
            ctrl.displayedData.lineChartOrderCount = makeLineChart("挂单笔数折线对比图", "挂单笔数 (笔)", "笔", 5);

            ctrl.displayedData.barChartProfitRate = makeBarChart("收益率亏分布对比图", "%", ctrl.displayedData.detail.profitRateBar, ctrl.displayedData.detail.profitRate, 3);
            ctrl.displayedData.barChartProfitAmount = makeBarChart("操作盈亏分布对比图", "", ctrl.displayedData.detail.profitAmountBar, ctrl.displayedData.detail.profitAmount);
            ctrl.displayedData.barChartMatchAmount = makeBarChart("成交金额分布对比图", "", ctrl.displayedData.detail.matchAmountBar, ctrl.displayedData.detail.matchAmount);
            ctrl.displayedData.barChartWinRate = makeBarChart("胜率分布对比图", "%", ctrl.displayedData.detail.winRateBar, ctrl.displayedData.detail.winRate);
            ctrl.displayedData.barChartTurnoverRate = makeBarChart("周转率分布对比图", "%", ctrl.displayedData.detail.turnoverRateBar, ctrl.displayedData.detail.turnoverRate);
            ctrl.displayedData.barChartWinDays = makeBarChart("连盈天数分布对比图", "", ctrl.displayedData.detail.winDaysBar, ctrl.displayedData.detail.winDays);
            ctrl.displayedData.barChartLoseDays = makeBarChart("连亏天数分布对比图", "", ctrl.displayedData.detail.loseDaysBar, ctrl.displayedData.detail.loseDays);
            ctrl.displayedData.barChartOrderCount = makeBarChart("下单笔数分布对比图", "", ctrl.displayedData.detail.orderCountBar, ctrl.displayedData.detail.orderCount);
        };

        $scope.getDetailData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.displayedData.isFailed = false;
            ctrl.displayedData.isLoading = true;

            ctrl.searchArgs.selectCode = ctrl.filterArgs.selectCode;
            ctrl.searchArgs.type = ctrl.filterArgs.supportPeriods.indexOf(ctrl.filterArgs.selectPeriod) + 1;
            ctrl.searchArgs.date = $filter('date')(ctrl.filterArgs.selectDate, 'yyyy-MM-dd');

            $http.get(ProfileService.SERVICE_CALC_TRADE + "?code=" + ctrl.searchArgs.selectCode.code + "&type=" + ctrl.searchArgs.type + "&date=" + ctrl.searchArgs.date).then(function (response) {
                ctrl.displayedData.detail = response.data;
                ctrl.displayedData.isLoading = false;
                ctrl.displayedData.isFailed = false;
                createCharts();
            }).catch(function (response) {
                ctrl.displayedData.detail = {};
                ctrl.displayedData.errorMessage = ((response.data && response.data.error) ? response.data.error : "");
                ctrl.displayedData.isLoading = false;
                ctrl.displayedData.isFailed = true;
            }).finally(function () {
                $scope.getMarkCodes(ctrl.searchArgs.date);

            });
        };


        var stringToDate = function (str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2]);
        };

        var setTest = function () {
            ctrl.displayedTotal = {
                createDate: "2017-05-18",
                score: 1280,
                rank: 31,
                codes: [{code: "150172", profitRate: 51, profitAmount: 1231.1}, {
                    code: "150187",
                    profitRate: -10,
                    profitAmount: -213.11
                }]
            };
            parseTotalCode();

            ctrl.filterArgs.supportCodes = ["150172", "150187"];
            ctrl.filterArgs.selectCode = ctrl.filterArgs.supportCodes[0];

            ctrl.filterArgs.supportPeriods = ["日", "周", "月", "季", "年", "至今"];
            ctrl.filterArgs.selectPeriod = ctrl.filterArgs.supportPeriods[0];

            ctrl.displayedData.data_personal = [];
            ctrl.displayedData.data_total = [];
            for (var i = 0; i < 30; i++) {
                var day_string = i % 30 + 1;
                day_string = day_string < 10 ? ("0" + day_string) : ("" + day_string);
                var month_string = parseInt(i / 30) + 1;
                month_string = month_string < 10 ? ("0" + month_string) : ("" + month_string);
                var tmp_value = {
                    tradeDate: "2016-" + month_string + "-" + day_string,
                    profitAmount: makeRandomPriceValue(),
                    matchAmount: makeRandomPriceValue() + 1000,
                    profitRate: makeRandomRateValue(),
                    winRate: makeRandomRateValue(),
                    turnoverRate: makeRandomRateValue(),
                    orderCount: makeRandomPriceValue() + 200
                };
                if (Math.random() * 100 >= 10) {
                    ctrl.displayedData.data_personal.push(tmp_value);
                    var relate_value = {
                        tradeDate: tmp_value.tradeDate,
                        profitAmount: tmp_value.profitAmount + makeRandomPriceValue(),
                        matchAmount: tmp_value.matchAmount + makeRandomPriceValue(),
                        profitRate: makeRandomRateValue(),
                        winRate: makeRandomRateValue(),
                        turnoverRate: makeRandomRateValue(),
                        orderCount: tmp_value.orderCount + makeRandomPriceValue()
                    };
                    ctrl.displayedData.data_total.push(relate_value);
                }
            }

            ctrl.displayedData.data_total_profitAmount = [
                {range: null, value: makeRandomPriceValue() + 100},
                {range: 100, value: makeRandomPriceValue() + 200},
                {range: 300, value: makeRandomPriceValue() + 300},
                {range: 500, value: makeRandomPriceValue() + 400},
                {range: 700, value: makeRandomPriceValue() + 300},
                {range: 900, value: makeRandomPriceValue() + 200},
                {range: 1100, value: makeRandomPriceValue() + 100}
            ];

            createLineChart();
        };

        var makeRandomPriceValue = function () {
            return Math.random() * 100 - 50;
        };

        var makeRandomRateValue = function () {
            return parseInt(Math.random() * 100 - 50);
        };
        //setTest();


        /////////////////////////////////////交易标记
        $scope.stockCodesDic = {};
        $scope.getMarkCodes = function (datestr) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            var urls = ProfileService.CALC_SERVER_HOST + 'his_codes?date='+ datestr;
            $http.get(urls).then(function (response) {
                // $scope.stockList.splice(0);
                for(var i in response.data.codes) {
                    var cxx = response.data.codes[i];
                    $scope.stockCodesDic[cxx.code] = cxx;
                }
                $scope.getMarkData();
                // $scope.getMinuteTicks();
            }).catch(function (response) {
            });
        };
        // $scope.getMarkCodes('');

        $scope.$watch('filterArgs.selectDate', function (newVal, oldVal) {
            $scope.chartConfig.title.text = $scope.filterArgs.selectDate.yyyymmdd() + '日交易标记';
            // console.info('date = ' + newVal.yyyymmdd());
            // $scope.getMarkCodes(newVal.yyyymmdd());
            // $scope.initPointLine();
        });


        //浮点数转字符串，精确小数点后length位
        $scope.toStringEx = function (x, length) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return '';
            }
            var f = Math.round(x * Math.pow(10, length)) / Math.pow(10, length);
            var s = f.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + length) {
                s += '0';
            }
            return s;
        }

        /***************分时图******************/
        $scope.minuteTicks = {code:'', xValue:0, type:'0', tagMode: 1, preClose:0, openPrice:0, highLimit:0, lowLimit:0, datas:[]};//分时数据 tagMode 1委托和成交；2委托；3成交
        $scope.showTicks = [];

        $scope.getTitle = function () {
            var title = '';
            if($scope.filterArgs.selectCode != ''){
                title = $scope.filterArgs.selectCode.code + ' ' + $scope.stockCodesDic[$scope.filterArgs.selectCode.code].name;
            }
            return title;
        }

        $scope.getName = function (n) {
            return n;
        }

        $scope.$watch('minuteTicks.tagMode', function (newVal, oldVal) {
            // $scope.initPointLine();
            $scope.getScatterData();
        });

        $scope.$watch('filterArgs.selectCode', function (newVal, oldVal) {
            if(newVal == '')
                return;
            var dd = $scope.stockCodesDic[newVal.code];
            if(!dd)
                return;
            // $scope.chartConfig.title.text = '交易标记';
            $scope.chartConfig.subtitle.text = newVal.code + ' ' + dd.name;
            $scope.chartConfig.title.text = $scope.filterArgs.selectDate.yyyymmdd() + '日交易标记';
        });

        $scope.orderTags = [];
        $scope.orderFlags = 0;//委托标线数量
        $scope.knockTags = [];
        $scope.knockFlags = 0;//成交标线数量
        for(var xxx = 0; xxx <= 240; xxx++){
            $scope.orderTags.push({x:xxx,orders:[]});
            $scope.knockTags.push({x:xxx,orders:[]});
        }

        $scope.accountDisplay = {code:'', orders:[]};

        $scope.getOrdersHis = function () {
            var urls = ProfileService.CALC_SERVER_HOST + 'his_trade/orders?code='+  $scope.filterArgs.selectCode.code +'&date='+ $scope.filterArgs.selectDate.yyyymmdd();
            $http.get(urls).then(function (response) {
                // console.info('xx');
                $scope.accountDisplay.code = response.data.code;
                $scope.accountDisplay.orders = response.data.orders;
                $scope.filterOrdersAndKnocks();
                // $scope.initPointLine();
                $scope.getScatterData();
            }).catch(function (response) {
                // console.info('xx');
            });
        }

        $scope.getLines = function (flag, index) {
            var ticks = [];
            if(flag == 'order'){
                for (var i = 0; i < 240; i++){
                    if($scope.orderTags[i].orders.length < index+1){
                        continue;
                    }
                    var order = $scope.orderTags[i].orders[index];
                    var tt = '●';
                    var font_size = '16px';
                    ticks.push({
                        x:i,
                        title: tt,
                        color:'transparent',
                        name:order.id,//委托号
                        style:{
                            color:order.status == 2?"#acacac":(order.direction==0?"#ff0000":"#00ff00"),
                            fontSize:font_size,
                            // fontWeight:font_weight,
                            cursor:'pointer',
                        }
                    });
                }
            } else if(flag == 'knock'){
                for (var i = 0; i < 240; i++){
                    if($scope.knockTags[i].orders.length < index+1){
                        continue;
                    }
                    var order = $scope.knockTags[i].orders[index];
                    ticks.push({
                        x:i,
                        title: '◆',
                        color:'transparent',
                        name:order.id,//委托号
                        style:{
                            color:order.direction==0?"#ff0000":"#00ff00",
                            fontSize:'16px',
                            fontWeight:'bold',
                            cursor:'pointer',
                        }
                    });
                }
            }
            return ticks;
        }

        //刷新委托标记和成交标记
        $scope.filterOrdersAndKnocks = function () {
            if($scope.filterArgs.selectCode.code == '')
                return;
            for(var xxx = 0; xxx < 240; xxx++){
                $scope.orderTags[xxx].orders.splice(0);
                $scope.knockTags[xxx].orders.splice(0);
            }
            var order_points = [];//x:[]
            var knock_points = [];
            for(var i = 0; i < $scope.accountDisplay.orders.length; i++){
                var order = $scope.accountDisplay.orders[i];
                // if(order.code != $scope.stockCodesDic[$scope.minuteTicks.code].code)
                //     continue;
                var createTime = order.createTime.substring(11);//2017-05-17 09:52:12
                order_points.push(order);
                if(order.status == 1){
                    knock_points.push(order);
                }
            }
            var ordersorted = [];
            if(order_points.length > 0){
                ordersorted = order_points.sort(function (a, b) {
                    var a_hour = a.createTime.substring(11, 13);
                    var a_minute = a.createTime.substring(14, 16);
                    var a_second = a.createTime.substring(17, 19);
                    var b_hour = b.createTime.substring(11, 13);
                    var b_minute = b.createTime.substring(14, 16);
                    var b_second = b.createTime.substring(17, 19);
                    var time_a = parseInt(a_hour + a_minute + a_second);
                    var time_b = parseInt(b_hour + b_minute + b_second);
                    return time_a - time_b;
                });
            }
            var knocksorted = [];
            if(knock_points.length > 0) {
                knocksorted = knock_points.sort(function (a, b) {
                    var a_hour = a.updateTime.substring(11, 13);
                    var a_minute = a.updateTime.substring(14, 16);
                    var a_second = a.updateTime.substring(17, 19);
                    var b_hour = b.updateTime.substring(11, 13);
                    var b_minute = b.updateTime.substring(14, 16);
                    var b_second = b.updateTime.substring(17, 19);
                    var time_a = parseInt(a_hour + a_minute + a_second);
                    var time_b = parseInt(b_hour + b_minute + b_second);
                    return time_a - time_b;
                });
            }

            for(var k in ordersorted){
                var order = ordersorted[k];
                var hour = order.createTime.substring(11, 13);
                var minute = order.createTime.substring(14, 16);
                if(hour < 9 || hour == 12 || (hour==11&&minute>=30) || hour >15){//过滤非交易时间段内的数据
                    continue;
                }
                var x = 0;
                if(parseInt(hour) == 9){
                    if(parseInt(minute) < 30){
                        minute = 30;
                    }
                }
                if(parseInt(hour) < 12){
                    x = (parseInt(hour) - 10) * 60 + 30 + parseInt(minute);
                } else {
                    x = (parseInt(hour) - 13) * 60 + 120 + parseInt(minute);
                }
                if(x > 240)
                    continue;
                $scope.orderTags[x].orders.push(order);
            }
            for(var k in knocksorted){
                var order = knocksorted[k];
                var hour = order.updateTime.substring(11, 13);
                var minute = order.updateTime.substring(14, 16);
                if(hour < 9 || hour == 12 || (hour==11&&minute>=30) || hour >15){//过滤非交易时间段内的数据
                    continue;
                }
                var x = 0;
                if(parseInt(hour) == 9){
                    if(parseInt(minute) < 30){
                        minute = 30;
                    }
                }
                if(parseInt(hour) < 12){
                    x = (parseInt(hour) - 10) * 60 + 30 + parseInt(minute);
                } else {
                    x = (parseInt(hour) - 13) * 60 + 120 + parseInt(minute);
                }
                if(x > 240)
                    continue;
                $scope.knockTags[x].orders.push(order);
            }
        }

        $scope.showTags = [];

        $scope.getScatterData = function () {
            $scope.showTags.splice(0);
            for( var xxx = 0; xxx <= 240; xxx++){
                var orders = $scope.orderTags[xxx];
                var knocks = $scope.knockTags[xxx];
                var yVal = $scope.showTicks.length > xxx ? $scope.showTicks[xxx] : 0;
                if($scope.minuteTicks.tagMode == 1 || $scope.minuteTicks.tagMode ==2){
                    for( var i = 0; i < orders.orders.length; i++) {
                        var color_ = (orders.orders[i].status == '2' || orders.orders[i].status == 0)?"#acacac":(orders.orders[i].direction==0?"#ff0000":"#00ff00");
                        var tagMark = {
                            x:xxx,
                            y:yVal.y - 0.3 * (1 + i),
                            id:'order_'+orders.orders[i].id,
                            name:'委托',
                            marker:{
                                enable:true,
                                symbol:'circle',
                                fillColor:color_,
                                lineWidth:2,
                                lineColor:color_,
                            },
                            events:{
                                mouseOver:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'knock_' + id1.substring(6);
                                    $scope.MakePairSelect(true, idd);
                                },
                                mouseOut:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'knock_' + id1.substring(6);
                                    $scope.MakePairSelect(false, idd);
                                }
                            }
                        };
                        $scope.showTags.push(tagMark);
                    }
                }

                if($scope.minuteTicks.tagMode == 1 || $scope.minuteTicks.tagMode == 3) {
                    for(var i = 0; i < knocks.orders.length; i++){
                        var color_ = knocks.orders[i].direction == 0 ? "#ff0000" : "#00ff00";
                        $scope.showTags.push({
                            x:xxx,
                            y:yVal.y + 0.3 * (1 + i),
                            id:'knock_'+knocks.orders[i].id,
                            name:'成交',
                            marker:{
                                enable:true,
                                symbol:'diamond',
                                fillColor:color_,
                                lineWidth:2,
                                lineColor:color_,
                            },
                            events:{
                                mouseOver:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'order_' + id1.substring(6);
                                    $scope.MakePairSelect(true, idd);
                                },
                                mouseOut:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'order_' + id1.substring(6);
                                    $scope.MakePairSelect(false, idd);
                                }
                            }
                        });
                    }
                }

            }
        }

        $scope.MakePairSelect = function (flag, id_) {
            var chart = angular.element(
                document.getElementById('myhighchart')
            ).highcharts();
            if(!chart)
                return;
            var p1 = chart.get(id_);
            if(!p1)
                return;
            // p1.update({marker:{
            //     lineWidth:lineWidth_,
            // }}, false, false)
            p1.select(flag);
        }

        $scope.calcMinuteTicks = function () {
            var cur_price = $scope.minuteTicks.openPrice > 0 ? $scope.minuteTicks.openPrice:$scope.minuteTicks.preClose;
            $scope.showTicks.splice(0);
            var multiply = $scope.stockCodesDic[$scope.filterArgs.selectCode.code].type == '0' ? 100 : 1000;

            // var multiply = 100;
            // var datas = $scope.minuteTicks.datas.sort();
            if($scope.minuteTicks.datas.length > 0){
                var lowest = cur_price;
                var highest = cur_price;
                for(var ii = 0; ii < $scope.minuteTicks.datas.length; ii++){
                    if($scope.minuteTicks.datas[ii] == 0){
                        $scope.minuteTicks.datas[ii] = cur_price;
                    }
                    cur_price = $scope.minuteTicks.datas[ii];
                    if(lowest > $scope.minuteTicks.datas[ii]){
                        lowest = $scope.minuteTicks.datas[ii];
                    }
                    if(highest < $scope.minuteTicks.datas[ii]){
                        highest = $scope.minuteTicks.datas[ii];
                    }
                }
                var amplitude = (highest - $scope.minuteTicks.preClose) > ($scope.minuteTicks.preClose - lowest) ? (highest - $scope.minuteTicks.preClose) : ($scope.minuteTicks.preClose - lowest);
                amplitude = amplitude * multiply;
                if(amplitude <= 6){
                    $scope.minuteTicks.highLimit = $scope.minuteTicks.preClose *multiply + 8;
                    $scope.minuteTicks.lowLimit = $scope.minuteTicks.preClose *multiply - 8;
                } else {
                    var max = Math.round(amplitude);
                    max = Math.round(max/6)*8;
                    $scope.minuteTicks.highLimit = Math.round($scope.minuteTicks.preClose*multiply + max) ;
                    $scope.minuteTicks.lowLimit = Math.round($scope.minuteTicks.preClose*multiply - max);
                }
            }
            var base_price = $scope.minuteTicks.preClose * multiply;
            for(var i = 0; i < $scope.minuteTicks.datas.length; i++){
                var xxp = $scope.minuteTicks.datas[i]*multiply;
                var vv = (xxp - base_price)/(base_price - $scope.minuteTicks.lowLimit) * 8.0;
                $scope.showTicks.push({x:i, y:vv, events:{mouseOver:function (eve) {
                    $scope.minuteTicks.xValue = eve.target.x;
                }}});
            }
        }

        $scope.getMarkData = function () {
            $scope.minuteTicks.type = $scope.stockCodesDic[$scope.filterArgs.selectCode.code].type;
            $scope.getMinuteTicks();

        }

        $scope.getMinuteTicks = function () {
            // console.info('select code = ' + $scope.filterArgs.selectCode.code);
            var urls = ProfileService.CALC_SERVER_HOST + $scope.filterArgs.selectCode.code +'/his_timebar?from='+$scope.filterArgs.selectDate.yyyymmdd();
            $http.get(urls).then(function (response) {
                $q.when().then(function () {
                    $scope.minuteTicks.datas = response.data.prices;
                    $scope.minuteTicks.openPrice = response.data.open;
                    $scope.minuteTicks.preClose = response.data.preClose;
                    if($scope.minuteTicks.datas.length == 240){
                        $scope.minuteTicks.datas.push(response.data.close);
                    }
                    $scope.calcMinuteTicks();
                    $scope.getOrdersHis();
                    // $scope.myChart.series[0].setData($scope.showTicks);
                    // $scope.$apply();
                    // console.info('ss');
                    // $scope.myChart.series[0].update();
                });

            }).catch(function (response) {
                $scope.minuteTicks.datas = [];
            });
        }

        $scope.getTimeByIndex = function (x) {
            var hour = 0;
            var miniute = 0;
            if(x < 120){
                var totalminute = parseInt(x + 30);
                hour = 9 + parseInt(totalminute / 60);
                miniute = totalminute % 60;
            } else {
                var tt = parseInt(x - 120);
                hour = 13 + parseInt(tt/60);
                miniute = tt%60;
            }
            var t1 = miniute.toString();
            if(t1.length == 1){
                t1 = '0' + t1;
            }
            var timestr = hour + ":" + t1;
            return timestr;
        }

        $scope.padNumberLeft = function (val, len) {
            var ss = val.toString();
            while (ss.length < len){
                ss = '0'+ss;
            }
            return ss;
        }

        $scope.chartConfig= {
            subtitle: {
                align: 'left',
                floating: true,
                style: {'color': "#c6a300"},
                text: '',
                x: 40,
                y: 15
            },
            chart: {
                // height: 750,
                // width: 1198,
                // renderTo:'chartcontainer',
                backgroundColor: '#000',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        x: 0,
                        y: 6
                    },
                    theme: {
                        fill: 'white',
                        stroke: 'silver',
                        r: 0,
                        states: {
                            hover: {
                                // fill: '#41739D',
                                fill: '#41739D',

                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    }
                }
            },
            navigator: {
                enabled: true,
                height:26,
                series: {
                    data: []
                },
                xAxis:{
                    min:0,
                    max:240,
                    labels:{
                        enabled:true,
                        formatter:function () {
                            return $scope.getTimeByIndex(this.value);
                        }
                    }
                }
            },
            rangeSelector: {
                enabled: false
            },
            lang: {
                noData: "no data show"
            },
            noData: {
                style: {
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: '#888888'
                }
            },

            xAxis: [{
                // type: 'datetime'
                lineColor: '#A5260B',
                lineWidth: 1,
                tickAmount: 9,
                min: 0,
                max: 240,
                minTickInterval:1,
                tickLength: 8,
                labels: { // 坐标轴标签 刻度值后面加 百分号
                    align: 'right',
                    formatter: function () {
                        return '<span style="fill: red;">' + $scope.getTimeByIndex(this.value) + '</span>';
                    },
                    x: 18,
                },
                crosshair: {//十字线
                    color: 'red',
                    dashStyle: 'Dash',//Dash虚线，Solid实线
                    snap: 'true',
                    width: 1
                },
                gridLineWidth:0.5,
                gridLineColor: '#A5260B',
                gridLineDashStyle:'Dash',
                plotLines: [{
                    value: 120,
                    width: 1,
                    color: '#A5260B',
                    label: {
                        align: 'right',
                        y: -3,
                        x: 0,
                    }
                }],
            }],

            yAxis: [
                {  // -- 第 0 个 y 轴 -- 行情

                    labels: {
                        // format : '{value}',
                        formatter: function () {
                            var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                            var lengthstep = $scope.minuteTicks.type == '0' ? 2 : 3;
                            var price = ($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit) *(this.value/8.0);

                            if(this.value == 0){
                                return '<span style="fill: gray;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            } else if(this.value < 0){
                                return '<span style="fill: green;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            } else {
                                return '<span style="fill: red;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            }
                        },
                        align: 'right',
                        x: -5
                    },
                    title: {
                        text: '证券行情'
                    },
                    opposite: false,
                    // height: '75%',
                    height: '100%',
                    //lineWidth: 2,
                    // tickInterval : 1,
                    // ceiling:40,
                    lineColor: '#A5260B',
                    // lineWidth: 1,
                    min:-8,
                    max:8,
                    // minTickInterval:1,
                    gridLineWidth:0.5,
                    gridLineColor: '#A5260B',
                    gridLineDashStyle:'Dash',
                    tickAmount: 17,
                    crosshair: {
                        color: 'red',
                        dashStyle: 'Dash',//Dash虚线，Solid实线
                        snap: 'true',
                        width: 1
                    }
                },
                // {  // -- 第 1 个  -- 分时量
                //     labels: {
                //         format: '{value}',
                //         align: 'right',
                //         x: -5,
                //
                //     },
                //     title: {
                //         text: '分时量'
                //     },
                //     top: '80%',
                //     opposite: false,
                //     height: '20%',
                //     gridLineWidth:0.5,
                //     gridLineColor: '#A5260B',
                //     gridLineDashStyle:'Dash',
                //     offset: 0,
                //     //lineWidth: 2
                //     tickAmount: 6,
                // },
                {     // -- 第 2 个 -- 百分比
                    // gridLineColor: '#FFF0F0',  // 网格线的颜色
                    // gridLineDashStyle :'Dash',  // 网格线的形状
                    // gridLineWidth: 2,
                    labels: { // 坐标轴标签 刻度值后面加 百分号
                        format: '{value}%',
                        align: 'left',
                        formatter: function () {
                            var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                            var percent = Math.round((Math.abs(this.value)/8)*100*(($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit)/$scope.minuteTicks.preClose))/step;
                            if (0 == this.value) {
                                return '<span style="fill: gray;">' + this.value + '%</span>';
                            } else if (this.value < 0) {
                                return '<span style="fill: green;">' + percent + '%</span>';
                            } else {
                                return '<span style="fill: red;">' + percent + '%</span>';
                            }
                        },
                        x: 6,//相对图表的x轴偏移
                    },
                    title: {
                        text: '百分比 ',
                    },
                    offset: 0,
                    min: -8,
                    max: 8,
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#A5260B',
                        label: {
                            align: 'right',
                            y: 2,
                            x: 0
                        }
                    }],
                    tickAmount: 17,
                    // lineWidth: 2,
                    height: '100%',
                    opposite: true,
                    gridLineWidth:0,
                    // lineColor: '#A5260B',
                    // lineWidth: 1,
                    /*  min: -7,
                     max: 7, */
                    // tickInterval :10,
                    /*  startOnTick: false,
                     endOnTick:false */

                }
            ],

            legend: {
                enabled: false
            },
            title: {
                text: '历史交易标记',
                style: {'color': "#c6a300",'font-height':'900'},
            },
            credits: {
                enabled: false
            },

            loading: false,
            tooltip: {
                headerFormat: '<div class="header" style="color: #fcfcfc">行情</div>',
                pointFormat: '<div class="line"><div class="circle" style="background-color:{series.color};float:left;margin-left:10px!important;clear:left;"></div><label class="country" style="float:left;color: red">{series.name}线条名字</label><label class="country" style="float:left;">{point.y}ddddddddddddd </label></div>',
                pointFormatter:function () {
                    // var  time = '';
                    // if(this.x <= 120){
                    //     time = $scope.padNumberLeft(parseInt((this.x+30)/60 + 9), 2) + ':' + $scope.padNumberLeft(parseInt((this.x+30)%60), 2);
                    // }else{
                    //     time = $scope.padNumberLeft(parseInt((this.x-120)/60+13), 2) + ':' + $scope.padNumberLeft(parseInt(this.x%60), 2);
                    // }
                    var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                    var lengthstep = $scope.minuteTicks.type == '0' ? 2 : 3;
                    var price = ($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit) *(this.y/8.0);
                    var pp = $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep);
                    var msg = '时间：' + $scope.getTimeByIndex(this.x);
                    msg += '<br/>价格：' + pp;
                    return msg;
                },
                borderWidth: 0,
                positioner: function () {
                    var width = document.getElementById('chartcontainer').clientWidth;
                    var xx = $scope.minuteTicks.xValue > 120 ? (width/4):(width*3/4);
                    return { x: xx, y: 80 };
                },

                borderRadius: 5,
                borderColor: '#a4a4a4',
                shadow: false,
                useHTML: true,
                percentageDecimals: 2,
                backgroundColor: "rgba(180,180,180,.7)",
                style: {
                    padding: 0
                },
                // shared: true
            },

            series: [
                {
                    id: 'lineQuotaMinute',
                    // name: 'Usage Time',
                    data: $scope.showTicks,
                    type: 'line',
                    lineWidth:1,
                    states:{
                        hover:{
                            lineWidth:1
                        }
                    },
                    yAxis: 0,
                    tooltip: {
                        valueSuffix: ' sec'
                    },
                    color: '#fcfcfc'
                },
                {
                    type:'scatter',
                    data:$scope.showTags,
                    tooltip: {
                        headerFormat: '<div class="header" style="color: #fcfcfc"><b>{point.key}</b></div>',
                        pointFormatter:function () {
                            var orderTime = '';//委托时间
                            var knockTime = '';//成交时间
                            var quantity = 0;//成交数量
                            var matchPrice = '';//成交价格
                            var price = 0;//委托价格
                            var orderType = '';//委托类型
                            var color = '';
                            var status = '0';
                            if(this.name == '委托'){
                                for(var i in $scope.orderTags[this.x].orders){
                                    var order = $scope.orderTags[this.x].orders[i];
                                    if(order.id == this.id.substring(6)){
                                        knockTime = order.updateTime.length > 12 ? order.updateTime.substring(11) : '';
                                        orderTime = (order.createTime.length > 12) ? order.createTime.substring(11) : '';
                                        quantity = order.quantity;
                                        matchPrice = order.matchPrice;
                                        price = order.price;
                                        orderType = order.direction == 0 ? '买单' : '卖单';
                                        status = order.status;
                                        break;
                                    }
                                }
                            } else {
                                for(var i in $scope.knockTags[this.x].orders){
                                    var order = $scope.knockTags[this.x].orders[i];
                                    if(order.id == this.id.substring(6)){
                                        knockTime = order.updateTime.length > 12 ? order.updateTime.substring(11) : '';
                                        orderTime = (order.createTime.length > 12) ? order.createTime.substring(11) : '';
                                        quantity = order.quantity;
                                        matchPrice = order.matchPrice;
                                        price = order.price;
                                        orderType = order.direction == 0 ? '买单' : '卖单';
                                        status = order.status;
                                        break;
                                    }
                                }
                            }

                            var s = '<span style="color: #fcfcfc">委托号：'+ this.id.substring(6);
                            s += '<br/>委托时间：' + orderTime;
                            if(status == '2'){
                                s += '<br/>撤单时间：' + knockTime;
                            } else if (status == '1'){
                                s += '<br/>成交时间：' + knockTime;
                            }

                            s += '<br/>委托类型：' + orderType;
                            s += '<br/>委托价格：' + price;
                            s += '<br/>成交价格：' + matchPrice;
                            if(status == '1') {
                                s += '<br/>成交/委托数量：' + quantity + '/' + quantity + '股';
                            } else {
                                s += '<br/>成交/委托数量：0/' + quantity + '股';
                            }

                            if(status == '2'){
                                s += '<br/>状态：已撤单';
                            } else if(status == '1'){
                                s += '<br/>状态：已成交';
                            } else {
                                s += '<br/>状态：未成交已撤单';
                            }
                            s += '</span>'
                            return s;
                        },
                        useHTML: true,
                    },
                    marker:{
                        states:{
                            select:{
                                fillColor: '#0099ff',
                                lineWidth: 6,
                                lineColor:'#0099ff',
                            }
                        }
                    }

                }
            ],
        };//图表配置

        // $scope.myChart = Highcharts.chart('chartcontainer', $scope.chartConfig);//图表配置

        // $scope.getTooltipX = function (index) {
        //     return $scope
        // }
        // var callLater = function () {
        //     window.setTimeout(function () {
        //         $q.when().then(function () {
        //             // $scope.myChart.reflow();
        //             var width = document.getElementById('chartcontainer').clientWidth;
        //             var height = document.getElementById('chartcontainer').clientHeight;
        //             // $scope.minuteTicks.xValue = parseInt(width/4);
        //             $scope.chartConfig.chart.height = height;
        //             $scope.chartConfig.chart.width = width;
        //         });
        //     },10);
        // }
        // function fixHeight() {
        //     var height_ = document.documentElement.clientHeight - (86 + 80 + 40);
        //     $scope.myStyles.height = height_;
        //     // height_ = 100;
        //     var a1 = height_ + "px";
        //     $scope.chartsHeight = {
        //         "height": a1
        //     };
        //     // $scope.myChart.reflow();
        //     callLater();
        // }
        // fixHeight();
        //
        // var resizeCall = $rootScope.$on("OnWindowResize", fixHeight);
        // $scope.$on('$destroy', function () {
        //     resizeCall();
        // });
    }
})();
(function () {

    'use strict';

    angular.module('myApp.pages.exam.paper')
        .controller('PaperCtrl', PaperCtrl);

    function PaperCtrl($scope, $filter, $stateParams, $state, $http, $interval, modalService, ProfileService, TokenCheckService) {
        var ctrl = $scope;

        ctrl.itemId = $stateParams.id;
        ctrl.item = {
            id:ctrl.itemId,
            name:"考试",
            startLeftSeconds :0,
            scorePeriod:0,
            papers:[]
        };

        ctrl.examAnswers = {
            paperAnswers : []
        };

        var initPaperAnswer = function (examType, papers) {
            //有问题没有回答
            var questionWithAnswer = 0;
            ctrl.examAnswers.paperAnswers = [];
            for(var i in papers)
            {
                var paper = papers[i];
                var paperAnswer = {
                    paperId : paper.id,
                    answers:[]
                };
                for(var j in paper.questions)
                {
                    var question = paper.questions[j];
                    if(question.type != 2 && examType != 2)
                    {
                        var answer = 0;
                        answer = question.answer == null ? 0 : question.answer;
                        if(answer == 0)
                        {
                            questionWithAnswer += 1;
                        }
                        //单选或者判断
                        paperAnswer.answers.push({"answer" : answer});
                    }
                    else
                    {
                        var answer = 0;
                        if(question.respA != null)
                        {
                            answer += (question.respA == true ? 1 : 0);
                        }
                        if(question.respB != null)
                        {
                            answer += (question.respB == true ? 2 : 0);
                        }
                        if(question.respC != null)
                        {
                            answer += (question.respC == true ? 4 : 0);
                        }
                        if(question.respD != null)
                        {
                            answer += (question.respD == true ? 8 : 0);
                        }
                        if(answer == 0)
                        {
                            questionWithAnswer += 1;
                        }
                        paperAnswer.answers.push({"answer" : answer});
                    }
                }
                ctrl.examAnswers.paperAnswers.push(paperAnswer);
            }
            return questionWithAnswer;
        };

        ctrl.submitExam = function () {
            var questionNoAnswers = initPaperAnswer(ctrl.item.type, ctrl.item.papers);
            var modalOptions = {
                closeButtonText: '取消',
                actionButtonText: '确认',
                bodyText: questionNoAnswers == 0 ? '请您确认提交测评？' : ("您还有" + questionNoAnswers + "道题目未答，确认提交测评？"),
                alertStyle: 'warning'
            };
            modalService.showConfirmModal({}, modalOptions).then(function (result) {
                $http.post(ProfileService.SERVER_HOST + "exams/" + ctrl.itemId + "/result", ctrl.examAnswers).then(function (response) {
                    $state.go('exam', {});
                }).catch(function (response) {
                    modalService.showInform({}, {bodyText: '提交试卷失败：' + response.data.error + "!"});
                });
            });
        };

        $scope.timer = null;
        ctrl.timeLeft = "--:--";
        var getLeftTime = function () {
            if(ctrl.item.startLeftSeconds > 0)
            {
                ctrl.timeLeft = "未开始";
            }
            else
            {
                var tempTime = ctrl.item.startLeftSeconds + 60 * ctrl.item.scorePeriod;
                if(tempTime < 0 )
                {
                    ctrl.timeLeft =  "已结束";
                }
                else if(tempTime == 0)
                {
                    initPaperAnswer(ctrl.item.type, ctrl.item.papers);
                    $http.post(ProfileService.SERVER_HOST + "exams/" + ctrl.itemId + "/result", ctrl.examAnswers).then(function (response) {
                        modalService.showInform({}, {bodyText: '考试时间结束，系统已经自动为您交卷！'});
                        $state.go('exam', {});
                    }).catch(function (response) {
                        modalService.showInform({}, {bodyText: '提交试卷失败：' + response.data.error + "!"});
                    });
                }
                else
                {
                    var tempLeftSeconds = tempTime % 60;
                    ctrl.timeLeft =  parseInt(tempTime/60) + ":" + (tempLeftSeconds < 10 ? ("0" + tempLeftSeconds) : tempLeftSeconds);
                }
            }
        };
        //设置考场的状态
        var setStartLeftSeconds = function () {
            ctrl.item.startLeftSeconds -= 1;
            getLeftTime();
        };

        $scope.getData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            $http.get(ProfileService.SERVER_HOST + "exams/" + ctrl.itemId).then(function (response) {
                ctrl.item = response.data;
                ctrl.timer = $interval(
                    function() {
                        setStartLeftSeconds();
                    },
                    1000
                );
            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载试卷！")});
            });
        };
        ctrl.getData();

        $scope.getCheckColor = function (val, val1) {
            if (val == val1)
                return {"color": "red", "font-weight": "bold"};
            else
                return {"color": "black", "font-weight": "normal"};
        };

        ctrl.getQuestionType = function (type) {
          if(type == 0)
          {
              return "单选";
          }
          else if(type == 1)
          {
            return  "判断";
          }
          else
          {
            return  "多选";
          }
        };

        ctrl.exitExam = function () {
            var modalOptions = {
                closeButtonText: '取消',
                actionButtonText: '确认',
                bodyText: '退出测评无法保存答题进度，但倒计时不会停止，“确定”退出测评吗？',
                alertStyle: 'warning'
            };

            modalService.showConfirmModal({}, modalOptions).then(function (result) {
                $state.go('exam', {
                });
            });
        };

        $scope.$on('$destroy',function(){
            if($scope.timer != null)
            {
                $interval.cancel($scope.timer);
            }
        })
    }
})();
(function () {

    'use strict';

    angular.module('myApp.pages.exam.result')
        .controller('ExamResultCtrl', ExamResultCtrl);

    function ExamResultCtrl($scope, $filter, $stateParams, $state, $http, $interval, modalService, ProfileService, TokenCheckService) {
        var ctrl = $scope;
        ctrl.itemId = $stateParams.id;

        var initQuestion = function (examRoom, examAnswers) {
            for(var i in examRoom.papers)
            {
                var paper = examRoom.papers[i];
                var totalScore = 0;
                for(var j in paper.questions)
                {
                    if(examRoom.type == 2 || (examRoom.type == 1 && paper.questions[j].type == 2))
                    {
                        paper.questions[j].respA = (examAnswers.paperAnswers[i].answers[j].answer & 1) > 0;
                        paper.questions[j].respB = (examAnswers.paperAnswers[i].answers[j].answer & 2) > 0;
                        paper.questions[j].respC = (examAnswers.paperAnswers[i].answers[j].answer & 4) > 0;
                        paper.questions[j].respD = (examAnswers.paperAnswers[i].answers[j].answer & 8) > 0;
                        paper.questions[j].answer = examAnswers.paperAnswers[i].answers[j].answer;
                    }
                    else
                    {
                        paper.questions[j].answer = examAnswers.paperAnswers[i].answers[j].answer;
                    }
                    paper.questions[j].userScore = examAnswers.paperAnswers[i].answers[j].score;
                    totalScore +=  paper.questions[j].userScore;
                }
                paper.totalScore = totalScore;
            }
        };

        var getData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            $http.get(ProfileService.SERVER_HOST + "exams/" + ctrl.itemId + "/result").then(function (response) {
                ctrl.item = response.data;
                initQuestion(ctrl.item.examRoom, ctrl.item.examAnswers);

            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载试卷！")});
            });
        };
        getData();

        $scope.getCheckColor = function (val, val1) {
            if (val != val1)
                return {"color": "red", "font-weight": "bold"};
            else
                return {"color": "black", "font-weight": "normal"};
        };

        $scope.getAnswerStr = function (type, val) {
            var ret = '';
            if ((val & 1) > 0)
                if(type == 1)
                {
                    ret += '正确';
                }
                else
                {
                    ret += 'A';
                }
            if ((val & 2) > 0)
                if(type == 1)
                {
                    ret += '错误';
                }
                else
                {
                    ret += 'B';
                }

            if ((val & 4) > 0)
                ret += 'C';
            if ((val & 8) > 0)
                ret += 'D';
            return ret;
        }

        // ctrl.getQuestionType = function (paperType, questionType, userScore, score) {
        //     if(paperType == 1)
        //     {
        //         return score + "分";
        //     }
        //     if(questionType == 0)
        //     {
        //         return "单选";
        //     }
        //     else if(questionType == 1)
        //     {
        //         return  "判断";
        //     }
        //     else
        //     {
        //         return  "多选";
        //     }
        // };
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.resources.jobs')
        .controller('JobsCtrl', JobsCtrl);

    function JobsCtrl($scope, $log, $http, $state, $stateParams, $location, $anchorScroll, $timeout, ProfileService, TokenService, modalService, $uibModal) {


        var ctrl = $scope;

        ctrl.currentTab = 0;
        //单页数量
        ctrl.itemsByPage = 10;

        var gotoAnchor = function () {
            if ($stateParams.anchor == "2") {
                $scope.currentTab = 2;
            }
            else {
                $scope.currentTab = 1;
            }
        };

        ctrl.getNavClass = function (index) {
            return ctrl.currentTab == index ? "active" : "";
        };

        ctrl.chooseNav = function (index) {
            // $state.current.reloadOnSearch = false;
            $location.search('anchor', index);
            if(ctrl.currentTab == index)
            {
                return;
            }
            $scope.currentTab = index;
        };

        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(target, start) {
            for (var i = 0; i < target.displayed.length; i++) {
                target.displayed[i].index = start + i + 1;
            }
        }

        ctrl.jobs = {
            isLoading: false,
            isFailed: false,
            displayed: [],
            totalItemCount: 0,
            tableState: null
        };

        ctrl.jobCallServer = function (tableState) {
            ctrl.jobs.tableState = tableState;
            ctrl.getJobData();
        };

        ctrl.getDateStr = function (datestr) {
            var ss = datestr.substring(0, 10);
            return ss;
        }

        ctrl.showJob = function (item) {
            $state.go('resources.jobDetails', {src: "subform", type: "jobs", id: item.id});
        };

        ctrl.getJobData = function () {
            ctrl.jobs.isLoading = true;
            var pagination = ctrl.jobs.tableState.pagination;
            var queryArgs = {
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: 'updateTime',
                order: 'desc'
            };

            $http.post(ProfileService.SERVICE_JOB_PAGE_QUERY, queryArgs).then(function (response) {
                ctrl.jobs.displayed = response.data.jobs;
                ctrl.jobs.totalItemCount = response.data.totalCount;
                ctrl.jobs.tableState.pagination.numberOfPages = getPageCount(ctrl.jobs.totalItemCount);
                ctrl.jobs.isLoading = false;
                ctrl.jobs.isFailed = false;
                addIndex(ctrl.jobs, queryArgs.start);
            }).catch(function (response) {
                $log.info('查询失败...');
                ctrl.jobs.displayed = [];
                ctrl.jobs.tableState.pagination.numberOfPages = 1;
                ctrl.jobs.isLoading = false;
                ctrl.jobs.isFailed = true;
            });
        };

        ctrl.posters = {
            isLoading: false,
            isFailed: false,
            displayed: [],
            totalItemCount: 0,
            tableState: null
        };

        ctrl.posterCallServer = function (tableState) {
            ctrl.posters.tableState = tableState;
            ctrl.getPosterData();
        };

        ctrl.showPoster = function (item) {
            $state.go('resources.jobDetails', {src: "subformposters", type: "posters", id: item.id});
        };

        ctrl.getPosterData = function () {
            ctrl.posters.isLoading = true;
            var pagination = ctrl.posters.tableState.pagination;
            var queryArgs = {
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: 'updateTime',
                order: 'desc'
            };

            $http.post(ProfileService.SERVICE_POSTER_PAGE_QUERY, queryArgs).then(function (response) {
                ctrl.posters.displayed = response.data.posters;
                ctrl.posters.totalItemCount = response.data.totalCount;
                ctrl.posters.tableState.pagination.numberOfPages = getPageCount(ctrl.posters.totalItemCount);
                ctrl.posters.isLoading = false;
                ctrl.posters.isFailed = false;
                addIndex(ctrl.posters, queryArgs.start);
            }).catch(function (response) {
                $log.info('查询失败...');
                ctrl.posters.displayed = [];
                ctrl.posters.tableState.pagination.numberOfPages = 1;
                ctrl.posters.isLoading = false;
                ctrl.posters.isFailed = true;
            });
        };


        $timeout(function () {
            gotoAnchor();
        }, 300);
    }
})();

(function () {
    'use strict';

    angular.module('myApp.pages.resources.ruleDetails')
        .controller('RuleDetailsCtrl', RuleDetailsCtrl);

    function RuleDetailsCtrl($scope, $window, $http, $stateParams, $sce, $state, ProfileService) {

        var ctrl = $scope;
        ctrl.itemType = $stateParams.type;
        $window.scrollTo(0, 0);
        ctrl.showItem = {id: 0, title: "", content: ""};
        //正在加载标志
        ctrl.isLoading = false;
        //加载失败标志
        ctrl.isFailed = false;

        var getData = function () {
            ctrl.isLoading = true;
            
            $http.get(ProfileService.SERVICE_RULE + ctrl.itemType).
            then(function (response) {
                ctrl.showItem.id = response.data.id;
                ctrl.showItem.title = response.data.title;
                ctrl.showItem.content = $sce.trustAsHtml(response.data.content);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).
            catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        ctrl.goBack = function () {
            $state.go("main");
        };

        getData();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.simulation.diary')
        .controller('DiaryCtrl', DiaryCtrl);

    function DiaryCtrl($scope, $filter, $stateParams, $state, $http, ProfileService, TokenCheckService) {
        var ctrl = $scope;

        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.firstLoad = true;
        ctrl.displayed = [];
        ctrl.canSubmit = false;
        //单页数量
        ctrl.itemsByPage = 20;
        //总数量
        ctrl.totalItemCount = 0;

        var stringToDate = function (str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2]);
        };


        ctrl.filterArgs = {
            dateOptions: {
                startingDay: 1,
                showWeeks: false
            },
            dateFormat: "yyyy-MM-dd",
            openFromPicker: false,
            fromDate: $stateParams.fromDate ? stringToDate($stateParams.fromDate) : new Date(new Date() - 30 * 24 * 60 * 60 * 1000),
            openToPicker: false,
            toDate: $stateParams.toDate ? stringToDate($stateParams.toDate) : new Date(),
            altDateInputFormats: ['yyyy-M!-d!']
        };

        ctrl.openFromPicker = function () {
            ctrl.filterArgs.openFromPicker = true;
        };

        ctrl.openToPicker = function () {
            ctrl.filterArgs.openToPicker = true;
        };

        ctrl.onToDateChanged = function () {
            if (ctrl.filterArgs.toDate < ctrl.filterArgs.fromDate) {
                ctrl.filterArgs.fromDate = ctrl.filterArgs.toDate;
            }
        };

        ctrl.searchArgs = {
            fromDate: ctrl.filterArgs.fromDate,
            toDate: ctrl.filterArgs.toDate
        };

        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(start) {
            for (var i = 0; i < ctrl.displayed.length; i++) {
                ctrl.displayed[i].index = start + i + 1;
            }
        }

        ctrl.getStatusString = function (status) {
            if (status == 1) {
                return "未提交";
            }
            else if (status == 2) {
                return "已提交";
            }
            else if (status == 3) {
                return "已提交";
            }
        };

        ctrl.getStatusStyle = function (status) {
            if (status == 1) {
                return {color: '#c52d2f'};
            }
            return {};
        };

        ctrl.getActionString = function (item) {
            if (item.type == 1) {
                return "----";
            }
            if (item.type == 3) {
                return "修改";
            }
            return "查看";
        };

        ctrl.getAddDiaryHref = function () {
            var href = $state.href('simulation.diaryEdit', {
                id: 0,
                fromDate: $filter('date')(ctrl.searchArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.searchArgs.toDate, 'yyyy-MM-dd'),
                start: (ctrl.tableState ? ctrl.tableState.pagination.start : 0)
            });
            return href;
        };

        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            ctrl.getData();
        };

        $scope.getData = function (reset_page) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            if (reset_page) {
                ctrl.tableState.pagination.start = 0;
                ctrl.searchArgs.fromDate = ctrl.filterArgs.fromDate;
                ctrl.searchArgs.toDate = ctrl.filterArgs.toDate;
            }
            var pagination = ctrl.tableState.pagination;
            var sort = ctrl.tableState.sort;
            var queryArgs = {
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: 'updateTime',
                order: 'desc',
                fromDate: $filter('date')(ctrl.searchArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.searchArgs.toDate, 'yyyy-MM-dd')
            };

            $state.go($state.current.name, {
                fromDate: queryArgs.fromDate,
                toDate: queryArgs.toDate,
                start: pagination.start
            }, {
                notify: false,
                location: ctrl.firstLoad ? "replace" : true,
                inherit: true
            });
            ctrl.firstLoad = false;

            $http.get(ProfileService.SERVICE_DIARY_QUERY + "?start=" +
                queryArgs.start + "&number=" + queryArgs.number +
                "&sortby=" + queryArgs.sortby + "&order=" + queryArgs.order +
                "&from_date=" + queryArgs.fromDate + "&to_date=" + queryArgs.toDate).then(function (response) {
                ctrl.displayed = response.data.diaries;
                ctrl.totalItemCount = response.data.totalCount;
                ctrl.canSubmit = response.data.canSubmit;
                pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
                addIndex(queryArgs.start);
            }).catch(function (response) {
                ctrl.displayed = [];
                pagination.numberOfPages = 1;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        var setTest = function (start) {
            ctrl.displayed = [];
            for (var i = 0; i < 20; i++) {
                var tmp_item = {
                    createDate: "2017-05-23",
                    status: i % 2,
                    score: makeRandomValue()
                };
                ctrl.displayed.push(tmp_item);
            }
            ctrl.totalItemCount = 100;
            addIndex(start);
            ctrl.tableState.pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
        };

        var makeRandomValue = function () {
            return parseInt(Math.random() * 100);
        };

        ctrl.getItemHref = function (item) {
            if (item.id == 0 || item.type == 1) {
                return "";
            }
            var href = $state.href('simulation.diaryEdit', {
                id: item.id,
                fromDate: $filter('date')(ctrl.searchArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.searchArgs.toDate, 'yyyy-MM-dd'),
                start: ctrl.tableState ? ctrl.tableState.pagination.start : 0
            });
            return href;
        };

    }
})();
(function () {

    'use strict';

    angular.module('myApp.pages.simulation.mistake')
        .controller('MistakeCtrl', MistakeCtrl);

    function MistakeCtrl($scope, $filter, $stateParams, $state, $http, ProfileService, TokenCheckService) {
        var ctrl = $scope;

        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.firstLoad = true;
        ctrl.displayed = [];
        ctrl.canSubmit = false;
        //单页数量
        ctrl.itemsByPage = 20;
        //总数量
        ctrl.totalItemCount = 0;

        var stringToDate = function (str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2]);
        };


        ctrl.filterArgs = {
            dateOptions: {
                startingDay: 1,
                showWeeks: false
            },
            dateFormat: "yyyy-MM-dd",
            openFromPicker: false,
            fromDate: $stateParams.fromDate ? stringToDate($stateParams.fromDate) : new Date(new Date() - 30 * 24 * 60 * 60 * 1000),
            openToPicker: false,
            toDate: $stateParams.toDate ? stringToDate($stateParams.toDate) : new Date(),
            altDateInputFormats: ['yyyy-M!-d!']
        };

        ctrl.openFromPicker = function () {
            ctrl.filterArgs.openFromPicker = true;
        };

        ctrl.openToPicker = function () {
            ctrl.filterArgs.openToPicker = true;
        };

        ctrl.onToDateChanged = function () {
            if (ctrl.filterArgs.toDate < ctrl.filterArgs.fromDate) {
                ctrl.filterArgs.fromDate = ctrl.filterArgs.toDate;
            }
        };

        ctrl.searchArgs = {
            fromDate: ctrl.filterArgs.fromDate,
            toDate: ctrl.filterArgs.toDate
        };

        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(start) {
            for (var i = 0; i < ctrl.displayed.length; i++) {
                ctrl.displayed[i].index = start + i + 1;
            }
        }

        // ctrl.getStatusString = function (status) {
        //     if (status == 1) {
        //         return "未提交";
        //     }
        //     else if (status == 2) {
        //         return "已提交";
        //     }
        //     else if (status == 3) {
        //         return "已提交";
        //     }
        // };

        // ctrl.getStatusStyle = function (status) {
        //     if (status == 1) {
        //         return {color: '#c52d2f'};
        //     }
        //     return {};
        // };

        ctrl.getActionString = function (item) {
            if (item.canModify == 0) {
                return "查看";
            }
            if (item.canModify == 1) {
                return "修改";
            }
            return "查看";
        };

        ctrl.getAddDiaryHref = function () {
            var href = $state.href('simulation.mistakeEdit', {
                id: 0,
                fromDate: $filter('date')(ctrl.searchArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.searchArgs.toDate, 'yyyy-MM-dd'),
                start: (ctrl.tableState ? ctrl.tableState.pagination.start : 0)
            });
            return href;
        };

        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            ctrl.getData();
        };

        $scope.getData = function (reset_page) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            if (reset_page) {
                ctrl.tableState.pagination.start = 0;
                ctrl.searchArgs.fromDate = ctrl.filterArgs.fromDate;
                ctrl.searchArgs.toDate = ctrl.filterArgs.toDate;
            }
            var pagination = ctrl.tableState.pagination;
            var sort = ctrl.tableState.sort;
            var queryArgs = {
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: 'createDate',
                order: 'desc',
                fromDate: $filter('date')(ctrl.searchArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.searchArgs.toDate, 'yyyy-MM-dd')
            };

            $state.go($state.current.name, {
                fromDate: queryArgs.fromDate,
                toDate: queryArgs.toDate,
                start: pagination.start
            }, {
                notify: false,
                location: ctrl.firstLoad ? "replace" : true,
                inherit: true
            });
            ctrl.firstLoad = false;

            $http.get(ProfileService.SERVICE_MISTAKE + "collections?start=" +
                queryArgs.start + "&number=" + queryArgs.number +
                "&sortby=" + queryArgs.sortby + "&order=" + queryArgs.order +
                "&from_date=" + queryArgs.fromDate + "&to_date=" + queryArgs.toDate).then(function (response) {
                ctrl.displayed = response.data.items;
                ctrl.totalItemCount = response.data.totalCount;
                pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
                addIndex(queryArgs.start);
            }).catch(function (response) {
                ctrl.displayed = [];
                pagination.numberOfPages = 1;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        var setTest = function (start) {
            ctrl.displayed = [];
            for (var i = 0; i < 20; i++) {
                var tmp_item = {
                    createDate: "2017-05-23",
                    status: i % 2,
                    score: makeRandomValue()
                };
                ctrl.displayed.push(tmp_item);
            }
            ctrl.totalItemCount = 100;
            addIndex(start);
            ctrl.tableState.pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
        };

        var makeRandomValue = function () {
            return parseInt(Math.random() * 100);
        };

        ctrl.getItemHref = function (item) {
            if (item.id == 0 || item.type == 1) {
                return "";
            }
            var href = $state.href('simulation.mistakeEdit', {
                id: item.id,
                fromDate: $filter('date')(ctrl.searchArgs.fromDate, 'yyyy-MM-dd'),
                toDate: $filter('date')(ctrl.searchArgs.toDate, 'yyyy-MM-dd'),
                start: ctrl.tableState ? ctrl.tableState.pagination.start : 0
            });
            return href;
        };

    }
})();
/**
 * Created by Administrator on 2017/6/2.
 */
(function () {
    'use strict';

    angular.module('myApp.pages.simulation.mark')
        .controller('MarkCtrl', MarkCtrl);

    function MarkCtrl($scope, $rootScope, $q, $http, ProfileService, TokenCheckService) {
        var ctrl = $scope;

        if (TokenCheckService.checkLogin() == false) {
            return;
        }
        ctrl.filterArgs = {
            dateOptions: {
                startingDay: 1,
                showWeeks: false
            },
            dateFormat: "yyyy-MM-dd",
            openFromPicker: false,
            openToPicker: false,
            toDate: new Date(),
            altDateInputFormats: ['yyyy-M!-d!']
        };
        $scope.myStyles = {height:0};

        ctrl.openToPicker = function () {
            ctrl.filterArgs.openToPicker = true;
        };
        $scope.stockCodesDic = {};
        $scope.stockList = [];
        $scope.getMarkCodes = function (datestr) {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            var urls = ProfileService.CALC_SERVER_HOST + 'his_codes?date='+ datestr;
            $http.get(urls).then(function (response) {
                $scope.stockList.splice(0);
                for(var i in response.data.codes) {
                    var cxx = response.data.codes[i];
                    $scope.stockCodesDic[cxx.code.substring(2)] = cxx;
                    $scope.stockList.push(cxx.code.substring(2));
                    $scope.stockList = $scope.stockList.sort();
                }
            }).catch(function (response) {
                console.info('xx');
            });
        };
        $scope.getMarkCodes('');

        $scope.securityCodeAdapt = function (code) {
            var dd = $scope.stockCodesDic[code];
            if(!dd){
                return code;
            }
            return dd.code;
        }

        $scope.getSecurityCode = function (search) {
            var newCode = $scope.stockList.slice();
            if (search && newCode.indexOf(search) === -1) {
                newCode.unshift(search);
            }
            return newCode;
        }

        Date.prototype.yyyymmdd = function() {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            return [this.getFullYear(),'-',
                (mm>9 ? '' : '0') + mm,'-',
                (dd>9 ? '' : '0') + dd
            ].join('');
        };

        $scope.$watch('filterArgs.toDate', function (newVal, oldVal) {
            console.info('date = ' + newVal.yyyymmdd());
            $scope.getMarkCodes(newVal.yyyymmdd());
            // $scope.initPointLine();
        });


        //浮点数转字符串，精确小数点后length位
        $scope.toStringEx = function (x, length) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return '';
            }
            var f = Math.round(x * Math.pow(10, length)) / Math.pow(10, length);
            var s = f.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + length) {
                s += '0';
            }
            return s;
        }

        /***************分时图******************/
        $scope.minuteTicks = {code:'', xValue:0, type:'0', tagMode: 1, preClose:0, openPrice:0, highLimit:0, lowLimit:0, datas:[]};//分时数据 tagMode 1委托和成交；2委托；3成交
        $scope.showTicks = [];

        $scope.getTitle = function () {
            var title = '';
            if($scope.minuteTicks.code != ''){
                title = $scope.minuteTicks.code + ' ' + $scope.stockCodesDic[$scope.minuteTicks.code].name;
            }
            return title;
        }

        $scope.getName = function (n) {
            return n;
        }

        $scope.$watch('minuteTicks.tagMode', function (newVal, oldVal) {
            // $scope.initPointLine();
            $scope.getScatterData();
        });

        $scope.$watch('minuteTicks.code', function (newVal, oldVal) {
            if(newVal == '')
                return;
            var dd = $scope.stockCodesDic[newVal];
            if(!dd)
                return;
            // $scope.chartConfig.title.text = '交易标记';
            $scope.chartConfig.subtitle.text = newVal + ' ' + dd.name;
        });

        $scope.orderTags = [];
        $scope.orderFlags = 0;//委托标线数量
        $scope.knockTags = [];
        $scope.knockFlags = 0;//成交标线数量
        for(var xxx = 0; xxx <= 240; xxx++){
            $scope.orderTags.push({x:xxx,orders:[]});
            $scope.knockTags.push({x:xxx,orders:[]});
        }

        $scope.accountDisplay = {code:'', orders:[]};

        $scope.getOrdersHis = function () {
            var urls = ProfileService.CALC_SERVER_HOST + 'his_trade/orders?code='+  $scope.securityCodeAdapt($scope.minuteTicks.code) +'&date='+ $scope.filterArgs.toDate.yyyymmdd();
            $http.get(urls).then(function (response) {
                console.info('xx');
                $scope.accountDisplay.code = response.data.code;
                $scope.accountDisplay.orders = response.data.orders;
                $scope.filterOrdersAndKnocks();
                // $scope.initPointLine();
                $scope.getScatterData();
            }).catch(function (response) {
                console.info('xx');
            });
        }

        $scope.getLines = function (flag, index) {
            var ticks = [];
            if(flag == 'order'){
                for (var i = 0; i < 240; i++){
                    if($scope.orderTags[i].orders.length < index+1){
                        continue;
                    }
                    var order = $scope.orderTags[i].orders[index];
                    var tt = '●';
                    var font_size = '16px';
                    ticks.push({
                        x:i,
                        title: tt,
                        color:'transparent',
                        name:order.id,//委托号
                        style:{
                            color:order.status == 2?"#acacac":(order.direction==0?"#ff0000":"#00ff00"),
                            fontSize:font_size,
                            // fontWeight:font_weight,
                            cursor:'pointer',
                        }
                    });
                }
            } else if(flag == 'knock'){
                for (var i = 0; i < 240; i++){
                    if($scope.knockTags[i].orders.length < index+1){
                        continue;
                    }
                    var order = $scope.knockTags[i].orders[index];
                    ticks.push({
                        x:i,
                        title: '◆',
                        color:'transparent',
                        name:order.id,//委托号
                        style:{
                            color:order.direction==0?"#ff0000":"#00ff00",
                            fontSize:'16px',
                            fontWeight:'bold',
                            cursor:'pointer',
                        }
                    });
                }
            }
            return ticks;
        }

        //刷新委托标记和成交标记
        $scope.filterOrdersAndKnocks = function () {
            if($scope.minuteTicks.code == '')
                return;
            for(var xxx = 0; xxx < 240; xxx++){
                $scope.orderTags[xxx].orders.splice(0);
                $scope.knockTags[xxx].orders.splice(0);
            }
            var order_points = [];//x:[]
            var knock_points = [];
            for(var i = 0; i < $scope.accountDisplay.orders.length; i++){
                var order = $scope.accountDisplay.orders[i];
                // if(order.code != $scope.stockCodesDic[$scope.minuteTicks.code].code)
                //     continue;
                var createTime = order.createTime.substring(11);//2017-05-17 09:52:12
                order_points.push(order);
                if(order.status == 1){
                    knock_points.push(order);
                }
            }
            var ordersorted = [];
            if(order_points.length > 0){
                ordersorted = order_points.sort(function (a, b) {
                    var a_hour = a.createTime.substring(11, 13);
                    var a_minute = a.createTime.substring(14, 16);
                    var a_second = a.createTime.substring(17, 19);
                    var b_hour = b.createTime.substring(11, 13);
                    var b_minute = b.createTime.substring(14, 16);
                    var b_second = b.createTime.substring(17, 19);
                    var time_a = parseInt(a_hour + a_minute + a_second);
                    var time_b = parseInt(b_hour + b_minute + b_second);
                    return time_a - time_b;
                });
            }
            var knocksorted = [];
            if(knock_points.length > 0) {
                knocksorted = knock_points.sort(function (a, b) {
                    var a_hour = a.updateTime.substring(11, 13);
                    var a_minute = a.updateTime.substring(14, 16);
                    var a_second = a.updateTime.substring(17, 19);
                    var b_hour = b.updateTime.substring(11, 13);
                    var b_minute = b.updateTime.substring(14, 16);
                    var b_second = b.updateTime.substring(17, 19);
                    var time_a = parseInt(a_hour + a_minute + a_second);
                    var time_b = parseInt(b_hour + b_minute + b_second);
                    return time_a - time_b;
                });
            }

            for(var k in ordersorted){
                var order = ordersorted[k];
                var hour = order.createTime.substring(11, 13);
                var minute = order.createTime.substring(14, 16);
                if(hour < 9 || (hour==9&&minute<30) || hour == 12 || (hour==11&&minute>=30) || hour >15){//过滤非交易时间段内的数据
                    continue;
                }
                var x = 0;
                if(parseInt(hour) < 12){
                    x = (parseInt(hour) - 10) * 60 + 30 + parseInt(minute);
                } else {
                    x = (parseInt(hour) - 13) * 60 + 120 + parseInt(minute);
                }
                if(x >= 240)
                    continue;
                $scope.orderTags[x].orders.push(order);
            }
            for(var k in knocksorted){
                var order = knocksorted[k];
                var hour = order.updateTime.substring(11, 13);
                var minute = order.updateTime.substring(14, 16);
                if(hour < 9 || (hour==9&&minute<30) || hour == 12 || (hour==11&&minute>=30) || hour >15){//过滤非交易时间段内的数据
                    continue;
                }
                var x = 0;
                if(parseInt(hour) < 12){
                    x = (parseInt(hour) - 10) * 60 + 30 + parseInt(minute);
                } else {
                    x = (parseInt(hour) - 13) * 60 + 120 + parseInt(minute);
                }
                if(x >= 240)
                    continue;
                $scope.knockTags[x].orders.push(order);
            }
        }

        $scope.showTags = [];

        $scope.getScatterData = function () {
            $scope.showTags.splice(0);
            for( var xxx = 0; xxx <= 240; xxx++){
                var orders = $scope.orderTags[xxx];
                var knocks = $scope.knockTags[xxx];
                var yVal = $scope.showTicks.length > xxx ? $scope.showTicks[xxx] : 0;
                if($scope.minuteTicks.tagMode == 1 || $scope.minuteTicks.tagMode ==2){
                    for( var i = 0; i < orders.orders.length; i++) {
                        var color_ = (orders.orders[i].status == '2' || orders.orders[i].status == 0)?"#acacac":(orders.orders[i].direction==0?"#ff0000":"#00ff00");
                        var tagMark = {
                            x:xxx,
                            y:yVal.y - 0.3 * (1 + i),
                            id:'order_'+orders.orders[i].id,
                            name:'委托',
                            marker:{
                                enable:true,
                                symbol:'circle',
                                fillColor:color_,
                                lineWidth:2,
                                lineColor:color_,
                            },
                            events:{
                                mouseOver:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'knock_' + id1.substring(6);
                                    $scope.MakePairSelect(true, idd);
                                },
                                mouseOut:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'knock_' + id1.substring(6);
                                    $scope.MakePairSelect(false, idd);
                                }
                            }
                        };
                        $scope.showTags.push(tagMark);
                    }
                }

                if($scope.minuteTicks.tagMode == 1 || $scope.minuteTicks.tagMode == 3) {
                    for(var i = 0; i < knocks.orders.length; i++){
                        var color_ = knocks.orders[i].direction == 0 ? "#ff0000" : "#00ff00";
                        $scope.showTags.push({
                            x:xxx,
                            y:yVal.y + 0.3 * (1 + i),
                            id:'knock_'+knocks.orders[i].id,
                            name:'成交',
                            marker:{
                                enable:true,
                                symbol:'diamond',
                                fillColor:color_,
                                lineWidth:2,
                                lineColor:color_,
                            },
                            events:{
                                mouseOver:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'order_' + id1.substring(6);
                                    $scope.MakePairSelect(true, idd);
                                },
                                mouseOut:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'order_' + id1.substring(6);
                                    $scope.MakePairSelect(false, idd);
                                }
                            }
                        });
                    }
                }

            }
        }

        $scope.MakePairSelect = function (flag, id_) {
            var chart = angular.element(
                document.getElementById('myhighchart')
            ).highcharts();
            if(!chart)
                return;
            var p1 = chart.get(id_);
            if(!p1)
                return;
            // p1.update({marker:{
            //     lineWidth:lineWidth_,
            // }}, false, false)
            p1.select(flag);
        }

        $scope.calcMinuteTicks = function () {
            var cur_price = $scope.minuteTicks.openPrice > 0 ? $scope.minuteTicks.openPrice:$scope.minuteTicks.preClose;
            $scope.showTicks.splice(0);
            var multiply = $scope.stockCodesDic[$scope.minuteTicks.code].type == '0' ? 100 : 1000;

            // var multiply = 100;
            // var datas = $scope.minuteTicks.datas.sort();
            if($scope.minuteTicks.datas.length > 0){
                var lowest = cur_price;
                var highest = cur_price;
                for(var ii = 0; ii < $scope.minuteTicks.datas.length; ii++){
                    if($scope.minuteTicks.datas[ii] == 0){
                        $scope.minuteTicks.datas[ii] = cur_price;
                    }
                    cur_price = $scope.minuteTicks.datas[ii];
                    if(lowest > $scope.minuteTicks.datas[ii]){
                        lowest = $scope.minuteTicks.datas[ii];
                    }
                    if(highest < $scope.minuteTicks.datas[ii]){
                        highest = $scope.minuteTicks.datas[ii];
                    }
                }
                var amplitude = (highest - $scope.minuteTicks.preClose) > ($scope.minuteTicks.preClose - lowest) ? (highest - $scope.minuteTicks.preClose) : ($scope.minuteTicks.preClose - lowest);
                amplitude = amplitude * multiply;
                if(amplitude <= 6){
                    $scope.minuteTicks.highLimit = $scope.minuteTicks.preClose *multiply + 8;
                    $scope.minuteTicks.lowLimit = $scope.minuteTicks.preClose *multiply - 8;
                } else {
                    var max = Math.round(amplitude);
                    max = Math.round(max/6)*8;
                    $scope.minuteTicks.highLimit = Math.round($scope.minuteTicks.preClose*multiply + max) ;
                    $scope.minuteTicks.lowLimit = Math.round($scope.minuteTicks.preClose*multiply - max);
                }
            }
            var base_price = $scope.minuteTicks.preClose * multiply;
            for(var i = 0; i < $scope.minuteTicks.datas.length; i++){
                var xxp = $scope.minuteTicks.datas[i]*multiply;
                var vv = (xxp - base_price)/(base_price - $scope.minuteTicks.lowLimit) * 8.0;
                $scope.showTicks.push({x:i, y:vv, events:{mouseOver:function (eve) {
                    $scope.minuteTicks.xValue = eve.target.x;
                }}});
            }
        }

        $scope.getData = function () {
            $scope.minuteTicks.type = $scope.stockCodesDic[$scope.minuteTicks.code].type;
            $scope.getMinuteTicks();

        }

        $scope.getMinuteTicks = function () {
            var urls = ProfileService.CALC_SERVER_HOST + $scope.securityCodeAdapt($scope.minuteTicks.code) +'/his_timebar?from='+$scope.filterArgs.toDate.yyyymmdd();
            $http.get(urls).then(function (response) {
                $q.when().then(function () {
                    $scope.minuteTicks.datas = response.data.prices;
                    $scope.minuteTicks.openPrice = response.data.open;
                    $scope.minuteTicks.preClose = response.data.preClose;
                    if($scope.minuteTicks.datas.length == 240){
                        $scope.minuteTicks.datas.push(response.data.close);
                    }
                    $scope.calcMinuteTicks();
                    $scope.getOrdersHis();
                    // $scope.myChart.series[0].setData($scope.showTicks);
                    // $scope.$apply();
                    // console.info('ss');
                    // $scope.myChart.series[0].update();
                });

            }).catch(function (response) {
                $scope.minuteTicks.datas = [];
            });
        }

        $scope.getTimeByIndex = function (x) {
            var hour = 0;
            var miniute = 0;
            if(x < 120){
                var totalminute = parseInt(x + 30);
                hour = 9 + parseInt(totalminute / 60);
                miniute = totalminute % 60;
            } else {
                var tt = parseInt(x - 120);
                hour = 13 + parseInt(tt/60);
                miniute = tt%60;
            }
            var t1 = miniute.toString();
            if(t1.length == 1){
                t1 = '0' + t1;
            }
            var timestr = hour + ":" + t1;
            return timestr;
        }

        $scope.padNumberLeft = function (val, len) {
            var ss = val.toString();
            while (ss.length < len){
                ss = '0'+ss;
            }
            return ss;
        }

        $scope.chartConfig= {
            subtitle: {
                align: 'left',
                floating: true,
                style: {'color': "#c6a300"},
                text: '',
                x: 40,
                y: 15
            },
            chart: {
                // height: 750,
                // width: 1198,
                // renderTo:'chartcontainer',
                backgroundColor: '#000',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        x: 0,
                        y: 6
                    },
                    theme: {
                        fill: 'white',
                        stroke: 'silver',
                        r: 0,
                        states: {
                            hover: {
                                // fill: '#41739D',
                                fill: '#41739D',

                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    }
                }
            },
            navigator: {
                enabled: true,
                height:26,
                series: {
                    data: []
                },
                xAxis:{
                    min:0,
                    max:240,
                    labels:{
                        enabled:true,
                        formatter:function () {
                            return $scope.getTimeByIndex(this.value);
                        }
                    }
                }
            },
            rangeSelector: {
                enabled: false
            },
            lang: {
                noData: "no data show"
            },
            noData: {
                style: {
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: '#888888'
                }
            },

            xAxis: [{
                // type: 'datetime'
                lineColor: '#A5260B',
                lineWidth: 1,
                tickAmount: 9,
                min: 0,
                max: 240,
                minTickInterval:1,
                tickLength: 8,
                labels: { // 坐标轴标签 刻度值后面加 百分号
                    align: 'right',
                    formatter: function () {
                        return '<span style="fill: red;">' + $scope.getTimeByIndex(this.value) + '</span>';
                    },
                    x: 18,
                },
                crosshair: {//十字线
                    color: 'red',
                    dashStyle: 'Dash',//Dash虚线，Solid实线
                    snap: 'true',
                    width: 1
                },
                gridLineWidth:0.5,
                gridLineColor: '#A5260B',
                gridLineDashStyle:'Dash',
                plotLines: [{
                    value: 120,
                    width: 1,
                    color: '#A5260B',
                    label: {
                        align: 'right',
                        y: -3,
                        x: 0,
                    }
                }],
            }],

            yAxis: [
                {  // -- 第 0 个 y 轴 -- 行情

                    labels: {
                        // format : '{value}',
                        formatter: function () {
                            var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                            var lengthstep = $scope.minuteTicks.type == '0' ? 2 : 3;
                            var price = ($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit) *(this.value/8.0);

                            if(this.value == 0){
                                return '<span style="fill: gray;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            } else if(this.value < 0){
                                return '<span style="fill: green;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            } else {
                                return '<span style="fill: red;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            }
                        },
                        align: 'right',
                        x: -5
                    },
                    title: {
                        text: '证券行情'
                    },
                    opposite: false,
                    // height: '75%',
                    height: '100%',
                    //lineWidth: 2,
                    // tickInterval : 1,
                    // ceiling:40,
                    lineColor: '#A5260B',
                    // lineWidth: 1,
                    min:-8,
                    max:8,
                    // minTickInterval:1,
                    gridLineWidth:0.5,
                    gridLineColor: '#A5260B',
                    gridLineDashStyle:'Dash',
                    tickAmount: 17,
                    crosshair: {
                        color: 'red',
                        dashStyle: 'Dash',//Dash虚线，Solid实线
                        snap: 'true',
                        width: 1
                    }
                },
                // {  // -- 第 1 个  -- 分时量
                //     labels: {
                //         format: '{value}',
                //         align: 'right',
                //         x: -5,
                //
                //     },
                //     title: {
                //         text: '分时量'
                //     },
                //     top: '80%',
                //     opposite: false,
                //     height: '20%',
                //     gridLineWidth:0.5,
                //     gridLineColor: '#A5260B',
                //     gridLineDashStyle:'Dash',
                //     offset: 0,
                //     //lineWidth: 2
                //     tickAmount: 6,
                // },
                {     // -- 第 2 个 -- 百分比
                    // gridLineColor: '#FFF0F0',  // 网格线的颜色
                    // gridLineDashStyle :'Dash',  // 网格线的形状
                    // gridLineWidth: 2,
                    labels: { // 坐标轴标签 刻度值后面加 百分号
                        format: '{value}%',
                        align: 'left',
                        formatter: function () {
                            var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                            var percent = Math.round((Math.abs(this.value)/8)*100*(($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit)/$scope.minuteTicks.preClose))/step;
                            if (0 == this.value) {
                                return '<span style="fill: gray;">' + this.value + '%</span>';
                            } else if (this.value < 0) {
                                return '<span style="fill: green;">' + percent + '%</span>';
                            } else {
                                return '<span style="fill: red;">' + percent + '%</span>';
                            }
                        },
                        x: 6,//相对图表的x轴偏移
                    },
                    title: {
                        text: '百分比 ',
                    },
                    offset: 0,
                    min: -8,
                    max: 8,
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#A5260B',
                        label: {
                            align: 'right',
                            y: 2,
                            x: 0
                        }
                    }],
                    tickAmount: 17,
                    // lineWidth: 2,
                    height: '100%',
                    opposite: true,
                    gridLineWidth:0,
                    // lineColor: '#A5260B',
                    // lineWidth: 1,
                    /*  min: -7,
                     max: 7, */
                    // tickInterval :10,
                    /*  startOnTick: false,
                     endOnTick:false */

                }
            ],

            legend: {
                enabled: false
            },
            title: {
                text: '历史交易标记',
                style: {'color': "#c6a300",'font-height':'900'},
            },
            credits: {
                enabled: false
            },

            loading: false,
            tooltip: {
                headerFormat: '<div class="header" style="color: #fcfcfc">行情</div>',
                pointFormat: '<div class="line"><div class="circle" style="background-color:{series.color};float:left;margin-left:10px!important;clear:left;"></div><label class="country" style="float:left;color: red">{series.name}线条名字</label><label class="country" style="float:left;">{point.y}ddddddddddddd </label></div>',
                pointFormatter:function () {
                    // var  time = '';
                    // if(this.x <= 120){
                    //     time = $scope.padNumberLeft(parseInt((this.x+30)/60 + 9), 2) + ':' + $scope.padNumberLeft(parseInt((this.x+30)%60), 2);
                    // }else{
                    //     time = $scope.padNumberLeft(parseInt((this.x-120)/60+13), 2) + ':' + $scope.padNumberLeft(parseInt(this.x%60), 2);
                    // }
                    var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                    var lengthstep = $scope.minuteTicks.type == '0' ? 2 : 3;
                    var price = ($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit) *(this.y/8.0);
                    var pp = $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep);
                    var msg = '时间：' + $scope.getTimeByIndex(this.x);
                    msg += '<br/>价格：' + pp;
                    return msg;
                },
                borderWidth: 0,
                positioner: function () {
                    var width = document.getElementById('chartcontainer').clientWidth;
                    var xx = $scope.minuteTicks.xValue > 120 ? (width/4):(width*3/4);
                    return { x: xx, y: 80 };
                },

                borderRadius: 5,
                borderColor: '#a4a4a4',
                shadow: false,
                useHTML: true,
                percentageDecimals: 2,
                backgroundColor: "rgba(180,180,180,.7)",
                style: {
                    padding: 0
                },
                // shared: true
            },

            series: [
                {
                    id: 'lineQuotaMinute',
                    // name: 'Usage Time',
                    data: $scope.showTicks,
                    type: 'line',
                    lineWidth:1,
                    states:{
                        hover:{
                            lineWidth:1
                        }
                    },
                    yAxis: 0,
                    tooltip: {
                        valueSuffix: ' sec'
                    },
                    color: '#fcfcfc'
                },
                {
                    type:'scatter',
                    data:$scope.showTags,
                    tooltip: {
                        headerFormat: '<div class="header" style="color: #fcfcfc"><b>{point.key}</b></div>',
                        pointFormatter:function () {
                            var orderTime = '';//委托时间
                            var knockTime = '';//成交时间
                            var quantity = 0;//成交数量
                            var matchPrice = '';//成交价格
                            var price = 0;//委托价格
                            var orderType = '';//委托类型
                            var color = '';
                            var status = '0';
                            if(this.name == '委托'){
                                for(var i in $scope.orderTags[this.x].orders){
                                    var order = $scope.orderTags[this.x].orders[i];
                                    if(order.id == this.id.substring(6)){
                                        knockTime = order.updateTime.length > 12 ? order.updateTime.substring(11) : '';
                                        orderTime = (order.createTime.length > 12) ? order.createTime.substring(11) : '';
                                        quantity = order.quantity;
                                        matchPrice = order.matchPrice;
                                        price = order.price;
                                        orderType = order.direction == 0 ? '买单' : '卖单';
                                        status = order.status;
                                        break;
                                    }
                                }
                            } else {
                                for(var i in $scope.knockTags[this.x].orders){
                                    var order = $scope.knockTags[this.x].orders[i];
                                    if(order.id == this.id.substring(6)){
                                        knockTime = order.updateTime.length > 12 ? order.updateTime.substring(11) : '';
                                        orderTime = (order.createTime.length > 12) ? order.createTime.substring(11) : '';
                                        quantity = order.quantity;
                                        matchPrice = order.matchPrice;
                                        price = order.price;
                                        orderType = order.direction == 0 ? '买单' : '卖单';
                                        status = order.status;
                                        break;
                                    }
                                }
                            }

                            var s = '<span style="color: #fcfcfc">委托号：'+ this.id.substring(6);
                            s += '<br/>委托时间：' + orderTime;
                            if(status == '2'){
                                s += '<br/>撤单时间：' + knockTime;
                            } else if (status == '1'){
                                s += '<br/>成交时间：' + knockTime;
                            }

                            s += '<br/>委托类型：' + orderType;
                            s += '<br/>委托价格：' + price;
                            s += '<br/>成交价格：' + matchPrice;
                            if(status == '1') {
                                s += '<br/>成交/委托数量：' + quantity + '/' + quantity + '股';
                            } else {
                                s += '<br/>成交/委托数量：0/' + quantity + '股';
                            }

                            if(status == '2'){
                                s += '<br/>状态：已撤单';
                            } else if(status == '1'){
                                s += '<br/>状态：已成交';
                            } else {
                                s += '<br/>状态：未成交已撤单';
                            }
                            s += '</span>'
                            return s;
                        },
                        useHTML: true,
                    },
                    marker:{
                        states:{
                            select:{
                                fillColor: '#0099ff',
                                lineWidth: 6,
                                lineColor:'#0099ff',
                            }
                        }
                    }

                }
            ],
        };//图表配置

        // $scope.myChart = Highcharts.chart('chartcontainer', $scope.chartConfig);//图表配置

        // $scope.getTooltipX = function (index) {
        //     return $scope
        // }
        var callLater = function () {
            window.setTimeout(function () {
                $q.when().then(function () {
                    // $scope.myChart.reflow();
                    var width = document.getElementById('chartcontainer').clientWidth;
                    var height = document.getElementById('chartcontainer').clientHeight;
                    // $scope.minuteTicks.xValue = parseInt(width/4);
                    $scope.chartConfig.chart.height = height;
                    $scope.chartConfig.chart.width = width;
                });
            },10);
        }
        function fixHeight() {
            var height_ = document.documentElement.clientHeight - (86 + 80 + 40);
            $scope.myStyles.height = height_;
            // height_ = 100;
            var a1 = height_ + "px";
            $scope.chartsHeight = {
                "height": a1
            };
            // $scope.myChart.reflow();
            callLater();
        }
        fixHeight();

        var resizeCall = $rootScope.$on("OnWindowResize", fixHeight);
        $scope.$on('$destroy', function () {
            resizeCall();
        });

    };

})();
(function () {

    'use strict';

    angular.module('myApp.pages.simulation.trade')
        .controller('TradeCtrl', TradeCtrl)
        .controller('VolumeEditModalCtrl', VolumeEditModalCtrl)
        .controller('CodeEditModalCtrl', CodeEditModalCtrl)
        .filter('orderTableFilter', function ($filter) {
            return function (input, predicate) {
                return $filter('filter')(input, predicate, true);
            }
        })
        .directive('stSearchOutside', function()
        {
            return {
                require:'^stTable',
                scope: {
                    stSearchOutside:'='
                },
                link: function(scope, element, attr, ctrl)
                {
                    scope.$watch('stSearchOutside', function(val)
                    {
                        if(val == '全部'){
                            return ctrl.search('');
                        }
                        return ctrl.search(val);
                    });
                }
            }
        })
        .directive('checkboxSearch', function ($parse, $timeout) {
            return {
                restrict: 'A',
                require: '^stTable',
                link: function (scope, element, attr, ctrl) {
                    var true_value = attr.ngTrueValue == undefined ? true : attr.ngTrueValue;
                    var false_value = attr.ngFalseValue == undefined ? false : attr.ngFalseValue;
                    var tableCtrl = ctrl;
                    var promise = null;
                    var throttle = 0;
                    var event = "change";

                    attr.$observe('checkboxSearch', function (newValue, oldValue) {
                        var checked = element.prop("checked");
                        console.info("cccccc...." + checked + "newValue = " + newValue);
                        if (newValue !== oldValue) {
                            ctrl.tableState().search = {};
                            tableCtrl.search(checked ? true_value : false_value, newValue);
                        }
                    });

                    //table state -> view
                    scope.$watch(function () {
                        return ctrl.tableState().search;
                    }, function (newValue, oldValue) {
                        var predicateExpression = attr.stSearch || '$';
                        if (newValue.predicateObject && $parse(predicateExpression)(newValue.predicateObject) !== element[0].value) {
                            element[0].value = $parse(predicateExpression)(newValue.predicateObject) || '';
                        }
                    }, true);

                    // view -> table state
                    element.bind(event, function (evt) {
                        var checked = element.prop("checked");
                        if (promise !== null) {
                            $timeout.cancel(promise);
                        }
                        promise = $timeout(function () {
                            console.info("aaaa...." + checked);
                            tableCtrl.search(checked ? true_value : false_value, attr.checkboxSearch || '');
                            promise = null;
                        }, throttle);
                    });

                    element.prop("checked", true);
                }
            }
        });

    function TradeCtrl($scope, $q, $rootScope, $state, $http, $timeout, $uibModal, $window, ProfileService, modalService, TokenCheckService) {
        var ctrl = $scope;

        $scope.stockList = [];
        // $scope.asset = 0;
        $scope.bsFlag = 'b';
        $scope.filterCode = {code:''};
        $scope.clickFilter = function () {
            $scope.filterCode.code = '';
        }

        $scope.stepPrice = {price: 0.001};//最小价格变动单位
        $scope.quickPendNotice = true;//双击下单提示
        $scope.quickCancelNotice = true;

        $scope.priceRate = 0;

        $scope.commVolume = {v1: 100, v2: 200, v3: 300, v4: 400, v5: 500};
        var xx = $window.localStorage.getItem("customCommVolume");
        if (xx != null) {
            $scope.commVolume = JSON.parse(xx);
        }
        $scope.pendingArgs = {
            code: '',
            name: '',
            buyVolume: 100,
            buyPrice: 0,
            sellVolume: 100,
            sellPrice: 0,
            canSellVolume: 0
        };
        $scope.preClose = 0;

        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        $scope.commissionRates = {
            stock_buy_rate : 0.00003,
            stock_sell_rate : 0.00003,
            fund_buy_rate : 0.00003,
            fund_sell_rate : 0.00003
        };
        $scope.iopv = {
            code: null,
            time: 0,
            serverTime: 0,
            buyIopv: 0,
            sellIopv: 0,
            lastIopv: 0,
            sgZyj: 0,
            shZyj: 0,
            buyNoneCostIopv: 0,
            sellNoneCostIopv: 0
        }
        // var getCommissionRates = function () {
        //     $http.get(ProfileService.SERVICE_TRADE + "commission_rate").then(function (response) {
        //         $scope.commissionRates.stock_buy_rate = response.data.stockBuyRate;
        //         $scope.commissionRates.stock_sell_rate = response.data.stockSellRate;
        //         $scope.commissionRates.fund_buy_rate = response.data.fundBuyRate;
        //         $scope.commissionRates.fund_buy_rate = response.data.fundBuyRate;
        //     }).catch(function (response) {
        //         modalService.showInform({}, {bodyText: '获取费率失败，请确认以下错误信息！' + "<br>失败原因：" + ((response.data && response.data.error) ? response.data.error : "服务异常") + "！"});
        //     });
        // };
        // getCommissionRates();

        $scope.profit = 0;
        //计算实时盈亏
        var getProfit = function () {
            var buyAmount = 0;
            var buyQuantity = 0;
            var sellAmount = 0;
            var sellQuantity = 0;
            if($scope.matchPrice == null || $scope.pendingArgs.code == null)
            {
                $scope.profit = 0;
                return;
            }
            for (var i in $scope.accountDisplay.orders){
                var order = $scope.accountDisplay.orders[i];
                if(order.codeKey.substring(2) != $scope.pendingArgs.code)
                    continue;
                if(order.status != 1)
                    continue;
                //0买1卖
                if(order.direction == 0)
                {
                    buyAmount = buyAmount + order.matchPrice * order.quantity + order.commission;
                    buyQuantity = buyQuantity + order.quantity;
                }
                else if(order.direction == 1)
                {
                    sellAmount = sellAmount + order.matchPrice * order.quantity - order.commission;
                    sellQuantity = sellQuantity + order.quantity;
                }
            }
            $scope.profit = sellAmount - buyAmount;
            var leftQuantity = buyQuantity - sellQuantity;
            if(leftQuantity > 0)
            {
                var stockCode = $scope.stockCodesDic[$scope.pendingArgs.code];
                //1股票2基金
                if(stockCode != null && stockCode.type == 1)
                {
                    $scope.profit =  $scope.profit + leftQuantity * $scope.matchPrice * (1 - $scope.commissionRates.stock_sell_rate);
                }
                else if(stockCode != null && stockCode.type == 2)
                {
                    $scope.profit =  $scope.profit + leftQuantity * $scope.matchPrice * (1 - $scope.commissionRates.fund_sell_rate);
                }
                else
                {
                    $scope.profit =  $scope.profit + leftQuantity * $scope.matchPrice;
                }
            }
            else if(leftQuantity < 0)
            {
                var stockCode = $scope.stockCodesDic[$scope.pendingArgs.code];
                //1股票2基金
                if(stockCode != null && stockCode.type == 1)
                {
                    $scope.profit =  $scope.profit + leftQuantity * $scope.matchPrice * (1 + $scope.commissionRates.stock_buy_rate);
                }
                else if(stockCode != null && stockCode.type == 2)
                {
                    $scope.profit =  $scope.profit + leftQuantity * $scope.matchPrice * (1 + $scope.commissionRates.fund_buy_rate);
                }
                else
                {
                    $scope.profit =  $scope.profit + leftQuantity * $scope.matchPrice;
                }
            }
        };
        $scope.clearProfit = function () {
            $scope.matchPrice == null;
            $scope.profit = 0;
            $scope.iopv = {
                code: null,
                time: 0,
                serverTime: 0,
                buyIopv: 0,
                sellIopv: 0,
                lastIopv: 0,
                sgZyj: 0,
                shZyj: 0,
                buyNoneCostIopv: 0,
                sellNoneCostIopv: 0
            }
        };
        $scope.getProfitStyle = function () {
            return $scope.profit >= 0 ? {'color': '#c52d2f'} : {'color': '#29a329'};
        };

        $scope.getQuotaBorderStyle = function (keyname) {
            var styles = {'padding': '0px', 'line-height': '1.42857143', 'vertical-align': 'top'};
            if (keyname == 'bp1') {
                styles['border-top'] = '1px solid #3c3c3c';
                styles['border-bottom'] = 'none';
            } else if (keyname == 'sp1' || keyname == 'lowLimit') {
                styles['border-bottom'] = '1px solid #3c3c3c';
                styles['border-top'] = 'none';
            } else {
                styles['border-top'] = 'none';
                styles['border-bottom'] = 'none';
            }
            return styles;
        }

        $scope.priceLevelClick = function (price) {
            if ($scope.bsFlag == 'b') {
                $scope.pendingArgs.buyPrice = price;
            } else {
                $scope.pendingArgs.sellPrice = price;
            }
        }

        $scope.getPriceLevelColor = function (price) {
            if (price == $scope.preClose) {
                return {'color': '#ffffff'};
            } else if (price > $scope.preClose) {
                return {'color': '#c52d2f'}
            } else {
                return {'color': '#29a329'};
            }
        };

        $scope.getPricePercentColor = function () {
            if ($scope.priceRate == 0) {
                return {'color': '#ffffff'};
            } else if ($scope.priceRate > 0) {
                return {'color': '#c52d2f'}
            } else {
                return {'color': '#29a329'};
            }
        }


        $scope.orderProcess = function (arr) {
            var myarr = [];
            for (var index in arr) {
                if (index >= 5)
                    break;
                myarr.push(arr[index]);
            }
            return myarr;
        }

        $scope.getTotalOrderVolume = function (arr) {
            var vol = 0;
            arr.forEach(function (val, index, array) {
                vol += val.volume;
            });
            return vol;
        }

        $scope.priceLevelSellOrders = {//卖盘
            highLimit: {orders: [], price: 0, volume: ''},
            sp5: {orders: [], price: 0, volume: 0},// {orderNo: '302130', volume: 2000, price: 1.021},
            sp4: {orders: [], price: 0, volume: 0},
            sp3: {orders: [], price: 0, volume: 0},
            sp2: {orders: [], price: 0, volume: 0},
            sp1: {orders: [], price: 0, volume: 0}
        }

        $scope.getLevelTitle = function (msg) {
            if (msg == 'lowLimit') {
                return '跌停';
            } else if (msg == 'highLimit') {
                return '涨停';
            } else {
                return msg.slice(2, 3);
            }
        }

        $scope.priceLevelOrders = {//买盘
            bp1: {orders: [], price: 0, volume: 0},
            bp2: {orders: [], price: 0, volume: 0},
            bp3: {orders: [], price: 0, volume: 0},
            bp4: {orders: [], price: 0, volume: 0},
            bp5: {orders: [], price: 0, volume: 0},
            lowLimit: {orders: [], price: 0, volume: ''}
        }

        $scope.quickPendOrder = function (bsFlag, price) {
            if ($scope.quickPendNotice) {
                modalService.showConfirm(
                    {
                        size: "sm"
                    },
                    {
                        alertStyle: bsFlag == 'b' ? "primary" : "info",
                        headerText: '委托确认',
                        bodyText: "证券代码：" + $scope.pendingArgs.code +
                        "<br>买卖方向：" + (bsFlag == 'b' ? '买入' : '卖出') +
                        "<br>委托价格：" + price +
                        "<br>委托数量：" + (bsFlag == 'b' ? $scope.pendingArgs.buyVolume : $scope.pendingArgs.sellVolume) + "<br>您是否确认以上委托？"
                    }).then(function () {
                    orderAction(bsFlag == 'b' ? 0 : 1, price);
                }).catch(function () {
                    console.info('canceled');
                })
            } else {
                orderAction(bsFlag == 'b' ? 0 : 1, price);
            }
        }

        $scope.quickCancelOrder = function (orderNo, bsFlag) {
            if ($scope.quickCancelNotice) {
                modalService.showConfirm(
                    {
                        size: "sm"
                    },
                    {
                        alertStyle: bsFlag == 'b' ? "primary" : "info",
                        headerText: '撤单确认',
                        bodyText: "您是否确认撤销该委托？"
                    }).then(function () {
                    $scope.cancelOrder(orderNo);
                }).catch(function () {
                    console.info('canceled');
                })
            } else {
                $scope.cancelOrder(orderNo);
            }
        }

        $scope.dblCancelLevelOrders = function (price, bsFlag) {
            if ($scope.quickCancelNotice) {
                modalService.showConfirm(
                    {
                        size: "sm"
                    },
                    {
                        alertStyle: bsFlag == 'b' ? "primary" : "info",
                        headerText: '撤单确认',
                        bodyText: "您是否确认撤单？"
                    }).then(function () {
                    $scope.cancelLevelOrders(price);
                }).catch(function () {
                })
            } else {
                $scope.cancelLevelOrders(price);
            }
        }

        $scope.cancelLevelOrders = function (price) {
            var  order_list = [];
            for (var key in $scope.priceLevelOrders) {
                var vv = $scope.priceLevelOrders[key];
                if (vv.price == price) {
                    for (var i in vv.orders) {
                        // $scope.cancelOrder(vv.orders[i].orderNo);
                        order_list.push(vv.orders[i].orderNo);
                    }
                    // vv.orders.splice(0, vv.orders.length);
                    if (order_list.length > 0) {
                        $scope.cancelMultiOrder(order_list);
                    }
                    return;
                }
            }
            for (var key in $scope.priceLevelSellOrders) {
                var vv = $scope.priceLevelSellOrders[key];
                if (vv.price == price) {
                    for (var i in vv.orders) {
                        // $scope.cancelOrder(vv.orders[i].orderNo);
                        order_list.push(vv.orders[i].orderNo);
                    }
                    // vv.orders.splice(0, vv.orders.length);
                    if (order_list.length > 0) {
                        $scope.cancelMultiOrder(order_list);
                    }
                    return;
                }
            }
        }

        $scope.getPaddingWidth = function (arr) {
            if (arr.length >= 5) {
                return {'width': '53px'};
            } else {
                return {'width': 53 * (6 - (arr.length > 0 ? arr.length : -1)) + 'px'}
            }
        }

        $scope.getMoreFlag = function (arr) {
            if (arr.length > 5) {
                return '...';
            } else {
                return '';
            }
        }

        $scope.getBsStyle = function (bsflag) {
            if (bsflag == $scope.bsFlag) {
                return {
                    'border': '1px solid #ff2d2d',
                    // 'border-radius': '5px',
                    'box-shadow': 'rgba(0, 0, 0, 0.6) 0px 0px 10px'
                };
            } else {
                return {'border': '1px solid #3c3c3c'};
            }
        }

        $scope.getQuotaPrice = function (bsflag, level) {
            var data1 = 0;
            if (bsflag == 'b') {
                if ($scope.quotaData.bp.length < level)
                    return '';
                data1 = $scope.quotaData.bp[level];
            } else {
                if ($scope.quotaData.sp.length < level)
                    return '';
                data1 = $scope.quotaData.sp[level];
            }
            return $scope.toStringEx(data1, 2);
        }

        $scope.pendingPriceAdd = function (bsflag, updown, max) {
            var s = $scope.stepPrice.price.toString();
            var rs = s.indexOf('.');
            var steps = s.length - rs - 1;
            if (bsflag == 'b') {
                $scope.pendingArgs.buyPrice = parseFloat($scope.toStringEx(parseFloat($scope.pendingArgs.buyPrice) + (updown == 'up' ? ($scope.stepPrice.price * max) : -($scope.stepPrice.price * max)), steps));
            } else {
                $scope.pendingArgs.sellPrice = parseFloat($scope.toStringEx(parseFloat($scope.pendingArgs.sellPrice) + (updown == 'up' ? ($scope.stepPrice.price * max) : -($scope.stepPrice.price * max)), steps));
            }
        }

        $scope.getHands = function (x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return '';
            }
            return Math.round(x / 100);
        }

        //浮点数转字符串，精确小数点后length位
        $scope.toStringEx = function (x, length) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return '';
            }
            var f = Math.round(x * Math.pow(10, length)) / Math.pow(10, length);
            var s = f.toString();
            var rs = s.indexOf('.');
            if (rs < 0) {
                rs = s.length;
                s += '.';
            }
            while (s.length <= rs + length) {
                s += '0';
            }
            return s;
        }

        $scope.formatNumber = function (num) {//千分位分割
            if (isNaN(num)) {
                throw new TypeError("num is not a number");
            }
            return ("" + num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
        }

        $scope.pendingVolumeAdd = function (bsflag, updown) {
            if (bsflag == 'b') {
                $scope.pendingArgs.buyVolume = parseInt($scope.pendingArgs.buyVolume) + (updown == 'up' ? 100 : -100);
                if($scope.pendingArgs.buyVolume <= 0){
                    $scope.pendingArgs.buyVolume = 100;
                }
            } else {
                $scope.pendingArgs.sellVolume = parseInt($scope.pendingArgs.sellVolume) + (updown == 'up' ? 100 : -100);
                if($scope.pendingArgs.sellVolume <= 0){
                    $scope.pendingArgs.sellVolume = 100;
                }
            }
        }

        $scope.volumeClick = function (volume) {
            if ($scope.bsFlag == 'b') {
                $scope.pendingArgs.buyVolume = parseInt(volume);
            } else {
                $scope.pendingArgs.sellVolume = parseInt(volume);
            }
        }

        $scope.commVolumeSet = function () {
            showVolumeEditModal({}, {commVolume: $scope.commVolume}).then(function (result) {

                $window.localStorage.setItem("customCommVolume", JSON.stringify($scope.commVolume));
            }).catch(function (result) {

            });
        }


        var modalCodeDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'CodeEditModalCtrl',
            templateUrl: 'app/pages/simulation/trade/codeEditModal.html',
            size: 'sm',
            resolve: {
                modalOptions: null
            }
        };

        var modalCodeOptions = {
            closeButtonText: '取消',
            actionButtonText: '确定',
            headerText: '选择可交易证券',
            bodyText: '',
            alertStyle: 'primary'
        };

        var showCodeEditModal = function (customModalDefaults, customModalOptions) {
            var tempModalDefaults = {};
            var tempModalOptions = {};
            angular.extend(tempModalDefaults, modalCodeDefaults, customModalDefaults);
            angular.extend(tempModalOptions, modalCodeOptions, customModalOptions);
            tempModalDefaults.resolve.modalOptions = tempModalOptions;
            return $uibModal.open(tempModalDefaults).result;
        };

        $scope.commCodeSet = function () {
            showCodeEditModal({}, {commVolume: $scope.commVolume}).then(function (result) {
                window.location.reload();
            }).catch(function (result) {

            });
        }

        //自动居中
        function fixWidth() {
            var width_ = document.documentElement.clientWidth - 1200;
            width_ = width_ > 0 ? width_ / 2 : 5;
            var a1 = width_ + "px";
            $scope.myMarginLeft = {
                "margin-left": a1
            };
        }

        fixWidth();

        $scope.bsSwitch = function (bsflag) {
            $scope.bsFlag = bsflag;
        };

        $scope.webclosed = false;
        var funxxx = $rootScope.$on("OnWindowResize", fixWidth);
        $scope.$on('$destroy', function () {
            funxxx();
            $scope.webclosed = true;
            if ($scope.socket != null) {
                $scope.socket.close();
            }
            if (delayed_promise != null) {
                $timeout.cancel(delayed_promise);
                delayed_promise = null;
            }
            if (keep_alive_promise != null) {
                $timeout.cancel(keep_alive_promise);
                keep_alive_promise = null;
            }
        });

        $scope.getSecurityCode = function (search) {
            var newCode = $scope.stockList.slice();
            if (search && newCode.indexOf(search) === -1) {
                newCode.unshift(search);
            }
            return newCode;
        }

        $scope.getSecurityCodeEx = function (search) {
            var newCode = $scope.stockList.slice();
            newCode.push('全部');
            if (search && newCode.indexOf(search) === -1) {
                newCode.unshift(search);
            }
            return newCode;
        }

        $scope.goHome = function () {
            modalService.showConfirm(
                {
                    size: "md"
                },
                {
                    headerText: '返回主界面',
                    bodyText: "您是否确认返回主界面？"
                }).then(function () {
                $state.go('main');
            }).catch(function () {
            })
        }

        $scope.getTradeProtocolHref = function () {
            // $state.go('resources.ruleDetails', {type: "trade"});
             var url = $state.href("resources.ruleDetails", {type: "trade"});
            window.open(url, '_blank');
        };

        $scope.displayed = [];
        $scope.callServer = function (tableState) {
            $scope.tableState = tableState;
            tableState.pagination.numberOfPages = 3;
        };

        $scope.getPriceStr = function (price) {
            var f = parseFloat(price);
            if (isNaN(f)) {
                return '--';
            }
            if(f <= 0){
                return '--';
            }
            var len = $scope.stepPrice.price == 0.01?2:3;
            return $scope.toStringEx(f, len);
        }

        $scope.requestID = 1;
        $scope.volumeBuyDic = {};
        $scope.volumeSellDic = {};
        $scope.$watch('pendingArgs.buyVolume', function (newVal, oldVal) {
            if($scope.pendingArgs.code == ''){
                return;
            }
            $scope.volumeBuyDic[$scope.pendingArgs.code] = newVal;
        });
        $scope.$watch('pendingArgs.sellVolume', function (newVal, oldVal) {
            if($scope.pendingArgs.code == ''){
                return;
            }
            $scope.volumeSellDic[$scope.pendingArgs.code] = newVal;
        });
        $scope.$watch('pendingArgs.code', function (newVal, oldVal) {
            console.info('new = ' + newVal + ', old = ' + oldVal);
            if (newVal == '') {
                return;
            }
            if(!$scope.stockCodesDic[newVal])
                return;
            if($scope.volumeBuyDic[newVal] != null){
                $scope.pendingArgs.buyVolume = $scope.volumeBuyDic[newVal];
            } else {
                $scope.pendingArgs.buyVolume = 100;
            }
            if($scope.volumeSellDic[newVal] != null){
                $scope.pendingArgs.sellVolume = $scope.volumeSellDic[newVal];
            } else {
                $scope.pendingArgs.sellVolume = 100;
            }
            $scope.pendingArgs.buyPrice = 0;
            $scope.pendingArgs.sellPrice = 0;
            $scope.minuteTicks.code = newVal;
            $scope.pendingArgs.name = $scope.stockCodesDic[newVal].codeName;
            $scope.stepPrice.price = $scope.stockCodesDic[newVal].type == '1' ? 0.01 : 0.001;
            $scope.subQuota();
        });

        $scope.securityCodeAdapt = function (code) {
            if (code != '') {
                if (code[0] != 's') {
                    code = $scope.stockCodesDic[code].codeKey;
                }
            }
            return code;
        }

        $scope.subQuota = function () {
            var codes = [];
            if($scope.pendingArgs.code != ''){
                codes.push($scope.securityCodeAdapt($scope.pendingArgs.code));
            }
            if($scope.minuteTicks.code != '' && $scope.minuteTicks.code != $scope.pendingArgs.code){
                codes.push($scope.securityCodeAdapt($scope.minuteTicks.code));
            }
            $scope.sendMsg(JSON.stringify({
                'id': $scope.requestID++,
                'type': 4,
                'data': {'codes': codes}
            }));//订阅行情
        }

        $scope.refreshLevelOrders = function () {
            for (var k in $scope.priceLevelOrders) {
                var l = $scope.priceLevelOrders[k];
                l.orders.splice(0, l.orders.length);
                for (var i in $scope.accountDisplay.orders) {
                    var order = $scope.accountDisplay.orders[i];
                    var code = order.codeKey.substring(2);
                    if (code != $scope.pendingArgs.code || order.status != 0 || order.direction != 0)//非当前代码或者不是未成交或者不是买单
                        continue;

                    if (order.price == l.price) {
                        l.orders.push({orderNo: order.id, volume: order.quantity, price: order.price});
                    }
                }
            }
            for (var k in $scope.priceLevelSellOrders) {
                var l = $scope.priceLevelSellOrders[k];
                l.orders.splice(0, l.orders.length);
                for (var i in $scope.accountDisplay.orders) {
                    var order = $scope.accountDisplay.orders[i];
                    var code = order.codeKey.substring(2);
                    if (code != $scope.pendingArgs.code || order.status != 0 || order.direction == 0)//非当前代码或者不是未成交
                        continue;

                    if (order.price == l.price) {
                        l.orders.push({orderNo: order.id, volume: order.quantity, price: order.price});
                    }
                }
            }
        }

        $scope.socket = null;
        $scope.webSocketError  = '';
        $scope.initWebSocket = function () {
            $scope.webSocketError = '';
            if (!window.WebSocket) {
                window.WebSocket = window.MozWebSocket;
            }
            if (window.WebSocket) {
                // $scope.socket = new WebSocket("ws://192.168.15.106:9000/traderelay" + '?tradekey=' + $scope.accountDisplay.tradeKey);
                $scope.socket = new WebSocket(ProfileService.getSocketUrl() + '?tradekey=' + $scope.accountDisplay.tradeKey);
                // $scope.socket = new WebSocket(ProfileService.getSocketUrl() + '?tradekey=3333333');
                $scope.socket.onmessage = function (event) {
                    var obj = JSON.parse(event.data);
                    console.info(obj)
                    if (obj.type == 5) {//行情数据
                        $q.when().then(function () {
                            // $scope.pendingArgs.name = obj.data.name;
                            if(obj.data.codeKey.substring(2) == $scope.pendingArgs.code){
                                $scope.preClose = obj.data.preClose;
                                $scope.matchPrice = obj.data.match;
                                var xxx = obj.data.match == 0 ? 0 : (obj.data.match - obj.data.preClose)/obj.data.preClose*100;
                                var hour = parseInt(obj.data.time.substr(11, 2));
                                var minute = parseInt(obj.data.time.substr(14, 2));
                                var second = parseInt(obj.data.time.substr(17, 2));
                                if(hour * 3600 + minute * 60 + second < 9*3600 + 25 * 60)
                                {
                                    if(obj.data.match == 0 && obj.data.buyPrice[0] != 0 && obj.data.preClose != 0) {
                                        xxx = (obj.data.buyPrice[0] - obj.data.preClose)/obj.data.preClose*100;
                                    }
                                }
                                // console.info('percent = ' + xxx);
                                $scope.priceRate = xxx;
                                $scope.pricePercent = $scope.toStringEx(xxx, 2) + '%';
                                var ii = 0;
                                if ($scope.pendingArgs.buyPrice == 0) {
                                    $scope.pendingArgs.buyPrice = obj.data.buyPrice[0];
                                }
                                if ($scope.pendingArgs.sellPrice == 0) {
                                    $scope.pendingArgs.sellPrice = obj.data.sellPrice[0];
                                }
                                for (var key in $scope.priceLevelOrders) {
                                    var vv = $scope.priceLevelOrders[key];
                                    if (key == 'lowLimit') {
                                        vv.price = obj.data.lowLimited;
                                        vv.volume = '';
                                    } else {
                                        vv.price = obj.data.buyPrice[ii];
                                        vv.volume = obj.data.buySize[ii];
                                    }
                                    ii++;
                                }
                                ii = 5;
                                for (var key in $scope.priceLevelSellOrders) {
                                    var vv = $scope.priceLevelSellOrders[key];
                                    if (key == 'highLimit') {
                                        vv.price = obj.data.highLimited;
                                        vv.volume = '';
                                    } else {
                                        vv.price = obj.data.sellPrice[ii];
                                        vv.volume = obj.data.sellSize[ii];
                                    }
                                    ii--;
                                }
                                $scope.refreshLevelOrders();
                            }
                            $scope.onQuotaData(obj.data);
                        });
                    } else if(obj.type == 3){//错误信息
                        $scope.webSocketError = obj.data.error;
                        // console.info('error websocket = ' + $scope.webSocketError );
                    }
                    else if(obj.type == 6){//分时数据推送
                        $q.when().then(function () {
                            $scope.onMinuteData(obj.data);
                        });
                    }
                    else if(obj.type == 8){
                        $q.when().then(function () {
                            if(obj.data.code.substring(2) == $scope.pendingArgs.code){
                                $scope.iopv.buyIopv = obj.data.buyIopv
                                $scope.iopv.sellIopv = obj.data.sellIopv
                            }
                        });
                    }
                    //22是账户更新通知
                    else if (obj.type == 22) {
                        console.info("notify account changed: " + obj.data.version);
                        $q.when().then(function () {
                            onAccountChanged(obj.data.version);
                        });
                    }
                    else if (obj.type == 20) {
                        console.info("notify order failed: " + obj.data);
                        $q.when().then(function () {
                            onOrderFailed(obj.data);
                        });
                    }
                    else if (obj.type == 23) {
                        console.info("notify cancel failed: " + obj.data);
                        $q.when().then(function () {
                            onCancelFailed(obj.data);
                        });
                    }
                };
                $scope.socket.onopen = function (event) {
                    console.info('打开WebSocket服务正常，浏览器支持WebSocket!');
                    $scope.subQuota($scope.pendingArgs.code);
                    $scope.delayedGetAccount(GET_ACCOUNT_DELAYED); //add by wangshuo 20170712
                };
                $scope.socket.onclose = function (event) {
                    console.info('WebSocket 关闭');
                    $scope.socket = null;
                    if (!$scope.webclosed) {
                        $scope.initWebSocket();
                    }
                };
            }
            else {
                alert("抱歉，您的浏览器不支持WebSocket协议！");
            }
        };

        $scope.sendMsg = function (message) {
            if (!window.WebSocket) {
                return;
            }
            if ($scope.socket == null) {
                return;
            }
            if ($scope.socket.readyState == WebSocket.OPEN) {
                $scope.socket.send(message);
            }
            else {
                // alert("WebSocket连接没有建立成功！");
            }
        };

        var keep_alive_promise = null;
        var startKeepAlive = function () {
            if (keep_alive_promise != null) {
                $timeout.cancel(keep_alive_promise);
            }
            keep_alive_promise = $timeout(function () {
                $rootScope.$emit("RefreshTokenCommand", "true");
                startKeepAlive();
            }, 15 * 60 * 1000);
        };

        $scope.accountDisplay = {
            accountId: "1916",
            stockCodes: [], //{code: "sh000001", name: "平安银行", type: "0", market: "0"}//type 0 股票，1基金
            tradeKey: "",
            curVersion: 0,
            account: null, //{}
            orders: [],
            orderDisplayedCollection: [],
            positions: [],
            itemsByPage: 10,
            // showCancelableOrder: 0,
        };

        $scope.stockCodesDic = {};
        $scope.initStockCodes = function () {
            for (var i in $scope.accountDisplay.stockCodes) {
                var stock = $scope.accountDisplay.stockCodes[i];
                $scope.stockCodesDic[stock.codeKey.substring(2)] = stock;
                $scope.stockList.push(stock.codeKey.substring(2));
                $scope.stockList = $scope.stockList.sort();
            }
        }

        $scope.isArrayNull = function (arr) {
            return arr.length > 0;
        };

        $scope.getRestCapital = function () {
            if ($scope.accountDisplay.account == null) {
                return 0;
            }
            return $scope.accountDisplay.account.baseCapital + $scope.accountDisplay.account.changedCapital - $scope.accountDisplay.account.freezedCapital;
        };

        $scope.getCanSellVolume = function () {
            for (var i = 0; i < $scope.accountDisplay.positions.length; i++) {
                if ($scope.stockCodesDic[$scope.pendingArgs.code] && $scope.accountDisplay.positions[i].codeKey == $scope.stockCodesDic[$scope.pendingArgs.code].codeKey) {
                    return $scope.accountDisplay.positions[i].baseVolume - $scope.accountDisplay.positions[i].totalSellVolume - $scope.accountDisplay.positions[i].curSellVolume;
                }
            }
            return 0;
        };

        $scope.getLongPosition = function () {
            for (var i = 0; i < $scope.accountDisplay.positions.length; i++) {
                if ($scope.stockCodesDic[$scope.pendingArgs.code] && $scope.accountDisplay.positions[i].codeKey == $scope.stockCodesDic[$scope.pendingArgs.code].codeKey) {
                    return $scope.accountDisplay.positions[i].changedVolume;
                }
            }
            return 0;
        };

        $scope.getMaxLongPosition = function () {
            for (var i = 0; i < $scope.accountDisplay.positions.length; i++) {
                if ($scope.stockCodesDic[$scope.pendingArgs.code] && $scope.accountDisplay.positions[i].codeKey == $scope.stockCodesDic[$scope.pendingArgs.code].codeKey) {
                    return $scope.accountDisplay.positions[i].maxLongPosition;
                }
            }
            return 0;
        }

        $scope.getMaxOrderVolume = function () {
            for (var i = 0; i < $scope.accountDisplay.positions.length; i++) {
                if ($scope.stockCodesDic[$scope.pendingArgs.code] && $scope.accountDisplay.positions[i].codeKey == $scope.stockCodesDic[$scope.pendingArgs.code].codeKey) {
                    return $scope.accountDisplay.positions[i].maxOrderVolume;
                }
            }
            return 0;
        }

        $scope.getLongPositionStyle = function () {
            var long_position = $scope.getLongPosition();
            return long_position >= 0 ? {'color': '#c52d2f'} : {'color': '#29a329'};
        };

        var requestAccount = function () {
            $http.post(ProfileService.SERVICE_TRADE + "accounts", null).then(function (response) {
                $scope.accountDisplay.accountId = response.data.accountId;
                $scope.accountDisplay.tradeKey = response.data.tradeKey;
                $scope.accountDisplay.stockCodes = response.data.codes;
                $scope.commissionRates.stock_buy_rate = response.data.commissionRate.stockBuyRate;
                $scope.commissionRates.stock_sell_rate = response.data.commissionRate.stockSellRate;
                $scope.commissionRates.fund_buy_rate = response.data.commissionRate.fundBuyRate;
                $scope.commissionRates.fund_sell_rate = response.data.commissionRate.fundSellRate;
                initAccount();
                if( $scope.accountDisplay.stockCodes.length == 0)
                {
                    ctrl.commCodeSet();
                }
            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '申请交易失败，请确认以下错误信息！' + "<br>失败原因：" + ((response.data && response.data.error) ? response.data.error : "服务异常") + "！"});
            });
        };

        var initAccount = function () {
            console.info("initAccount...");
            $scope.getAccount();
            $scope.initWebSocket();
            $scope.initStockCodes();
        };

        var GET_ACCOUNT_DELAYED = 0;
        var RETRY_ACCOUNT_DELAYED = 5000;

        var pendingGetVersion = 0;
        var isGettingAccount = false;
        $scope.getAccount = function (pending_version) {
            if (isGettingAccount == true) {
                // console.info("is getting account, skip...");
                pendingGetVersion = pending_version ? pending_version : Number.MAX_VALUE;
                return;
            }
            isGettingAccount = true;
            $http.get(ProfileService.SERVICE_TRADE + $scope.accountDisplay.accountId + "?from_version=" + $scope.accountDisplay.curVersion, {headers: {'TradeKey': $scope.accountDisplay.tradeKey}}).then(function (response) {
                updateAccount(response.data.account);
                updateOrders(response.data.orders);
                updatePositions(response.data.positions);
                isGettingAccount = false;
                if (pendingGetVersion >= $scope.accountDisplay.curVersion) {
                    // console.info("pendingGetVersion = " + pendingGetVersion);
                    pendingGetVersion = 0;
                    $scope.delayedGetAccount(GET_ACCOUNT_DELAYED);
                }
                //如果加载成功，则清除delayed
            }).catch(function (response) {
                //失败，则考虑延迟刷新
                isGettingAccount = false;
                if(response.status == 404) {
                    console.info("account unfound, no need reget...");
                    return;
                }
                $scope.delayedGetAccount(RETRY_ACCOUNT_DELAYED);
            });
        };

        var onOrderFailed = function (order_failed_event) {
            var error_string =
                // "证券代码：" + order_failed_event.code +
                // "<br>买卖方向：" + (order_failed_event.direction == 0 ? '买入' : '卖出') +
                // "<br>委托价格：" + order_failed_event.price +
                // "<br>委托数量：" + order_failed_event.quantity +
                "失败原因：" + order_failed_event.errorMessage + "！";
            modalService.showInform({}, {headerText: "委托失败", bodyText: error_string});
        };

        var onCancelFailed = function (order_failed_event) {
            var error_string =
                "失败原因：" + order_failed_event.errorMessage + "！";
            modalService.showInform({}, {headerText: "撤单失败", bodyText: error_string});
        };

        var delayed_promise = null;
        $scope.delayedGetAccount = function (delayed, pending_version) {
            if (delayed_promise != null) {
                // console.info("delayed_promise != null, skip it..");
                return;
            }
            delayed_promise = $timeout(function () {
                delayed_promise = null;
                $scope.getAccount(pending_version);
            }, delayed);
        };

        var onAccountChanged = function (version) {
            if ($scope.accountDisplay.curVersion <= version) {
                $scope.delayedGetAccount(GET_ACCOUNT_DELAYED, version);
            }
        };
        var updateAccount = function (account) {
            $scope.accountDisplay.account = account;
            $scope.accountDisplay.curVersion = $scope.accountDisplay.account.version + 1;
        };
        //重置委托列表
        var resetOrders = function (orders) {
            $scope.accountDisplay.orders = [];
            for (var i = 0; i < orders.length; i++) {
                $scope.accountDisplay.orders.push(orders[i]);
            }
            $scope.refreshLevelOrders();
        };
        //增量添加委托列表
        //因为orderId是递增的，所以我们通过逆序 + 值比较判断能够大大提升排序性能
        var updateOrders = function (orders) {
            var need_refresh = true;
            for (var i = 0; i < orders.length; i++) {
                var tmp_order = orders[i];
                var cur_order = {
                    id: tmp_order.id,
                    direction: tmp_order.direction,
                    codeKey: tmp_order.codeKey,
                    price: tmp_order.price,
                    quantity: tmp_order.quantity,
                    status: tmp_order.status,
                    matchPrice: tmp_order.matchPrice,
                    commission: tmp_order.commission,
                    errorCode: tmp_order.errorCode,
                    createTime: tmp_order.createTime,
                    updateTime: tmp_order.updateTime
                };
                var found = false;
                //如果增量的比最后一个id还要大，则表示为新增
                if ($scope.accountDisplay.orders.length > 0 && $scope.accountDisplay.orders[$scope.accountDisplay.orders.length - 1].id < cur_order.id) {
                    found = false;
                }
                else {
                    for (var j = $scope.accountDisplay.orders.length - 1; j >= 0; j--) {
                        if ($scope.accountDisplay.orders[j].id == cur_order.id) {
                            // angular.extend($scope.accountDisplay.orders[j], cur_order);
                            $scope.accountDisplay.orders[j] = cur_order;
                            found = true;
                            break;
                        }
                    }
                }
                if (found == false) {
                    need_refresh = false;
                    $scope.accountDisplay.orders.push(cur_order);
                }
            }
            //强制刷新
            if (need_refresh && $scope.accountDisplay.orders.length > 0) {
                var tmp_order = $scope.accountDisplay.orders[0];
                var cur_order = {
                    id: tmp_order.id,
                    direction: tmp_order.direction,
                    codeKey: tmp_order.codeKey,
                    price: tmp_order.price,
                    quantity: tmp_order.quantity,
                    status: tmp_order.status,
                    matchPrice: tmp_order.matchPrice,
                    commission: tmp_order.commission,
                    errorCode: tmp_order.errorCode,
                    createTime: tmp_order.createTime,
                    updateTime: tmp_order.updateTime
                };
                $scope.accountDisplay.orders[0] = cur_order;
            }
            $scope.refreshLevelOrders();
            $scope.filterOrdersAndKnocks();
            $scope.getScatterData();
            // $scope.initPointLine();
            //计算实时盈亏
            getProfit();
        };

        $scope.showBuyTotal = false;
        $scope.showSellTotal = false;

        $scope.getOrderCount = function (bsflag) {
            var volume = 0;
            var direct = bsflag == 'b'?0:1;
            for (var i in $scope.accountDisplay.orders){
                var order = $scope.accountDisplay.orders[i];
                if(order.codeKey.substring(2) != $scope.pendingArgs.code)
                    continue;
                if(order.direction != direct)
                    continue;
                if(order.status != 0)
                    continue;
                volume += order.quantity;
            }
            var total = parseInt(volume/100);
            if(bsflag == 'b'){
                $scope.showBuyTotal = total > 0?true:false;
            }else{
                $scope.showSellTotal = total > 0?true:false;
            }
            if(total == 0)
                return '';
            return total;
        }

        //重置持仓列表
        var resetPositions = function (positions) {
            $scope.accountDisplay.positions = [];
            for (var i = 0; i < positions.length; i++) {
                $scope.accountDisplay.positions.push(positions[i]);
            }
        };
        //增量添加持仓列表
        var updatePositions = function (positions) {
            for (var i = 0; i < positions.length; i++) {
                var cur_position = positions[i];
                var found = false;
                for (var j = 0; j < $scope.accountDisplay.positions.length; j++) {
                    if ($scope.accountDisplay.positions[j].id == cur_position.id) {
                        angular.extend($scope.accountDisplay.positions[j], cur_position);
                        found = true;
                        break;
                    }
                }
                if (found == false) {
                    $scope.accountDisplay.positions.push(cur_position);
                }
            }
        };
        //获取委托状态
        $scope.getOrderStatus = function (order) {
            if (order.status == 0) {
                return "未成交";
            }
            else if (order.status == 1) {
                return "已成交";
            }
            else if (order.status == 2) {
                return "已撤单";
            }
            else {
                return "废单";
            }
        };
        //2017-09-09
        $scope.getDayTime = function (time) {
            return time.substring(10);
        };
        //买
        $scope.buyAction = function () {
            // for(var i = 0; i < 10; i++)
            // {
            //     orderAction(0, $scope.pendingArgs.buyPrice);
            // }
            orderAction(0, $scope.pendingArgs.buyPrice);
        };
        //卖
        $scope.sellAction = function () {
            orderAction(1, $scope.pendingArgs.sellPrice);
        };
        //委托
        var orderAction = function (direction, price) {
            // if($scope.webSocketError != ''){
            //     modalService.showInform({}, {headerText: "委托失败", bodyText: $scope.webSocketError});
            //     return;
            // }
            var orderArgs = {
                accountId: $scope.accountDisplay.accountId,
                direction: direction,
                codeKey: $scope.securityCodeAdapt($scope.pendingArgs.code),
                price: price,
                quantity: direction == 0 ? $scope.pendingArgs.buyVolume : $scope.pendingArgs.sellVolume
            };
            $http.post(ProfileService.SERVICE_TRADE + $scope.accountDisplay.accountId + "/orders", orderArgs, {headers: {'TradeKey': $scope.accountDisplay.tradeKey}}).then(function (response) {

            }).catch(function (response) {
                var error_string =
                    // "证券代码：" + orderArgs.code +
                    // "<br>买卖方向：" + (orderArgs.direction == 0 ? '买入' : '卖出') +
                    // "<br>委托价格：" + orderArgs.price +
                    // "<br>委托数量：" + orderArgs.quantity +
                    "失败原因：" + ((response.data && response.data.error) ? response.data.error : "发生异常") + "！";
                modalService.showInform({}, {headerText: "委托失败", bodyText: error_string});
            });
        };

        $scope.cancelAll = function (direction) {
            console.info("cancelAll: " + direction);
            if($scope.quickCancelNotice){
                modalService.showConfirm(
                    {
                        size: "sm"
                    },
                    {
                        alertStyle: direction==0 ? "primary" : "info",
                        headerText: '撤单确认',
                        bodyText: "您是否确认所有"+ (direction==0?'买':'卖')+"撤单？"
                    }).then(function () {
                    $scope.cancelAllReal(direction);
                }).catch(function () {
                })
            } else {
                $scope.cancelAllReal(direction);
            }
        };

        $scope.cancelAllReal = function (direction) {
            var order_list = [];
            for (var i = 0; i < $scope.accountDisplay.orders.length; i++) {
                if ($scope.accountDisplay.orders[i].status == 0 && $scope.accountDisplay.orders[i].direction == direction) {
                    order_list.push($scope.accountDisplay.orders[i].id);
                }
            }
            if (order_list.length > 0) {
                $scope.cancelMultiOrder(order_list);
            }
        }

        $scope.cancelOrder = function (orderId) {
            var cancelArgs = {
                accountId: $scope.accountDisplay.accountId,
                orderId: orderId
            };
            $http.post(ProfileService.SERVICE_TRADE + $scope.accountDisplay.accountId + "/orders/cancel_order_command", cancelArgs, {headers: {'TradeKey': $scope.accountDisplay.tradeKey}}).then(function (response) {

            }).catch(function (response) {
                var error_string =
                    // "委托号：" + cancelArgs.orderId +
                    "失败原因：" + ((response.data && response.data.error) ? response.data.error : "发生异常") + "！";
                modalService.showInform({}, {headerText: "撤单失败", bodyText: error_string});
            });
        };

        $scope.cancelMultiOrder = function (orderId_list) {
            var cancelArgs = {
                accountId: $scope.accountDisplay.accountId,
                orderIds: orderId_list
            };
            $http.post(ProfileService.SERVICE_TRADE + $scope.accountDisplay.accountId + "/orders/cancel_multi_order_command", cancelArgs, {headers: {'TradeKey': $scope.accountDisplay.tradeKey}}).then(function (response) {

            }).catch(function (response) {
                modalService.showInform({size: "sm"}, {bodyText: '撤单失败：' + ((response.data && response.data.error) ? response.data.error : "发生异常") + "！"});
            });
        };

        startKeepAlive();
        requestAccount();

        //
        var modalHeadImageDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'VolumeEditModalCtrl',
            templateUrl: 'app/pages/simulation/trade/orderVolumeEditModal.html',
            resolve: {
                modalOptions: null
            }
        };

        var modalHeadImageOptions = {
            closeButtonText: '取消',
            actionButtonText: '确定',
            headerText: '常用数量',
            bodyText: '',
            alertStyle: 'primary'
        };

        var showVolumeEditModal = function (customModalDefaults, customModalOptions) {
            var tempModalDefaults = {};
            var tempModalOptions = {};
            angular.extend(tempModalDefaults, modalHeadImageDefaults, customModalDefaults);
            angular.extend(tempModalOptions, modalHeadImageOptions, customModalOptions);
            tempModalDefaults.resolve.modalOptions = tempModalOptions;
            return $uibModal.open(tempModalDefaults).result;
        };

        /***************分时图******************/
        $scope.minuteTicks = {code:'', isReturnMinute:false, xValue:0, type:'0', tagMode: 1, preClose:0, openPrice:0, highLimit:0, lowLimit:0, datas:[]};//分时数据 tagMode 1委托和成交；2委托；3成交
        $scope.showTicks = [];

        $scope.getTitle = function () {
            var title = '';
            if($scope.minuteTicks.code != ''){
                title = $scope.minuteTicks.code + ' ' + $scope.stockCodesDic[$scope.minuteTicks.code].codeName;
            }
            return title;
        }

        $scope.getName = function (n) {
            return n;
        }

        $scope.$watch('minuteTicks.tagMode', function (newVal, oldVal) {
            $scope.lastTicks.splice(0);
            $scope.lastTags.splice(0);
            $scope.getScatterData();
            // $scope.initPointLine();
        });

        $scope.$watch('minuteTicks.code', function (newVal, oldVal) {
            if (newVal == '') {
                return;
            }
            $scope.chartConfig.subtitle.text = $scope.getTitle();
            $scope.minuteTicks.type = $scope.stockCodesDic[newVal].type;
            if(newVal != oldVal) {
                for(var xxx = 0; xxx <= 240; xxx++){
                    $scope.orderTags[xxx].orders.splice(0);
                    $scope.knockTags[xxx].orders.splice(0);
                }
                $scope.lastTicks.splice(0);
                $scope.lastTags.splice(0);
            }
            $scope.minuteTicks.isReturnMinute = false;
            $scope.getMinuteTicks();
            $scope.subQuota();
            // $scope.filterOrdersAndKnocks();
            // $scope.initPointLine();
        });

        $scope.orderTags = [];
        $scope.orderFlags = 0;//委托标线数量
        $scope.knockTags = [];
        $scope.knockFlags = 0;//成交标线数量
        for(var xxx = 0; xxx <= 240; xxx++){
            $scope.orderTags.push({x:xxx,orders:[]});
            $scope.knockTags.push({x:xxx,orders:[]});
        }

        $scope.getLines = function (flag, index) {
            var ticks = [];
            if(flag == 'order'){
                for (var i = 0; i < 240; i++){
                    if($scope.orderTags[i].orders.length < index+1){
                        continue;
                    }
                    var order = $scope.orderTags[i].orders[index];
                    var tt = '●';
                    var font_size = '16px';
                    // if(order.status == 1){
                    //     tt = 'D';
                    //     font_size = '11px';
                    // } else if(order.status == 0){
                    //     tt = 'O';
                    //     font_size = '11px';
                    // } else if(order.status == 2) {
                    //     tt = 'C';
                    //     font_size = '11px';
                    // } else {
                    //     tt = 'U';
                    //     font_size = '11px';
                    // }
                    ticks.push({
                        x:i,
                        title: tt,
                        color:'transparent',
                        name:order.id,//委托号
                        style:{
                            color:order.status == 2?"#acacac":(order.direction==0?"#ff0000":"#00ff00"),
                            fontSize:font_size,
                            // fontWeight:font_weight,
                            cursor:'pointer',
                        }
                    });
                }
            } else if(flag == 'knock'){
                for (var i = 0; i < 240; i++){
                    if($scope.knockTags[i].orders.length < index+1){
                        continue;
                    }
                    var order = $scope.knockTags[i].orders[index];
                    ticks.push({
                        x:i,
                        title: '◆',
                        color:'transparent',
                        name:order.id,//委托号
                        style:{
                            color:order.direction==0?"#ff0000":"#00ff00",
                            fontSize:'16px',
                            fontWeight:'bold',
                            cursor:'pointer',
                        }
                    });
                }
            }
            return ticks;
            // return [{
            //     x:1,
            //     title: '10000',
            // }, {
            //     x:130,
            //     title: '◆',
            //     color:'transparent',
            //     name:'orderid520145',
            //     style:{
            //         color:"#ff0000",
            //         fontSize:'11px',
            //         fontWeight:'bold',
            //     }
            // },{
            //     x:6,
            //     title:'●',
            // }];
        }

        //刷新委托标记和成交标记
        $scope.filterOrdersAndKnocks = function () {
            if($scope.minuteTicks.code == '')
                return;
            for(var xxx = 0; xxx <= 240; xxx++){
                $scope.orderTags[xxx].orders.splice(0);
                $scope.knockTags[xxx].orders.splice(0);
            }
            var order_points = [];//x:[]
            var knock_points = [];
            for(var i = 0; i < $scope.accountDisplay.orders.length; i++){
                var order = $scope.accountDisplay.orders[i];
                if(order.codeKey != $scope.stockCodesDic[$scope.minuteTicks.code].codeKey)
                    continue;
                var createTime = order.createTime.substring(11);//2017-05-17 09:52:12
                order_points.push(order);
                if(order.status == 1){
                    knock_points.push(order);
                }
            }
            var ordersorted = order_points.sort(function (a, b) {
                return a.id - b.id;
            });
            var knocksorted = knock_points.sort(function (a, b) {
                return a.id - b.id;
            });
            for(var k in ordersorted){
                var order = ordersorted[k];
                var hour = order.createTime.substring(11, 13);
                var minute = order.createTime.substring(14, 16);
                if(hour < 9 || hour == 12 || (hour==11&&minute>=30) || hour >15){//过滤非交易时间段内的数据
                    continue;
                }
                var x = 0;
                if(parseInt(hour) == 9){
                    if(parseInt(minute) < 30){
                        minute = 30;
                    }
                }
                if(parseInt(hour) < 12){
                    x = (parseInt(hour) - 10) * 60 + 30 + parseInt(minute);
                } else {
                    x = (parseInt(hour) - 13) * 60 + 120 + parseInt(minute);
                }
                if(x > 240)
                    continue;
                $scope.orderTags[x].orders.push(order);
            }
            for(var k in knocksorted){
                var order = knocksorted[k];
                var hour = order.updateTime.substring(11, 13);
                var minute = order.updateTime.substring(14, 16);
                if(hour < 9 || hour == 12 || (hour==11&&minute>=30) || hour >15){//过滤非交易时间段内的数据
                    continue;
                }
                var x = 0;
                if(parseInt(hour) == 9){
                    if(parseInt(minute) < 30){
                        minute = 30;
                    }
                }
                if(parseInt(hour) < 12){
                    x = (parseInt(hour) - 10) * 60 + 30 + parseInt(minute);
                } else {
                    x = (parseInt(hour) - 13) * 60 + 120 + parseInt(minute);
                }
                if(x > 240)
                    continue;
                $scope.knockTags[x].orders.push(order);
            }
            // $scope.orderFlags = 0;
            // $scope.knockFlags = 0;
            // for(var xxx = 0; xxx < 240; xxx++){
            //     if($scope.orderTags[xxx].orders.length > $scope.orderFlags){
            //         $scope.orderFlags = $scope.orderTags[xxx].orders.length;
            //     }
            //     if($scope.knockTags[xxx].orders.length > $scope.knockFlags)
            //         $scope.knockFlags = $scope.knockTags[xxx].orders.length;
            // }
            $scope.getScatterData();
        }

        $scope.showTags = [];
        $scope.lastTags = [];//上一次的标记点
        $scope.lastTicks = [];//上一次的分时点
        $scope.SetSeriesData = function (datas, id, issquare) {
            var chart = angular.element(
                document.getElementById('myhighchart')
            ).highcharts();
            if(!chart)
                return;
            chart.series[id].setData([], true);
            chart.series[id].setData(datas, true);
        }

        $scope.MakePairSelect = function (flag, id_) {
            var chart = angular.element(
                document.getElementById('myhighchart')
            ).highcharts();
            if(!chart)
                return;
            var p1 = chart.get(id_);
            if(!p1)
                return;
            // p1.update({marker:{
            //     lineWidth:lineWidth_,
            // }}, false, false)
            p1.select(flag);
        }

        $scope.getScatterData = function () {
            $scope.showTags.splice(0);
            for( var xxx = 0; xxx <= 240; xxx++){
                var orders = $scope.orderTags[xxx];
                var knocks = $scope.knockTags[xxx];
                if($scope.showTicks.length > xxx) {
                    if($scope.showTicks[xxx].x != xxx)
                        continue;
                }
                var yVal = $scope.showTicks.length > xxx ? $scope.showTicks[xxx] : 0;
                if($scope.minuteTicks.tagMode == 1 || $scope.minuteTicks.tagMode ==2){
                    for( var i = 0; i < orders.orders.length; i++) {
                        var color_ = orders.orders[i].status == '2'?"#acacac":(orders.orders[i].direction==0?"#ff0000":"#00ff00");
                        var yvv = yVal.y - 0.3 * (1 + i);
                        if(yvv > 8.0 || yvv < -8.0)
                            continue;
                        var tagMark = {
                            x:xxx,
                            y:yVal.y - 0.3 * (1 + i),
                            id:'order_' + orders.orders[i].id,
                            name:'委托',
                            marker:{
                                enable:true,
                                symbol:'circle',
                                fillColor:color_,
                                lineWidth:2,
                                lineColor:color_,
                            },
                            events:{
                                mouseOver:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'knock_' + id1.substring(6);
                                    $scope.MakePairSelect(true, idd);
                                },
                                mouseOut:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'knock_' + id1.substring(6);
                                    $scope.MakePairSelect(false, idd);
                                }
                            }
                        };
                        $scope.showTags.push(tagMark);
                    }
                }

                if($scope.minuteTicks.tagMode == 1 || $scope.minuteTicks.tagMode == 3) {
                    for(var i = 0; i < knocks.orders.length; i++){
                        var color_ = knocks.orders[i].direction == 0 ? "#ff0000" : "#00ff00";
                        var yvv = yVal.y + 0.3 * (1 + i);
                        if(yvv > 8.0 || yvv < -8.0)
                            continue;
                        $scope.showTags.push({
                            x:xxx,
                            y:yVal.y + 0.3 * (1 + i),
                            id:'knock_' + knocks.orders[i].id,
                            name:'成交',
                            marker:{
                                enable:true,
                                symbol:'diamond',
                                fillColor:color_,
                                lineWidth:2,
                                lineColor:color_,
                            },
                            events:{
                                mouseOver:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'order_' + id1.substring(6);
                                    $scope.MakePairSelect(true, idd);
                                },
                                mouseOut:function (point) {
                                    var daa = point.target;
                                    var id1 = daa.id;
                                    var idd  = 'order_' + id1.substring(6);
                                    $scope.MakePairSelect(false, idd);
                                }
                            }
                        });
                    }
                }

            }
            $scope.SetSeriesData($scope.showTags, 1);
        }

        $scope.onMinuteData = function (data) {
            if(data.codeKey.substring(2) != $scope.minuteTicks.code)
                return;

            // var hour = parseInt(parseInt(data.time)/100);
            // var minute = parseInt(data.time)%100;
            var hour = parseInt(data.time.substring(11, 13));
            var minute = parseInt(data.time.substring(14, 16));
            var index = 0;
            if(hour < 12){
                index = (hour -9) * 60 + minute - 30;
            } else {
                index = (hour - 13) * 60 + 120 + minute;
            }
            if($scope.minuteTicks.datas.length == index){//数据完整，刚好少了此一分钟数据
                $scope.minuteTicks.datas.push(data.close);
            } else if($scope.minuteTicks.datas.length > index){//此一分钟数据已经更新，则覆盖
                $scope.minuteTicks.datas[index] = data.close;
            } else {
                var cnt = index - $scope.minuteTicks.datas.length;
                for(var i = 0; i <= cnt; i++){
                    $scope.minuteTicks.datas.push(0);
                }
                $scope.minuteTicks.datas.push(data.close);;
            }
            // $scope.minuteTicks.isReturnMinute=true;
            $scope.calcMinuteTicks();
        };

        $scope.onQuotaData = function (quota) {
            if(quota.codeKey.substring(2) != $scope.minuteTicks.code)
                return;
            if(!$scope.minuteTicks.isReturnMinute)
                return;
            var hour = parseInt(quota.time.substring(11, 13));
            var minute = parseInt(quota.time.substring(14, 16));
            var index = 0;
            if(hour < 12){
                index = (hour -9) * 60 + minute - 30;
            } else {
                index = (hour - 13) * 60 + 120 + minute;
            }
            $scope.minuteTicks.preClose = quota.preClose;
            if($scope.minuteTicks.datas.length == index){//数据完整，刚好少了此一分钟数据
                $scope.minuteTicks.datas.push(quota.match);
            } else if($scope.minuteTicks.datas.length > index){//此一分钟数据已经更新，则覆盖
                $scope.minuteTicks.datas[index] = quota.match;
            } else {
                var cnt = index - $scope.minuteTicks.datas.length;
                for(var i = 0; i <= cnt; i++){
                    $scope.minuteTicks.datas.push(0);
                }
                $scope.minuteTicks.datas.push(quota.match);;
            }
            $scope.calcMinuteTicks();
            //计算实时盈亏
            getProfit();
        }

        $scope.calcMinuteTicks = function () {
            var cur_price = $scope.minuteTicks.openPrice > 0 ? $scope.minuteTicks.openPrice:$scope.minuteTicks.preClose;
            $scope.showTicks.splice(0);
            var multiply = $scope.stockCodesDic[$scope.minuteTicks.code].type == '0' ? 100 : 1000;
            // var datas = $scope.minuteTicks.datas.sort();
            if($scope.minuteTicks.datas.length > 0){
                var lowest = cur_price;
                var highest = cur_price;
                for(var ii = 0; ii < $scope.minuteTicks.datas.length; ii++){
                    if($scope.minuteTicks.datas[ii] == 0){
                        $scope.minuteTicks.datas[ii] = cur_price;
                    }
                    cur_price = $scope.minuteTicks.datas[ii];
                    if(lowest > $scope.minuteTicks.datas[ii]){
                        lowest = $scope.minuteTicks.datas[ii];
                    }
                    if(highest < $scope.minuteTicks.datas[ii]){
                        highest = $scope.minuteTicks.datas[ii];
                    }
                }
                var amplitude = (highest - $scope.minuteTicks.preClose) > ($scope.minuteTicks.preClose - lowest) ? (highest - $scope.minuteTicks.preClose) : ($scope.minuteTicks.preClose - lowest);
                amplitude = amplitude * multiply;
                if(amplitude <= 6){
                    $scope.minuteTicks.highLimit = $scope.minuteTicks.preClose *multiply + 8;
                    $scope.minuteTicks.lowLimit = $scope.minuteTicks.preClose *multiply - 8;
                } else {
                    var max = Math.round(amplitude);
                    max = Math.round(max/6)*8;
                    $scope.minuteTicks.highLimit = Math.round($scope.minuteTicks.preClose*multiply + max) ;
                    $scope.minuteTicks.lowLimit = Math.round($scope.minuteTicks.preClose*multiply - max);
                }
            }
            var base_price = $scope.minuteTicks.preClose * multiply;
            for(var i = 0; i < $scope.minuteTicks.datas.length; i++){
                var xxp = $scope.minuteTicks.datas[i]*multiply;
                var vv = (xxp - base_price)/(base_price - $scope.minuteTicks.lowLimit) * 8.0;
                $scope.showTicks.push({id:'minute_'+i,x:i, y:vv, events:{mouseOver:function (eve) {
                    $scope.minuteTicks.xValue = eve.target.x;
                }}});
            }
            $scope.SetSeriesData($scope.showTicks, 0);
            $scope.getScatterData();
        }

        $scope.getMinuteTicks = function () {
            $http.get(ProfileService.TRADE_SERVER_HOST + 'quotations/'+ $scope.securityCodeAdapt($scope.minuteTicks.code) +'/timebar?from=930').then(function (response) {
                $scope.minuteTicks.datas = response.data.prices;
                $scope.minuteTicks.openPrice = response.data.open;
                $scope.minuteTicks.preClose = response.data.preClose;
                // console.info($scope.minuteTicks.code + ', minute data len = ' + $scope.minuteTicks.datas.length);
                if($scope.minuteTicks.datas.length == 240){
                    $scope.minuteTicks.datas.push(response.data.close);
                }
                $scope.calcMinuteTicks();
                $scope.minuteTicks.isReturnMinute=true;
                $scope.filterOrdersAndKnocks();

            }).catch(function (response) {
                $scope.minuteTicks.datas = [];
            });
        }

        $scope.getTimeByIndex = function (x) {
            var hour = 0;
            var miniute = 0;
            if(x < 120){
                var totalminute = parseInt(x + 30);
                hour = 9 + parseInt(totalminute / 60);
                miniute = totalminute % 60;
            } else {
                var tt = parseInt(x - 120);
                hour = 13 + parseInt(tt/60);
                miniute = tt%60;
            }
            var t1 = miniute.toString();
            if(t1.length == 1){
                t1 = '0' + t1;
            }
            var timestr = hour + ":" + t1;
            return timestr;
        }

        $scope.padNumberLeft = function (val, len) {
            var ss = val.toString();
            while (ss.length < len){
                ss = '0'+ss;
            }
            return ss;
        }

        Highcharts.setOptions({
            lang:{
                resetZoom:'还原',
                resetZoomTitle:'还原至初始大小',
            },
        });

        $scope.chartConfig = {

            subtitle: {
                align: 'left',
                floating: false,
                style: {'color': "#c6a300"},
                text: '',
                x: 30,
                y: 10
            },
            chart: {
                height: 750,
                width: 1198,
                backgroundColor: '#000',
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        x: 0,
                        y: 6
                    },
                    theme: {
                        fill: 'white',
                        stroke: 'silver',
                        r: 0,
                        states: {
                            hover: {
                                // fill: '#41739D',
                                fill: '#41739D',

                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    }
                }
            },
            navigator: {
                enabled: false,
                height:26,
                series: {
                    data: []
                },
                xAxis:{
                    min:0,
                    max:240,
                    labels:{
                        enabled:true,
                        formatter:function () {
                            return $scope.getTimeByIndex(this.value);
                        }
                    }
                }
            },
            rangeSelector: {
                enabled: false
            },
            // plotOptions: {
            //     series: {
            //         lineWidth: 1,
            //         fillOpacity: 0.5
            //     },
            //     column: {
            //         stacking: 'normal'
            //     },
            //     area: {
            //         stacking: 'normal',
            //         marker: {
            //             enabled: false
            //         }
            //     }
            //
            // },

            exporting: {enabled: false},

            xAxis: [{
                // type: 'datetime'
                lineColor: '#A5260B',
                lineWidth: 1,
                tickAmount: 9,
                min: 0,
                max: 240,
                minTickInterval:1,
                tickLength: 8,
                labels: { // 坐标轴标签 刻度值后面加 百分号
                    align: 'right',
                    formatter: function () {
                        // var hour = 0;
                        // var miniute = 0;
                        // if(this.value <= 120){
                        //     var totalminute = parseInt(this.value + 30);
                        //     hour = 9 + parseInt(totalminute / 60);
                        //     miniute = totalminute % 60;
                        // } else {
                        //     var tt = parseInt(this.value - 120);
                        //     hour = 13 + parseInt(tt/60);
                        //     miniute = tt%60;
                        // }
                        // var t1 = miniute.toString();
                        // if(t1.length == 1){
                        //     t1 = '0' + t1;
                        // }
                        // var timestr = hour + ":" + t1;
                        return '<span style="fill: red;">' + $scope.getTimeByIndex(this.value) + '</span>';
                    },
                    x: 18,
                },
                crosshair: {//十字线
                    color: 'red',
                    dashStyle: 'Dash',//Dash虚线，Solid实线
                    snap: 'true',
                    width: 1
                },
                gridLineWidth:0.5,
                gridLineColor: '#A5260B',
                gridLineDashStyle:'Dash',
                plotLines: [{
                    value: 120,
                    width: 1,
                    color: '#A5260B',
                    label: {
                        align: 'right',
                        y: -3,
                        x: 0,
                    }
                }],
            }],

            yAxis: [
                {  // -- 第 0 个 y 轴 -- 行情

                    labels: {
                        // format : '{value}',
                        formatter: function () {
                            var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                            var lengthstep = $scope.minuteTicks.type == '0' ? 2 : 3;
                            var price = ($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit) *(this.value/8.0);

                            if(this.value == 0){
                                return '<span style="fill: gray;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            } else if(this.value < 0){
                                return '<span style="fill: green;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            } else {
                                return '<span style="fill: red;">' + $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep) + '</span>';
                            }
                        },
                        align: 'right',
                        x: -5
                    },
                    title: {
                        text: '证券行情'
                    },
                    opposite: false,
                    // height: '75%',
                    height: '100%',
                    //lineWidth: 2,
                    // tickInterval : 1,
                    // ceiling:40,
                    lineColor: '#A5260B',
                    // lineWidth: 1,
                    min:-8,
                    max:8,
                    // minTickInterval:1,
                    gridLineWidth:0.5,
                    gridLineColor: '#A5260B',
                    gridLineDashStyle:'Dash',
                    tickAmount: 17,
                    crosshair: {
                        color: 'red',
                        dashStyle: 'Dash',//Dash虚线，Solid实线
                        snap: 'true',
                        width: 1
                    }
                },
                // {  // -- 第 1 个  -- 分时量
                //     labels: {
                //         format: '{value}',
                //         align: 'right',
                //         x: -5,
                //
                //     },
                //     title: {
                //         text: '分时量'
                //     },
                //     top: '80%',
                //     opposite: false,
                //     height: '20%',
                //     gridLineWidth:0.5,
                //     gridLineColor: '#A5260B',
                //     gridLineDashStyle:'Dash',
                //     offset: 0,
                //     //lineWidth: 2
                //     tickAmount: 6,
                // },
                {     // -- 第 2 个 -- 百分比
                    // gridLineColor: '#FFF0F0',  // 网格线的颜色
                    // gridLineDashStyle :'Dash',  // 网格线的形状
                    // gridLineWidth: 2,
                    labels: { // 坐标轴标签 刻度值后面加 百分号
                        format: '{value}%',
                        align: 'left',
                        formatter: function () {
                            var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                            var percent = Math.round((Math.abs(this.value)/8)*100*(($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit)/$scope.minuteTicks.preClose))/step;
                            if (0 == this.value) {
                                return '<span style="fill: gray;">' + this.value + '%</span>';
                            } else if (this.value < 0) {
                                return '<span style="fill: green;">' + percent + '%</span>';
                            } else {
                                return '<span style="fill: red;">' + percent + '%</span>';
                            }
                        },
                        x: 6,//相对图表的x轴偏移
                    },
                    title: {
                        text: '百分比 ',
                    },
                    offset: 0,
                    min: -8,
                    max: 8,
                    plotLines: [{
                        value: 0,
                        width: 1,
                        color: '#A5260B',
                        label: {
                            align: 'right',
                            y: 2,
                            x: 0
                        }
                    }],
                    tickAmount: 17,
                    // lineWidth: 2,
                    height: '100%',
                    opposite: true,
                    gridLineWidth:0,
                    // lineColor: '#A5260B',
                    // lineWidth: 1,
                    /*  min: -7,
                     max: 7, */
                    // tickInterval :10,
                    /*  startOnTick: false,
                     endOnTick:false */

                }
            ],

            legend: {
                enabled: false
            },
            title: {
                text: ' '
            },
            credits: {
                enabled: false
            },

            loading: false,
            tooltip: {
                headerFormat: '<div class="header" style="color: #fcfcfc">行情</div>',
                pointFormat: '<div class="line"><div class="circle" style="background-color:{series.color};float:left;margin-left:10px!important;clear:left;"></div><label class="country" style="float:left;color: red">{series.name}线条名字</label><label class="country" style="float:left;">{point.y}ddddddddddddd </label></div>',
                pointFormatter:function () {
                    // var  time = '';
                    // if(this.x <= 120){
                    //     time = $scope.padNumberLeft(parseInt((this.x+30)/60 + 9), 2) + ':' + $scope.padNumberLeft(parseInt((this.x+30)%60), 2);
                    // }else{
                    //     time = $scope.padNumberLeft(parseInt((this.x-120)/60+13), 2) + ':' + $scope.padNumberLeft(parseInt(this.x%60), 2);
                    // }
                    var step = $scope.minuteTicks.type == '0' ? 100 : 1000;
                    var lengthstep = $scope.minuteTicks.type == '0' ? 2 : 3;
                    var price = ($scope.minuteTicks.preClose*step - $scope.minuteTicks.lowLimit) *(this.y/8.0);
                    var pp = $scope.toStringEx($scope.minuteTicks.preClose + price/step, lengthstep);
                    var msg = '时间：' + $scope.getTimeByIndex(this.x);
                    msg += '<br/>价格：' + pp;
                    return msg;
                },
                borderWidth: 0,
                positioner: function () {
                    var xx = $scope.minuteTicks.xValue > 120 ? 380:680;
                    return { x: xx, y: 160 };
                },

                borderRadius: 5,
                borderColor: '#a4a4a4',
                shadow: false,
                useHTML: true,
                percentageDecimals: 2,
                backgroundColor: "rgba(180,180,180,.7)",
                style: {
                    padding: 0
                },
                // shared: true
            },

            series: [
                {
                    id: 'lineQuotaMinute',
                    // name: 'Usage Time',
                    // data: $scope.showTicks,
                    data:[],
                    type: 'line',
                    lineWidth:1,
                    states:{
                        hover:{
                            lineWidth:1
                        }
                    },
                    yAxis: 0,
                    tooltip: {
                        valueSuffix: ' sec'
                    },
                    color: '#fcfcfc'
                },
                {
                    type:'scatter',
                    // data:$scope.showTags,
                    data:[],
                    tooltip: {
                        headerFormat: '<div class="header" style="color: #fcfcfc"><b>{point.key}</b></div>',
                        pointFormatter:function () {
                            var orderTime = '';//委托时间
                            var knockTime = '';//成交时间
                            var quantity = 0;//成交数量
                            var matchPrice = '';//成交价格
                            var price = 0;//委托价格
                            var orderType = '';//委托类型
                            var color = '';
                            var status = '0';
                            if(this.name == '委托'){
                                for(var i in $scope.orderTags[this.x].orders){
                                    var order = $scope.orderTags[this.x].orders[i];
                                    if(order.id == this.id.substring(6)){
                                        knockTime = order.updateTime.length > 12 ? order.updateTime.substring(11) : '';
                                        orderTime = (order.createTime.length > 12) ? order.createTime.substring(11) : '';
                                        quantity = order.quantity;
                                        matchPrice = order.matchPrice;
                                        price = order.price;
                                        orderType = order.direction == 0 ? '买单' : '卖单';
                                        status = order.status;
                                        break;
                                    }
                                }
                            } else {
                                for(var i in $scope.knockTags[this.x].orders){
                                    var order = $scope.knockTags[this.x].orders[i];
                                    if(order.id == this.id.substring(6)){
                                        knockTime = order.updateTime.length > 12 ? order.updateTime.substring(11) : '';
                                        orderTime = (order.createTime.length > 12) ? order.createTime.substring(11) : '';
                                        quantity = order.quantity;
                                        matchPrice = order.matchPrice;
                                        price = order.price;
                                        orderType = order.direction == 0 ? '买单' : '卖单';
                                        status = order.status;
                                        break;
                                    }
                                }
                            }

                            var s = '<span style="color: #fcfcfc">委托号：'+ this.id.substring(6);
                            s += '<br/>委托时间：' + orderTime;
                            if(status == '2'){
                                s += '<br/>撤单时间：' + knockTime;
                            } else if (status == '1'){
                                s += '<br/>成交时间：' + knockTime;
                            }

                            s += '<br/>委托类型：' + orderType;
                            s += '<br/>委托价格：' + price;
                            s += '<br/>成交价格：' + matchPrice;
                            if(status == '1') {
                                s += '<br/>成交/委托数量：' + quantity + '/' + quantity + '股';
                            } else {
                                s += '<br/>成交/委托数量：0/' + quantity + '股';
                            }

                            if(status == '2'){
                                s += '<br/>状态：已撤单';
                            } else if(status == '1'){
                                s += '<br/>状态：已成交';
                            } else {
                                s += '<br/>状态：成交中';
                            }
                            s += '</span>'
                            return s;
                        },
                        useHTML: true,
                    },
                    marker:{
                        states:{
                            select:{
                                fillColor: '#0099ff',
                                lineWidth: 6,
                                lineColor:'#0099ff',
                            }
                        }
                    }
                }

            ],
        };//图表配置

    }

    function VolumeEditModalCtrl($scope, $uibModalInstance, $log, modalOptions, FileUploader, ProfileService) {
        var ctrl = $scope;
        $scope.modalOptions = modalOptions;
        $scope.volumes = modalOptions.commVolume;
        // $scope.$watch('volumes', function (newVal, oldVal) {
        //     for(var i in $scope.volumes){
        //         var xx = $scope.volumes[i];
        //
        //     }
        // });
        $scope.modalOptions.ok = function (result) {
            result = 'ok';
            // $scope.commVolume.splice(0, $scope.commVolume.length);
            // for(var x in $scope.volumes){
            //     var val = parseInt($scope.volumes[x]);
            //     $scope.commVolume.push(val ? val.toString() : '0');
            // }
            $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function (result) {
            result = 'cancel';
            $uibModalInstance.dismiss(result);
        };
    }

    function CodeEditModalCtrl($scope, $uibModalInstance, $http, $log, modalOptions, FileUploader, ProfileService, modalService) {
        var ctrl = $scope;
        $scope.modalOptions = modalOptions;
        ctrl.itemInformation = {
            codes: [],
            selectCodes:[],
            selectTitle: "已选（最多三只）："
        };
        // ctrl.itemInformation.codes = [{code:'510050',codeName:'ETF',selected:true},{code:'000001',codeName:'平安银行',selected:false}];

        ctrl.selectCode = function (item) {
            ctrl.itemInformation.selectTitle = "已选（最多三只）：";
            if(ctrl.itemInformation.selectCodes.length < 3)
            {
                item.selected = !item.selected;
                if(item.selected)
                {
                    ctrl.itemInformation.selectCodes.push(item);
                }
                else
                {
                    var index = -1;
                    for(var i in ctrl.itemInformation.selectCodes)
                    {
                        if(ctrl.itemInformation.selectCodes[i].code == item.code)
                        {
                            index = i;
                        }
                    }
                    if(index != -1)
                    {
                        ctrl.itemInformation.selectCodes.splice(index, 1);
                    }
                }
            }
            else
            {
                 if(item.selected == true)
                 {
                     item.selected = !item.selected;
                     var index = -1;
                     for(var i in ctrl.itemInformation.selectCodes)
                     {
                         if(ctrl.itemInformation.selectCodes[i].code == item.code)
                         {
                             index = i;
                         }
                     }
                     if(index != -1)
                     {
                         ctrl.itemInformation.selectCodes.splice(index, 1);
                     }
                 }
                else
                 {
                     item.selected = false;
                 }
            }
        }

       ctrl.userTradeConfig = {
            stockProfitRate: 0,
            fundProfitRate: 0,
            selectedCodeKeys: [],
            codes:[],
            defaultCodeKeys:[]
        };
        var getData = function () {
            $http.get(ProfileService.SERVER_HOST + "trade/config/codes").
            then(function (response) {
                $log.info("查询成功...");
                ctrl.userTradeConfig = response.data;
                initCodes(ctrl.userTradeConfig.codes, ctrl.userTradeConfig.defaultCodeKeys, ctrl.userTradeConfig.selectedCodeKeys);
            }).
            catch(function (response) {
                $log.info('查询失败...');
            });
        }
        getData();

        var initCodes = function (codes, defaultCodeKeys, selectedCodeKeys) {
            for(var i in codes)
            {
                var code = {
                    code: codes[i].codeKey.substring(2, 8),
                    codeKey: codes[i].codeKey,
                    codeName: codes[i].codeName,
                    selected: false
                }
                if(selectedCodeKeys.length == 0)
                {
                    ctrl.itemInformation.selectTitle = "系统推荐代码：";
                    for(var j in defaultCodeKeys)
                    {
                        if(code.codeKey == defaultCodeKeys[j])
                        {
                            code.selected = true;
                            ctrl.itemInformation.selectCodes.push(code);
                        }
                    }
                }
                else
                {
                    for(var j in selectedCodeKeys)
                    {
                        if(code.codeKey == selectedCodeKeys[j])
                        {
                            code.selected = true;
                            ctrl.itemInformation.selectCodes.push(code);
                        }
                    }
                }
                ctrl.itemInformation.codes.push(code);
            }
        }

        $scope.modalOptions.ok = function (result) {
            result = 'ok';
            var param = {selectedCodeKeys:[]};
            for(var i in ctrl.itemInformation.selectCodes)
            {
                param.selectedCodeKeys.push(ctrl.itemInformation.selectCodes[i].codeKey);
            }
            if(param.selectedCodeKeys.length == 0)
            {
                modalService.showInform({}, {bodyText: '至少选择一只代码'});
                return;
            }
            $http.put(ProfileService.SERVER_HOST + "trade/config/selected_codes", param).then(function (response) {
                $uibModalInstance.close(result);
            }).catch(function (response) {
                $log.info('选择代码失败...');
                modalService.showInform({}, {bodyText: '选择代码失败！' + UtilsService.parseHttpResponse(response)}).catch(function (response) {

                });
            });
            // $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function (result) {
            result = 'cancel';
            $uibModalInstance.dismiss(result);
        };
    }

})();

(function () {

    'use strict';

    angular.module('myApp.pages.turtle.forum')
        .controller('ForumCtrl', ForumCtrl);


    function ForumCtrl($scope, $rootScope, $http, $state, $stateParams, $document, ProfileService, TokenService, modalService, $window) {

        var ctrl = $scope;
        ctrl.firstLoad = true;
        //单页数量
        ctrl.itemsByPage = 20;
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.filterArgs = {
            filter: $stateParams.filter == null ? '' : $stateParams.filter,
            sort: $stateParams.sort == null ? 0 : parseInt($stateParams.sort)
        };
        ctrl.searchArgs = {
            filter: ctrl.filterArgs.filter,
            sort: ctrl.filterArgs.sort
        };
        ctrl.displayed = [];
        ctrl.totalItemCount = 0;
        ctrl.tableState = null;
        ctrl.goHeadFlag = false;

        ctrl.mysort = 'answerCount';
        ctrl.mysort = 'answerCount';

        ctrl.getSortContent = function () {
            return ctrl.filterArgs.sort == 0 ? "回复量排序" : "按时间排序";
        };

        ctrl.changeSortOrder = function () {
            if (ctrl.filterArgs.sort == 0) {
                ctrl.filterArgs.sort = 1;
            } else {
                ctrl.filterArgs.sort = 0;
            }
            ctrl.getData(true);
        };

        ctrl.getSearchWidth = function () {
            var width = $window.innerWidth;
            if (width > 1600)
                return {'width': '30%'};
            if (width > 1440)
                return {'width': '36%'};
            return {'width': '40%'};
        };

        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(start) {
            for (var i = 0; i < ctrl.displayed.length; i++) {
                ctrl.displayed[i].index = start + i + 1;
            }
        }

        ctrl.checkEnter = function (e) {
            var key_code = window.event ? e.keyCode : e.which;
            if (key_code == 13) {
                ctrl.getData(true);
            }
        };

        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            if (ctrl.firstLoad && $stateParams.start) {
                ctrl.tableState.pagination.start = $stateParams.start;
            }
            ctrl.getData();
        };

        ctrl.getDateStr = function (datestr) {
            return datestr.substring(0, 10);
        };

        ctrl.getData = function (reset_page) {
            ctrl.isLoading = true;
            if (reset_page) {
                ctrl.tableState.pagination.start = 0;
                ctrl.searchArgs.filter = ctrl.filterArgs.filter;
                ctrl.searchArgs.sort = ctrl.filterArgs.sort;
            }
            var pagination = ctrl.tableState.pagination;
            var tmp_args = {
                filter: ctrl.searchArgs.filter,
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: ctrl.searchArgs.sort == 0 ? "answerCount" : "createTime",
                order: 'desc'
            };

            $state.go($state.current.name, {
                filter: tmp_args.filter,
                sort: ctrl.searchArgs.sort,
                start: pagination.start
            }, {
                notify: false,
                location: ctrl.firstLoad ? "replace" : true,
                inherit: true
            });
            ctrl.firstLoad = false;
            var myfilters = tmp_args.filter != '' ? window.encodeURIComponent(tmp_args.filter) : '';
            // var queryArgs = "?filter=" + tmp_args.filter + "&start=" + tmp_args.start + "&number=" + tmp_args.number;
            var queryArgs = "?filter=" + myfilters + "&start=" + tmp_args.start + "&number=" + tmp_args.number + "&sortby=" + tmp_args.sortby + "&order=desc";
            $http.get(ProfileService.SERVICE_FORUM_QUERY + queryArgs).then(function (response) {
                ctrl.displayed = response.data.questions;
                ctrl.totalItemCount = response.data.totalCount;
                ctrl.tableState.pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
                ctrl.isLoading = false;
                if (ctrl.displayed == null || response.data.questions.length == 0) {
                    ctrl.isFailed = true;
                    ctrl.failedMsg = ctrl.filterArgs.filter;
                }
                else
                    ctrl.isFailed = false;
                addIndex(queryArgs.start);
                if (ctrl.goHeadFlag) {
                    $document.scrollTo(0, 0, 500);
                    ctrl.goHeadFlag = false;
                }
            }).catch(function (response) {
                ctrl.displayed = [];
                ctrl.totalItemCount = 0;
                ctrl.tableState.pagination.numberOfPages = 1;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        ctrl.canAction = function (item) {
            if (TokenService.isLogin() && TokenService.user.userId == item.userId) {
                return true;
            }
            return false;
        };

        ctrl.deleteItem = function (item) {
            modalService.showConfirm({}, {
                headerText: "请确认！",
                bodyText: '确认删除提问 \"' + item.title + '\" 吗？'
            }).then(function (result) {
                $http.delete(ProfileService.SERVICE_FORUM + item.id).then(function (response) {
                    ctrl.getData();
                }).catch(function (response) {
                    var error_message = response.data.error ? response.data.error : "发生异常，无法删除！";
                    modalService.showInform({}, {
                        headerText: "删除失败！",
                        bodyText: "失败原因：" + error_message
                    }).catch(function (response) {
                        ctrl.getData();
                    });
                });
            }).catch(function (result) {

            });
        };

        ctrl.getWriteHref = function () {
            return $state.href('turtle.forumWrite', {
                filter: ctrl.searchArgs.filter,
                sort: ctrl.searchArgs.sort,
                start: ctrl.tableState ? ctrl.tableState.pagination.start : 0
            });
        };

        ctrl.getEditHref = function (item) {
            return $state.href('turtle.forumWrite', {
                id: item.id,
                filter: ctrl.searchArgs.filter,
                sort: ctrl.searchArgs.sort,
                start: ctrl.tableState ? ctrl.tableState.pagination.start : 0
            });
        };

        ctrl.getItemHref = function (item) {
            return $state.href('turtle.forumDetails', {
                id: item.id,
                filter: ctrl.searchArgs.filter,
                from_sort: ctrl.searchArgs.sort,
                from_start: ctrl.tableState ? ctrl.tableState.pagination.start : 0
            });
        };

        function StringToDate(str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2], str[3], str[4], str[5]);
        }

        ctrl.showInterval = function (etime) {
            var re = "";
            var sjc = parseInt((new Date().getTime() - StringToDate(etime).getTime()) / 1000);
            if (sjc < 10) {
                return "刚刚";
            } else {
                if (sjc >= 60 * 60 * 24 * 7) {
                    return etime.substring(0, 10);
                }
                if (sjc >= 60 * 60 * 24)
                    re = parseInt(sjc / (60 * 60 * 24)) + "天";
                else {
                    if (sjc >= 60 * 60)
                        re = parseInt(sjc / (60 * 60)) + "小时";
                    else {
                        if (sjc >= 60)
                            re = parseInt(sjc / 60) + "分钟";
                        else
                            re = sjc + "秒";
                    }
                }
                re += "前";
            }
            return re;
        };
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.getPassword')
        .controller('GetPasswordCtrl', GetPasswordCtrl);

    function GetPasswordCtrl($scope, $q, $http, $state, ProfileService, TokenService, modalService, EncryptService) {
        //检测登录
        var checkLogin = function () {
            if (TokenService.checkLogin()) {
                $state.go("main");
            }
        };
        $scope.totalError = '';

        checkLogin();

        $scope.forgetPasswordLink = $state.params.type == null ? 1 : $state.params.type;

        $scope.registerArgs = {
            phoneNumber: "",
            password: "",
            password2: "",
            codeId: "",
            code:""
        };

        $scope.isPhoneNumberValid = function () {
            var r = /^1\d{10}$/;
            if (r.test($scope.registerArgs.phoneNumber))
                return true;
            else
                return false;
        }

        $scope.phoneNumberInput = function () {
            $scope.textChange();
            if ($scope.registerArgs.phoneNumber != null && $scope.registerArgs.phoneNumber.length == 11 && $scope.isPhoneNumberValid() == true) {
                $scope.errorMsg = '';
                $scope.isPhoneRegistered($scope.registerArgs.phoneNumber);
            } else {
                $scope.errorMsg = '无效手机号';
            }
        }

        $scope.isPhoneRegistered = function (num) {
            $http.get(ProfileService.USER_SERVICE + 'phoneNumbers/' + num, '').then(function (response) {
                if (response.data.usedFlag == '0') {
                    $scope.errorMsg = '该号码未注册';
                    return;
                } else {
                    $scope.errorMsg = '';
                }
            }).catch(function (response) {
                $scope.errorMsg = response.data;
            });
        }

        $scope.isPasswdValid = function () {
            if ($scope.registerArgs.password.length < 8 || $scope.registerArgs.password.length > 12)
            {
                $scope.errorPwdMsg = '密码不符合安全规范';
                return false;
            }
            var r = /^\+?[0-9]*$/;
            if (r.test($scope.registerArgs.password))
            {
                $scope.errorPwdMsg = '密码不符合安全规范';
                return false;
            }
            else
            {
                $scope.errorPwdMsg = '';
                return true;
            }
        }

        $scope.phoneAvailable = false;
        $scope.$watch('registerArgs.phoneNumber', function (newVal, oldVal) {
            if (newVal.length != 11) {
                return;
            }
            $scope.phoneAvailable = false;
            $scope.checkValidPhone();
        });

        $scope.textChange = function () {
            $scope.totalError = '';
        }

        $scope.checkRePwd = function () {
            if($scope.registerArgs.password != $scope.registerArgs.password2)
            {
                $scope.errorRePwdMsg = '密码不一致';
                return false;
            }
            else
            {
                $scope.errorRePwdMsg = '';
                return true;
            }
        }

        $scope.checkValidPhone = function () {
            $http.get(ProfileService.USER_SERVICE + 'phoneNumbers/' + $scope.registerArgs.phoneNumber, '').then(function (response) {
                if (response.data.usedFlag == '1') {
                    $scope.phoneAvailable = true;
                } else {
                    $scope.phoneAvailable = false;
                    $scope.totalError = '该手机号码未注册,请注册!';
                    // modalService.showInform({}, {bodyText: '该手机号码未注册,请注册!'});
                }
            }).catch(function (response) {
                $scope.totalError = '后台连接失败';
                // modalService.showInform({}, {bodyText: '后台连接失败!'});
            });
        }

        $scope.submit = function () {
            if(!$scope.phoneAvailable){
                $scope.totalError = '请输入正确的手机号码';
                return;
            }
            if(!$scope.isPasswdValid()){
                $scope.totalError = '密码需要8到12数字 + 字母组合';
                return;
            }
            if($scope.registerArgs.password != $scope.registerArgs.password2){
                $scope.totalError = '密码验证不匹配';
                return;
            }
            if($scope.registerArgs.codeId == ''){
                $scope.totalError = '请获取短信验证码';
                return;
            }
            if($scope.registerArgs.code == ''){
                $scope.totalError = '请输入短信验证码';
                return;
            }
            //先加密
            var send_data = {
                phoneNumber: $scope.registerArgs.phoneNumber,
                password: EncryptService.encryptPassword($scope.registerArgs.password)
            };
            $http.put(ProfileService.GOT_PASSWORD_SERVICE, send_data, {headers: {
                "AuthCode": JSON.stringify({
                    codeId: $scope.registerArgs.codeId,
                    code: $scope.registerArgs.code
                })
            }}).then(function (response) {
                $state.go("user.login", {phone:$scope.registerArgs.phoneNumber});
                // modalService.showInform({}, {bodyText: '修改成功!'}).catch(function (response) {
                //     $state.go("user.login");
                // });
            }).catch(function (response) {
                $scope.totalError = response.data.error;
                // modalService.showInform({}, {bodyText: '修改失败：' + response.statusText + "!"});
            });
        };

        $scope.cancel = function () {
            $state.go("user.login");
        };

        $scope.holdForTimeOut = false;
        $scope.timeOutCount = 120;
        $scope.intervalId = '';
        $scope.getTimeBtnText = function () {
            if($scope.holdForTimeOut){
                return $scope.timeOutCount + '秒后重试';
            }
            return '获取验证码';
        }
        $scope.shortMsgClick = function () {
            $scope.holdForTimeOut = true;
            $scope.intervalId = window.setInterval(function () {
                $q.when().then(function () {
                    $scope.timeOutCount--;
                    if($scope.timeOutCount == 0){
                        window.clearInterval($scope.intervalId);
                        $scope.timeOutCount = 120;
                        $scope.holdForTimeOut = false;
                    }
                });
            },1000);
            $http.post(ProfileService.AUTH_MSG_SERVICE, {phoneNumber:$scope.registerArgs.phoneNumber}).then(function (response) {
                $scope.registerArgs.codeId = response.data.codeId;
            }).catch(function (response) {
                console.info('shortmsg failed');
            });
        }

        $scope.$on('$destory', function () {
            if($scope.holdForTimeOut){
                window.clearInterval($scope.intervalId);
            }
        });
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.turtle.wiki')
        .controller('WikiCtrl', WikiCtrl)
        .directive('overflowHide', overflowHide);


    function overflowHide($window, $q) {
        return {
            restrict: 'A',
            // scope: false,
            // scope: {},
            link: function (scope, element, attrs) {
                scope.$watch('$viewContentLoaded', function () {
                    console.info("$viewContentLoaded...");
                    $q.when().then(function () {
                        checkOverflow();
                    });
                });

                angular.element($window).bind("resize", function () {
                    checkOverflow();
                });

                var checkOverflow = function () {
                    var container_width = element.width();
                    var parent_width = element.parent().width();
                    // console.info("containerWidth = " + container_width + ", parentWidth = " + parent_width);
                    var list_element = element.find("li");
                    // console.info("list length = " + list_element.length);
                    for (var i = 0; i < list_element.length; i++) {
                        var list_item = element.find(list_element[i]);
                        // console.info("item: left = " + list_item.position().left + ", width = " + list_item.width());
                        if (list_item.position().left + list_item.width() > parent_width) {
                            list_item.addClass("hidden-item");
                        }
                        else {
                            list_item.removeClass("hidden-item");
                        }
                    }
                };
            }
        };
    }

    function WikiCtrl($scope, $window, $log, $http, $state, $stateParams, $location, $timeout, ProfileService, TokenService, $document, $rootScope) {

        var ctrl = $scope;
        ctrl.currentStart = $stateParams.start == null ? 0 : $stateParams.start;
        ctrl.isFirstLoad = true;
        //单页数量
        ctrl.itemsByPage = 20;
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.filter = $stateParams.filter == null ? '' : $stateParams.filter;
        ctrl.displayed = [];
        ctrl.totalItemCount = 0;
        ctrl.tableState = null;
        ctrl.currentGroupId = $stateParams.groupId == null ? '' : $stateParams.groupId;
        ctrl.wikiGroups = [
            // {id:'',name:'',url:'',createTime:''}
        ];

        ctrl.getSearchWidth = function () {
            var width = $window.innerWidth;
            if (width > 1600)
                return {'width': '30%'};
            if (width > 1440)
                return {'width': '36%'}
            return {'width': '40%'};
        }

        ctrl.getItemBackColor = function (typeName) {
            if (typeName == ctrl.currentGroupId) {
                return {
                    "box-shadow": "0 0 12px rgba(0, 0, 0, 0.9)",
                    "-moz-box-shadow": "0 0 12px rgba(0, 0, 0, 0.9)",
                    "-webkit-box-shadow": "0 0 12px rgba(0, 0, 0, 0.9)",
                    // "border-color":"#c52d2f",
                    // "border": "2px solid #000",

                    "-webkit-transform": "scale(0.99)",
                    "-moz-transform": "scale(0.99)",
                    "-o-transform": "scale(0.99)",
                    "transform": "scale(0.99)",
                    "transition-duration": "0.5s",
                    "-webkit-transition-duration": "0.5s",
                    "-moz-transition-duration": "0.5s",
                    "-o-transition-duration": "0.5s"
                }
            } else {
                return {
                    "-webkit-transform": "scale(0.8)",
                    "-moz-transform": "scale(0.8)",
                    "-o-transform": "scale(0.8)",
                    "transform": "scale(0.8)",
                    "transition-duration": "0.5s",
                    "-webkit-transition-duration": "0.5s",
                    "-moz-transition-duration": "0.5s",
                    "-o-transition-duration": "0.5s",

                }
            }
            // return {'background': '#c52d2f', 'border': '0px'};
        }

        ctrl.getItemColor = function (typeName) {
            if (typeName == ctrl.currentGroupId)
                return {'color': '#c52d2f', 'border': '0px', 'font-weight': 'bold'};
        }

        ctrl.itemClick = function (typeName) {
            ctrl.currentGroupId = typeName;
            ctrl.filter = '';
            if (ctrl.tableState.pagination != null) {
                $scope.currentStart = 0;
                ctrl.tableState.pagination.start = 0;
            }
            ctrl.getData();
        }

        function getPageCount(total) {
            return Math.ceil(total / ctrl.itemsByPage);
        }

        function addIndex(start) {
            for (var i = 0; i < ctrl.displayed.length; i++) {
                ctrl.displayed[i].index = start + i + 1;
            }
        }

        ctrl.checkEnter = function (e) {
            var key_code = window.event ? e.keyCode : e.which;
            if (key_code == 13) {
                ctrl.getFirstData();
            }
        };

        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            // console.info("callServer: " + ctrl.isFirstLoad + ", " + ctrl.currentStart);

            if (ctrl.isFirstLoad) {
                ctrl.tableState.pagination.start = ctrl.currentStart;
            }
            else {
                ctrl.currentStart = ctrl.tableState.pagination.start;
            }
            ctrl.isFirstLoad = false;
            ctrl.currentStart = tableState.pagination.start;
            ctrl.getData();
        };

        ctrl.getDateStr = function (datestr) {
            return datestr.substring(0, 10);
        };

        ctrl.showItem = function (item) {
            $state.go('turtle.wikiDetails', {
                start: $scope.currentStart,
                id: item.id,
                groupId: ctrl.currentGroupId,
                filter: ctrl.filter
            });
        };

        ctrl.getItemUrl = function (item) {
            //'/wiki_details/{start}/{id}/{groupId}/{filter}',
            var urls = '/#/turtle/wiki_details/' + $scope.currentStart + '/' + item.id + '/' + ctrl.currentGroupId + '/' + ctrl.filter;
            return urls;
        }

        ctrl.getFirstData = function () {
            if (ctrl.filter == '')
                return;
            if (ctrl.tableState.pagination != null) {
                $scope.currentStart = 0;
                ctrl.tableState.pagination.start = 0;
            }
            if (ctrl.filter != '')
                ctrl.currentGroupId = '';
            ctrl.getData();
        }

        ctrl.getWikiGroup = function () {
            $http.get(ProfileService.SERVER_HOST + 'turtle/wiki_groups').then(function (response) {
                ctrl.wikiGroups = response.data;
                if (ctrl.wikiGroups.length > 0 && ctrl.currentGroupId == '' && ctrl.currentStart == 0 && ctrl.filter == '') {
                    ctrl.currentGroupId = ctrl.wikiGroups[0].id;
                }
                //
            }).catch(function () {
                ctrl.wikiGroups = [];
            });
        }

        ctrl.getWikiGroup();
        ctrl.isEdit = false;
        ctrl.textChange = function () {
            ctrl.isEdit = true;
        }

        ctrl.isShowFailed = function () {
            if (!ctrl.isEdit && ctrl.isFailed)
                return true;
            else
                return false;
        }

        ctrl.failedMsg = '';

        ctrl.getData = function () {
            ctrl.isEdit = false;
            ctrl.isLoading = true;
            var pagination = ctrl.tableState.pagination;
            var tmp_args = {
                filter: ctrl.filter,
                start: pagination.start || 0,
                number: ctrl.itemsByPage,
                sortby: 'updateTime',
                order: 'desc'
            };
            $state.current.reloadOnSearch = false;
            $location.search('groupId', ctrl.currentGroupId);
            $location.search('filter', ctrl.filter);
            $location.search('start', pagination.start);
            var myfilters = tmp_args.filter != '' ? window.encodeURIComponent(tmp_args.filter) : '';
            var queryArgs = "?groupId=" + ctrl.currentGroupId + "&filter=" + myfilters + "&start=" + tmp_args.start + "&number=" + tmp_args.number + "&sortby=" + tmp_args.sortby + "&order=" + tmp_args.order;

            $http.get(ProfileService.SERVICE_WIKI_QUERY + queryArgs).then(function (response) {
                ctrl.displayed = response.data.results;
                ctrl.totalItemCount = response.data.totalCount;
                ctrl.tableState.pagination.numberOfPages = getPageCount(ctrl.totalItemCount);
                ctrl.isLoading = false;
                if (ctrl.displayed == null || response.data.results.length == 0) {
                    ctrl.isFailed = true;
                    ctrl.failedMsg = ctrl.filter;
                }
                else
                    ctrl.isFailed = false;
                addIndex(queryArgs.start);
                if (ctrl.goHeadFlag) {
                    $document.scrollTo(0, 0, 500);
                    ctrl.goHeadFlag = false;
                }
                else {
                    ctrl.gotoContentsTop();
                }
            }).catch(function (response) {
                $log.info('查询失败...');
                ctrl.displayed = [];
                ctrl.totalItemCount = 0;
                ctrl.tableState.pagination.numberOfPages = 1;
                ctrl.failedMsg = ctrl.filter;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        ctrl.filterKeyword = function (keyword) {
            ctrl.filter = keyword;
            // ctrl.getData();
            ctrl.getFirstData();
        };

        ctrl.goHeadFlag = false;
        var myfun = function (event, msg) {
            ctrl.filter = '';
            ctrl.tableState.pagination.start = 0;
            ctrl.currentStart = ctrl.tableState.pagination.start;
            if (ctrl.wikiGroups.length > 0 && ctrl.currentGroupId == '' && ctrl.currentStart == 0 && ctrl.filter == '') {
                ctrl.currentGroupId = ctrl.wikiGroups[0].id;
            }
            ctrl.getData();
            ctrl.goHeadFlag = true;
        }
        var funxxx = $rootScope.$on("turtleMemuClick", myfun);

        $scope.$on('$destroy', function () {
            funxxx();
        });

        ctrl.gotoContentsTop = function () {
            $document.scrollTo(0, 0, 500);
        };
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.edit')
        .controller('EditCtrl', EditCtrl)
        .controller('HeadImageModalCtrl', HeadImageModalCtrl);

    function EditCtrl($scope, $rootScope, $log, $http, $state, $filter, FileUploader, ProfileService, TokenService, modalService, EncryptService, TokenRefreshService, TokenCheckService, $uibModal) {

        var ctrl = $scope;

        // $scope.auth_code = {codeId: "", image_url: ""};
        $scope.editArgs = {
            phoneNumber: TokenService.user.phoneNumber,
            nickName: "",
            pwdFlag: false,
            sex: 1,
            code: "",
            oriPassword: null,
            newPassword: null,
            confirmPassword: null,
            headPicUrl: '',
            sign: ""
        };

        var stringToDate = function (str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2]);
        };

        $scope.dataPickerArgs = {
            dateFormat: "yyyy-MM-dd",
            dateOptions: {
                startingDay: 1,
                showWeeks: false
            },
            altDateInputFormats: ['yyyy-M!-d!'],
            openDatePicker: false,
            selectDateBirth: null
        };

        ctrl.openDatePicker = function () {
            ctrl.dataPickerArgs.openDatePicker = true;
        };

        $scope.croppedImage = '';

        $scope.totalError = "";
        
        if (TokenCheckService.checkLogin() == false) {
            return;
        }
        else {
            $scope.croppedImage = TokenService.user.headPicUrl ? TokenService.user.headPicUrl : 'images/turtle/default_header.png';
        }
        
        $scope.textChange = function () {
            $scope.totalError = '';
        };
        //获取星座
        $scope.getStar = function () {
            if($scope.dataPickerArgs.selectDateBirth == null)
            {
                return "未知";
            }
            var date = $filter('date')(ctrl.dataPickerArgs.selectDateBirth, 'yyyy-MM-dd');
            var month = date.substring(5, 7);
            var day = date.substring(8, 10);
            if((month == 3 && day >= 21) || (month == 4 && day <=19))
            {
                return "白羊座";
            }
            else if((month == 4 && day >= 20) || (month == 5 && day <= 20))
            {
                return "金牛座";
            }
            else if((month == 5 && day >= 21) || (month == 6 && day <= 21))
            {
                return "双子座";
            }
            else if((month == 6 && day >= 22) || (month == 7 && day <= 22))
            {
                return "巨蟹座";
            }
            else if((month == 7 && day >= 23) || (month == 8 && day <= 22))
            {
                return "狮子座";
            }
            else if((month == 8 && day >= 23) || (month == 9 && day <= 22))
            {
                return "处女座";
            }
            else if((month == 9 && day >= 23) || (month == 10 && day <= 23))
            {
                return "天秤座";
            }
            else if((month == 10 && day >= 24) || (month ==11 && day <= 22))
            {
                return "天蝎座";
            }
            else if((month == 11 && day >= 23) || (month == 12 && day <= 21))
            {
                return "射手座";
            }
            else if((month == 12 && day >= 22) || (month == 1 && day <= 19))
            {
                return "魔蝎座";
            }
            else if((month == 1 && day >= 20) || (month == 2 && day <= 18))
            {
                return "水瓶座";
            }
            else if((month == 2 && day >= 19) || (month == 3 && day <= 20))
            {
                return "双鱼座";
            }
            else
            {
                return "未知";
            }
        };

        // //请求验证码
        // $scope.requestAuthCode = function () {
        //     var req = $http.post(ProfileService.AUTH_CODE_SERVICE, "").then(function (response) {
        //         $log.log('获取验证码成功：' + response.data.codeId);
        //         $scope.auth_code.codeId = response.data.codeId;
        //         $scope.auth_code.image_url = ProfileService.AUTH_CODE_SERVICE + $scope.auth_code.codeId;
        //     }).catch(function (response) {
        //         $log.log('获取验证码失败...');
        //         $scope.auth_code.codeId = "";
        //         $scope.auth_code.image_url = "";
        //     });
        // };
        //
        // //启动的时候，请求验证码
        // $scope.requestAuthCode();

        $http.get(ProfileService.USER_SERVICE + TokenService.user.userId).then(function (response) {
            $scope.editArgs.phoneNumber = response.data.phoneNumber;
            $scope.editArgs.nickName = response.data.nickName;
            $scope.editArgs.sex = response.data.sex;
            $scope.editArgs.sign = response.data.sign;
            if(response.data.birth)
            {
                $scope.dataPickerArgs.selectDateBirth = stringToDate(response.data.birth);
            }
        }).catch(function (response) {
            modalService.showInform({}, {bodyText: '失败：' + response.statusText + "!"});
            // $scope.totalError = response.data.error == null ? response.statusText : response.data.error;
        });

        // $scope.pwdCheckboxClick = function () {
        //     $scope.editArgs.oriPassword = null;
        //     $scope.editArgs.newPassword = null;
        //     $scope.editArgs.confirmPassword = null;
        // }
        //
        // $scope.isPasswdValid = function (passstr) {
        //     if (passstr.length < 8 || passstr.length > 12)
        //         return false;
        //     var r = /^\+?[0-9]*$/;
        //     if (r.test(passstr))
        //         return false;
        //     else
        //         return true;
        // }
        //
        // $scope.isAgeValid = function () {
        //     var r = /^\+?[0-9][0-9]*$/;　　//正整数
        //     if (r.test($scope.editArgs.age)) {
        //         if ($scope.editArgs.age > 100 || $scope.editArgs.age <= 0)
        //             return false;
        //         else
        //             return true;
        //     }
        //     else
        //         return false;
        // };

        $scope.submit = function () {
            //先加密
            var send_data = {
                nickName: $scope.editArgs.nickName,
                sex: $scope.editArgs.sex,
                headPicUrl: $scope.croppedImage,
                birth: $filter('date')(ctrl.dataPickerArgs.selectDateBirth, 'yyyy-MM-dd'),
                sign : $scope.editArgs.sign
            };

            // if ($scope.editArgs.pwdFlag) {
            //     if ($scope.editArgs.newPassword == "" || $scope.editArgs.oriPassword == "" || $scope.editArgs.confirmPassword == "" ||
            //         $scope.editArgs.newPassword == null || $scope.editArgs.oriPassword == null || $scope.editArgs.confirmPassword == null) {
            //         // modalService.showInformModal({}, {headerText: '修改失败', bodyText: "密码不能为空", alertStyle: 'danger'});
            //         $scope.totalError = "密码不能为空";
            //         return;
            //     }
            //
            //     if (!$scope.isPasswdValid($scope.editArgs.newPassword)) {
            //         // modalService.showInformModal({}, {headerText: '修改失败', bodyText: "密码需要8到12数字、字母组合", alertStyle: 'danger'});
            //         $scope.totalError = "密码需要8到12数字、字母组合";
            //         return;
            //     }
            //
            //     if ($scope.editArgs.newPassword != $scope.editArgs.confirmPassword) {
            //         // modalService.showInformModal({}, {headerText: '修改失败', bodyText: "新密码与确认密码不一致", alertStyle: 'danger'});
            //         $scope.totalError = "新密码与确认密码不一致";
            //         return;
            //     }
            //     send_data.oldPassword = EncryptService.encryptPassword($scope.editArgs.oriPassword);
            //     send_data.password = EncryptService.encryptPassword($scope.editArgs.newPassword);
            // }

            // $http.post(ProfileService.USER_SERVICE, send_data, {headers: {"AuthCode": JSON.stringify({code_id: $scope.auth_code.code_id, code: $scope.registerArgs.code})}}).
            // $http.put(ProfileService.USER_SERVICE + TokenService.user.userId, send_data, {
            //     headers: {
            //         "AuthCode": JSON.stringify({
            //             codeId: $scope.auth_code.codeId,
            //             code: $scope.editArgs.code
            //         })
            //     }
            $http.put(ProfileService.USER_SERVICE + TokenService.user.userId, send_data).then(function (response) {
                // $rootScope.$emit("HeadPictureChanged", $scope.croppedImage);
                TokenRefreshService.refreshToken();
                $state.go('main');
            }).catch(function (response) {
                $scope.totalError = response.data.error == null ? response.statusText : response.data.error;
                $scope.requestAuthCode();
            });
        };
        $scope.cancel = function () {
            // TokenService.refreshUserName($scope.editArgs.name);
            $state.go('main');
        };


        $scope.getImgStyle = function () {
            return {"background-image": 'url(' + $scope.croppedImage + ')'};
        }

        $scope.showHeadEdit = function () {
            showHeadImageModal({}, {currentImageItem: $scope.currentImageItem}).then(function (result) {
                if (ctrl.currentImageItem && ctrl.currentImageItem.croppedImage) {
                    var blob = dataURItoBlob(ctrl.currentImageItem.croppedImage);
                    ctrl.currentImageItem._file = blob;
                    ctrl.currentImageItem.upload();
                }
            }).catch(function (result) {

            });
        };


        //头像对话框
        var modalHeadImageDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'HeadImageModalCtrl',
            templateUrl: 'app/pages/user/edit/headImageEditModal.html',
            resolve: {
                modalOptions: null
            }
        };

        var modalHeadImageOptions = {
            closeButtonText: '取消',
            actionButtonText: '确定',
            headerText: '编辑头像',
            bodyText: '',
            alertStyle: 'primary'
        };

        var showHeadImageModal = function (customModalDefaults, customModalOptions) {
            var tempModalDefaults = {};
            var tempModalOptions = {};
            angular.extend(tempModalDefaults, modalHeadImageDefaults, customModalDefaults);
            angular.extend(tempModalOptions, modalHeadImageOptions, customModalOptions);
            tempModalDefaults.resolve.modalOptions = tempModalOptions;
            return $uibModal.open(tempModalDefaults).result;
        };

        //当前上传文件
        //image、croppedImage
        ctrl.currentImageItem = null;

        var uploader = $scope.uploader = new FileUploader({
            url: ProfileService.USER_SERVICE + 'pictures',
            queueLimit: 5,
            removeAfterUpload: true
        });

        // ctrl.uploadPic = function () {
        //     if (ctrl.currentImageItem != '') {
        //         ctrl.showScrop = false;
        //     }
        // };

        // FILTERS
        uploader.filters.push({
            name: 'imageFilter',
            fn: function (item, options) {
                var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        });

        uploader.onWhenAddingFileFailed = function (item, filter, options) {
            console.info('onWhenAddingFileFailed', item, filter, options);
        };

        uploader.onAfterAddingFile = function (item) {
            ctrl.currentImageItem = item;
            item.croppedImage = '';
            var reader = new FileReader();
            reader.onload = function (event) {
                $scope.$apply(function () {
                    item.image = event.target.result;
                    $scope.showHeadEdit();
                });
            };
            reader.readAsDataURL(item._file);
        };

        var dataURItoBlob = function (dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var array = [];
            for (var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: mimeString});
        };

        uploader.onAfterAddingAll = function (addedFileItems) {
        };

        uploader.onBeforeUploadItem = function (item) {
            // var blob = dataURItoBlob(item.croppedImage);
            // item._file = blob;
        };
        uploader.onProgressItem = function (fileItem, progress) {
        };
        uploader.onProgressAll = function (progress) {
        };
        uploader.onSuccessItem = function (fileItem, response, status, headers) {
        };
        uploader.onErrorItem = function (fileItem, response, status, headers) {
        };
        uploader.onCancelItem = function (fileItem, response, status, headers) {
        };
        uploader.onCompleteItem = function (fileItem, response, status, headers) {
            var xurl = response.imageUrl;
            $scope.croppedImage = xurl;
            console.info('onCompleteItem: ' + $scope.croppedImage);
            // $uibModalInstance.close(xurl);
        };

        uploader.onCompleteAll = function () {
            console.info('onCompleteAll');
            ctrl.currentImageItem = null;
        };


    }

    function HeadImageModalCtrl($scope, $uibModalInstance, $log, modalOptions, FileUploader, ProfileService) {
        var ctrl = $scope;
        $scope.modalOptions = modalOptions;
        $scope.currentImageItem = modalOptions.currentImageItem;

        $scope.modalOptions.ok = function (result) {
            result = 'ok';
            $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function (result) {
            result = 'cancel';
            $uibModalInstance.dismiss(result);
        };
        
        // $scope.modalOptions.ok = function (result) {
        //     if (ctrl.currentImageItem != '' && !$scope.showScrop) {
        //         ctrl.currentImageItem.upload();
        //     } else {
        //
        //     }
        // };
        // $scope.modalOptions.close = function (result) {
        //     $uibModalInstance.dismiss('cancel');
        // };
        //
        // ctrl.showScrop = false;
        // ctrl.currentImageItem = '';
        //
        // var uploader = $scope.uploader = new FileUploader({
        //     url: ProfileService.USER_SERVICE + 'pictures',
        //     queueLimit: 5,
        //     removeAfterUpload: true
        // });
        //
        // ctrl.uploadPic = function () {
        //     if (ctrl.currentImageItem != '') {
        //         // ctrl.currentImageItem.upload()
        //         ctrl.showScrop = false;
        //     }
        // }
        //
        // // FILTERS
        // uploader.filters.push({
        //     name: 'imageFilter',
        //     fn: function (item /*{File|FileLikeObject}*/, options) {
        //         var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
        //         return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
        //     }
        // });
        //
        // uploader.onWhenAddingFileFailed = function (item, filter, options) {
        //     console.info('onWhenAddingFileFailed', item, filter, options);
        // };
        // uploader.onAfterAddingFile = function (item) {
        //     ctrl.currentImageItem = item;
        //     item.croppedImage = '';
        //     var reader = new FileReader();
        //     reader.onload = function (event) {
        //         $scope.$apply(function () {
        //             item.image = event.target.result;
        //             ctrl.showScrop = true;
        //         });
        //     };
        //     reader.readAsDataURL(item._file);
        // };
        //
        // var dataURItoBlob = function (dataURI) {
        //     var binary = atob(dataURI.split(',')[1]);
        //     var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        //     var array = [];
        //     for (var i = 0; i < binary.length; i++) {
        //         array.push(binary.charCodeAt(i));
        //     }
        //     return new Blob([new Uint8Array(array)], {type: mimeString});
        // };
        //
        // uploader.onAfterAddingAll = function (addedFileItems) {
        // };
        //
        // uploader.onBeforeUploadItem = function (item) {
        //     var blob = dataURItoBlob(item.croppedImage);
        //     item._file = blob;
        // };
        // uploader.onProgressItem = function (fileItem, progress) {
        // };
        // uploader.onProgressAll = function (progress) {
        // };
        // uploader.onSuccessItem = function (fileItem, response, status, headers) {
        // };
        // uploader.onErrorItem = function (fileItem, response, status, headers) {
        // };
        // uploader.onCancelItem = function (fileItem, response, status, headers) {
        // };
        // uploader.onCompleteItem = function (fileItem, response, status, headers) {
        //     var xurl = response;
        //     $uibModalInstance.close(xurl);
        // };
        //
        // uploader.onCompleteAll = function () {
        //     console.info('onCompleteAll');
        //     ctrl.curUploadItem = null;
        // };
        //
        // ctrl.curUploadItem = null;
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.login')
        .controller('LoginCtrl', LoginCtrl);

    function LoginCtrl($scope, $stateParams, $log, $http, $state, ProfileService, TokenService, EncryptService, modalService) {
        //登录传参
        $scope.loginArgs = {phoneNumber: TokenService.user.phoneNumber, password: "", code: ""};
        $scope.loginArgs.phoneNumber = $stateParams.phone;
        $scope.auth_code = {codeId: "", image_url: ""};
        $scope.totalError = "";
        $scope.previousState = null;
        $scope.previousParams = null;

        $scope.forgetPasswordLink = 1;

        $scope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
            console.info("" + $scope.previousState);
            $scope.previousState = from;
            $scope.previousParams = fromParams;
        });

        //登录动作
        $scope.login = function () {
            if ($scope.loginArgs.phoneNumber == "") {
                $scope.totalError = '请输入账号';
                return;
            } else if ($scope.loginArgs.password == "") {
                $scope.totalError = '请输入密码';
                return;
            } else if ($scope.loginArgs.code.length != 4) {
                $scope.totalError = '请输入验证码';
                return;
            }
            //先加密
            var send_data = {
                phoneNumber: $scope.loginArgs.phoneNumber,
                password: EncryptService.encryptPassword($scope.loginArgs.password)
            };
            $http.post(ProfileService.TOKEN_SERVICE, send_data, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "AuthCode": JSON.stringify({
                        codeId: $scope.auth_code.codeId,
                        code: $scope.loginArgs.code
                    })
                }
            }).then(function (response) {
                TokenService.login(response.data);
                // if (TokenService.user.userStatus == TokenService.STATUS_STRING.STATUS_VISITOR) {
                //     $state.go('user.personalStyle', '', {location: 'replace'});
                //     return;
                // }
                if ($scope.previousState && $scope.previousState.name) {
                    $state.go($scope.previousState, $scope.previousParams);
                }
                else {
                    $state.go("main");
                }
            }).catch(function (response) {
                $scope.totalError = response.data.error == null ? response.statusText : response.data.error;
                $scope.requestAuthCode();
            });
        };

        //取消登录动作，我们做了特殊处理，当前一个页面不需要登录的时候，直接跳到那个页面，否则就跳回主页
        $scope.cancel = function () {
            // $state.go("main");
            if ($scope.previousState && $scope.previousState.name && !$scope.previousState.needLogin) {
                $state.go($scope.previousState, $scope.previousParams);
            }
            else {
                $state.go("main");
            }
        };

        $scope.textChange = function () {
            $scope.totalError = '';
            if(!$scope.isPhoneNumberValid())
            {
                $scope.forgetPasswordLink = 1;
            }
        }

        $scope.isPhoneNumberValid = function () {
            var r = /^1\d{10}$/;
            if (r.test($scope.loginArgs.phoneNumber))
                return true;
            else
                return false;
        }

        $scope.phoneNumberInput = function () {
            $scope.textChange();
            if ($scope.loginArgs.phoneNumber != null && $scope.loginArgs.phoneNumber.length == 11 && $scope.isPhoneNumberValid() == true) {
                $scope.errorMsg = '';
                $scope.isPhoneRegistered($scope.loginArgs.phoneNumber);
            } else {
                $scope.errorMsg = '无效手机号';
            }
        }

        $scope.isPhoneRegistered = function (num) {
            $http.get(ProfileService.USER_SERVICE + 'phoneNumbers/' + num, '').then(function (response) {
                if (response.data.usedFlag == '0') {
                    $scope.errorMsg = '该号码未注册！';
                    $scope.forgetPasswordLink = 1;
                    return;
                } else {
                    $scope.errorMsg = '';
                }
                if(response.data.usedPassword == 0)
                {
                    $scope.forgetPasswordLink = 2;
                }
                else {
                    $scope.forgetPasswordLink = 1;
                }
            }).catch(function (response) {
                $scope.errorMsg = response.data;
            });
        }

        //请求验证码
        $scope.requestAuthCode = function () {
            var req = $http.post(ProfileService.AUTH_CODE_SERVICE, "").then(function (response) {
                $log.log('获取验证码成功：' + response.data.codeId);
                $scope.auth_code.codeId = response.data.codeId;
                $scope.auth_code.image_url = ProfileService.AUTH_CODE_SERVICE + $scope.auth_code.codeId;
            }).catch(function (response) {
                $log.log('获取验证码失败...');
                $scope.auth_code.codeId = "";
                $scope.auth_code.image_url = "";
            });
        };
        //检测登录
        var checkLogin = function () {
            if (TokenService.checkLogin()) {
                $state.go("main");
            }
        };
        //启动的时候，请求验证码
        $scope.requestAuthCode();

        checkLogin();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.personalStyle')
        .controller('PersonalStyleCtrl', PersonalStyleCtrl);

    function PersonalStyleCtrl($scope, $rootScope, $log, $http, $state, ProfileService, TokenService, modalService, TokenRefreshService) {

        var ctrl = $scope;
        //正在加载标志
        ctrl.isLoading = false;
        //加载失败标志
        ctrl.isFailed = false;

        $scope.previousState = null;
        $scope.previousParams = null;

        $scope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
            console.info("" + $scope.previousState);
            if (from.name != "user.login") {
                $scope.previousState = from;
                $scope.previousParams = fromParams;
            }
        });

        ctrl.isAllCompleted = function () {
            $log.info('check all completed...');
            if (ctrl.isLoading || ctrl.isFailed) {
                return false;
            }
            for (var i in ctrl.displayedExam.questions) {
                if (ctrl.displayedExam.questions[i].answer <= 0) {
                    return false;
                }
            }
            return true;
        };

        ctrl.displayedExam = {id: 0, questions: []};

        ctrl.randomOrderExam = {id:0, questions:[]};

        ctrl.makeRandomOrder = function () {
            if(ctrl.displayedExam.questions.length > 6){
                var qss = [];
                for(var i = 0; i < ctrl.displayedExam.questions.length; i++){
                    var question = ctrl.displayedExam.questions[i];
                    if(i < 6){
                        ctrl.randomOrderExam.questions.push(question);
                    } else {
                        qss.push(question);
                    }
                }
                qss.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
                for(var i = 0; i < qss.length; i++){
                    ctrl.randomOrderExam.questions.push(qss[i]);
                }
            } else {
                for(var i = 0; i < ctrl.displayedExam.questions.length; i++){
                    var question = ctrl.displayedExam.questions[i];
                    ctrl.randomOrderExam.questions.push(question);
                }
                ctrl.randomOrderExam.questions.sort(function(a,b){ return Math.random()>.5 ? -1 : 1;});
            }
        }

        ctrl.getData = function () {
            ctrl.isLoading = true;

            $http.post(ProfileService.USER_SERVICE + TokenService.user.userId + "/character_exam", "").then(function (response) {
                ctrl.displayedExam = response.data;
                ctrl.displayedExam.questions.forEach(function (question) {
                    question.answer = 0;
                });
                ctrl.makeRandomOrder();
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                //409表示已经有了，则直接GET
                if (response.status == 409) {
                    $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + "/character_exam").then(function (response) {
                        ctrl.displayedExam = response.data;
                        ctrl.displayedExam.questions.forEach(function (question) {
                            question.answer = 0;
                        });
                        ctrl.makeRandomOrder();
                        ctrl.isLoading = false;
                        ctrl.isFailed = false;
                    }).catch(function (response) {
                        modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载试题！")});
                        ctrl.isLoading = false;
                        ctrl.isFailed = true;
                    });
                }
                else {
                    modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载试题！")});
                    ctrl.isLoading = false;
                    ctrl.isFailed = true;
                }
            });
        };

        $scope.getAnswer = function (val) {
            if (val == 1)
                return 'A';
            else if (val == 2)
                return 'B';
            else if (val == 3)
                return 'C';
            else if (val == 4)
                return 'D';
            else
                return '';
        };


        $scope.getCheckColor = function (val, val1) {
            if (val == val1)
                return {"color": "red", "font-weight": "bold"};
            else
                return {"color": "black", "font-weight": "normal"};
        };

        $scope.getUserStatus = function () {
            $http.get(ProfileService.USER_SERVICE + TokenService.user.userId).then(function (response) {
                TokenService.refreshUserStatus(response.data.status);
            }).finally(function () {
                if ($scope.previousState && $scope.previousState.name) {
                    $state.go($scope.previousState, $scope.previousParams);
                }
                else {
                    $state.go("main");
                }
            });
        }

        $scope.commit = function () {
            modalService.showConfirmModal({}, {bodyText:'确定要交卷吗？', headerText:'交卷提示'}).then(function () {
                $http.put(ProfileService.USER_SERVICE + TokenService.user.userId + "/character_exam", ctrl.displayedExam).then(function (response) {
                    $log.info('register success');
                    // $state.go("user.interview");
                    modalService.showInform({}, {bodyText: '交卷成功！'}).catch(function (result) {
                        // $state.go("user.interview");
                        $scope.getUserStatus();
                    });
                    $scope.getUserStatus();
                }).catch(function (response) {
                    if (response.status == 304) {
                        modalService.showInform({}, {bodyText: '已经提交过了！'}).catch(function (result) {
                            // $state.go("user.interview");
                            $scope.getUserStatus();
                        });
                    }
                    else {
                        modalService.showInform({}, {bodyText: '失败：' + ((response.data && response.data.error )? response.data.error : "发生异常，无法提交！请重试")});
                    }
                }).finally(function () {
                    // $scope.getUserStatus();
                })
            }).catch(function () {
            });
        };

        $scope.cancel = function () {
            $state.go("main");
        };

        //检测登录，如果没有登录上，则回登录界面
        var checkLogin = function () {
            if (!TokenService.checkLogin()) {
                $state.go("user.login");
            }
        };

        checkLogin();
        ctrl.getData();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.interview')
        .controller('InterviewCtrl', InterviewCtrl);

    function InterviewCtrl($scope, $rootScope, $log, $http, $state, ProfileService, TokenService, modalService) {


        var ctrl = $scope;
        //正在加载标志
        ctrl.isLoading = false;
        //加载失败标志
        ctrl.isFailed = false;
        //预约状态
        ctrl.appointment = false;

        $scope.commit = function () {
            ctrl.isLoading = true;
            $http.put(ProfileService.USER_SERVICE + TokenService.user.userId + "/interview_status").then(function (response) {
                ctrl.isLoading = false;
                ctrl.getData();
            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '预约失败：' + response.statusText + "!"});
                ctrl.isLoading = false;
                ctrl.getData();
            });
        };

        $scope.finish = function () {
            $state.go("main");
        };

        ctrl.getData = function () {
            ctrl.isLoading = true;

            $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + "/interview_status").then(function (response) {
                ctrl.appointment = response.data == "1" ? true : false;
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                modalService.showInform({}, {bodyText: '失败：' + response.statusText + "!"});
                ctrl.appointment = false;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        ctrl.getData();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.user.register')
        .controller('RegisterCtrl', RegisterCtrl);

    function RegisterCtrl($scope, $q, $log, $http, $state, ProfileService, TokenService, modalService, EncryptService) {

        $scope.registerArgs = {
            phoneNumber: "",
            name: "",
            password: "",
            password2: "",
            code: ""
        };

        $scope.errorMsg = '';
        $scope.totalError = "";

        $scope.textChange = function () {
            $scope.totalError = '';
        }

        $scope.isPhoneNumberValid = function () {
            var r = /^1\d{10}$/;
            if (r.test($scope.registerArgs.phoneNumber))
                return true;
            else
                return false;
        }

        $scope.phoneNumberInput = function () {
            $scope.textChange();
            if ($scope.registerArgs.phoneNumber != null && $scope.registerArgs.phoneNumber.length == 11 && $scope.isPhoneNumberValid() == true) {
                $scope.errorMsg = '';
                $scope.isPhoneRegistered($scope.registerArgs.phoneNumber);
            } else {
                $scope.errorMsg = '手机号码不合法';
            }
        }

        $scope.isPhoneRegistered = function (num) {
            $http.get(ProfileService.USER_SERVICE + 'phoneNumbers/' + num, '').then(function (response) {
                if (response.data.usedFlag == '1') {
                    $scope.errorMsg = '该号码已注册！';
                } else {
                    $scope.errorMsg = '';
                }
            }).catch(function (response) {
                $scope.errorMsg = response.data;
            });
        }

        // $scope.isAgeValid = function () {
        //     var r = /^\+?[0-9][0-9]*$/;　　//正整数
        //     if (r.test($scope.registerArgs.age)) {
        //         if ($scope.registerArgs.age > 100 || $scope.registerArgs.age <= 0)
        //             return false;
        //         else
        //             return true;
        //     }
        //     else
        //         return false;
        // }

        $scope.isPasswdValid = function () {
            if ($scope.registerArgs.password != null && ($scope.registerArgs.password.length < 8 || $scope.registerArgs.password.length > 12))
                return false;
            var r = /^\+?[0-9]*$/;
            if (r.test($scope.registerArgs.password))
                return false;
            else
                return true;
        }

        $scope.auth_code = {codeId: "", image_url: ""};
        $scope.register = function () {
            //先加密
            var send_data = {
                phoneNumber: $scope.registerArgs.phoneNumber,
                nickName: $scope.registerArgs.name,
                // codeId:$scope.auth_code.codeId,
                // code:$scope.registerArgs.code,
                password: EncryptService.encryptPassword($scope.registerArgs.password)
            };
            $http.post(ProfileService.USER_SERVICE, send_data, {
            headers: {
                "AuthCode": JSON.stringify({
                    codeId: $scope.auth_code.codeId,
                    code: $scope.registerArgs.code
                })
            }
        }).then(function (response) {
            TokenService.login(response.data);
            //跳转
            // $state.go('user.personalStyle');
            $state.go("main");
        }).catch(function (response) {
            // modalService.showInformModal({}, {headerText: '注册失败', bodyText: response.data.error, alertStyle: 'danger'});
            $scope.totalError = response.data.error == null ? response.statusText : response.data.error;
            // $scope.requestAuthCode();
        });
    };

        $scope.cancel = function () {
            $state.go('main');
        };

        //请求验证码
        $scope.requestAuthCode = function () {
            $http.post(ProfileService.AUTH_CODE_SERVICE, "").then(function (response) {
                $log.log('获取验证码成功：' + response.data.codeId);
                $scope.auth_code.codeId = response.data.codeId;
                $scope.auth_code.image_url = ProfileService.AUTH_CODE_SERVICE + $scope.auth_code.codeId;
            }).catch(function (response) {
                $log.log('获取验证码失败...');
                $scope.auth_code.codeId = "";
                $scope.auth_code.image_url = "";
            });
        };
        //启动的时候，请求验证码
        // $scope.requestAuthCode();

        //检测登录
        var checkLogin = function () {
            if (TokenService.checkLogin()) {
                $state.go("main");
            }
        };

        checkLogin();
        $scope.holdForTimeOut = false;
        $scope.timeOutCount = 120;
        $scope.intervalId = '';
        $scope.getTimeBtnText = function () {
            if($scope.holdForTimeOut){
                return $scope.timeOutCount + '秒后重试';
            }
            return '获取验证码';
        }
        $scope.shortMsgClick = function () {
            $scope.holdForTimeOut = true;
            $scope.intervalId = window.setInterval(function () {
                $q.when().then(function () {
                    $scope.timeOutCount--;
                    if($scope.timeOutCount == 0){
                        window.clearInterval($scope.intervalId);
                        $scope.timeOutCount = 120;
                        $scope.holdForTimeOut = false;
                    }
                });
            },1000);
            $http.post(ProfileService.AUTH_MSG_SERVICE, {phoneNumber:$scope.registerArgs.phoneNumber}).then(function (response) {
                $scope.auth_code.codeId = response.data.codeId;
            }).catch(function (response) {
                console.info('shortmsg failed');
            });
        };

        $scope.$on('$destory', function () {
            if($scope.holdForTimeOut){
                window.clearInterval($scope.intervalId);
            }
        });

        $scope.getProtocolHref = function () {
            return $state.href("resources.ruleDetails", {type: "register"});
        };
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.bigData.scoreData.details')
        .controller('ScoreDetailsCtrl', ScoreDetailsCtrl);

    function ScoreDetailsCtrl($scope, $stateParams, $state, $http, ProfileService, TokenCheckService) {
        var ctrl = $scope;

        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.errorMessage = "";
        ctrl.itemId = $stateParams.id;
        ctrl.itemDisplayed = null;
        ctrl.displayed = []; //{title: "", data[], totalScore: 0}

        $scope.getData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            $http.get(ProfileService.SERVICE_SCORE + ctrl.itemId).then(function (response) {
                ctrl.itemDisplayed = response.data;
                ctrl.isLoading = false;
                ctrl.isFailed = false;
                ctrl.errorMessage = "";
            }).catch(function (response) {
                ctrl.itemDisplayed = null;
                ctrl.isLoading = false;
                ctrl.isFailed = true;
                ctrl.errorMessage = ((response.data && response.data.error) ? response.data.error : "");
            }).finally(function () {
                parseData();
            });
        };

        var parseData = function () {
            ctrl.displayed = [];
            var index = 0;
            //统计盈利能力维度
            var tmp_item = {title: "盈利能力维度", data: [], totalScore: 0};
            if(ctrl.itemDisplayed.profitScore.posProfitScore != 0)
            {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据当日仓位收益率，积分变化 " + ctrl.itemDisplayed.profitScore.posProfitScore + " 个",
                    score: ctrl.itemDisplayed.profitScore.posProfitScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.profitScore.posProfitScore;
            }
            if(ctrl.itemDisplayed.profitScore.turnoverRateScore != 0)
            {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据当日周转率，积分变化 " + ctrl.itemDisplayed.profitScore.turnoverRateScore + " 个",
                    score: ctrl.itemDisplayed.profitScore.turnoverRateScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.profitScore.turnoverRateScore;
            }
            if(ctrl.itemDisplayed.profitScore.winRateScore != 0)
            {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据当日胜率，积分变化 " + ctrl.itemDisplayed.profitScore.winRateScore + " 个",
                    score: ctrl.itemDisplayed.profitScore.winRateScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.profitScore.winRateScore;
            }
            if(ctrl.itemDisplayed.profitScore.winDayScore != 0)
            {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据连盈，连亏天数，积分变化 " + ctrl.itemDisplayed.profitScore.winDayScore + " 个",
                    score: ctrl.itemDisplayed.profitScore.winDayScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.profitScore.winDayScore;
            }
            if (tmp_item.data.length > 0) {
                ctrl.displayed.push(tmp_item);
            }

            //统计风控能力维度
            index = 0;
            var tmp_item = {title: "风控能力维度", data: [], totalScore: 0};
            if(ctrl.itemDisplayed.riskScore.changeVolumeScore != 0) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据操作股票头寸情况，积分变化 " + ctrl.itemDisplayed.riskScore.changeVolumeScore + " 个",
                    score: ctrl.itemDisplayed.riskScore.changeVolumeScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.riskScore.changeVolumeScore;
            }
            if(ctrl.itemDisplayed.riskScore.loseTimeScore != 0) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据平局亏损时间，积分变化 " + ctrl.itemDisplayed.riskScore.loseTimeScore + " 个",
                    score: ctrl.itemDisplayed.riskScore.loseTimeScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.riskScore.loseTimeScore;
            }
            if (tmp_item.data.length > 0) {
                ctrl.displayed.push(tmp_item);
            }

            //交易态度维度
            index = 0;
            var tmp_item = {title: "交易态度维度", data: [], totalScore: 0};
            if (ctrl.itemDisplayed.tradeScore.orderCountScore != 0) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "根据当日委托笔数，积分变化：" + ctrl.itemDisplayed.tradeScore.orderCountScore + "个",
                    score: ctrl.itemDisplayed.tradeScore.orderCountScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.tradeScore.orderCountScore;
            }
            if (tmp_item.data.length > 0) {
                ctrl.displayed.push(tmp_item);
            }

            //统计其他积分
            index = 0;
            var tmp_item = {title: "其他", data: [], totalScore: 0};
            if (ctrl.itemDisplayed.otherScore.diaryScore != 0) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "交易日志，积分变化 " + ctrl.itemDisplayed.otherScore.diaryScore + " 个",
                    score: ctrl.itemDisplayed.otherScore.diaryScore
                });
                tmp_item.totalScore += ctrl.itemDisplayed.otherScore.diaryScore;
            }
            for (var i = 0; i < ctrl.itemDisplayed.otherScore.mistakeScores.length; i++)
            {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: ctrl.itemDisplayed.otherScore.mistakeScores[i].misDate + "： 因 \"" + ctrl.itemDisplayed.otherScore.mistakeScores[i].description + "\"，积分变化 "
                    + ctrl.itemDisplayed.otherScore.mistakeScores[i].score + " 个",
                    score: ctrl.itemDisplayed.otherScore.mistakeScores[i].score
                });
                tmp_item.totalScore += ctrl.itemDisplayed.otherScore.mistakeScores[i].score;
            }
            for (var i = 0; i < ctrl.itemDisplayed.otherScore.rewardScores.length; i++) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "因 \"" + ctrl.itemDisplayed.otherScore.rewardScores[i].description + "\"，积分变化 " + ctrl.itemDisplayed.otherScore.rewardScores[i].score + " 个",
                    score: ctrl.itemDisplayed.otherScore.rewardScores[i].score
                });
                tmp_item.totalScore += ctrl.itemDisplayed.otherScore.rewardScores[i].score;
            }
            if (ctrl.itemDisplayed.otherScore.askScore.score != 0) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "当日提出 " + ctrl.itemDisplayed.otherScore.askScore.count + " 个问题，增加积分 " + ctrl.itemDisplayed.otherScore.askScore.score + " 个",
                    score: ctrl.itemDisplayed.otherScore.askScore.score
                });
                tmp_item.totalScore += ctrl.itemDisplayed.otherScore.askScore.score;
            }
            if (ctrl.itemDisplayed.otherScore.answerScore.score != 0) {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "当日回答 " + ctrl.itemDisplayed.otherScore.answerScore.count + " 个问题，增加积分 " + ctrl.itemDisplayed.otherScore.answerScore.score + " 个",
                    score: ctrl.itemDisplayed.otherScore.answerScore.score
                });
                tmp_item.totalScore += ctrl.itemDisplayed.otherScore.answerScore.score;
            }
            for (var i = 0; i < ctrl.itemDisplayed.otherScore.starScores.length; i++)
            {
                index += 1;
                tmp_item.data.push({
                    index: index,
                    content: "1个回答累计获得 " + ctrl.itemDisplayed.otherScore.starScores[i].count+ " 个赞，积分增加 " + ctrl.itemDisplayed.otherScore.starScores[i].score + " 个",
                    score: ctrl.itemDisplayed.otherScore.starScores[i].score
                });
                tmp_item.totalScore += ctrl.itemDisplayed.otherScore.starScores[i].score;
            }
            if (tmp_item.data.length > 0) {
                ctrl.displayed.push(tmp_item);
            }

        }

        ctrl.getValueStyle = function (value) {
            return {color: value > 0 ? '#c52d2f' : '#088205'};
        };

        ctrl.getGobackHref = function () {
            return $state.href('bigData.scoreData', {
                fromDate: $stateParams.fromDate,
                toDate: $stateParams.toDate,
                start: $stateParams.start
            });
        };

        ctrl.getData();
    }
})();
(function () {
    'use strict';

    angular.module('myApp.pages.resources.jobs.details')
        .controller('JobDetailsCtrl', JobDetailsCtrl);

    function JobDetailsCtrl($scope, $window, $log, $http, $stateParams, $sce, $state, ProfileService, TokenService, modalService) {

        var ctrl = $scope;
        ctrl.itemId = $stateParams.id;
        ctrl.itemType = $stateParams.type;
        ctrl.src = $stateParams.src;
        $window.scrollTo(0, 0);
        ctrl.showItem = {id: 0, title: "", content: ""};
        //正在加载标志
        ctrl.isLoading = false;
        //加载失败标志
        ctrl.isFailed = false;

        var getData = function () {
            ctrl.isLoading = true;
            var request_url = "";
            if(ctrl.itemType == "jobs")
            {
                request_url = ProfileService.SERVICE_JOB_PAGE;
            }
            else if(ctrl.itemType == "posters")
            {
                request_url = ProfileService.SERVICE_POSTER_PAGE;
            }
            else if(ctrl.itemType == '1')
            {
                request_url = ProfileService.SERVICE_ADVERT_PAGE;
            }
            else  if(ctrl.itemType == '2')
            {
                request_url = ProfileService.SERVICE_POSTER_PAGE;
            }

            // if(ctrl.src == "main")
            // {
            //     request_url = ProfileService.SERVICE_ADVERT_PAGE;
            // }

            $http.get(request_url + ctrl.itemId).
            then(function (response) {
                ctrl.showItem.id = response.data.id;
                ctrl.showItem.title = response.data.title;
                ctrl.showItem.content = $sce.trustAsHtml(response.data.content);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).
            catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
                // modalService.showConfirm({}, {bodyText: '查询详情失败，点确定重新刷新，或取消返回上一级！'}).then(function (result){getData();}).catch(function (result){$state.go('resources.jobPage');});
            });
        };

        ctrl.goBack = function () {
            // if(ctrl.itemType == "adverts")
            // {
            //     $state.go("main");
            // }
            // else
            // {
            //     $state.go("resources.jobs");
            // }

            if(ctrl.src == "main")
            {
                $state.go("main");
            }
            else
            {
                $state.go("resources.jobs");
            }
        };

        getData();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.simulation.diary.edit')
        .controller('DiaryEditCtrl', DiaryEditCtrl);

    function DiaryEditCtrl($scope, $sce, $http, $state, $stateParams, ProfileService, TokenCheckService, modalService) {

        var ctrl = $scope;
        ctrl.itemId = $stateParams.id;
        ctrl.updateTime = "";
        ctrl.content = "";
        ctrl.comment = "";
        ctrl.editable = ctrl.itemId == 0;
        ctrl.errorMessage = "";
        ctrl.localError = false;
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.ckInstance = null;

        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        ctrl.emptyStringCheck = function (str) {
            var tmp = str.replace(/&nbsp;/g, "").replace(/ /g, "").replace(/<p>/g, "").replace(/<\/p>/g, "");
            if (tmp == "") {
                return true;
            }
            return false;
        };

        ctrl.getHtmlText = function () {
            return $sce.trustAsHtml($scope.content);
        };

        ctrl.clearError = function () {
            this.errorMessage = "";
            ctrl.localError = false;
        };

        ctrl.getHelp = function () {
            if (ctrl.errorMessage) {
                return ctrl.errorMessage;
            }
            return "";
        };

        ctrl.onCKEditorReady = function (ckeditor_instance) {
            ctrl.ckInstance = ckeditor_instance;
        };

        ctrl.getHelpClass = function () {
            if (ctrl.errorMessage) {
                return "error";
            }
            return "help";
        };

        ctrl.options = ProfileService.CKEDITOR_TRADE_DIARY_OPTIONS;

        ctrl.getData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            $http.get(ProfileService.SERVICE_DIARY + ctrl.itemId).then(function (response) {
                ctrl.title = response.data.title;
                ctrl.content = response.data.content;
                ctrl.comment = response.data.comment;
                ctrl.updateTime = response.data.updateTime;
                ctrl.editable = response.data.type == 3;
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
                modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载日志！")});
            });
        };

        if (ctrl.itemId > 0) {
            ctrl.getData();
        }

        ctrl.getGobackHref = function () {
            var href = $state.href('simulation.diary', {
                fromDate: $stateParams.fromDate,
                toDate: $stateParams.toDate,
                start: $stateParams.start
            });
            return href;
        };

        ctrl.checkGoBack = function () {
            if (ctrl.isEditable() == true) {
                modalService.showConfirm({}, {
                    headerText: "请确认！",
                    bodyText: "确认退出编辑吗？"
                }).then(function (result) {
                    ctrl.goBack();
                }).catch(function (result) {

                });
            }
            else {
                ctrl.goBack();
            }
        };

        ctrl.goBack = function (reset_page) {
            $state.go('simulation.diary', reset_page ? {} : {
                fromDate: $stateParams.fromDate,
                toDate: $stateParams.toDate,
                start: $stateParams.start
            });
        };

        ctrl.submit = function () {
            // if (TokenCheckService.checkLogin() == false) {
            //     return;
            // }
            if (ctrl.ckInstance != null) {
                ctrl.content = ctrl.ckInstance.getData();
            }
            if (ctrl.emptyStringCheck(ctrl.content) == true) {
                ctrl.errorMessage = "内容不能为空";
                ctrl.localError = true;
                return;
            }
            if (!checkContentSize()) {
                return;
            }
            var tmp_args = {
                id: ctrl.itemId ? ctrl.itemId : 0,
                content: ctrl.content
            };
            modalService.showConfirm({}, {
                headerText: "请确认！",
                bodyText: "确认提交日志吗？"
            }).then(function (result) {
                if (ctrl.itemId > 0) {
                    $http.put(ProfileService.SERVICE_DIARY + ctrl.itemId, tmp_args).then(function (response) {
                        ctrl.goBack();
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = response.data.error;
                        }
                        else {
                            ctrl.errorMessage = "发生异常，无法提交日志";
                        }
                    });
                }
                else {
                    $http.post(ProfileService.SERVICE_DIARY, tmp_args).then(function (response) {
                        ctrl.goBack();
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = response.data.error;
                        }
                        else {
                            ctrl.errorMessage = "发生异常，无法提交日志";
                        }
                    });
                }
            }).catch(function (result) {

            });
        };

        var registerWatcher = function () {
            $scope.$watch('content', function () {
                ctrl.clearError();
                checkContentSize();
            });
        };

        var checkContentSize = function () {
            if (ctrl.content.length > 20000) {
                ctrl.errorMessage = "内容超过最大限制，无法提交日志";
                ctrl.localError = true;
                return false;
            }
            return true;
        };

        ctrl.isEditable = function () {
            return ctrl.editable;
        };

        registerWatcher();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.simulation.mistake.edit')
        .controller('MistakeEditCtrl', MistakeEditCtrl);

    function MistakeEditCtrl($scope, $sce, $http, $state, $stateParams, $filter, ProfileService, TokenCheckService, modalService) {

        var ctrl = $scope;
        ctrl.itemId = $stateParams.id;
        ctrl.misDate = "";
        ctrl.level = 0;
        ctrl.editable = ctrl.itemId == 0;
        ctrl.errorMessage = "";
        ctrl.localError = false;
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        // ctrl.ckInstance = null;

        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        ctrl.emptyStringCheck = function (str) {
            var tmp = str.replace(/&nbsp;/g, "").replace(/ /g, "").replace(/<p>/g, "").replace(/<\/p>/g, "");
            if (tmp == "") {
                return true;
            }
            return false;
        };

        // ctrl.getHtmlText = function () {
        //     return $sce.trustAsHtml($scope.content);
        // };

        // ctrl.clearError = function () {
        //     this.errorMessage = "";
        //     ctrl.localError = false;
        // };

        ctrl.getHelp = function () {
            if (ctrl.errorMessage) {
                return ctrl.errorMessage;
            }
            return "";
        };

        // ctrl.onCKEditorReady = function (ckeditor_instance) {
        //     ctrl.ckInstance = ckeditor_instance;
        // };

        ctrl.getHelpClass = function () {
            if (ctrl.errorMessage) {
                return "error";
            }
            return "help";
        };

        // ctrl.options = ProfileService.CKEDITOR_TRADE_DIARY_OPTIONS;

        var stringToDate = function (str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2]);
        };

        $scope.dataPickerArgs = {
            dateFormat: "yyyy-MM-dd",
            dateOptions: {
                startingDay: 1,
                showWeeks: false
            },
            altDateInputFormats: ['yyyy-M!-d!'],
            openDatePicker: false,
            selectMisDate: null
        };
        ctrl.openDatePicker = function () {
            ctrl.dataPickerArgs.openDatePicker = true;
        };


        ctrl.getData = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            ctrl.isLoading = true;
            $http.get(ProfileService.SERVICE_MISTAKE + ctrl.itemId).then(function (response) {
                ctrl.description = response.data.description;
                ctrl.misDate = response.data.misDate;
                ctrl.level = response.data.level;
                ctrl.dataPickerArgs.selectMisDate = stringToDate(response.data.misDate);
                ctrl.editable = response.data.level == 0;
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
                modalService.showInform({}, {bodyText: '失败：' + (response.data.error ? response.data.error : "发生异常，无法加载日志！")});
            });
        };

        if (ctrl.itemId > 0) {
            ctrl.getData();
        }

        ctrl.getGobackHref = function () {
            var href = $state.href('simulation.mistake', {
                fromDate: $stateParams.fromDate,
                toDate: $stateParams.toDate,
                start: $stateParams.start
            });
            return href;
        };

        ctrl.checkGoBack = function () {
            if (ctrl.isEditable() == true) {
                modalService.showConfirm({}, {
                    headerText: "请确认！",
                    bodyText: "确认退出编辑吗？"
                }).then(function (result) {
                    ctrl.goBack();
                }).catch(function (result) {

                });
            }
            else {
                ctrl.goBack();
            }
        };

        ctrl.goBack = function (reset_page) {
            $state.go('simulation.mistake', reset_page ? {} : {
                fromDate: $stateParams.fromDate,
                toDate: $stateParams.toDate,
                start: $stateParams.start
            });
        };

        ctrl.submit = function () {
            // if (TokenCheckService.checkLogin() == false) {
            //     return;
            // }
            // if (ctrl.ckInstance != null) {
            //     ctrl.content = ctrl.ckInstance.getData();
            // }
            if (ctrl.emptyStringCheck(ctrl.description) == true) {
                ctrl.errorMessage = "内容不能为空";
                ctrl.localError = true;
                return;
            }
            // if (!checkContentSize()) {
            //     return;
            // }
            var tmp_args = {
                id: ctrl.itemId ? ctrl.itemId : 0,
                description: ctrl.description,
                misDate: $filter('date')(ctrl.dataPickerArgs.selectMisDate, 'yyyy-MM-dd'),
            };
            modalService.showConfirm({}, {
                headerText: "请确认！",
                bodyText: "确认提交过失单吗？"
            }).then(function (result) {
                if (ctrl.itemId > 0) {
                    $http.put(ProfileService.SERVICE_MISTAKE + ctrl.itemId, tmp_args).then(function (response) {
                        ctrl.goBack();
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = response.data.error;
                        }
                        else {
                            ctrl.errorMessage = "发生异常，无法提交过失单";
                        }
                    });
                }
                else {
                    $http.post(ProfileService.SERVICE_MISTAKE, tmp_args).then(function (response) {
                        ctrl.goBack();
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = response.data.error;
                        }
                        else {
                            ctrl.errorMessage = "发生异常，无法提交过失单";
                        }
                    });
                }
            }).catch(function (result) {

            });
        };

        // var registerWatcher = function () {
        //     $scope.$watch('content', function () {
        //         ctrl.clearError();
        //         checkContentSize();
        //     });
        // };
        //
        // var checkContentSize = function () {
        //     if (ctrl.content.length > 20000) {
        //         ctrl.errorMessage = "内容超过最大限制，无法提交日志";
        //         ctrl.localError = true;
        //         return false;
        //     }
        //     return true;
        // };

        ctrl.isEditable = function () {
            return ctrl.editable;
        };

        // registerWatcher();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.turtle.forum.details')
        .controller('ForumDetailsCtrl', ForumDetailsCtrl);

    function ForumDetailsCtrl($scope, $sce, $http, $state, $stateParams, ProfileService, TokenService, TokenCheckService, modalService, $document) {

        var ctrl = $scope;
        ctrl.firstLoad = true;
        var ORDER_TYPE = {
            NORMAL: "获赞数排序",
            TIME: "按时间排序"
        };

        ctrl.itemId = $stateParams.id;

        ctrl.questionItem = {
            id: 0,
            title: "",
            content: "",
            userName: "",
            userId: 0,
            createTime: "",
            headPicUrl: "",
            answerCount: 0,
            clicks: 0
        };
        ctrl.answersDisplayed = {
            itemsByPage: 30,
            totalCount: 0,
            totalPages: 1,
            answers: [],
            sort: $stateParams.sort == null ? 0 : parseInt($stateParams.sort),
            isLoading: false,
            isFailed: false
        };

        //编辑的回复，如果有，则表示为编辑
        ctrl.replyId = 0;
        ctrl.replyContent = "";
        //正在加载标志
        ctrl.isLoading = false;
        //加载失败标志
        ctrl.isFailed = false;
        ctrl.ckInstance = null;

        ctrl.options = ProfileService.CKEDITOR_FORUM_ANSWER_OPTIONS;


        ctrl.getSortContent = function () {
            if (ctrl.answersDisplayed.sort == 0) {
                return ORDER_TYPE.NORMAL;
            }
            else {
                return ORDER_TYPE.TIME;
            }
        };

        ctrl.isReplyEditable = function () {
            return TokenService.isLogin();
        };

        ctrl.emptyStringCheck = function (str) {
            var tmp = str.replace(/&nbsp;/g, "").replace(/ /g, "").replace(/<p>/g, "").replace(/<\/p>/g, "");
            if (tmp == "") {
                return true;
            }
            return false;
        };

        ctrl.onCKEditorReady = function (ckeditor_instance) {
            ctrl.ckInstance = ckeditor_instance;
        };

        // ctrl.headImgUrl = 'images/turtle/default_header.png';
        // var getHeadImgUrl = function () {
        //     if (TokenService.user.userId == null || TokenService.user.userId == '') {
        //         return;
        //     }
        //     $http.get(ProfileService.USER_SERVICE + TokenService.user.userId + '/head_url').then(function (response) {
        //         $scope.headImgUrl = response.data;
        //     });
        // };
        //
        // getHeadImgUrl();

        function getPageCount(total) {
            return Math.ceil(total / ctrl.answersDisplayed.itemsByPage);
        }

        var getData = function () {
            ctrl.isLoading = true;
            $http.get(ProfileService.SERVICE_FORUM + ctrl.itemId).then(function (response) {
                ctrl.questionItem.id = response.data.id;
                ctrl.questionItem.title = response.data.title;
                ctrl.questionItem.userName = response.data.userName;
                ctrl.questionItem.userId = response.data.userId;
                ctrl.questionItem.createTime = ctrl.showInterval(response.data.createTime);
                ctrl.questionItem.answerCount = response.data.answerCount;
                ctrl.questionItem.clicks = response.data.clicks;
                ctrl.questionItem.headPicUrl = response.data.headPicUrl;
                ctrl.questionItem.content = convertText2Html(response.data.content);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
                getAnswerData(true);
            }).catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        var addClicks = function () {
            $http.put(ProfileService.SERVICE_FORUM + ctrl.itemId + "/clicks");
        };

        ctrl.callServer = function (tableState) {
            ctrl.tableState = tableState;
            if (ctrl.firstLoad && $stateParams.start) {
                ctrl.tableState.pagination.start = $stateParams.start;
            }
            getAnswerData(true);
        };

        ctrl.changeSortOrder = function () {
            ctrl.answersDisplayed.sort = ctrl.answersDisplayed.sort == 0 ? 1 : 0;
            getAnswerData(true);
        };


        var getAnswerData = function (scroll_flag, answer_id) {
            if (ctrl.questionItem.id == 0 || !ctrl.tableState) {
                return;
            }
            if (answer_id > 0) {
                ctrl.tableState.pagination.start = 0;
            }
            var tmp_args = {
                start: ctrl.tableState.pagination.start ? ctrl.tableState.pagination.start : 0,
                number: ctrl.answersDisplayed.itemsByPage,
                sortby: ctrl.answersDisplayed.sort == 0 ? "starMarkCount" : "createTime",
                order: "desc",
                answerId: answer_id ? answer_id : 0
            };
            ctrl.answersDisplayed.isLoading = true;

            $state.go($state.current.name, {
                sort: ctrl.answersDisplayed.sort,
                start: ctrl.tableState.pagination.start
            }, {
                notify: false,
                location: ctrl.firstLoad ? "replace" : true,
                inherit: true
            });
            ctrl.firstLoad = false;

            $http.get(ProfileService.SERVICE_FORUM + ctrl.itemId + "/answers?start=" + tmp_args.start + "&number=" + tmp_args.number + "&sortby=" + tmp_args.sortby + "&order=" + tmp_args.order + "&answerId=" + tmp_args.answerId).then(function (response) {
                ctrl.answersDisplayed.answers = [];
                for (var i = 0; i < response.data.answers.length; i++) {
                    var tmp_item = response.data.answers[i];
                    ctrl.answersDisplayed.answers.push({
                        id: tmp_item.id,
                        questionId: tmp_item.questionId,
                        userId: tmp_item.userId,
                        userName: tmp_item.userName,
                        origContent: tmp_item.content,
                        content: convertText2Html(tmp_item.content),
                        createTime: ctrl.showInterval(tmp_item.createTime),
                        starMarkCount: tmp_item.starMarkCount,
                        headPicUrl: tmp_item.headPicUrl,
                        starMarkable: tmp_item.starMarkable
                    });
                }
                ctrl.answersDisplayed.totalCount = response.data.totalCount;
                ctrl.questionItem.answerCount = ctrl.answersDisplayed.totalCount;
                ctrl.answersDisplayed.totalPages = getPageCount(ctrl.answersDisplayed.totalCount);
                ctrl.tableState.pagination.numberOfPages = ctrl.answersDisplayed.totalPages;
                ctrl.answersDisplayed.isLoading = false;
                ctrl.answersDisplayed.isFailed = false;
                if (scroll_flag) {
                    gotoAnswers(answer_id);
                }
            }).catch(function (response) {
                ctrl.answersDisplayed.answers = [];
                ctrl.answersDisplayed.totalCount = 0;
                ctrl.answersDisplayed.totalPages = 1;
                ctrl.tableState.pagination.numberOfPages = 1;
                ctrl.answersDisplayed.isLoading = false;
                ctrl.answersDisplayed.isFailed = true;
            });
        };

        ctrl.isAnswerEditable = function (item) {
            return TokenService.isLogin() && TokenService.user.userId == item.userId;
        };

        ctrl.editAnswer = function (item) {
            if (ctrl.isAnswerEditable(item) == false) {
                return;
            }
            ctrl.replyId = item.id;
            ctrl.replyContent = item.origContent;
            ctrl.gotoReply();
        };

        ctrl.cancelReply = function () {
            if (!ctrl.replyId) {
                return;
            }
            var tmp_e = document.getElementById('answer_' + ctrl.replyId);
            if (tmp_e) {
                var target_element = angular.element(tmp_e);
                if (target_element) {
                    $document.scrollTo(target_element, 8, 500);
                }
            }
            ctrl.replyId = 0;
            ctrl.replyContent = "";
        };

        ctrl.voteAnswer = function (item) {
            $http.put(ProfileService.SERVICE_FORUM + ctrl.itemId + "/answers/" + item.id + "/starmarks").then(function (response) {
                item.starMarkCount += 1;
                item.starMarkable = false;
            });
        };

        ctrl.canVoteAnswer = function (item) {
            return item.starMarkable;
        };

        ctrl.isAnswerVoted = function (item) {
            if (TokenService.isLogin() == true && !item.starMarkable) {
                return true;
            }
            return false;
        };

        ctrl.getGobackHref = function () {
            return $state.href('turtle.forum', {
                filter: $stateParams.filter,
                start: $stateParams.from_start,
                sort: $stateParams.from_sort
            });
        };

        var first_load = true;

        var gotoAnswers = function (answer_id) {
            if (first_load) {
                first_load = false;
                return;
            }
            var target_element = angular.element(document.getElementById('answers'));
            $document.scrollTo(target_element, 8, 500);
        };

        ctrl.gotoReply = function () {
            if (TokenCheckService.checkLogin() == true) {
                var target_element = angular.element(document.getElementById('reply'));
                $document.scrollTo(target_element, 8, 500);
                focusOnCKEditor();
            }
        };

        var focusOnCKEditor = function () {
            if (ctrl.ckInstance != null) {
                ctrl.ckInstance.focus();
            }
        };

        ctrl.errorMessage = "";
        ctrl.helpMessage = "";
        if (TokenService.isLogin() == false) {
            ctrl.helpMessage = $sce.trustAsHtml("您尚未登录，请 <a href='#/user/login'>登录</a> 或者 <a href='#/user/register'>注册</a> 发表回复。");
        }
        ctrl.localError = false;

        ctrl.clearError = function () {
            this.errorMessage = "";
            ctrl.localError = false;
        };

        ctrl.getHelp = function () {
            if (ctrl.errorMessage) {
                return ctrl.errorMessage;
            }
            return ctrl.helpMessage;
        };

        ctrl.getHelpClass = function () {
            if (ctrl.errorMessage) {
                return "error";
            }
            return "help";
        };

        ctrl.submitReply = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            if (ctrl.ckInstance != null) {
                ctrl.replyContent = ctrl.ckInstance.getData();
            }
            if (ctrl.emptyStringCheck(ctrl.replyContent)) {
                ctrl.errorMessage = $sce.trustAsHtml("内容不能为空");
                ctrl.localError = true;
                return;
            }
            if (!checkContentSize()) {
                return;
            }
            var tmp_args = {
                id: ctrl.replyId,
                questionId: ctrl.itemId,
                content: ctrl.replyContent
            };
            modalService.showConfirm({}, {
                headerText: "请确认！",
                bodyText: '确认' + (tmp_args.id > 0 ? '修改' : '发布') + '回答吗？'
            }).then(function (result) {
                //编辑逻辑
                if (tmp_args.id > 0) {
                    $http.put(ProfileService.SERVICE_FORUM + ctrl.itemId + "/answers/" + tmp_args.id, tmp_args).then(function (response) {
                        ctrl.replyId = 0;
                        ctrl.replyContent = "";
                        getAnswerData(true, response.data.id);
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = $sce.trustAsHtml(response.data.error);
                        }
                        else {
                            ctrl.errorMessage = $sce.trustAsHtml("发生异常，无法修改回答");
                        }
                    });
                }
                else {
                    $http.post(ProfileService.SERVICE_FORUM + ctrl.itemId + "/answers/", tmp_args).then(function (response) {
                        ctrl.replyId = 0;
                        ctrl.replyContent = "";
                        getAnswerData(true, response.data.id);
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = $sce.trustAsHtml(response.data.error);
                        }
                        else {
                            ctrl.errorMessage = $sce.trustAsHtml("发生异常，无法发布回答");
                        }
                    });
                }

            }).catch(function (result) {

            });
        };

        var registerWatcher = function () {
            $scope.$watch('replyContent', function () {
                ctrl.clearError();
                checkContentSize();
            });
        };

        var checkContentSize = function () {
            if (ctrl.replyContent.length > 10000) {
                ctrl.errorMessage = "内容超过最大限制，无法回复问题";
                ctrl.localError = true;
                return false;
            }
            return true;
        };

        function StringToDate(str) {
            str = str.replace(/-/g, " ").replace(/:/g, " ");
            str = str.split(" ");
            return new Date(str[0], str[1] - 1, str[2], str[3], str[4], str[5]);
        }

        ctrl.showInterval = function (etime) {
            var re = "";
            var sjc = parseInt((new Date().getTime() - StringToDate(etime).getTime()) / 1000);
            if (sjc < 10) {
                return "刚刚";
            } else {
                if (sjc >= 60 * 60 * 24 * 7) {
                    return etime.substring(0, 10);
                }
                if (sjc >= 60 * 60 * 24)
                    re = parseInt(sjc / (60 * 60 * 24)) + "天";
                else {
                    if (sjc >= 60 * 60)
                        re = parseInt(sjc / (60 * 60)) + "小时";
                    else {
                        if (sjc >= 60)
                            re = parseInt(sjc / 60) + "分钟";
                        else
                            re = sjc + "秒";
                    }
                }
                re += "前";
            }
            return re;
        };

        //html判断
        var isHtml = function(str) {
            if(!str) {
                return false;
            }
            if (str.substr(0, 1) == "<" && str.substr(str.length - 1, 1) == ">") {
                return true;
            }
            return false;
        };

        //把文字转换成html
        var convertText2Html = function(str) {
            if(isHtml(str) == true) {
                return str;
            }
            var result_string = "";
            var lines = str.split("\n");
            for(var i = 0; i < lines.length; i++) {
                if(lines[i] == "") {
                    result_string += "<br/>";
                }
                result_string += "<p>" + lines[i] + "</p>";
            }
            return result_string;
        };

        registerWatcher();
        addClicks();
        getData();
    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.turtle.wiki.details')
        .controller('WikiDetailsCtrl', WikiDetailsCtrl);

    function WikiDetailsCtrl($scope, $window, $http, $stateParams, $sce, $state, ProfileService) {

        var ctrl = $scope;
        ctrl.itemId = $stateParams.id;
        ctrl.fromStart = $stateParams.start;
        ctrl.groupId = $stateParams.groupId;
        ctrl.filter = $stateParams.filter;
        $window.scrollTo(0, 0);
        ctrl.showItem = {id: 0, title: "", content: ""};
        //正在加载标志
        ctrl.isLoading = false;
        //加载失败标志
        ctrl.isFailed = false;

        var getData = function () {
            ctrl.isLoading = true;

            $http.get(ProfileService.SERVICE_WIKI + ctrl.itemId).then(function (response) {
                ctrl.showItem.id = response.data.id;
                ctrl.showItem.title = response.data.title;
                ctrl.showItem.content = $sce.trustAsHtml(response.data.content);
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        var addClicks = function () {
            $http.put(ProfileService.SERVICE_WIKI + ctrl.itemId + '/clicks', null).then(function (response) {

            }).catch(function (response) {

            });
        };

        ctrl.goBack = function () {
            $state.go("turtle.wiki", {start: ctrl.fromStart, groupId:ctrl.groupId, filter:ctrl.filter});
        };

        getData();
        addClicks();

    }
})();

(function () {

    'use strict';

    angular.module('myApp.pages.turtle.forum.write')
        .controller('WriteCtrl', WriteCtrl)
        .directive('textareaAutogrow', textareaAutogrow);

    function textareaAutogrow($window, $q) {
        return {
            restrict: 'A',
            // scope: false,
            // scope: {},
            link: function (scope, element, attrs) {
                scope.$watch('$viewContentLoaded', function () {
                    $q.when().then(function () {
                        checkAutoGrow();
                    });
                });

                element.bind("input propertychange", function (event) {
                    checkAutoGrow();
                });

                var checkAutoGrow = function () {
                    element.height(10);
                    var scroll_height = element[0].scrollHeight;
                    // console.info("scroll_height = " + scroll_height);
                    element.height(scroll_height);

                };

                element.bind("keydown", function (event) {
                    if (event.keyCode == "13") {
                        event.preventDefault();
                        focusOnCKEditor();
                    }
                });

                var focusOnCKEditor = function () {
                    for (var instance in CKEDITOR.instances) {
                        var editor = CKEDITOR.instances[instance];
                        if (editor) {
                            editor.focus();
                            return;
                        }
                    }
                }
            }
        };
    }

    function WriteCtrl($scope, $sce, $http, $state, $stateParams, ProfileService, TokenService, modalService, TokenCheckService) {

        var ctrl = $scope;
        ctrl.itemId = $stateParams.id;
        ctrl.content = "";
        ctrl.title = "";
        ctrl.errorMessage = "";
        ctrl.localError = false;
        ctrl.isLoading = false;
        ctrl.isFailed = false;
        ctrl.ckInstance = null;
        
        if (TokenCheckService.checkLogin() == false) {
            return;
        }

        ctrl.emptyStringCheck = function (str) {
            var tmp = str.replace(/&nbsp;/g, "").replace(/ /g, "").replace(/<p>/g, "").replace(/<\/p>/g, "");
            if (tmp == "") {
                return true;
            }
            return false;
        };

        ctrl.getHtmlText = function () {
            return $sce.trustAsHtml($scope.content);
        };

        ctrl.clearError = function () {
            this.errorMessage = "";
            ctrl.localError = false;
        };

        ctrl.getHelp = function () {
            if (ctrl.errorMessage) {
                return ctrl.errorMessage;
            }
            return "";
        };

        ctrl.onCKEditorReady = function (ckeditor_instance) {
            ctrl.ckInstance = ckeditor_instance;
        };

        ctrl.getHelpClass = function () {
            if (ctrl.errorMessage) {
                return "error";
            }
            return "help";
        };

        ctrl.options = ProfileService.CKEDITOR_FORUM_QUESTION_OPTIONS;

        ctrl.getData = function () {
            ctrl.isLoading = true;

            $http.get(ProfileService.SERVICE_FORUM + ctrl.itemId).then(function (response) {
                ctrl.title = response.data.title;
                ctrl.content = response.data.content;
                ctrl.isLoading = false;
                ctrl.isFailed = false;
            }).catch(function (response) {
                ctrl.isLoading = false;
                ctrl.isFailed = true;
            });
        };

        if (ctrl.itemId > 0) {
            ctrl.getData();
        }

        ctrl.getGobackHref = function () {
            return $state.href('turtle.forum', {
                start: $stateParams.start,
                filter: $stateParams.filter,
                sort: $stateParams.sort
            });
        };

        ctrl.submit = function () {
            if (TokenCheckService.checkLogin() == false) {
                return;
            }
            if (ctrl.ckInstance != null) {
                ctrl.content = ctrl.ckInstance.getData();
            }
            if (ctrl.emptyStringCheck(ctrl.title) == true) {
                ctrl.errorMessage = "标题不能为空";
                ctrl.localError = true;
                return;
            }
            if (ctrl.emptyStringCheck(ctrl.content) == true) {
                ctrl.errorMessage = "内容不能为空";
                ctrl.localError = true;
                return;
            }
            if (!checkTitleSize()) {
                return;
            }
            if (!checkContentSize()) {
                return;
            }
            var tmp_args = {
                id: ctrl.itemId ? ctrl.itemId : 0,
                title: ctrl.title,
                content: ctrl.content
            };
            modalService.showConfirm({}, {
                headerText: "请确认！",
                bodyText: '确认发布问题： \"' + ctrl.title + "\" 吗？"
            }).then(function (result) {
                if (ctrl.itemId > 0) {
                    $http.put(ProfileService.SERVICE_FORUM + ctrl.itemId, tmp_args).then(function (response) {
                        gotoDetails(response.data.id);
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = response.data.error;
                        }
                        else {
                            ctrl.errorMessage = "发生异常，无法发布问题";
                        }
                    });
                }
                else {
                    $http.post(ProfileService.SERVICE_FORUM, tmp_args).then(function (response) {
                        gotoDetails(response.data.id);
                    }).catch(function (response) {
                        if (response.data.error) {
                            ctrl.errorMessage = response.data.error;
                        }
                        else {
                            ctrl.errorMessage = "发生异常，无法发布问题";
                        }
                    });
                }
            }).catch(function (result) {

            });
        };

        var gotoDetails = function (id) {
            return $state.go('turtle.forumDetails', {
                id: id,
                filter: $stateParams.filter,
                from_start: $stateParams.start,
                from_sort: $stateParams.sort
            });
        };

        var registerWatcher = function () {
            $scope.$watch('title', function () {
                ctrl.clearError();
                checkTitleSize();
            });
            $scope.$watch('content', function () {
                ctrl.clearError();
                checkContentSize();
            });
        };

        var checkTitleSize = function () {
            if (ctrl.title.length > 50) {
                ctrl.errorMessage = "标题超过 " + (ctrl.title.length - 50) + " 字，无法发布问题";
                ctrl.localError = true;
                return false;
            }
            return true;
        };

        var checkContentSize = function () {
            console.info("checkContentSize: " + ctrl.content.length);
            if (ctrl.content.length > 20000) {
                ctrl.errorMessage = "内容超过最大限制，无法发布问题";
                ctrl.localError = true;
                return false;
            }
            return true;
        };

        registerWatcher();
    }
})();

angular.module('myApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/theme/components/pagination.custom.html','<nav ng-if="numPages && pages.length >= 2"><ul class="pagination beauty-pagination"><li ng-style="{\'visibility\': (currentPage > 1 ? \'inherit\' : \'hidden\')}"><a ng-click="selectPage(1)" style="cursor:pointer;"><i class="fa fa-fw fa-angle-double-left"></i>\u9996\u9875</a></li><li ng-style="{\'visibility\': (currentPage > 1 ? \'inherit\' : \'hidden\')}"><a ng-click="selectPage(currentPage-1)" style="cursor:pointer;"><i class="fa fa-fw fa-angle-left"></i>&lt;</a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}" style="cursor:pointer;"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-style="{\'visibility\': (currentPage < numPages ? \'inherit\' : \'hidden\')}"><a ng-click="selectPage(currentPage+1)" style="cursor:pointer;"><i class="fa fa-fw fa-angle-right"></i>&gt;</a></li><li ng-style="{\'visibility\': (currentPage < numPages ? \'inherit\' : \'hidden\')}"><a ng-click="selectPage(numPages)" style="cursor:pointer;"><i class="fa fa-fw fa-angle-double-right"></i>\u5C3E\u9875</a></li></ul></nav>');
$templateCache.put('app/theme/components/trade.pagination.html','<nav ng-if="numPages && pages.length >= 2"><ul class="pagination grubby-pagination"><li><a ng-click="selectPage(1)" ng-class="{enable_class: (currentPage!=1)}"><i class="fa fa-fw fa-angle-double-left"></i>\u9996\u9875</a></li><li><a ng-click="selectPage(currentPage-1)" ng-class="{enable_class: (currentPage!=1)}"><i class="fa fa-fw fa-angle-left"></i>&lt;</a></li><li ng-repeat="page in pages" class="page-number"><a ng-click="selectPage(page)" ng-class="{enable_class: (currentPage!=page)}">{{page}}</a></li><li></li><li><a ng-click="selectPage(currentPage+1)" ng-style="currentPage!=numPages?{\'cursor\':\'pointer\'}:{\'cursor\':\'normal\'}" ng-class="{enable_class: (currentPage!=numPages)}"><i class="fa fa-fw fa-angle-right"></i>&gt;</a></li><li><a ng-click="selectPage(numPages)" ng-class="{enable_class: (currentPage!=numPages)}"><i class="fa fa-fw fa-angle-double-right"></i>\u5C3E\u9875</a></li></ul></nav>');
$templateCache.put('app/pages/aboutUs/aboutUs.html','<div class="main_page"><section id="main-slider" class="no-margin"><div class="top-banner" style="background-image: url(images/about_us_banner.png);"><div id="main-top-cover"></div><div class="container"><div class="center" style="margin-top: 138px;"><div style="position:absolute;left:50%;margin-left:-80px;"><div style="color: #FFFFFF;font-size: 30px;">\u5173\u4E8E\u6211\u4EEC</div><div style="color: #FFFFFF;font-size: 17px;opacity: 0.5">About US</div></div></div></div></div></section><section id="about-us"><div class="container"><div class="lead scroll-hidden" when-visible="fadeIn2" style="text-align: left;font-size: 17px;line-height: 1.8;padding-left: 70px;padding-right: 70px;margin-bottom: 0px" ng-bind-html="showItem.content"></div><div ng-show="showItem.content == \'\'" style="text-align: center;padding-left: 70px;padding-right: 70px;margin-bottom: 0px"><p class="lead scroll-hidden" when-visible="fadeIn2" style="text-align: left; font-size: 17px;line-height: 1.8">&emsp;&emsp;\u5C0F\u725B\u6570\u636E\u662F\u4E3AT0\u673A\u6784\u548C\u4EA4\u6613\u5458\u91CF\u8EAB\u6253\u9020\u7684\u4E00\u6B3E\u5927\u6570\u636E\u5206\u6790\u8F6F\u4EF6\u3002</p><p class="lead scroll-hidden" when-visible="fadeIn3" style="text-align: left; font-size: 17px;line-height: 1.8">&emsp;&emsp; \u901A\u8FC7\u5BF9\u4EA4\u6613\u5458\u548C\u8BC1\u5238\u7684\u957F\u671F\u91C7\u96C6\u548C\u8DDF\u8E2A\uFF0C\u7CBE\u786E\u523B\u753B\u51FA\u673A\u6784\u7684\u7FA4\u4F53\u7279\u6027\u3001\u4EA4\u6613\u5458\u7684\u4E2A\u6027\u5316\u80FD\u529B\u4E94\u7EF4\u753B\u50CF\u3001\u6807\u7684\u8BC1\u5238\u7684T0\u7279\u5F81\u7B49\u3002\u901A\u8FC7\u6211\u4EEC\u7684\u5927\u6570\u636E\u5206\u6790\uFF0C\u673A\u6784\u53EF\u4EE5\u66F4\u65B9\u4FBF\u5730\u7BA1\u7406\u56E2\u961F\uFF0C\u4EA4\u6613\u5458\u53EF\u4EE5\u66F4\u5BA2\u89C2\u6E05\u6670\u5730\u91CF\u5316\u81EA\u5DF1\u7684\u80FD\u529B\uFF0C\u67E5\u6F0F\u8865\u7F3A\uFF0C\u626C\u957F\u907F\u77ED\uFF0C\u4ECE\u800C\u5B9E\u73B0\u6574\u4F53\u7684\u5171\u8D62\u3002</p><p class="lead scroll-hidden" when-visible="fadeIn4" style="text-align: left; font-size: 17px;line-height: 1.8">&emsp;&emsp;\u540C\u65F6\u6211\u4EEC\u8FD8\u6709\u6A21\u62DF\u4EA4\u6613\u3001\u57F9\u8BAD\u89C6\u9891\u3001\u5206\u6BB5\u8BAD\u7EC3\u573A\u3001\u5206\u4EAB\u3001\u4EA4\u6613\u65E5\u5FD7\u7B49\u6A21\u5757\u548C\u573A\u666F\u5E2E\u52A9\u4EA4\u6613\u5458\u63D0\u9AD8\u4EA4\u6613\u6C34\u5E73\u3002</p><p class="lead scroll-hidden" when-visible="fadeIn4" style="text-align: left; font-size: 17px;line-height: 1.8">&emsp;&emsp;\u5728\u670D\u52A1\u5927\u91CF\u4F18\u8D28\u79C1\u52DF\u7684\u5BA2\u6237\u8FC7\u7A0B\u4E2D\u6211\u4EEC\u66F4\u52A0\u76F8\u4FE1\uFF0C\u901A\u8FC7\u6570\u636E\u7684\u529B\u91CF\uFF0C\u7ED9\u4EA4\u6613\u5458\u9002\u5408\u81EA\u8EAB\u7279\u6027\u7684\u8BC1\u5238\uFF0C\u5C31\u4F1A\u8D21\u732E\u51FA\u81EA\u5DF1\u6700\u5927\u7684\u6F5C\u80FD\uFF0C\u4ECE\u800C\u4E3A\u516C\u53F8\u5E26\u6765\u4E30\u539A\u7684\u56DE\u62A5\u3002\u771F\u6B63\u5B9E\u73B0\u201C\u4EBA\u4EBA\u90FD\u662F\u4EA4\u6613\u5458\u201D\u3002</p></div></div></section><section id="contract-us" style="visibility: collapse;"><div class="container"><div class="gmap-area" style="background-image: url(images/map.jpg);margin-bottom: 104px;"><div class="container"><div class="row"><div class="col-md-offset-2 col-md-3 col-sm-5 text-center scroll-hidden" when-visible="fadeInIcon" style="margin-top: 40px"><div class="gmap"><iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="baidumap.html"></iframe></div></div><div class="col-md-7 col-sm-7 map-content"><ul class="row" style="margin-top: 50px"><li class="col-sm-12"><address><h5 class="scroll-hidden" when-visible="fadeIn1" style="color:#333333;">\u5317\u4EAC\u5409\u6C99\u79D1\u6280\u6709\u9650\u516C\u53F8</h5><p class="scroll-hidden" when-visible="fadeIn2" style="color:#151515;">\u516C\u53F8\u5730\u5740\uFF1A\u5317\u4EAC\u5E02\u671D\u9633\u533A\u4E1C\u4E09\u73AF\u5317\u8DEF19\u53F7\u4E2D\u9752\u5927\u53A61103</p><p class="scroll-hidden" when-visible="fadeIn3" style="color:#151515;">\u5BA2\u670D\u7535\u8BDD\uFF1A0591-38200582</p><p class="scroll-hidden" when-visible="fadeIn4" style="color:#151515;">E - Mail\uFF1A<a href="mailto:xntrader@xntrader.com\u200D" style="color:#151515;">xntrader@xntrader.com\u200D</a></p></address></li></ul></div></div></div></div></div></section></div>');
$templateCache.put('app/pages/download/download.html','<div class="main_page"><div class="center" style="padding-top: 20px;font-size: 20px;"><div style="padding-top: 80px;padding-bottom: 70px"><img src="images/logo.png"></div><div><a ng-href="{{androidUrl}}">Android\u5E73\u53F0</a></div><div style="padding-top: 20px"><a ng-href="http://itunes.apple.com/us/app/pages/id1352190315?mt=8">IOS\u5E73\u53F0</a></div></div></div>');
$templateCache.put('app/pages/exam/exam.html','<div class="main_page secend_page big-data-page"><section id="main-slider" class="no-margin"><div class="top-banner" style="background-image: url(images/test_center_banner.png);"><div id="main-top-cover"></div><div class="container"><div class="center" style="margin-top: 138px;"><div style="position:absolute;left:50%;margin-left:-80px;"><div style="color: #FFFFFF;font-size: 30px;">\u6D4B\u8BC4\u4E2D\u5FC3</div><div style="color: #FFFFFF;font-size: 17px;opacity: 0.5">Test Center</div></div></div></div></div></section><section class="page-detail" style="padding-top: 30px;"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6;box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div class="horizontal-scroll" style="margin-left: 40px;margin-right: 40px;margin-top: 40px"><table class="table" st-pipe="callServer" st-table="displayed" style="text-align: center"><thead><tr class="black-muted-bg"><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u6D4B\u8BC4\u540D\u79F0</th><th style="text-align: center">\u6D4B\u8BC4\u5F00\u59CB\u65F6\u95F4</th><th style="text-align: center">\u6D4B\u8BC4\u65F6\u957F</th><th style="text-align: center">\u6D4B\u8BC4\u5185\u5BB9\u6E05\u5355</th><th style="text-align: center">\u6EE1\u5206</th><th style="text-align: center">\u5F97\u5206</th><th style="text-align: center">\u6D4B\u8BC4</th></tr></thead><tbody ng-show="!isFailed"><tr ng-repeat-start="item in displayed"><td rowspan="{{item.papers.length}}" style="vertical-align: middle"><b>{{item.index}}</b></td><td rowspan="{{item.papers.length}}" style="vertical-align: middle">{{item.name}}</td><td rowspan="{{item.papers.length}}" style="vertical-align: middle">{{item.scoreTime}}</td><td rowspan="{{item.papers.length}}" style="vertical-align: middle">{{item.type == 1 ? item.scorePeriod + "\u5206\u949F" : item.scorePeriod/24/60 + "\u5929"}}</td><td style="vertical-align: middle">{{item.papers[0].name}}</td><td style="vertical-align: middle">{{item.type == 1 ? item.papers[0].score : "--"}}</td><td style="vertical-align: middle"><a ng-href="{{item.papers[0].userScore == -1 || item.type == 2 ? \'\' : getExamResultLink(item.id, item.startStatus)}}">{{item.papers[0].userScore == -1 || item.type == 2 ? "--" : getScore(item.startStatus, item.papers[0].userScore, item.scorePeriod)}}</a></td><td rowspan="{{item.papers.length}}" style="vertical-align: middle"><a id="examStatusBtn" class="btn btn-action" style="width: 80px;height: 30px;padding-top: 3px" ng-href="{{getStartBtnLink(item.id, item.startStatus, item.userFinished)}}" ng-style="getStartBtnStyle(item.startStatus, item.userFinished)">{{getStartBtnName(item.startStatus, item.startLeftSeconds, item.userFinished)}}</a></td></tr><tr ng-repeat="paper in item.papers" ng-if="$index > 0"><td>{{paper.name}}</td><td>{{item.type == 1 ? paper.score : "--"}}</td><td><a ng-href="{{(item.papers[0].userScore == -1 || item.type == 2)? \'\' : getExamResultLink(item.id, item.startStatus)}}">{{(paper.userScore == -1 || item.type == 2) ? "--" : getScore(item.startStatus, paper.userScore, item.scorePeriod)}}</a></td></tr><tr ng-repeat-end="" ng-if="false"></tr></tbody><tbody ng-show="!isLoading && isFailed"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u5931\u8D25 ...</td></tr><tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></tbody></tbody></table></div></div></section></div>');
$templateCache.put('app/pages/goingOnline/goingOnline.html','<div class="online_page"><div class="banner-title"><img class="banner-img back-scalable" src="images/online/online-bg.jpg"><h1 class="banner-title-text scroll-hidden" when-visible="fadeIn1">\u4E0A\u7EBF\u4E2D...</h1></div><div><h1 style="padding-top: 10%; margin-bottom: 0px;margin-top: 0px; color: #000;" class="text-center">\u4E0A\u7EBF\u4E2D...</h1></div></div>');
$templateCache.put('app/pages/lessons/examPage.html','<div class="main_page secend_page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-click="goBack()"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">{{displayedExam.lessonName}}</h2></div><div class="title-line"></div><div class="row"><div class="col-sm-10 col-sm-offset-1" style="margin-bottom: 12px">\u4E0B\u5217\u6BCF\u9898\u7ED9\u51FA\u7684\u56DB\u4E2A\u9009\u9879\u4E2D\uFF0C\u6709\u4E00\u4E2A\u6216\u591A\u4E2A\u662F\u7B26\u5408\u9898\u76EE\u8981\u6C42\u7684\uFF0C\u8BF7\u5728\u7B26\u5408\u8981\u6C42\u7684\u9009\u9879\u524D\u6253\u94A9\u3002</div></div><div class="row"><div class="col-sm-10 col-sm-offset-1"><div ng-repeat="item in displayedExam.answers"><p>{{$index + 1 + \'\u3001\' + item.ask.content}}<span style="color: red;" ng-show="!isAnswered(item)"><strong>&nbsp&nbsp(\u672A\u7B54\u9898)</strong></span></p><label ng-style="getCheckColor(item.repA, item.correct, item.answer)"><input type="checkbox" name="{{$index+1}}" ng-model="item.repA" ng-disabled="isViewMode" ng-change="answerClick(item.type, 1, item.id)"> {{\'A\u3001\' + (item.type == 1 ? \'\u6B63\u786E\': item.ask.answerA)}}</label><br><label ng-style="getCheckColor(item.repB, item.correct, item.answer)"><input type="checkbox" name="{{$index+1}}" ng-model="item.repB" ng-disabled="isViewMode" ng-change="answerClick(item.type, 2, item.id)"> {{\'B\u3001\' + (item.type == 1 ? \'\u9519\u8BEF\': item.ask.answerB)}}</label><br><label ng-style="getCheckColor(item.repC, item.correct, item.answer)" ng-show="item.ask.answerC != null && item.ask.answerC != \'\'"><input type="checkbox" name="{{$index+1}}" ng-model="item.repC" ng-disabled="isViewMode" ng-change="answerClick(item.type, 4, item.id)"> {{\'C\u3001\' + item.ask.answerC}}</label><br ng-show="item.ask.answerC != null && item.ask.answerC != \'\'"><label ng-style="getCheckColor(item.repD, item.correct, item.answer)" ng-show="item.ask.answerD != null && item.ask.answerD != \'\'"><input type="checkbox" name="{{$index+1}}" ng-model="item.repD" ng-disabled="isViewMode" ng-change="answerClick(item.type, 8, item.id)"> {{\'D\u3001\' + item.ask.answerD}}</label><br ng-show="item.ask.answerD != null && item.ask.answerD != \'\'"><label ng-style="getCheckColor(true, item.correct, item.answer)" ng-show="isViewMode">{{\'[\u7B54\u6848]\' + getAnswerStr(item.correct)}} <strong>{{\'&nbsp&nbsp(\' +item.score + \'\u5206)\'}}</strong></label><br ng-show="isViewMode"><br></div></div><div class="btn-container col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6" ng-if="!isViewMode"><div class="col-xs-12 col-sm-6 col-md-6 pull-right" style="padding: 8px 15px"><button class="btn btn-action" ng-click="commit()" ng-disabled="!isAllCompleted()">\u63D0\u4EA4\u8BD5\u5377<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div><div class="col-xs-12 col-sm-6 col-md-6 pull-right" style="padding: 8px 16px"><button class="btn btn-default btn-cancel" ng-click="goBack()">\u8FD4\u56DE</button></div></div><div class="btn-container col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6" ng-if="isViewMode"><div class="col-sm-offset-3 col-md-offset-3 col-xs-12 col-sm-6 col-md-6" style="padding: 8px 16px"><button class="btn btn-default btn-cancel" ng-click="goBack()">\u5173\u95ED</button></div></div></div></div></section></div>');
$templateCache.put('app/pages/lessons/lessonContent.html','<div class="main_page secend_page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-click="goBack()"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2">{{mediaData.title}}</h2><form ng-if="mediaData.mediaType == 1" style="vertical-align: middle;"><switch ng-model="highDefinition" on="\u9AD8\u6E05" off="\u6807\u6E05" class="green" ng-change="highChange()"></switch></form></div><div class="title-line"></div><div ng-if="mediaData.mediaType == 1"><video width="100%" controls="" autoplay="" ng-right-click="" current-video-play-time="" dynamic-url=""></video></div><div ng-if="mediaData.mediaType == 0"><pdf src="mediaUrl"></pdf></div></div></section></div>');
$templateCache.put('app/pages/lessons/mystudy.html','<div class="main_page" my-study-scroll="" ng-if="true"><div class="banner-title"><div class="back-fix" style="background-image: url(images/class/class-bg2.jpg)"></div><h1 class="banner-title-text scroll-hidden" when-visible="fadeIn1">\u6211\u7684\u5B66\u4E60</h1></div><section class="open-lesson-nav"><div class="container"><div class="section-nav"><div class="nav-li arrow-left"><a ng-show="isLeftCourseShowing()" ng-click="courseCursorLeft()"><span class="glyphicon glyphicon glyphicon-chevron-left"></span></a></div><div class="li-container" ng-class="getCourseContainerClass()"><div class="nav-li" ng-repeat="course in userCourses" ng-class="getCourseClass(course.courseId)" ng-if="isCourseShowing(course)"><a ng-click="courseSelect(course.courseId, false)">{{getCourseTitle(course.courseId)}}<span class="nav-arrow"></span></a></div></div><div class="nav-li arrow-right"><a ng-show="isRightCourseShowing()" ng-click="courseCursorRight()"><span class="glyphicon glyphicon glyphicon-chevron-right"></span></a></div></div></div></section><section class="open-lesson" ng-if="currentLessons"><div ng-repeat="lesson in currentLessons.lessons"><div class="container" ng-class="getLessonContainerClass(lesson)"><div class="lesson-title"><h2 class="scroll-hidden" when-visible="fadeIn1">{{lesson.name}}</h2><h3 class="scroll-hidden text-center" when-visible="fadeIn2"><a ng-click="viewExam(lesson.id, lesson.examFlag)">{{getAction(lesson.examFlag)}}</a> &nbsp;&nbsp;&nbsp;&nbsp;<span class="score">\u5F97\u5206/\u6EE1\u5206\uFF1A{{lesson.score + \'/\' + lesson.totalScore}}</span>&nbsp;&nbsp;&nbsp;&nbsp; <span class="glyphicon glyphicon-time"></span> {{lesson.period + \'\u5B66\u65F6\'}}</h3></div><div class="page-oneicon"><i></i><div></div></div><div class="row lesson-row"><div class="col-md-3 col-sm-6 scroll-hidden lesson-item-container" when-visible="fadeIn3" ng-repeat="section in lesson.sections"><div class="lesson-item"><div class="item-header"><img class="img-bg" ng-src="{{getBackgroundImage(section)}}"><div class="img-container" ng-if="section.picUrl" ng-style="{\'background-image\': \'url(\\\'{{section.picUrl}}\\\')\'}"></div><a class="cover" ng-style="getCoverImage(lesson, section)" ng-href="{{getStudyUrl(lesson.id, section.id, lesson.examFlag)}}" ng-click="goStudy(lesson.id, section.id, lesson.examFlag)"><div><span>{{getCoverText(lesson)}}</span></div></a></div><div class="item-separate"></div><div class="entry-content"><h5><a ng-href="{{getStudyUrl(lesson.id, section.id, lesson.examFlag)}}" ng-click="goStudy(lesson.id, section.id, lesson.examFlag)">{{section.name}}</a></h5><div class="entry-content-info"><span class="glyphicon glyphicon-time"></span><span>&nbsp;{{section.period}}\u5B66\u65F6</span> <span class="pull-right">&nbsp;{{section.clicks + \'\u4EBA\u5DF2\u5B66\'}}</span><span class="glyphicon glyphicon-user pull-right"></span></div></div></div></div></div><div class="page-oneicon"><img src="images/class/class-next.png"></div><div class="lesson-bottom"><h2 class="scroll-hidden" when-visible="fadeIn1"><a ng-if="lesson.examFlag == 1" ng-click="goExam(lesson.id, lesson.examFlag)">[\u5F00\u59CB\u8003\u8BD5]</a></h2></div><div class="row bottom-row" ng-if="currentLessons.lessons.indexOf(lesson) >= currentLessons.lessons.length - 1"><p>\u5DF2\u7ECF\u5230\u5E95\u4E86</p></div></div></div></section></div>');
$templateCache.put('app/pages/lessons/pubLesson.html','<div class="main_page" my-scroll=""><div class="banner-title"><div class="back-fix" style="background-image: url(images/class/class-bg2.jpg)"></div><h1 class="banner-title-text scroll-hidden" when-visible="fadeIn1">\u516C\u5F00\u8BFE\u7A0B</h1></div><section class="open-lesson-nav"><div class="container"><div class="section-nav"><div class="nav-li arrow-left"><a ng-show="isLeftGroupShowing()" ng-click="groupCursorLeft()"><span class="glyphicon glyphicon glyphicon-chevron-left"></span></a></div><div class="li-container" ng-class="getGroupContainerClass()"><div class="nav-li" ng-repeat="lesson in lessonGroups" ng-class="getClassM(lesson.id)" ng-if="isGroupShowing(lesson)"><a ng-click="groupCheck(lesson.id)">{{lesson.name}}<span class="nav-arrow"></span></a></div></div><div class="nav-li arrow-right"><a ng-show="isRightGroupShowing()" ng-click="groupCursorRight()"><span class="glyphicon glyphicon glyphicon-chevron-right"></span></a></div></div></div></section><section class="open-lesson"><div ng-repeat="lesson in publicListens.lessons"><div class="container"><div class="lesson-title"><h2 class="scroll-hidden" when-visible="fadeIn1">{{lesson.name}}</h2></div><div class="page-oneicon"><i></i><div></div></div><div class="row lesson-row"><div class="col-md-3 col-sm-6 scroll-hidden lesson-item-container" when-visible="fadeIn2" ng-repeat="section in lesson.sections"><div class="lesson-item"><div class="item-header"><img class="img-bg" ng-src="{{getBackgroundImage(section)}}"><div class="img-container" ng-if="section.picUrl" ng-style="{\'background-image\': \'url(\\\'{{section.picUrl}}\\\')\'}"></div><a class="cover" ng-style="getCoverImage(section)" ng-href="{{getLessonUrl(lesson.id, section.id)}}" ng-click="goLesson(lesson.id, section.id)"></a></div><div class="item-separate"></div><div class="entry-content"><h5><strong><a ng-href="{{getLessonUrl(lesson.id, section.id)}}" ng-click="goLesson(lesson.id, section.id)">{{section.name}}</a></strong></h5><div class="entry-content-info"><span class="glyphicon glyphicon-time"></span><span>&nbsp;{{section.period}}\u5B66\u65F6</span> <span class="pull-right">&nbsp;{{section.clicks + \'\u4EBA\u5DF2\u5B66\'}}</span><span class="glyphicon glyphicon-user pull-right"></span></div></div></div></div></div><div class="page-oneicon"><img src="images/class/class-next.png"></div><div class="row bottom-row" ng-if="getIndex(publicListens.lessons.indexOf(lesson) + 1) == totalCount"><p>\u5DF2\u7ECF\u5230\u5E95\u4E86</p></div></div></div><div class="container"><table style="width: 100%" st-pipe="callbackPubListen" st-table="publicListens"><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="numPerPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></table></div></section></div>');
$templateCache.put('app/pages/lessons/study_tab.html','<div class="container"><div class="panel panel-default"><div class="panel-heading"><p u_\u6BB5\u843D\u6807\u9898="">\u6211\u7684\u5B66\u4E60</p></div><div class="panel-body"><uib-tabset active="activeJustified" justified="true"><uib-tab ng-repeat="x in myListens" heading="{{x.listenname}}" index="x.listenid">{{x.contents}}</uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="main_page"><section id="main-slider" class="no-margin"><div class="carousel slide" uib-carousel="" template-url="app/theme/components/carousel/carousel.html" active="navigations.active" interval="navigations.interval" no-wrap="navigations.noWrapSlides"><div uib-slide="" template-url="app/theme/components/carousel/slide.html" interval="navigations.interval" ng-repeat="slide in navigations.displayed track by slide.id" ng-style="{\'background-image\':\'url({{slide.image}})\'}" index="slide.id" ng-click="getSlideHerf(slide.id)"><div id="main-top-cover" ng-show="slide.noLink == 1"></div><div id="div-link" ng-show="slide.noLink == 0"></div><div class="container" ng-show="slide.noLink == 1"><div style="margin-top: 208px;margin-left:140px;position: absolute"><div class="main-first-label" style="font-size: 24px;opacity: 0.5">\u5C0F\u725B\u6570\u636EAPP</div><div class="main-first-label" style="font-size: 36px;margin-left: -5px;"><span style="color: #ff353d;">\u65E5\u5185\u4EA4\u6613</span>\u6570\u636E\u6559\u7EC3</div><div class="main-first-label" style="font-size: 17px;opacity: 0.5">build your great dream</div></div></div><div class="container" ng-show="slide.noLink == 1"><div style="margin-top: 152px;margin-left:740px;opacity: 0.67;background: #0C263E;width: 280px;height:400px;position: absolute;"></div><div style="margin-top: 152px;margin-left:740px;width: 280px;height:400px;position: absolute"><div class="center" style="font-size: 20px;margin-top:30px;color: #FFFFFF;opacity: 0.67">\u5C0F\u725B\u6570\u636EAPP\u4E0B\u8F7D</div><div class="center" style="opacity: 100"><img src="images/app_load.png" style="width: 128px;height:128px"></div><div style="color: #FFFFFF;font-size: 15px"><img src="images/android.png"> <img src="images/ios.png"> <span style="opacity: 0.67">| \u626B\u7801\u4E0B\u8F7D</span></div></div></div></div></div></section><section id="first-section"><div class="container"><div class="row" style="margin-left: 140px"><div class="col-md-4 col-sm-12 col-xs-12"><img src="images/main_phone.png"></div><div class="col-md-offset-4 col-md-4 col-sm-12 col-xs-12" style="margin-top: 100px;"><div style="font-size: 24px;color: #0C263E">\u6A21\u62DF\u4EA4\u6613</div><div class="main-second-label" style="color: #000000">\u57FA\u4E8E\u65E5\u5185\u4EA4\u6613\u6A21\u62DF\u771F\u5B9E\u7684\u4EA4\u6613\u573A\u666F</div><br><div class="main-second-label">Tick\u7EA7\u5B9E\u65F6\u884C\u60C5\u6570\u636E</div><div class="main-second-label">\u4FBF\u6377\u7684\u4EA4\u6613\u754C\u9762</div><div class="main-second-label">\u5F62\u8C61\u7684\u62A5\u5355\u6807\u8BB0\u56FE</div><div class="main-second-label">\u5168\u9762\u7684\u4EA4\u6613\u6570\u636E\u5206\u6790</div><div class="main-second-label">\u4F18\u9009\u7684\u4EA4\u6613\u8BC1\u5238\u6C60</div><hr></div></div></div></section><section id="second-section" style="background-color: #0C263E"><div class="container"><div class="row" style="margin-left: 140px"><div class="col-md-offset-1 col-md-4 col-sm-6" style="margin-top: 100px;"><div class="main-third-label" style="font-size: 24px;">\u6570\u636E\u5206\u6790</div><div class="main-third-label">\u9488\u5BF9\u4EA4\u6613\u63D0\u4F9B\u5168\u65B9\u4F4D\u7684\u6570\u636E\u5206\u6790</div><br><div class="main-third-label">\u76C8\u5229\u80FD\u529B\u7EF4\u5EA6</div><div class="main-third-label">\u98CE\u63A7\u80FD\u529B\u7EF4\u5EA6</div><div class="main-third-label">\u5FC3\u7406\u7D20\u8D28\u7EF4\u5EA6</div><div class="main-third-label">\u6280\u672F\u76D8\u611F\u7EF4\u5EA6</div><div class="main-third-label">\u4EA4\u6613\u6001\u5EA6\u7EF4\u5EA6</div><hr></div><div class="col-md-4 col-sm-4"><img src="images/main_stat.png"></div></div><div class="bottomSecondPic" style="background-image: url(images/main_stat_bottom.png);"></div></div></section><section id="third-section"><div class="container"><div class="row" style="margin-left: 140px"><div class="col-md-4 col-sm-12 col-xs-12"><img src="images/main_trade.png"></div><div class="col-md-offset-4 col-md-4 col-sm-12 col-xs-12" style="margin-top: 100px;"><div style="font-size: 24px;color: #0C263E">\u4EA4\u6613\u57F9\u8BAD</div><div class="main-second-label" style="color: #000000">\u6210\u529F\u6E90\u4E8E\u5927\u91CF\u7684\u7EC3\u4E60</div><br><div class="main-second-label">\u968F\u65F6\u968F\u5730\u8FDB\u884C\u8BAD\u7EC3</div><div class="main-second-label">\u53CC\u76F2\u6A21\u5F0F</div><div class="main-second-label">\u968F\u673A\u884C\u60C5\u5305\u542B\u591A\u79CD\u6CE2\u5F62\u6A21\u6001</div><div class="main-second-label">\u8BAD\u7EC3\u590D\u76D8\u603B\u7ED3\u63D0\u9AD8</div><div class="main-second-label">\u7CBE\u54C1\u7406\u8BBA\u89C6\u9891\u4E0E\u8BAD\u7EC3\u4E92\u4E3A\u8865\u5145</div><hr></div></div></div></section><section id="forth-section" style="background-color: #0C263E"><div class="container"><div class="row" style="margin-left: 140px;"><div class="col-md-offset-1 col-md-4 col-sm-6" style="margin-top: 100px;"><div class="main-third-label" style="font-size: 24px;">\u52A8\u6001\u5206\u4EAB</div><div class="main-third-label">\u591A\u79CD\u65B9\u5F0F\u4E0E\u5404\u8DEF\u9AD8\u624B\u4E92\u52A8\u4EA4\u6D41</div><br><div class="main-third-label">\u5206\u4EAB\u4EA4\u6613\u5FC3\u5F97</div><div class="main-third-label">\u5C55\u793A\u8BAD\u7EC3\u6210\u7EE9</div><div class="main-third-label">\u53C2\u4E0E\u70ED\u95E8\u8BDD\u9898</div><div class="main-third-label">\u7814\u7A76\u57F9\u8BAD\u653B\u7565</div><div class="main-third-label">\u79EF\u7D2F\u4EBA\u8109\u5708\u5B50</div><hr></div><div class="col-md-4 col-sm-4"><img src="images/main_poster.png"></div><div class="bottomForthPic" style="background-image: url(images/main_poster_bottom.png);"></div></div></div></section></div>');
$templateCache.put('app/pages/main/study_tab.html','<div class="container" style="position: relative; top: 10px;"><div class="panel panel-default"><div class="panel-heading"><p u_\u6BB5\u843D\u6807\u9898=""><span>\u6211\u7684\u5B66\u4E60</span></p></div><div class="panel-body"><uib-tabset active="activeJustified" justified="true"><uib-tab index="0" heading="\u8BFE\u7A0B\u4F53\u7CFBA\uFF08\u5DF2\u5B8C\u6210\uFF09"><table class="table table-hover"><caption>\u60AC\u505C\u8868\u683C\u5E03\u5C40</caption><tbody><tr ng-repeat="x in kechengA"><td>{{$index + 1}}</td><td><img ng-src="{{getClassPic(x.bookid.img_add)}}" alt="Ballade" width="24px" height="24px"> <a href="javascript:void(0);">{{x.bookid.id}}</a></td><td><a href="javascript:void(0);">{{x.act}}</a></td><td>{{\'\u5F97\u5206/\u6EE1\u5206:\' + x.score.mark + \'/\' + x.score.total}}</td><td>{{x.timetotal}}</td></tr></tbody></table></uib-tab><uib-tab index="1" heading="\u8BFE\u7A0B\u4F53\u7CFBB\uFF08\u8FDB\u884C\u4E2D\uFF09"><table class="table table-hover"><caption>\u8FDB\u9636\u8BFE\u7A0B</caption><thead><tr><th>\u5E8F\u53F7</th><th>\u540D\u79F0</th><th>\u67E5\u770B\u6210\u7EE9</th><th>\u5F97\u5206</th><th>\u5B66\u65F6</th></tr></thead><tbody><tr ng-repeat="x in kechengB"><td>{{$index + 1}}</td><td><img ng-src="{{getClassPic(x.bookid.img_add)}}" alt="Ballade" width="24px" height="24px"> <a href="javascript:void(0);">{{x.bookid.id}}</a></td><td><a href="javascript:void(0);">{{x.act}}</a></td><td>{{\'\u5F97\u5206/\u6EE1\u5206:\' + x.score.mark + \'/\' + x.score.total}}</td><td>{{x.timetotal}}</td></tr></tbody></table></uib-tab><uib-tab index="2" heading="\u8BFE\u7A0B\u4F53\u7CFBC\uFF08\u672A\u5F00\u59CB\uFF09"><table class="table table-hover"><caption>\u8FDB\u9636\u8BFE\u7A0B</caption><thead><tr><th>\u5E8F\u53F7</th><th>\u540D\u79F0</th><th>\u67E5\u770B\u6210\u7EE9</th><th>\u5F97\u5206</th><th>\u5B66\u65F6</th></tr></thead><tbody><tr ng-repeat="x in kechengC"><td>{{$index + 1}}</td><td><img ng-src="{{getClassPic(x.bookid.img_add)}}" alt="Ballade" width="24px" height="24px"> <a href="javascript:void(0);">{{x.bookid.id}}</a></td><td><a href="javascript:void(0);">{{x.act}}</a></td><td>{{\'\u5F97\u5206/\u6EE1\u5206:\' + x.score.mark + \'/\' + x.score.total}}</td><td>{{x.timetotal}}</td></tr></tbody></table></uib-tab></uib-tabset></div></div><div class="horizontal-scroll"><table class="table table-hover" st-pipe="callServer" st-table="displayed"><thead><tr class="sortable black-muted-bg"><th class="table-id">\u5E8F\u53F7</th><th st-sort="phoneNumber">\u624B\u673A\u53F7</th><th st-sort="name">\u771F\u5B9E\u59D3\u540D</th><th st-sort="company">\u6240\u5C5E\u5355\u4F4D</th><th st-sort="createTime">\u6CE8\u518C\u65E5\u671F</th><th st-sort="status">\u72B6\u6001</th><th>\u5220\u9664</th></tr></thead><tbody ng-show="!isLoading && !isFailed"><tr ng-repeat="item in displayed"><td class="table-id">{{item.index}}</td><td>{{item.phoneNumber}}</td><td>{{item.name}}</td><td>{{item.company}}</td><td>{{item.createTime}}</td><td><button class="status-button btn btn-xs btn-info">{{getStatusString(item.status)}}</button></td><td><button class="status-button btn btn-xs btn-danger" ng-click="deleteUser(item)">\u5220\u9664</button></td></tr></tbody><tbody ng-show="!isLoading && isFailed"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u5931\u8D25 ...</td></tr><tbody><tbody ng-show="isLoading"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u4E2D ...</td></tr></tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></tbody></tbody></table></div></div>');
$templateCache.put('app/pages/xmActivity/activity.html','<div class="main_page"><section class="no-margin"><div style="background-image: url(images/activity/summber_competition_xiamen.png); height: 620px;background-position:center; background-repeat:no-repeat;"></div></section><section style="margin-top: 60px"><div class="container"><div style="font-size: 22px;color:#4360FF;text-align: center"><div style="height: 1px;width: 50px;background-color: #4360FF;display: inline-block;vertical-align: middle"></div><div style="margin-left: 10px;margin-right: 10px; display: inline-block">\u6BD4\u8D5B\u7B80\u4ECB</div><div style="height: 1px;width: 50px;background-color: #4360FF;display: inline-block;vertical-align: middle"></div></div><div style="float: right;margin-top: 10px"><div id="competitionDetails" ng-click="getCompetitionDetails()"></div><div id="competitionTradeDetails" ng-click="getTradeDetails()"></div></div><div style="margin-top: 100px;font-size: 16px;line-height: 2"><p style="text-indent:2em">\u201C\u5C0F\u869C\u866B\u676F\u201D\u7092\u80A1\u5927\u8D5B\u4EE5\u666E\u53CA\u8BC1\u5238\u77E5\u8BC6\uFF0C\u6559\u80B2\u5728\u6821\u5B66\u751F\u6811\u7ACB\u826F\u597D\u7684\u6295\u8D44\u7406\u5FF5\uFF0C\u6B63\u786E\u7684\u98CE\u63A7\u610F\u8BC6\u4E3A\u5B97\u65E8\u3002\u8BA9\u5B66\u751F\u5728\u5207\u8EAB\u611F\u53D7\u8BC1\u5238\u5E02\u573A\u673A\u9047\u4E0E\u98CE\u9669\u540C\u65F6\uFF0C\u53EF\u4EE5\u4F53\u9A8C\u4E30\u5BCC\u591A\u6837\u7684\u6295\u8D44\u670D\u52A1\u548C\u4EA7\u54C1\uFF0C\u63D0\u5347\u6295\u8D44\u6C34\u5E73\uFF0C\u4E3A\u4EE5\u540E\u7684\u91D1\u878D\u804C\u4E1A\u751F\u6DAF\u89C4\u5212\u6253\u4E0B\u575A\u5B9E\u7684\u57FA\u7840\u3002</p><p style="text-indent:2em">\u5927\u8D5B\u5206\u4E3A\u5916\u56F4\u8D44\u683C\u8D5B\uFF0C\u573A\u5185\u5FAA\u73AF\u8D5B\uFF0C\u573A\u5185\u51B3\u8D5B\u548C\u603B\u51B3\u8D5B\u3002\u5916\u56F4\u8D44\u683C\u8D5B\uFF0C\u573A\u5185\u5FAA\u73AF\u8D5B\uFF0C\u573A\u5185\u51B3\u8D5B\u4F1A\u5728\u591A\u4E2A\u9AD8\u6821\u540C\u6B65\u8FDB\u884C\uFF0C\u6392\u540D\u548C\u664B\u7EA7\u5404\u9AD8\u6821\u72EC\u7ACB\u7EDF\u8BA1\u3002\u603B\u51B3\u8D5B\u662F\u53A6\u95E8\u5168\u90E8\u53C2\u8D5B\u9AD8\u6821\u7684\u7EDF\u4E00\u6BD4\u8D5B\uFF0C\u6392\u540D\u4E0D\u518D\u533A\u5206\u9AD8\u6821\u3002</p><p style="text-indent:2em">\u4E3B\u529E\u65B9\uFF1A&nbsp;&nbsp;\u5C0F\u869C\u866B\u91CF\u5316&nbsp;&nbsp;\u5C0F\u725B\u6570\u636E</p></div><div style="font-size: 22px;color:#4360FF;text-align: center;margin-top: 120px"><div style="height: 1px;width: 50px;background-color: #4360FF;display: inline-block;vertical-align: middle"></div><div style="margin-left: 10px;margin-right: 10px; display: inline-block">\u6BD4\u8D5B\u65F6\u95F4</div><div style="height: 1px;width: 50px;background-color: #4360FF;display: inline-block;vertical-align: middle"></div></div><div style="margin-top: 53px;margin-bottom: 40px; font-size: 18px;color:#FD6253;text-align: center"><p>2018\u5E747\u670802\u65E5 - 2019\u5E744\u670830\u65E5</p></div><div class="center"><img id="join" ng-src="{{joinSrc}}" style="margin: auto" ng-click="join()"></div></div><div id="main-slider" class="no-margin" style="height: 320px"><div class="carousel slide" uib-carousel="" template-url="app/theme/components/carousel/carousel.html" active="navigations.active" interval="navigations.interval" no-wrap="navigations.noWrapSlides" style="height: 320px"><div uib-slide="" template-url="app/theme/components/carousel/slide.html" interval="navigations.interval" ng-repeat="slide in navigations.displayed track by slide.id" ng-style="{\'background-image\':\'url({{slide.image}})\'};" style="height: 320px" index="slide.id"></div></div></div></section></div>');
$templateCache.put('app/pages/xmActivity/activityDetails.html','<div class="main_page"><div class="container" style="margin-top: 150px"><div style="font-size: 22px;color: #333333;font-weight: bold;text-align: center">\u8D5B\u7A0B\u8D5B\u5236</div><div><img src="images/activity/xmProgram.png" style="margin-left: -60px"></div><div><p style="font-size: 17px;color: #333333;font-weight: bold;">\u5916\u56F4\u8D44\u683C\u8D5B</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">1.\u8D5B\u5236</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u5916\u56F4\u8D44\u683C\u8D5B\u4E3A\u6A21\u62DF\u76D8\u7684\u6BD4\u8D5B\uFF0C\u591A\u4E2A\u9AD8\u6821\u540C\u6B65\u8FDB\u884C\uFF0C\u5916\u56F4\u8D44\u683C\u8D5B\u6392\u540D\u4EC5\u5728\u672C\u6821\u62A5\u540D\u9009\u624B\u4E2D\u7EDF\u8BA1\uFF08\u4E0E\u5176\u4ED6\u9AD8\u6821\u65E0\u5173\uFF09\u3002\u5916\u56F4\u8D44\u683C\u8D5B\u5171\u5206\u4E3A6\u4E2A\u8D5B\u5B63\uFF0C\u6BCF\u8D5B\u5B63\u6210\u7EE9\u72EC\u7ACB\u7EDF\u8BA1\uFF0C\u4E0D\u5E26\u5165\u4E0B\u4E00\u8D5B\u5B63\u3002\u672A\u5165\u56F4\u573A\u5185\u5FAA\u73AF\u8D5B\u7684\u9009\u624B\u53EF\u7EE7\u7EED\u53C2\u52A0\u4E0B\u4E00\u4E2A\u8D5B\u5B63\u7684\u5916\u56F4\u8D44\u683C\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">2.\u6BD4\u8D5B\u65F6\u95F4</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6BCF\u8D5B\u5B63\u6309\u7167\u81EA\u7136\u6708\u7684\u9996\u4E2A\u4EA4\u6613\u65E5\u548C\u6700\u540E\u4E00\u4E2A\u4EA4\u6613\u65E5\u4F5C\u4E3A\u6BD4\u8D5B\u7684\u5F00\u59CB\u548C\u7ED3\u675F\u65E5\u671F\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">3.\u6BD4\u8D5B\u5730\u70B9</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E0D\u9650\u5236\u5730\u70B9\uFF0C\u6BCF\u4E2A\u4EA4\u6613\u65E5\u7EBF\u4E0A\u5B8C\u6210\u4EA4\u6613\u5373\u53EF\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">4.\u6307\u5B9A\u4EA4\u6613\u8F6F\u4EF6</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u548C\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u3002\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u7F51\u5740\u4E3A<a href="http://www.xntrader.com">www.xntrader.com</a>\uFF0C\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u53EF\u626B\u63CF\u4E8C\u7EF4\u7801\u4E0B\u8F7D\u3002\u53C2\u8D5B\u8005\u53EF\u5728\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u548C\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u62A5\u5355\uFF0C\u4E8C\u8005\u6570\u636E\u662F\u540C\u6B65\u7EDF\u4E00\u7684\u3002\u76D8\u540E\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u4F1A\u63D0\u4F9B\u5168\u9762\u7684\u6570\u636E\u5206\u6790\uFF0C\u4EE5\u5E2E\u52A9\u53C2\u8D5B\u8005\u67E5\u770B\u6210\u7EE9\u548C\u53D1\u73B0\u3001\u6539\u8FDB\u4E0D\u8DB3\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">5.\u53C2\u8D5B\u8D44\u683C</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u6EE1\u8DB3\u4EE5\u4E0B\u4E24\u4E2A\u6761\u4EF6\uFF0C\u5373\u53EF\u53C2\u8D5B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u53A6\u95E8\u4EFB\u4E00\u9AD8\u6821\u5728\u6821\u751F\u6216\u8005\u6BD5\u4E1A\u4E24\u5E74\u5185\u7684\u4EBA\u5458\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u9700\u6CE8\u518C\u6210\u4E3A\u201C\u5C0F\u725B\u6570\u636E\u201D\u7528\u6237\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E3A\u4FDD\u8BC1\u7ADE\u8D5B\u7684\u516C\u5E73\uFF0C\u6CE8\u518C\u201C\u5C0F\u725B\u6570\u636E\u201D\u7528\u6237\u65F6\uFF0C\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u5982\u5B9E\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F\u3002\u5982\u679C\u9009\u624B\u83B7\u5F97\u4E86\u573A\u5185\u5FAA\u73AF\u8D5B\u7684\u5165\u56F4\u8D44\u683C\uFF0C\u4E3B\u529E\u65B9\u5C06\u5BA1\u6838\u8BE5\u9009\u624B\u7684\u8EAB\u4EFD\uFF0C\u5982\u679C\u53D1\u73B0\u4E0D\u7B26\u5408\u53C2\u8D5B\u6761\u4EF6\uFF0C\u5C06\u53D6\u6D88\u5E76\u987A\u5EF6\u83B7\u5165\u56F4\u573A\u5185\u6BD4\u8D5B\u7684\u8D44\u683C\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u5728\u5916\u56F4\u8D44\u683C\u8D5B\u5F00\u59CB\u4E4B\u524D\uFF0C\u7528\u6237\u53EF\u5148\u884C\u6CE8\u518C\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u3002\u901A\u8FC7APP\u201C\u8BFE\u5802\u2014>\u7406\u8BBA/\u8BAD\u7EC3\u201D\u7B49\u57F9\u8BAD\u5185\u5BB9\u53EF\u5148\u884C\u5B66\u4E60\u6295\u8D44\u77E5\u8BC6\u548C\u65B9\u6CD5\u3002\u4E5F\u53EF\u5728\u4EA4\u6613\u65E5\u901A\u8FC7\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u548C\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u7EC3\u4E60\u6A21\u62DF\u4EA4\u6613\uFF0C\u4E3A\u5927\u8D5B\u505A\u524D\u671F\u51C6\u5907\u3002\u672C\u6B21\u5927\u8D5B\u6392\u540D\u4EC5\u7EDF\u8BA1\u8D5B\u5B63\u5185\u7684\u4EA4\u6613\u6210\u7EE9\uFF0C\u8D5B\u524D\u7684\u7EC3\u4E60\u6210\u7EE9\u4E0D\u5E26\u5165\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">6.\u62A5\u540D\u6D41\u7A0B</p><div style="margin-top:40px"><img src="images/activity/signStep.png"></div><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">7.\u6392\u540D\u89C4\u5219</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6839\u636E\u53C2\u8D5B\u8005\u6BCF\u65E5\u6536\u76CA\u7387\uFF08\u5305\u62EC\u6BCF\u65E5\u6709\u4EA4\u6613\u8BB0\u5F55\u7684\u5168\u90E8\u8BC1\u5238\u7684\u7EFC\u5408\u6536\u76CA\u7387\uFF09\uFF0C\u518D\u9010\u65E5\u7D2F\u8BA1\u6BCF\u65E5\u6536\u76CA\u7387\u5F97\u51FA \u201C\u603B\u6536\u76CA\u7387\u201D\u3002\u6839\u636E\u201C\u603B\u6536\u76CA\u7387\u201D\u4ECE\u9AD8\u5230\u4F4E\u8FDB\u884C\u6392\u540D\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6392\u540D\u4EC5\u7EDF\u8BA1\u6BD4\u8D5B\u671F\u95F4\u7684\u6BCF\u65E5\u6536\u76CA\u7387\uFF0C\u201C\u6BCF\u65E5\u6536\u76CA\u7387\u201D\u548C\u201C\u603B\u6536\u76CA\u7387\u201D\u6570\u636E\u4EE5\u5C0F\u725B\u6570\u636E\u7684APP\u7EDF\u8BA1\u6570\u636E\u4E3A\u51C6\u3002</p><p style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 19px">\u573A\u5185\u5FAA\u73AF\u8D5B</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">1.\u8D5B\u5236</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u573A\u5185\u5FAA\u73AF\u8D5B\u5728\u591A\u4E2A\u9AD8\u6821\u540C\u6B65\u8FDB\u884C\uFF0C\u573A\u5185\u5FAA\u73AF\u8D5B\u6392\u540D\u4EC5\u5728\u672C\u6821\u62A5\u540D\u9009\u624B\u4E2D\u7EDF\u8BA1\uFF08\u4E0E\u5176\u4ED6\u9AD8\u6821\u65E0\u5173\uFF09\u3002\u573A\u5185\u5FAA\u73AF\u8D5B\u5171\u5206\u4E3A6\u4E2A\u8D5B\u5B63\uFF0C\u6BCF\u8D5B\u5B63\u6210\u7EE9\u72EC\u7ACB\u7EDF\u8BA1\uFF0C\u4E0D\u5E26\u5165\u4E0B\u4E00\u8D5B\u5B63\u3002\u8D5B\u5236\u5177\u4F53\u8981\u6C42\u5982\u4E0B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u573A\u5185\u5FAA\u73AF\u8D5B\u662F\u5B9E\u76D8\u4EA4\u6613\u3002\u9009\u624B\u4E0D\u9700\u8981\u63D0\u4F9B\u4EFB\u4F55\u8D44\u91D1\uFF0C\u4E8F\u635F\u91D1\u989D\u4E0D\u9700\u8981\u9009\u624B\u627F\u62C5\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u8D5B\u540E\u6839\u636E\u6BD4\u8D5B\u671F\u95F4\u9009\u624B\u4E2A\u4EBA\u7684\u603B\u76C8\u5229\u91D1\u989D\uFF0C\u4F1A\u6309\u7167\u6BD4\u4F8B\u63D0\u6210\u4F5C\u4E3A\u5956\u52B1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3)\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u9075\u5B88\u4E3B\u529E\u65B9\u5236\u5B9A\u7684\u4EA4\u6613\u7EAA\u5F8B\u548C\u98CE\u63A7\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4)\u6BD4\u8D5B\u4E2D\uFF0C\u9009\u624B\u56E0\u8FDD\u53CD\u4EA4\u6613\u7EAA\u5F8B\uFF0C\u89E6\u72AF\u4E25\u91CD\u98CE\u63A7\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u7EC8\u6B62\u8BE5\u53C2\u8D5B\u8005\u7684\u6BD4\u8D5B\u8D44\u683C\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5)\u6BCF\u8D5B\u5B63\u524D3\u540D\u9009\u624B\u83B7\u5F97\u53C2\u4E0E\u573A\u5185\u51B3\u8D5B\u7684\u8D44\u683C\u3002\u9009\u624B\u53EF\u5FAA\u73AF\u53C2\u4E0E\u4E0B\u4E00\u8D5B\u5B63\u6BD4\u8D5B\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">6)\u9996\u6B21\u8FDB\u5165\u573A\u5185\u5FAA\u73AF\u8D5B\u7684\u9009\u624B\uFF08\u901A\u8FC7\u201C\u573A\u5916\u8D44\u683C\u8D5B\u201D\u65B0\u5165\u56F4\u7684\u9009\u624B\uFF09\uFF0C\u4EC5\u80FD\u5B8C\u6210\u6A21\u62DF\u4EA4\u6613\u3002\u5728\u573A\u5185\u4E00\u4E2A\u6708\u6A21\u62DF\u4EA4\u6613\u4E2D\u8868\u73B0\u6EE1\u8DB3\u664B\u7EA7\u6761\u4EF6\u7684\u624D\u80FD\u53C2\u4E0E\u573A\u5185\u5FAA\u73AF\u8D5B\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">7)\u8D5B\u524D\u4E3B\u529E\u65B9\u4F1A\u4E0E\u6BCF\u4F4D\u53C2\u8D5B\u8005\u8BE6\u7EC6\u8BB2\u89E3\u98CE\u63A7\uFF0C\u4EA4\u6613\u7EAA\u5F8B\uFF0C\u63D0\u6210\u6BD4\u4F8B\uFF0C\u4EE5\u53CA\u201C\u573A\u5916\u8D44\u683C\u8D5B\u201D\u65B0\u5165\u56F4\u7684\u9009\u624B\u664B\u7EA7\u7B49\u95EE\u9898\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">2.\u6BD4\u8D5B\u65F6\u95F4</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6BCF\u8D5B\u5B63\u6309\u7167\u81EA\u7136\u6708\u7684\u9996\u4E2A\u4EA4\u6613\u65E5\u548C\u6700\u540E\u4E00\u4E2A\u4EA4\u6613\u65E5\u4F5C\u4E3A\u6BD4\u8D5B\u7684\u5F00\u59CB\u548C\u7ED3\u675F\u65E5\u671F\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">3.\u6BD4\u8D5B\u5730\u70B9</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u672C\u6821\u5185\u6307\u5B9A\u5730\u70B9\uFF0C\u96C6\u4E2D\u8FDB\u884C\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">4.\u6307\u5B9A\u62A5\u5355\u8F6F\u4EF6</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E3B\u529E\u65B9\u6307\u5B9A\u6A21\u62DF\u4EA4\u6613\u548C\u5B9E\u76D8\u4EA4\u6613\u7684\u8F6F\u4EF6\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">5.\u53C2\u8D5B\u8D44\u683C</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u6EE1\u8DB3\u4EE5\u4E0B\u6761\u4EF6\u4E4B\u4E00\uFF0C\u5373\u53EF\u53C2\u8D5B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u901A\u8FC7\u4E3B\u529E\u65B9\u7B14\u8BD5\u3001\u9762\u8BD5\uFF0C\u5E76\u901A\u8FC7\u573A\u5185\u4E00\u4E2A\u6708\u6A21\u62DF\u4EA4\u6613\uFF0C\u8868\u73B0\u6EE1\u8DB3\u664B\u7EA7\u6761\u4EF6\u8005</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u901A\u8FC7\u201C\u573A\u5916\u8D44\u683C\u8D5B\u201D\u65B0\u5165\u56F4\u7684\u9009\u624B\uFF0C\u5728\u573A\u5185\u4E00\u4E2A\u6708\u6A21\u62DF\u4EA4\u6613\u4E2D\u8868\u73B0\u6EE1\u8DB3\u664B\u7EA7\u6761\u4EF6\u8005</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 40px">6.\u6392\u540D\u89C4\u5219</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u573A\u5185\u5FAA\u73AF\u8D5B\u4F7F\u7528\u5C0F\u725B\u6570\u636EAPP\u7684\u201C\u4EA4\u6613\u79EF\u5206\u201D\u8FDB\u884C\u6392\u540D\uFF0C\u201C\u4EA4\u6613\u79EF\u5206\u201D\u662F\u9009\u624B\u591A\u7EF4\u5EA6\u4EA4\u6613\u80FD\u529B\u7684\u52A0\u6743\u6210\u7EE9\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6392\u540D\u4EC5\u6C47\u603B\u7EDF\u8BA1\u6709\u6548\u6BD4\u8D5B\u65E5\u671F\u5185\u7684\u6BCF\u65E5\u201C\u4EA4\u6613\u79EF\u5206\u201D\uFF0C\u975E\u6BD4\u8D5B\u671F\u95F4\u83B7\u5F97\u7684\u201C\u4EA4\u6613\u79EF\u5206\u201D\u4E0D\u5728\u6392\u540D\u6C47\u603B\u7EDF\u8BA1\u4E4B\u5185\uFF0C\u201C\u4EA4\u6613\u79EF\u5206\u201D\u4EE5\u5C0F\u725B\u6570\u636EAPP\u7EDF\u8BA1\u7684\u6570\u636E\u4E3A\u51C6\u3002</p><p style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 19px">\u573A\u5185\u51B3\u8D5B</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">1.\u8D5B\u5236</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u573A\u5185\u51B3\u8D5B\u591A\u4E2A\u9AD8\u6821\u540C\u6B65\u8FDB\u884C\uFF0C\u573A\u5185\u51B3\u8D5B\u6392\u540D\u4EC5\u5728\u672C\u6821\u62A5\u540D\u9009\u624B\u4E2D\u7EDF\u8BA1\uFF08\u4E0E\u5176\u4ED6\u9AD8\u6821\u65E0\u5173\uFF09\u3002\u8D5B\u5236\u5177\u4F53\u8981\u6C42\u5982\u4E0B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u573A\u5185\u51B3\u8D5B\u4EC5\u4E00\u573A\uFF0C\u5404\u9AD8\u6821\u573A\u5185\u51B3\u8D5B\u7684\u524D\u4E09\u540D\u83B7\u5F97\u73B0\u91D1\u5956\u52B1\uFF0C\u51A0\u519B\u8FD8\u83B7\u5F97\u5165\u56F4\u603B\u51B3\u8D5B\u7684\u8D44\u683C\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u573A\u5185\u51B3\u8D5B\u4E3A\u5B9E\u76D8\u4EA4\u6613\u3002\u9009\u624B\u4E0D\u9700\u8981\u63D0\u4F9B\u4EFB\u4F55\u8D44\u91D1\uFF0C\u4E8F\u635F\u91D1\u989D\u4E0D\u9700\u8981\u9009\u624B\u627F\u62C5\uFF0C\u76C8\u5229\u91D1\u989D\u4E0D\u53C2\u4E0E\u63D0\u6210\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3)\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u9075\u5B88\u4E3B\u529E\u65B9\u5236\u5B9A\u7684\u4EA4\u6613\u7EAA\u5F8B\u548C\u98CE\u63A7\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4)\u6BD4\u8D5B\u4E2D\uFF0C\u9009\u624B\u56E0\u8FDD\u53CD\u4EA4\u6613\u7EAA\u5F8B\uFF0C\u89E6\u72AF\u4E25\u91CD\u98CE\u63A7\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u7EC8\u6B62\u8BE5\u53C2\u8D5B\u8005\u7684\u6BD4\u8D5B\u8D44\u683C\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5)\u8D5B\u524D\u4E3B\u529E\u65B9\u4F1A\u4E0E\u6BCF\u4F4D\u53C2\u8D5B\u8005\u8BE6\u7EC6\u8BB2\u89E3\u98CE\u63A7\uFF0C\u4EA4\u6613\u7EAA\u5F8B\u7B49\u95EE\u9898\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">2.\u6BD4\u8D5B\u65F6\u95F4</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2019\u5E742\u670825\u65E5~3\u670822\u65E5\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">3.\u6BD4\u8D5B\u5730\u70B9</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u672C\u6821\u5185\u6307\u5B9A\u5730\u70B9\uFF0C\u96C6\u4E2D\u8FDB\u884C\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">4.\u6307\u5B9A\u62A5\u5355\u8F6F\u4EF6</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E3B\u529E\u65B9\u6307\u5B9A\u6A21\u62DF\u4EA4\u6613\u548C\u5B9E\u76D8\u4EA4\u6613\u7684\u8F6F\u4EF6\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">5.\u53C2\u8D5B\u8D44\u683C</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u6EE1\u8DB3\u5FC5\u987B\u662F\u573A\u5185\u5FAA\u73AF\u8D5B\u4EFB\u4E00\u8D5B\u5B63\u7684\u524D\u4E09\u540D\u4EBA\u5458\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">6.\u6392\u540D\u89C4\u5219</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u573A\u5185\u51B3\u8D5B\u7684\u6392\u540D\u89C4\u5219\u4E0E\u573A\u5185\u5FAA\u73AF\u8D5B\u7684\u89C4\u5219\u4E00\u81F4\uFF0C\u4F7F\u7528\u6BD4\u8D5B\u671F\u95F4\u83B7\u5F97\u7684\u201C\u4EA4\u6613\u79EF\u5206\u201D\u6C47\u603B\u6392\u540D\uFF0C\u201C\u4EA4\u6613\u79EF\u5206\u201D\u4EE5\u5C0F\u725B\u6570\u636EAPP\u7EDF\u8BA1\u7684\u6570\u636E\u4E3A\u51C6\u3002</p><p style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 19px">\u603B\u51B3\u8D5B</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">1.\u8D5B\u5236</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u603B\u51B3\u8D5B\u662F\u5404\u9AD8\u6821\u573A\u5185\u51B3\u8D5B\u51A0\u519B\u4E4B\u95F4\u7684\u6BD4\u8D5B\uFF0C\u5177\u4F53\u8D5B\u5236\u5982\u4E0B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u603B\u51B3\u8D5B\u4EC5\u4E00\u573A\uFF0C\u4E3A\u5B9E\u76D8\u4EA4\u6613\uFF0C\u5E76\u63D0\u4F9B\u4E30\u539A\u5956\u54C1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u9009\u624B\u4E0D\u9700\u8981\u63D0\u4F9B\u4EFB\u4F55\u8D44\u91D1\uFF0C\u4E8F\u635F\u91D1\u989D\u4E0D\u9700\u8981\u9009\u624B\u627F\u62C5\uFF0C\u76C8\u5229\u91D1\u989D\u4E0D\u53C2\u4E0E\u63D0\u6210\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3)\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u9075\u5B88\u4E3B\u529E\u65B9\u5236\u5B9A\u7684\u4EA4\u6613\u7EAA\u5F8B\u548C\u98CE\u63A7\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4)\u6BD4\u8D5B\u4E2D\uFF0C\u9009\u624B\u56E0\u8FDD\u53CD\u4EA4\u6613\u7EAA\u5F8B\uFF0C\u89E6\u72AF\u4E25\u91CD\u98CE\u63A7\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u7EC8\u6B62\u8BE5\u53C2\u8D5B\u8005\u7684\u6BD4\u8D5B\u8D44\u683C\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5)\u8D5B\u524D\u4E3B\u529E\u65B9\u4F1A\u4E0E\u6BCF\u4F4D\u53C2\u8D5B\u8005\u8BE6\u7EC6\u8BB2\u89E3\u98CE\u63A7\uFF0C\u4EA4\u6613\u7EAA\u5F8B\u7B49\u95EE\u9898\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">2.\u6BD4\u8D5B\u65F6\u95F4</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2019\u5E744\u67081\u65E5~4\u670830\u65E5\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">3.\u6BD4\u8D5B\u5730\u70B9</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53A6\u95E8\u5E02\u5185\u6307\u5B9A\u5730\u70B9\uFF0C\u96C6\u4E2D\u8FDB\u884C\u6BD4\u8D5B\u3002\u73AF\u5883\u4F18\u7F8E\uFF0C\u63D0\u4F9B\u98DF\u5BBF</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">4.\u6307\u5B9A\u62A5\u5355\u8F6F\u4EF6</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E3B\u529E\u65B9\u6307\u5B9A\u6A21\u62DF\u4EA4\u6613\u548C\u5B9E\u76D8\u4EA4\u6613\u7684\u8F6F\u4EF6\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">5.\u53C2\u8D5B\u8D44\u683C</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u6EE1\u8DB3\u5FC5\u987B\u662F\u5404\u9AD8\u6821\u573A\u5185\u51B3\u8D5B\u7684\u51A0\u519B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">6.\u6392\u540D\u89C4\u5219</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u603B\u51B3\u8D5B\u7684\u6392\u540D\u89C4\u5219\u4E0E\u573A\u5185\u5FAA\u73AF\u8D5B\u7684\u6392\u540D\u89C4\u5219\u4E00\u81F4\uFF0C\u4F7F\u7528\u6BD4\u8D5B\u671F\u95F4\u83B7\u5F97\u7684\u201C\u4EA4\u6613\u79EF\u5206\u201D\u6C47\u603B\u6392\u540D\uFF0C\u201C\u4EA4\u6613\u79EF\u5206\u201D\u4EE5\u5C0F\u725B\u6570\u636EAPP\u7EDF\u8BA1\u7684\u6570\u636E\u4E3A\u51C6\u3002</p><br><br></div></div></div>');
$templateCache.put('app/pages/xmActivity/activityTradeDetails.html','<div class="main_page"><div class="container" style="margin-top: 150px"><div style="font-size: 22px;color: #333333;font-weight: bold;text-align: center">\u4EA4\u6613\u89C4\u5219</div><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px;text-align: center">\u4E3B\u529E\u65B9\u672C\u7740\u516C\u5E73\u3001\u516C\u6B63\u3001\u516C\u5F00\u7684\u539F\u5219\u7EC4\u7EC7\u8BE5\u8D5B\u4E8B\uFF0C\u4E3B\u529E\u65B9\u4FDD\u7559\u5BF9\u89C4\u5219\u7684\u89E3\u91CA\u6743\u3002</div><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 31px">\u5916\u56F4\u8D5B\u4EA4\u6613\u89C4\u5219</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u5916\u56F4\u8D5B\u4F7F\u7528\u5C0F\u725B\u6570\u636EAPP\u6216\u8005\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u5B8C\u6210\u4EA4\u6613\uFF0C\u5177\u4F53\u6BD4\u8D5B\u7684\u4EA4\u6613\u89C4\u5219\u5982\u4E0B\uFF1A</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4EA4\u6613\u54C1\u79CD</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u8005\u9700\u8981\u4ECE\u7CFB\u7EDF\u63D0\u4F9B\u7684\u8BC1\u5238\u6C60\u4E2D\u9009\u62E9\u8BC1\u5238\u8FDB\u884C\u4EA4\u6613\uFF0C\u8BC1\u5238\u6C60\u4E2D\u5305\u62EC\u80A1\u7968\u548C\u4E0A\u5E02\u57FA\u91D1\u4E24\u7C7B\u8BC1\u5238\uFF0C\u662F\u7CFB\u7EDF\u7BA1\u7406\u5458\u6839\u636E\u7ECF\u9A8C\u4F18\u9009\u7684\u4FBF\u4E8E\u65E5\u5185\u4EA4\u6613\u7684\u8BC1\u5238\u96C6\u5408\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u8005\u6CE8\u518C\u767B\u5F55\u540E\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u7CFB\u7EDF\u4F1A\u9ED8\u8BA4\u5206\u914D\u865A\u62DF\u53EF\u7528\u8D44\u91D1100\u4E07\u5143\uFF0C\u865A\u62DF\u53EF\u7528\u8D44\u91D1\u662F\u8BE5\u53C2\u8D5B\u8005\u5168\u90E8\u53EF\u4EA4\u6613\u8BC1\u5238\u7684\u5171\u7528\u8D44\u91D1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u53C2\u8D5B\u8005\u83B7\u5F97\u201C\u8BC1\u5238\u6C60\u201D\u5185\u5168\u90E8\u8BC1\u5238\u7684\u4EA4\u6613\u6743\u9650\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.\u6BCF\u53EA\u8BC1\u5238\u6301\u4ED3\u80A1\u6570\u4E3A10000\u80A1\uFF0C\u5934\u5BF8\u9608\u503C\u4E3A2500\u80A1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u7CFB\u7EDF\u4F1A\u9ED8\u8BA4\u4ECE\u201C\u8BC1\u5238\u6C60\u201D\u4E2D\u9009\u62E93\u53EA\u7528\u4E8E\u62A5\u5355\u754C\u9762\u663E\u793A\u7684\u8BC1\u5238\u3002\u62A5\u5355\u754C\u9762\u4EC5\u663E\u793A3\u53EA\u7684\u76EE\u7684\u662F\u4FBF\u4E8E\u5FEB\u901F\u5207\u6362\uFF0C\u53EF\u81EA\u884C\u4FEE\u6539\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5.\u7CFB\u7EDF\u4E0D\u9650\u5236\u4E5F\u4E0D\u63A8\u8350\u6BCF\u65E5\u4EA4\u6613\u8FC7\u591A\u7684\u8BC1\u5238\uFF0C\u63A8\u83501~2\u53EA\u4E3A\u5B9C\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4EA4\u6613\u65F6\u95F4</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u4EA4\u6613\u65F6\u95F4\u4E3A\u6B63\u5E38\u4EA4\u6613\u65E5\u7684\u8FDE\u7EED\u7ADE\u4EF7\u4EA4\u6613\u65F6\u95F4\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">9\uFF1A30\u201411\uFF1A30\uFF0C13\uFF1A00\u201415:00\uFF1B</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u76D8\u524D\u96C6\u5408\u7ADE\u4EF79:15\u20149:25\uFF0C\u4E0D\u63A5\u6536\u62A5\u5355\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4E70\u5356\u8D39\u7387</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6A21\u62DF\u4EA4\u6613\u7684\u80A1\u7968\u548C\u4E0A\u5E02\u57FA\u91D1\u4E70\u5356\u8D39\u7387\u4F1A\u4E0E\u5B9E\u76D8\u4EA4\u6613\u8D39\u7387\u5B58\u5728\u5DEE\u5F02\uFF0C\u5177\u4F53\u8D39\u7387\u8BBE\u7F6E\u5982\u4E0B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u5168\u90E8\u4E0A\u5E02\u57FA\u91D1\u8D39\u7387\uFF1A\u4E70\u51650.005%\uFF0C \u5356\u51FA0.005%</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u5168\u90E8\u80A1\u7968\u8D39\u7387\uFF1A \u4E70\u51650.009%\uFF0C \u5356\u51FA0.109%</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u6301\u4ED3\u9694\u591C\u5904\u7406</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u6A21\u62DF\u4EA4\u6613\u4EE5\u8BAD\u7EC3\u65E5\u5185\u4EA4\u6613\u4E3A\u76EE\u6807\u3002T\u65E5\u4E0D\u7BA1\u53C2\u8D5B\u8005\u76C8\u5229\u8FD8\u662F\u4E8F\u635F\uFF0C\u76D8\u540E\u4F1A\u865A\u62DF\u53EF\u7528\u8D44\u91D1\u6062\u590D\u5230\u8BBE\u7F6E\u503C\uFF08\u76EE\u524D\u4E3A100\u4E07\u5143\uFF09\uFF0C\u4EE5\u4FDD\u969CT+1\u65E5\u6709\u8DB3\u591F\u7684\u8D44\u91D1\u7528\u4E8E\u8BC1\u5238\u4E70\u5165\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.T\u65E5\u4EA4\u6613\u7ED3\u675F\u540E\uFF0C\u4E0D\u7BA1\u53C2\u8D5B\u8005\u9057\u7559\u7684\u4EA4\u6613\u5934\u5BF8\u662F\u591A\u5C11\uFF0C\u76D8\u540E\u4F1A\u5C06\u5168\u90E8\u53EF\u4EA4\u6613\u8BC1\u5238\u7684\u6301\u4ED3\u80A1\u6570\u6062\u590D\u5230\u8BBE\u7F6E\u503C\uFF08\u76EE\u524D\u4E3A10000\u80A1\uFF09\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.T\u65E5\u65E9\u76D8\uFF0C\u8D26\u6237\u5185\u6301\u4ED3\u7684\u8BC1\u5238\u53EF\u5356\u51FA\uFF0CT\u65E5\u76D8\u4E2D\u4E70\u5165\u7684\u8BC1\u5238\u4E0D\u53EF\u5356\u51FA\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u5982\u679C\u8BC1\u5238\u53D1\u751F\u9664\u606F\u9664\u6743\uFF0CT+1\u65E5\u65E9\u76D8\u4EC5\u4F1A\u5F71\u54CD\u8BC1\u5238\u6628\u6536\u4EF7\uFF0C\u4E0D\u4F1A\u6539\u53D8\u6301\u4ED3\u6570\u91CF\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4E70\u5356\u62A5\u5355\u98CE\u63A7</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u6A21\u62DF\u4EA4\u6613\u62A5\u5355\u6700\u5C0F\u5355\u4F4D100\u80A1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u6BCF\u4E2A\u4EA4\u6613\u65E5\u5F00\u59CB\uFF0C\u59D4\u6258\u754C\u9762\u7684\u59D4\u6258\u201C\u6570\u91CF\u201D\u9ED8\u8BA4\u4E3A100\u80A1\uFF0C\u4FEE\u6539\u540E\u7CFB\u7EDF\u4F1A\u8BB0\u5F55\u6700\u65B0\u7684\u59D4\u6258\u6570\u91CF\u6570\u636E\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.\u5B9E\u65F6\u5934\u5BF8\u6309\u7167\u4E70\u5356\u6210\u4EA4\u603B\u80A1\u6570\u8BA1\u7B97\u5F97\u51FA\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u5934\u5BF8\u9608\u503C\u662F\u9632\u6B62\u5355\u65B9\u5411\u62A5\u5355\u8FC7\u591A\u7684\u98CE\u63A7\u53C2\u6570\u3002\u7CFB\u7EDF\u8981\u6C42\u201C\u59D4\u6258\u6570\u91CF+\u5B9E\u65F6\u5934\u5BF8\uFF08\u540C\u65B9\u5411\uFF09&lt;=\u5934\u5BF8\u9608\u503C\uFF08\u76EE\u524D\u4E3A2500\u80A1\uFF09\u201D\uFF0C\u5426\u5219\u7981\u6B62\u63D0\u4EA4\u59D4\u6258\u3002\u9700\u8981\u8F83\u5C11\u59D4\u6258\u6570\u91CF\u6216\u8005\u53CD\u65B9\u5411\u62A5\u5355\uFF0C\u6765\u63A7\u5236\u98CE\u9669\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5.\u8BC1\u5238\u505C\u590D\u724C\u65F6\u95F4\u540C\u6B65\u5B9E\u76D8\u884C\u60C5\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4EA4\u6613\u6A21\u5F0F</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4EA4\u6613\u6A21\u5F0F\u5206\u4E3A\u666E\u901A\u4E0B\u5355\u548C\u5FEB\u901F\u4E0B\u5355\u6A21\u5F0F\uFF0C\u70B9\u51FB\u754C\u9762\u7684\u95EA\u7535\u56FE\u6807\u6309\u94AE\u53EF\u5207\u6362\u4E24\u79CD\u6A21\u5F0F\u3002\u5F00\u542F\u5FEB\u901F\u4E0B\u5355\u6A21\u5F0F\uFF0C\u4E70\u5165\u59D4\u6258\u4EF7\u683C\u4E3A\u5356\u4E00\u4EF7\uFF0C\u5356\u51FA\u59D4\u6258\u4EF7\u683C\u4E3A\u4E70\u4E00\u4EF7\uFF0C\u59D4\u6258\u6570\u91CF\u4F7F\u7528\u666E\u901A\u4E0B\u5355\u4E70\u5165\u548C\u5356\u51FA\u9875\u9762\u5185\u201C\u6570\u91CF\u201D\u4E2D\u8BBE\u7F6E\u7684\u6570\u636E\u3002\u4F7F\u7528\u5FEB\u901F\u4E0B\u5355\u9700\u8981\u614E\u91CD\u3002</p><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 50px">\u573A\u5185\u8D5B\u548C\u51B3\u8D5B\u4EA4\u6613\u89C4\u5219</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u573A\u5185\u8D5B\u548C\u51B3\u8D5B\u4EA4\u6613\u89C4\u5219\u662F\u6307\u573A\u5185\u5FAA\u73AF\u8D5B\uFF0C\u573A\u5185\u51B3\u8D5B\uFF0C\u603B\u51B3\u8D5B\uFF0C\u4EE5\u53CA\u573A\u5185\u6A21\u62DF\u4EA4\u6613\u7684\u4EA4\u6613\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u6839\u636E\u6BCF\u4E2A\u53C2\u8D5B\u4EBA\u5458\u7684\u6001\u5EA6\u3001\u7EAA\u5F8B\u6027\u3001\u98CE\u63A7\u80FD\u529B\u3001\u4EA4\u6613\u80FD\u529B\uFF0C\u4E3B\u529E\u65B9\u6BCF\u65E5\u4F1A\u5408\u7406\u8C03\u6574\u6BCF\u4F4D\u53C2\u8D5B\u4EBA\u5458\u7684\u53EF\u7528\u8D44\u91D1\u3001\u914D\u4ED3\u80A1\u6570\uFF0C\u5E76\u4E0E\u53C2\u8D5B\u8005\u534F\u5546\u786E\u5B9A\u4EA4\u6613\u54C1\u79CD\u548C\u6570\u91CF\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u9075\u5B88\u4E3B\u529E\u65B9\u5236\u5B9A\u7684\u5B9E\u76D8\u4EA4\u6613\u7EAA\u5F8B\u548C\u98CE\u63A7\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u4EA4\u6613\u65F6\u95F4\uFF0C\u4E0E\u6CAA\u6DF1\u4E24\u5E02\u65F6\u95F4\u4E00\u81F4\uFF0C\u76D8\u524D\u548C\u5C3E\u76D8\u96C6\u5408\u7ADE\u4EF7\u671F\u95F4\u5747\u53EF\u62A5\u5355\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5.\u4E70\u5356\u8D39\u7387\u4E3A\u5B9E\u76D8\u8D26\u6237\u7684\u771F\u5B9E\u8D39\u7387\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">6.\u9664\u606F\u9664\u6743\uFF0C\u505C\u590D\u724C\uFF0C\u4E70\u5356\u62A5\u5355\u89C4\u5219\u4E0E\u6CAA\u6DF1\u4E24\u5E02\u89C4\u5219\u4E00\u81F4\u3002</p><br><br></div></div>');
$templateCache.put('app/pages/xmActivity/selectUniversity.html','<div class="modal-content"><div class="modal-header bg-{{modalOptions.alertStyle}}"><i class="ion-android-{{modalOptions.alertStyle}} modal-icon"></i><span>{{modalOptions.headerText}}</span></div><div class="modal-body"><ui-select ng-model="university" ng-change="selectUniversity(university)"><ui-select-match placeholder="">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="university in universities | filter: $select.search"><div ng-bind="university.name"></div></ui-select-choices></ui-select></div><div class="modal-footer"><button class="btn btn-{{modalOptions.alertStyle}} btn-action" ng-disabled="selectedUniversity.id == 0" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}} <span class="glyphicon glyphicon-circle-arrow-right"></span></button> <button type="button" class="btn" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button></div></div>');
$templateCache.put('app/pages/activity/activity.html','<div class="main_page"><section class="no-margin"><div style="background-image: url(images/activity/summber_competition.png); height: 620px;background-position:center; background-repeat:no-repeat;"></div></section><section style="margin-top: 60px"><div class="container"><div style="font-size: 22px;color:#FD6253;text-align: center"><div style="height: 1px;width: 50px;background-color: #FD6253;display: inline-block;vertical-align: middle"></div><div style="margin-left: 10px;margin-right: 10px; display: inline-block">\u6BD4\u8D5B\u7B80\u4ECB</div><div style="height: 1px;width: 50px;background-color: #FD6253;display: inline-block;vertical-align: middle"></div></div><div style="float: right;margin-top: 10px"><div id="competitionDetails" ng-click="getCompetitionDetails()"></div><div id="competitionTradeDetails" ng-click="getTradeDetails()"></div></div><div style="margin-top: 100px;font-size: 16px;line-height: 2"><p style="text-indent:2em">\u201C\u5C0F\u725B\u676F\u201D\u7092\u80A1\u5927\u8D5B\u4EE5\u666E\u53CA\u8BC1\u5238\u77E5\u8BC6\uFF0C\u6559\u80B2\u5728\u6821\u5B66\u751F\u6811\u7ACB\u826F\u597D\u7684\u6295\u8D44\u7406\u5FF5\uFF0C\u6B63\u786E\u7684\u98CE\u63A7\u610F\u8BC6\u4E3A\u5B97\u65E8\u3002\u8BA9\u5B66\u751F\u5728\u5207\u8EAB\u611F\u53D7\u8BC1\u5238\u5E02\u573A\u673A\u9047\u4E0E\u98CE\u9669\u540C\u65F6\uFF0C\u53EF\u4EE5\u4F53\u9A8C\u4E30\u5BCC\u591A\u6837\u7684\u6295\u8D44\u670D\u52A1\u548C\u4EA7\u54C1\uFF0C\u63D0\u5347\u6295\u8D44\u6C34\u5E73\uFF0C\u4E3A\u4EE5\u540E\u7684\u91D1\u878D\u804C\u4E1A\u751F\u6DAF\u89C4\u5212\u6253\u4E0B\u575A\u5B9E\u7684\u57FA\u7840\u3002</p><p style="text-indent:2em">\u5927\u8D5B\u5206\u4E3A\u8D44\u683C\u8D5B\u548C\u51B3\u8D5B\u3002\u8D44\u683C\u8D5B\u662F\u6A21\u62DF\u76D8\u7684\u6BD4\u8D5B\uFF0C\u8D44\u683C\u8D5B\u664B\u7EA7\u540E\u8FDB\u5165\u51B3\u8D5B\uFF0C\u51B3\u8D5B\u4E3A\u5B9E\u76D8\u6BD4\u8D5B\u3002</p><p style="text-indent:2em">\u4E3B\u529E\u65B9\uFF1A&nbsp;&nbsp;\u5C0F\u725B\u6570\u636E</p></div><div style="font-size: 22px;color:#FD6253;text-align: center;margin-top: 120px"><div style="height: 1px;width: 50px;background-color: #FD6253;display: inline-block;vertical-align: middle"></div><div style="margin-left: 10px;margin-right: 10px; display: inline-block">\u6BD4\u8D5B\u65F6\u95F4</div><div style="height: 1px;width: 50px;background-color: #FD6253;display: inline-block;vertical-align: middle"></div></div><div style="margin-top: 53px;margin-bottom: 40px; font-size: 18px;color:#FD6253;text-align: center"><p>\u8D44\u683C\u8D5B\uFF1A2018\u5E747\u670802\u53F7&nbsp;-&nbsp;8\u670815\u53F7</p><p>\u51B3&emsp;\u8D5B\uFF1A2018\u5E748\u670816\u53F7&nbsp;-&nbsp;8\u670831\u53F7</p></div></div><div id="main-slider" class="no-margin"></div><div style="background-image: url(images/activity/prize.png);height: 320px;background-position:center; background-repeat:no-repeat;margin-top: 200px"></div></section></div>');
$templateCache.put('app/pages/activity/activityDetails.html','<div class="main_page"><div class="container" style="margin-top: 150px"><div style="font-size: 22px;color: #333333;font-weight: bold;text-align: center">\u8D5B\u7A0B\u8D5B\u5236</div><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 50px">\u6BD4\u8D5B\u5206\u4E3A\u8D44\u683C\u8D5B\u548C\u51B3\u8D5B</div><div><img src="images/activity/program.png"></div><div><p style="font-size: 17px;color: #333333;font-weight: bold;">\u8D44\u683C\u8D5B</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">1.\u6BD4\u8D5B\u65F6\u95F4</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2018\u5E747\u67082\u65E5 ~ 8\u670815\u65E5\uFF0C\u8D44\u683C\u8D5B\u662F\u6A21\u62DF\u76D8\u7684\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">2.\u6307\u5B9A\u4EA4\u6613\u8F6F\u4EF6</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u5C0F\u725B\u6570\u636EAPP\u201D\u548C\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u3002\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u7F51\u5740\u4E3A<a href="http://www.xntrader.com">www.xntrader.com</a>\uFF0C\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u53EF\u626B\u63CF\u4E8C\u7EF4\u7801\u4E0B\u8F7D\u3002\u53C2\u8D5B\u8005\u53EF\u5728\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u548C\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u4EA4\u6613\u62A5\u5355\uFF0C\u4E8C\u8005\u6570\u636E\u662F\u540C\u6B65\u7EDF\u4E00\u7684\u3002\u76D8\u540E\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u4F1A\u63D0\u4F9B\u5168\u9762\u7684\u6570\u636E\u5206\u6790\uFF0C\u4EE5\u5E2E\u52A9\u53C2\u8D5B\u8005\u67E5\u770B\u6210\u7EE9\u548C\u53D1\u73B0\u3001\u6539\u8FDB\u4E0D\u8DB3\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">3.\u53C2\u8D5B\u8D44\u683C</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u6EE1\u8DB3\u4EE5\u4E0B\u4E24\u4E2A\u6761\u4EF6\uFF0C\u5373\u53EF\u53C2\u8D5B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u798F\u5DDE\u9AD8\u6821\u5728\u6821\u5B66\u751F</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u5E76\u6CE8\u518C\u6210\u4E3A\u201C\u5C0F\u725B\u6570\u636E\u201D\u7528\u6237</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E3A\u4FDD\u8BC1\u7ADE\u8D5B\u7684\u516C\u5E73\uFF0C\u6CE8\u518C\u201C\u5C0F\u725B\u6570\u636E\u201D\u7528\u6237\u65F6\uFF0C\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u5982\u5B9E\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F\u3002\u9886\u5956\u65F6\uFF0C\u4E3B\u529E\u65B9\u5C06\u5BA1\u6838\u83B7\u5956\u4EBA\u5458\u7684\u8EAB\u4EFD\uFF0C\u5982\u679C\u53D1\u73B0\u4E0D\u7B26\u5408\u53C2\u8D5B\u6761\u4EF6\u7684\u4EBA\u5458\uFF0C\u5C06\u53D6\u6D88\u5176\u6210\u7EE9\u5E76\u987A\u5EF6\u83B7\u5956\u540D\u5355\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u5728\u8D44\u683C\u8D5B\u5F00\u59CB\u4E4B\u524D\uFF0C\u7528\u6237\u53EF\u5148\u884C\u6CE8\u518C\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u3002\u901A\u8FC7APP\u201C\u8BFE\u5802\u2014>\u7406\u8BBA/\u8BAD\u7EC3\u201D\u7B49\u57F9\u8BAD\u5185\u5BB9\u53EF\u5148\u884C\u5B66\u4E60\u6295\u8D44\u77E5\u8BC6\u548C\u65B9\u6CD5\u3002\u4E5F\u53EF\u5728\u4EA4\u6613\u65E5\u901A\u8FC7\u201C\u5C0F\u725B\u6570\u636EAPP\u201D\u548C\u201C\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u201D\u7EC3\u4E60\u6A21\u62DF\u4EA4\u6613\uFF0C\u4E3A\u5927\u8D5B\u505A\u524D\u671F\u51C6\u5907\u3002\u672C\u6B21\u5927\u8D5B\u6392\u540D\u4EC5\u7EDF\u8BA12018\u5E747\u67082\u65E5 ~ 8\u670815\u65E5\u7684\u4EA4\u6613\u6210\u7EE9\uFF0C\u8D5B\u524D\u7684\u7EC3\u4E60\u6210\u7EE9\u4E0D\u5E26\u5165\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">4.\u62A5\u540D\u6D41\u7A0B</p><div style="margin-top:40px"><img src="images/activity/signStep.png"></div><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 40px">5.\u6392\u540D\u89C4\u5219</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6839\u636E\u53C2\u8D5B\u8005\u6BCF\u65E5\u6536\u76CA\u7387\uFF08\u5305\u62EC\u6BCF\u65E5\u6709\u4EA4\u6613\u8BB0\u5F55\u7684\u5168\u90E8\u8BC1\u5238\u7684\u7EFC\u5408\u6536\u76CA\u7387\uFF09\uFF0C\u518D\u9010\u65E5\u7D2F\u8BA1\u6BCF\u65E5\u6536\u76CA\u7387\u5F97\u51FA \u201C\u603B\u6536\u76CA\u7387\u201D\u3002\u6839\u636E\u201C\u603B\u6536\u76CA\u7387\u201D\u4ECE\u9AD8\u5230\u4F4E\u8FDB\u884C\u6392\u540D\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6392\u540D\u4EC5\u7EDF\u8BA1\u6BD4\u8D5B\u671F\u95F4\u7684\u6BCF\u65E5\u6536\u76CA\u7387\uFF0C\u201C\u6BCF\u65E5\u6536\u76CA\u7387\u201D\u548C\u201C\u603B\u6536\u76CA\u7387\u201D\u6570\u636E\u4EE5\u5C0F\u725B\u6570\u636E\u7684APP\u7EDF\u8BA1\u6570\u636E\u4E3A\u51C6\u3002</p><p style="font-size: 17px;color: #333333;font-weight: bold;;margin-top: 19px">\u51B3\u8D5B</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">1.\u6BD4\u8D5B\u65F6\u95F4</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2018\u5E748\u670816\u65E5~8\u670831\u65E5\uFF0C\u51B3\u8D5B\u662F\u5B9E\u76D8\u6295\u8D44\u7684\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">2.\u53C2\u6570\u8D44\u683C</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u52A0\u51B3\u8D5B\u7684\u4EBA\u5458\u540D\u5355\u4ECE\u7531\u4E3B\u529E\u65B9\u6309\u7167\u8D44\u683C\u8D5B\u7684\u201C\u603B\u6536\u76CA\u7387\u201D\u6392\u540D\u4F18\u9009\uFF0C\u4E3B\u529E\u65B9\u901A\u8FC7\u7535\u8BDD\u901A\u77E5\u8FDB\u5165\u51B3\u8D5B\u7684\u4EBA\u5458\uFF0C\u53CC\u65B9\u5747\u540C\u610F\u65B9\u53EF\u8FDB\u5165\u51B3\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">3.\u6BD4\u8D5B\u5730\u70B9</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u7531\u4E3B\u529E\u65B9\u6307\u5B9A\u5177\u4F53\u5730\u70B9\u5E76\u514D\u8D39\u63D0\u4F9B\u4F4F\u5BBF\uFF0C\u96C6\u4E2D\u8FDB\u884C\u6BD4\u8D5B\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">4.\u7279\u6B8A\u8BF4\u660E</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1)\u53C2\u8D5B\u4EBA\u5458\u4E0D\u9700\u8981\u4EFB\u4F55\u62A5\u540D\u8D39\u7528\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2)\u53C2\u8D5B\u4EBA\u5458\uFF0C\u4E0D\u9700\u8981\u63D0\u4F9B\u4EFB\u4F55\u8D44\u91D1\u3002\u6BD4\u8D5B\u4EA4\u6613\u7684\u76C8\u4E8F\u91D1\u989D\u4EC5\u505A\u6BD4\u8D5B\u6392\u540D\u4F7F\u7528\uFF0C\u4E8F\u635F\u91D1\u989D\u4E0D\u9700\u8981\u53C2\u8D5B\u4EBA\u5458\u627F\u62C5\uFF0C\u76C8\u5229\u91D1\u989D\u4E0D\u5F52\u53C2\u8D5B\u4EBA\u5458\u6240\u6709\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3)\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u9075\u5B88\u4E3B\u529E\u65B9\u5236\u5B9A\u7684\u4EA4\u6613\u7EAA\u5F8B\u548C\u98CE\u63A7\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4)\u51B3\u8D5B\u4E2D\uFF0C\u53C2\u8D5B\u4EBA\u5458\u56E0\u8FDD\u53CD\u4EA4\u6613\u7EAA\u5F8B\uFF0C\u89E6\u72AF\u4E25\u91CD\u98CE\u63A7\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u7EC8\u6B62\u8BE5\u53C2\u8D5B\u8005\u7684\u6BD4\u8D5B\u8D44\u683C\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5)\u53C2\u52A0\u51B3\u8D5B\u7684\u4EBA\u5458\uFF0C\u4E3B\u529E\u65B9\u4F1A\u53D1\u653E\u4E00\u5B9A\u7684\u751F\u6D3B\u8865\u8D34\u3002</p><p style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">5.\u6392\u540D\u89C4\u5219</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4E0E\u8D44\u683C\u8D5B\u6392\u540D\u89C4\u5219\u8BA1\u7B97\u65B9\u6CD5\u4E00\u81F4\uFF0C\u6570\u636E\u662F\u5B9E\u76D8\u6BD4\u8D5B\u671F\u95F4\u5B9E\u76D8\u7684\u201C\u603B\u6536\u76CA\u7387\u201D\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6392\u540D\u4EC5\u7EDF\u8BA1\u6BD4\u8D5B\u671F\u95F4\u7684\u6BCF\u65E5\u6536\u76CA\u7387\uFF0C\u201C\u603B\u6536\u76CA\u7387\u201D\u6570\u636E\u4F9D\u65E7\u4EE5\u5C0F\u725B\u6570\u636E\u7684APP\u7EDF\u8BA1\u6570\u636E\u4E3A\u51C6\u3002</p><br><br></div></div></div>');
$templateCache.put('app/pages/activity/activityPrize.html','<div class="main_page"><div class="container" style="margin-top: 150px"><div style="font-size: 22px;color: #333333;font-weight: bold;text-align: center">\u5956\u9879\u8BBE\u7F6E</div><div style="margin-left: 400px"><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 50px">\u8D44\u683C\u8D5B</div><p style="font-size: 16px;color: #999999;margin-top: 19px">\u6839\u636E\u8D44\u683C\u8D5B\u7684\u201C\u603B\u6536\u76CA\u7387\u201D\u6392\u540D\uFF0C\u5956\u52B1\u524D10\u540D\u3002</p><p style="font-size: 16px;color: #999999;margin-top: 19px">\u6BCF\u4EBA\u7CBE\u7F8E\u793C\u54C1\u4E00\u4EFD</p><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 50px">\u51B3\u8D5B</div><p style="font-size: 16px;color: #999999;margin-top: 19px">\u6839\u636E\u51B3\u8D5B\u7684\u201C\u603B\u6536\u76CA\u7387\u201D\u6392\u540D\uFF0C\u5956\u52B1\u524D6\u540D</p><p style="font-size: 16px;color: #999999;margin-top: 19px">\u7B2C1\u540D\u5956\u91D1\uFFE54000\u5143\u6574</p><p style="font-size: 16px;color: #999999;margin-top: 19px">\u7B2C2\u30013\u540D\u6BCF\u4EBA\u5956\u91D1\uFFE52000\u5143\u6574</p><p style="font-size: 16px;color: #999999;margin-top: 19px">\u7B2C4\u30015\u30016\u540D\u6BCF\u4EBA\u5956\u91D1\uFFE51000\u5143\u6574</p><br><br></div></div></div>');
$templateCache.put('app/pages/activity/activityTradeDetails.html','<div class="main_page"><div class="container" style="margin-top: 150px"><div style="font-size: 22px;color: #333333;font-weight: bold;text-align: center">\u4EA4\u6613\u89C4\u5219</div><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 50px">\u8D44\u683C\u8D5B\u4EA4\u6613\u89C4\u5219</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u8D44\u683C\u8D5B\u4F7F\u7528\u5C0F\u725B\u6570\u636EAPP\u6216\u8005\u5C0F\u725B\u6570\u636E\u7F51\u7AD9\u5B8C\u6210\u4EA4\u6613\uFF0C\u5177\u4F53\u6BD4\u8D5B\u7684\u4EA4\u6613\u89C4\u5219\u5982\u4E0B\uFF1A</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4EA4\u6613\u54C1\u79CD</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u53EA\u80FD\u4ECE\u7CFB\u7EDF\u63D0\u4F9B\u7684\u8BC1\u5238\u6C60\u4E2D\u9009\u62E9\u8BC1\u5238\u8FDB\u884C\u4EA4\u6613\uFF0C\u8BC1\u5238\u6C60\u4E2D\u5305\u62EC\u80A1\u7968\u548C\u4E0A\u5E02\u57FA\u91D1\u4E24\u7C7B\u8BC1\u5238\uFF0C\u662F\u7CFB\u7EDF\u7BA1\u7406\u5458\u6839\u636E\u7ECF\u9A8C\u4F18\u9009\u7684\u4FBF\u4E8E\u65E5\u5185\u4EA4\u6613\u7684\u8BC1\u5238\u96C6\u5408\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">\u53C2\u8D5B\u4EBA\u5458\u6CE8\u518C\u767B\u5F55\u540E\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u7CFB\u7EDF\u4F1A\u9ED8\u8BA4\u5206\u914D\u865A\u62DF\u53EF\u7528\u8D44\u91D1100\u4E07\u5143\uFF0C\u865A\u62DF\u53EF\u7528\u8D44\u91D1\u662F\u8BE5\u53C2\u8D5B\u8005\u5168\u90E8\u53EF\u4EA4\u6613\u8BC1\u5238\u7684\u5171\u7528\u8D44\u91D1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u53C2\u8D5B\u8005\u83B7\u5F97\u201C\u8BC1\u5238\u6C60\u201D\u5185\u5168\u90E8\u8BC1\u5238\u7684\u4EA4\u6613\u6743\u9650\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.\u6BCF\u53EA\u8BC1\u5238\u6301\u4ED3\u80A1\u6570\u4E3A10000\u80A1\uFF0C\u5934\u5BF8\u9608\u503C\u4E3A2500\u80A1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u7CFB\u7EDF\u4F1A\u9ED8\u8BA4\u4ECE\u201C\u8BC1\u5238\u6C60\u201D\u4E2D\u9009\u62E93\u53EA\u7528\u4E8E\u62A5\u5355\u754C\u9762\u663E\u793A\u7684\u8BC1\u5238\u3002\u62A5\u5355\u754C\u9762\u4EC5\u663E\u793A3\u53EA\u7684\u76EE\u7684\u662F\u4FBF\u4E8E\u5FEB\u901F\u5207\u6362\uFF0C\u53EF\u81EA\u884C\u4FEE\u6539\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5.\u7CFB\u7EDF\u4E0D\u9650\u5236\u4E5F\u4E0D\u63A8\u8350\u6BCF\u65E5\u4EA4\u6613\u8FC7\u591A\u7684\u8BC1\u5238\uFF0C\u63A8\u83501~2\u53EA\u4E3A\u5B9C\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4EA4\u6613\u65F6\u95F4</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u4EA4\u6613\u65F6\u95F4\u4E3A\u6B63\u5E38\u4EA4\u6613\u65E5\u7684\u8FDE\u7EED\u7ADE\u4EF7\u4EA4\u6613\u65F6\u95F4\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">9\uFF1A30\u201411\uFF1A30\uFF0C13\uFF1A00\u201415:00\uFF1B</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u76D8\u524D\u96C6\u5408\u7ADE\u4EF79:15\u20149:25\uFF0C\u4E0D\u63A5\u6536\u62A5\u5355\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4E70\u5356\u8D39\u7387</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u6A21\u62DF\u4EA4\u6613\u80A1\u7968\u548C\u4E0A\u5E02\u57FA\u91D1\u4E70\u5356\u8D39\u7387\u4F1A\u4E0E\u5B9E\u76D8\u4EA4\u6613\u8D39\u7387\u5B58\u5728\u5DEE\u5F02\uFF0C\u5177\u4F53\u8D39\u7387\u8BBE\u7F6E\u5982\u4E0B\uFF1A</p><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u5168\u90E8\u4E0A\u5E02\u57FA\u91D1\u8D39\u7387\uFF1A\u4E70\u51650.005%\uFF0C \u5356\u51FA0.005%</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u5168\u90E8\u80A1\u7968\u8D39\u7387\uFF1A \u4E70\u51650.009%\uFF0C \u5356\u51FA0.109%</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u6301\u4ED3\u9694\u591C\u5904\u7406</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u6A21\u62DF\u4EA4\u6613\u4EE5\u8BAD\u7EC3\u65E5\u5185\u4EA4\u6613\u4E3A\u76EE\u6807\u3002T\u65E5\u4E0D\u7BA1\u53C2\u8D5B\u8005\u76C8\u5229\u8FD8\u662F\u4E8F\u635F\uFF0C\u76D8\u540E\u4F1A\u865A\u62DF\u53EF\u7528\u8D44\u91D1\u6062\u590D\u5230\u8BBE\u7F6E\u503C\uFF08\u76EE\u524D\u4E3A100\u4E07\u5143\uFF09\uFF0C\u4EE5\u4FDD\u969CT+1\u65E5\u6709\u8DB3\u591F\u7684\u8D44\u91D1\u7528\u4E8E\u8BC1\u5238\u4E70\u5165\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2..T\u65E5\u4EA4\u6613\u7ED3\u675F\u540E\uFF0C\u4E0D\u7BA1\u53C2\u8D5B\u8005\u9057\u7559\u7684\u4EA4\u6613\u5934\u5BF8\u662F\u591A\u5C11\uFF0C\u76D8\u540E\u4F1A\u5C06\u5168\u90E8\u53EF\u4EA4\u6613\u8BC1\u5238\u7684\u6301\u4ED3\u80A1\u6570\u6062\u590D\u5230\u8BBE\u7F6E\u503C\uFF08\u76EE\u524D\u4E3A10000\u80A1\uFF09\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.T\u65E5\u65E9\u76D8\uFF0C\u8D26\u6237\u5185\u6301\u4ED3\u7684\u8BC1\u5238\u53EF\u5356\u51FA\uFF0CT\u65E5\u76D8\u4E2D\u4E70\u5165\u7684\u8BC1\u5238\u4E0D\u53EF\u5356\u51FA\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u5982\u679C\u8BC1\u5238\u53D1\u751F\u9664\u606F\u9664\u6743\uFF0CT+1\u65E5\u65E9\u76D8\u4EC5\u4F1A\u5F71\u54CD\u8BC1\u5238\u6628\u6536\u4EF7\uFF0C\u4E0D\u4F1A\u6539\u53D8\u6301\u4ED3\u6570\u91CF\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4E70\u5356\u62A5\u5355\u98CE\u63A7</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u6A21\u62DF\u4EA4\u6613\u62A5\u5355\u6700\u5C0F\u5355\u4F4D100\u80A1\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u6BCF\u4E2A\u4EA4\u6613\u65E5\u5F00\u59CB\uFF0C\u59D4\u6258\u754C\u9762\u7684\u59D4\u6258\u201C\u6570\u91CF\u201D\u9ED8\u8BA4\u4E3A100\u80A1\uFF0C\u4FEE\u6539\u540E\u7CFB\u7EDF\u4F1A\u8BB0\u5F55\u6700\u65B0\u7684\u59D4\u6258\u6570\u91CF\u6570\u636E\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.\u5B9E\u65F6\u5934\u5BF8\u6309\u7167\u4E70\u5356\u6210\u4EA4\u603B\u80A1\u6570\u8BA1\u7B97\u5F97\u51FA\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u5934\u5BF8\u9608\u503C\u662F\u9632\u6B62\u5355\u65B9\u5411\u62A5\u5355\u8FC7\u591A\u7684\u98CE\u63A7\u53C2\u6570\u3002\u7CFB\u7EDF\u8981\u6C42\u201C\u59D4\u6258\u6570\u91CF+\u5B9E\u65F6\u5934\u5BF8\uFF08\u540C\u65B9\u5411\uFF09 &lt;=\u5934\u5BF8\u9608\u503C\uFF08\u76EE\u524D\u4E3A2500\u80A1\uFF09\u201D\uFF0C\u5426\u5219\u7981\u6B62\u63D0\u4EA4\u59D4\u6258\u3002\u9700\u8981\u8F83\u5C11\u59D4\u6258\u6570\u91CF\u6216\u8005\u53CD\u65B9\u5411\u62A5\u5355\uFF0C\u6765\u63A7\u5236\u98CE\u9669\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5.\u8BC1\u5238\u505C\u590D\u724C\u65F6\u95F4\u540C\u6B65\u5B9E\u76D8\u884C\u60C5\u3002</p><div style="font-size: 16px;color: #333333;font-weight: bold;margin-top: 19px">\u4EA4\u6613\u6A21\u5F0F</div><p style="font-size: 14px;color: #999999;margin-top: 19px">\u4EA4\u6613\u6A21\u5F0F\u5206\u4E3A\u666E\u901A\u4E0B\u5355\u548C\u5FEB\u901F\u4E0B\u5355\u6A21\u5F0F\uFF0C\u70B9\u51FB\u754C\u9762\u7684\u95EA\u7535\u56FE\u6807\u6309\u94AE\u53EF\u5207\u6362\u4E24\u79CD\u6A21\u5F0F\u3002\u5F00\u542F\u5FEB\u901F\u4E0B\u5355\u6A21\u5F0F\uFF0C\u4E70\u5165\u59D4\u6258\u4EF7\u683C\u4E3A\u5356\u4E00\u4EF7\uFF0C\u5356\u51FA\u59D4\u6258\u4EF7\u683C\u4E3A\u4E70\u4E00\u4EF7\uFF0C\u59D4\u6258\u6570\u91CF\u4F7F\u7528\u666E\u901A\u4E0B\u5355\u4E70\u5165\u548C\u5356\u51FA\u9875\u9762\u5185\u201C\u6570\u91CF\u201D\u4E2D\u8BBE\u7F6E\u7684\u6570\u636E\u3002\u4F7F\u7528\u5FEB\u901F\u4E0B\u5355\u9700\u8981\u614E\u91CD\u3002</p><div style="font-size: 17px;color: #333333;font-weight: bold;margin-top: 50px">\u51B3\u8D5B\u4EA4\u6613\u89C4\u5219</div><p style="font-size: 14px;color: #999999;margin-top: 19px">1.\u6839\u636E\u6BCF\u4E2A\u53C2\u8D5B\u4EBA\u5458\u7684\u6001\u5EA6\u3001\u7EAA\u5F8B\u6027\u3001\u98CE\u63A7\u80FD\u529B\u3001\u4EA4\u6613\u80FD\u529B\uFF0C\u4E3B\u529E\u65B9\u65E5\u4F1A\u516C\u5E73\u5408\u7406\u8C03\u6574\u6BCF\u4F4D\u53C2\u8D5B\u4EBA\u5458\u7684\u53EF\u7528\u8D44\u91D1\u3001\u914D\u4ED3\u80A1\u6570\uFF0C\u5E76\u4E0E\u53C2\u8D5B\u8005\u534F\u5546\u786E\u5B9A\u4EA4\u6613\u54C1\u79CD\u548C\u6570\u91CF\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">2.\u53C2\u8D5B\u4EBA\u5458\u5FC5\u987B\u9075\u5B88\u4E3B\u529E\u65B9\u5236\u5B9A\u7684\u5B9E\u76D8\u4EA4\u6613\u7EAA\u5F8B\u548C\u98CE\u63A7\u89C4\u5219\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">3.\u4EA4\u6613\u65F6\u95F4\uFF0C\u4E0E\u6CAA\u6DF1\u4E24\u5E02\u65F6\u95F4\u4E00\u81F4\uFF0C\u76D8\u524D\u548C\u5C3E\u76D8\u96C6\u5408\u7ADE\u4EF7\u671F\u95F4\u5747\u53EF\u62A5\u5355\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">4.\u4E70\u5356\u8D39\u7387\u4E3A\u5B9E\u76D8\u8D26\u6237\u7684\u771F\u5B9E\u8D39\u7387\u3002</p><p style="font-size: 14px;color: #999999;margin-top: 19px">5.\u9664\u606F\u9664\u6743\uFF0C\u505C\u590D\u724C\uFF0C\u4E70\u5356\u62A5\u5355\u89C4\u5219\u4E0E\u6CAA\u6DF1\u4E24\u5E02\u89C4\u5219\u4E00\u81F4\u3002</p><br><br></div></div>');
$templateCache.put('app/pages/activity/selectUniversity.html','<div class="modal-content"><div class="modal-header bg-{{modalOptions.alertStyle}}"><i class="ion-android-{{modalOptions.alertStyle}} modal-icon"></i><span>{{modalOptions.headerText}}</span></div><div class="modal-body"><ui-select ng-model="university" ng-change="selectUniversity(university)"><ui-select-match placeholder="">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="university in universities | filter: $select.search"><div ng-bind="university.name"></div></ui-select-choices></ui-select></div><div class="modal-footer"><button class="btn btn-{{modalOptions.alertStyle}} btn-action" ng-disabled="selectedUniversity.id == 0" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}} <span class="glyphicon glyphicon-circle-arrow-right"></span></button> <button type="button" class="btn" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button></div></div>');
$templateCache.put('app/theme/components/carousel/carousel.html','<div class="carousel" ng-mouseenter="pause(); focused = true;" ng-mouseleave="play(); focused = false;" ng-swipe-right="prev()" ng-swipe-left="next()"><div class="carousel-inner" ng-transclude=""></div><ol class="carousel-indicators" ng-show="slides.length > 1"><li ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)"><span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span></li></ol></div>');
$templateCache.put('app/theme/components/carousel/carousel2.html','<div class="carousel" ng-mouseenter="pause(); focused = true;" ng-mouseleave="play(); focused = false;" ng-swipe-right="prev()" ng-swipe-left="next()"><div class="carousel-inner" ng-transclude=""></div><a class="left carousel-control" href="" data-slide="prev" ng-click="prev()" ng-class="{ disabled: isPrevDisabled() }" ng-show="focused && slides.length > 1"><i class="glyphicon glyphicon-chevron-left"></i></a> <a class="right carousel-control" href="" data-slide="next" ng-click="next()" ng-class="{ disabled: isNextDisabled() }" ng-show="focused && slides.length > 1"><i class="glyphicon glyphicon-chevron-right"></i></a></div>');
$templateCache.put('app/theme/components/carousel/slide.html','<div ng-class="{\'active\': active}" class="myitem text-center" ng-transclude=""></div>');
$templateCache.put('app/theme/components/carousel/slide2.html','<div ng-class="{\'active\': active}" class="item text-center" ng-transclude=""></div>');
$templateCache.put('app/theme/components/modal/confirmModal.html','<div class="modal-content"><div class="modal-header bg-{{modalOptions.alertStyle}}"><i class="ion-android-{{modalOptions.alertStyle}} modal-icon"></i><span>{{modalOptions.headerText}}</span></div><div class="modal-body"><p ng-bind-html="modalOptions.bodyText"></p></div><div class="modal-footer"><button type="button" class="btn" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button> <button class="btn btn-action btn-bg-{{modalOptions.alertStyle}}" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}} <span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></div>');
$templateCache.put('app/theme/components/modal/informModal.html','<div class="modal-content"><div class="modal-header bg-{{modalOptions.alertStyle}}"><i class="ion-android-{{modalOptions.alertStyle}} modal-icon"></i><span>{{modalOptions.headerText}}</span></div><div class="modal-body"><p ng-bind-html="modalOptions.bodyText"></p></div><div class="modal-footer"><button class="btn btn-action" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}}<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></div>');
$templateCache.put('app/theme/components/pageFooter/pageFooter.html','<footer id="footer" class="midnight-blue" page-bottom-footer=""><div class="container"><div class="row" style="margin-top: 26px;margin-bottom:20px;color: #1D232C"><div class="col-md-8 declare" style="font-size: 14px;color: #A1ABB5"><p>\u672C\u5E73\u53F0\u5173\u6CE8\u4EA4\u6613\u57F9\u8BAD\uFF0C\u63D0\u4F9B\u7684\u5168\u90E8\u6570\u636E\u548C\u8D44\u6599\u4E5F\u5747\u670D\u52A1\u4E8E\u57F9\u8BAD\uFF0C\u4E0D\u6784\u6210\u6295\u8D44\u548C\u4EA4\u6613\u5EFA\u8BAE\uFF01\u4EFB\u4F55\u8FDB\u884C\u6295\u8D44\u548C\u4EA4\u6613\u5E76\u9020\u6210\u635F\u5931\u7684\u4EBA\uFF0C\u4E0D\u7BA1\u662F\u5426\u53C2\u8003\u4E86\u672C\u5E73\u53F0\u7684\u6570\u636E\u548C\u8D44\u6599\uFF0C\u5747\u89C6\u4E3A\u4E0E\u672C\u5E73\u53F0\u65E0\u5173\uFF0C\u672C\u5E73\u53F0\u4E0D\u627F\u62C5\u4EFB\u4F55\u5F62\u5F0F\u7684\u8D23\u4EFB\uFF01\u5728\u4E0D\u901A\u77E5\u4EFB\u4F55\u4EBA\u7684\u60C5\u51B5\u4E0B\uFF0C\u672C\u5E73\u53F0\u4FDD\u7559\u66F4\u65B0\u3001\u66FF\u6362\u3001\u5220\u9664\u5E73\u53F0\u4E0A\u5168\u90E8\u6570\u636E\u548C\u8D44\u6599\u7684\u6743\u5229\uFF01</p></div><div class="col-md-offset-1 col-md-3"><p class="text-right" style="font-size: 14px; margin-bottom: 0;"><a href="mailto:xntrader@xntrader.com\u200D"><span style="color: #A1ABB5">xntrader@xntrader.com</span>\u200D</a><hr style="float:right;height:5px;width:39px;border-radius: 3px;background-color:#E31735;border: none;margin-top:5px"></p></div><div class="col-md-12 text-left declare" style="font-size: 14px;color: #A1ABB5;margin-top:-30px"><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p><a href="https://beian.miit.gov.cn/">\u95FDICP\u59072021009883\u53F7</a></div></div></div></footer>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<header class="main-header" ng-controller="pageTopCtrl" page-top-header=""><nav class="fixed clearfix navbar navbar-inverse navbar-fixed-top" style="background-color: #1D232C;height: 70px;opacity: 0.8"><div class="container navbar-container"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse" ng-init="navCollapsed = true" aria-controls="navbar" ng-click="navCollapsed = !navCollapsed"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><div class="header-left clearfix"><div style="float:left;height: 29px;margin-top: 13px;"><a href="#"><img id="logo" src="images/logo.png" style="height: 41px;" alt="\u5C0F\u725B\u5B9E\u4E60\u751F"></a></div><div style="float:left;height: 29px;margin-top: 15px;"><a href="#"><img id="site" src="images/site.png" alt="\u5C0F\u725B\u5B9E\u4E60\u751F"></a></div></div></div><div class="collapse navbar-collapse" ng-class="{\'in\':!navCollapsed}" style="float:right"><ul class="nav navbar-nav"><li><a href="#/main" ng-click="menuClick()">\u9996\u9875</a></li><li class="dropdown" uib-dropdown=""><a href="#" class="dropdown-toggle" uib-dropdown-toggle="">\u6A21\u62DF\u4EA4\u6613 <b class="caret"></b></a><ul class="dropdown-menu"><li><a href="#/simulation/trade" target="_blank">\u4EA4\u6613\u62A5\u5355</a></li><li class="divider" style="background-color: #384A5D"></li><li><a href="#/simulation/diary" target="_blank">\u4EA4\u6613\u65E5\u5FD7</a></li><li class="divider" style="background-color: #384A5D"></li><li><a href="#/simulation/mistake" target="_blank">\u8FC7\u5931\u5355&#12288;</a></li></ul></li><li><a href="#/exam" ng-click="menuClick()">\u6D4B\u8BC4\u4E2D\u5FC3</a></li><li><a href="#/about_us" ng-click="menuClick()">\u5173\u4E8E\u6211\u4EEC</a></li></ul><ul class="nav navbar-nav" style="width:1px;height:85px;background-color: #A1ABB5;margin-top:-15px;padding: 0px"></ul><ul class="nav navbar-nav navbar-right" ng-hide="logined"><li><a href="#/user/login"><img id="login_header" src="images/login_header.png" style="height: 22px;border:none;line-height: 22px;padding-bottom: 3px" alt="\u5C0F\u725B\u5B9E\u4E60\u751F">&#12288;\u767B\u5F55</a></li><li><a href="#/user/register">\u514D\u8D39\u6CE8\u518C</a></li></ul><ul class="nav navbar-nav navbar-right" ng-show="logined"><li class="dropdown" uib-dropdown="" style="margin-left:30px;margin-top:-5px;color:#A1ABB5;"><a class="dropdown-toggle head-image-url" uib-dropdown-toggle="" href="#"><img ng-src="{{headImgUrl}}" style="height: 40px;width: 40px"></a> {{getUserName()}}<ul class="dropdown-menu" uib-dropdown-menu="" style="left: -45px"><li><a href="#/user/edit">\u4FEE\u6539\u4E2A\u4EBA\u4FE1\u606F</a></li><li><a href="#" ng-click="logout()">\u9000\u51FA</a></li></ul></li></ul></div></div></nav></header>');
$templateCache.put('app/theme/components/pageTop/popovermsg.html','<div style="min-width: 400px;"><label style="color: red;">{{dynamicPopover.content}}</label><br><a style="cursor: pointer" ng-show="isRegistering()" ng-click="continueRegister()">\u7EE7\u7EED\u6CE8\u518C</a><label style="width:50px;" ng-show="isRegistering()"></label><a ng-click="closePopover()" style="cursor: pointer">\u5FFD\u7565</a></div>');
$templateCache.put('app/pages/bigData/scoreData/scoreData.html','<div class="main_page secend_page big-data-page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-href="{{getGobackHref()}}"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u4E0A\u7EA7</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">\u4E2A\u4EBA\u79EF\u5206\u67E5\u8BE2</h2></div><div class="title-line"></div><form class="form-horizontal" role="form"><div class="form-group score-filter-form"><div style="float: left"><label for="fromDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u8D77\u59CB\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px"><input type="text" readonly="" class="form-control" id="fromDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.fromDate" is-open="filterArgs.openFromPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1px" ng-click="openFromPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div style="float: left"><label for="toDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u622A\u81F3\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px"><input type="text" readonly="" class="form-control" id="toDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.toDate" is-open="filterArgs.openToPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats" ng-change="onToDateChanged()"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1px" ng-click="openToPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button class="btn btn-action search-btn" ng-click="getData(true)">\u67E5\u8BE2<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></form><div class="horizontal-scroll"><table class="table table-hover table-striped" st-pipe="callServer" st-table="displayed"><thead><tr class="black-muted-bg"><th class="table-id">\u5E8F\u53F7</th><th>\u79EF\u5206\u65E5\u671F</th><th>\u5F53\u65E5\u79EF\u5206\u53D8\u5316</th><th>\u5F53\u65E5\u79EF\u5206\u660E\u7EC6</th><th>\u7D2F\u8BA1\u79EF\u5206</th></tr></thead><tbody ng-show="!isFailed"><tr ng-repeat="item in displayed"><td class="table-id"><b>{{item.index}}</b></td><td>{{item.createDate}}</td><td ng-style="getValueStyle(item.score)">{{(item.score >= 0 ? "+" : "") + item.score}}</td><td><a ng-href="{{getItemHref(item)}}" class="status-button btn btn-xs btn-link">\u67E5\u770B</a></td><td>{{item.volume}}</td></tr></tbody><tbody ng-show="!isLoading && isFailed"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u5931\u8D25 ...</td></tr><tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></tbody></tbody></table></div></div></section></div>');
$templateCache.put('app/pages/bigData/tradeData/tradeData.html','<div class="main_page secend_page big-data-page"><section class="page-detail"><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">\u4EA4\u6613\u6570\u636E\u7EDF\u8BA1\u5206\u6790</h2></div><div class="title-line"></div><div class="horizontal-scroll"><table class="table table-bordered" st-table="displayedTotal.displayedTotalCode"><thead><tr class="black-muted-bg"><th class="text-center">\u6700\u65B0\u79EF\u5206</th><th class="text-center">\u6700\u65B0\u6392\u540D</th><th class="text-center">\u4EA4\u6613\u65E5\u671F</th><th class="text-center">\u8BC1\u5238\u4EE3\u7801</th><th class="text-center">\u5F53\u65E5\u6536\u76CA\u7387</th><th class="text-center">\u5F53\u65E5\u6536\u76CA</th></tr></thead><tbody ng-show="!isLoading && !isFailed"><tr ng-repeat="item in displayedTotal.displayedTotalCode"><td ng-if="item.firstCode" rowspan="{{item.rowSpan}}" style="vertical-align: middle; text-align: center"><a href="#/big_data/score_data" class="score-href" target="_blank"><b>{{item.target.score}}</b></a><br><label class="glyphicon glyphicon-hand-up" style="font-size: 12px;color: #0099ff">\u67E5\u770B</label></td><td class="text-center" ng-if="item.firstCode" rowspan="{{item.rowSpan}}" style="vertical-align: middle;">\u7B2C <span style="color: #c52d2f; font-weight: bold">{{item.target.rank}}</span> \u540D</td><td class="text-center" ng-if="item.firstCode" rowspan="{{item.rowSpan}}" style="vertical-align: middle;">{{item.target.date ? item.target.date : "----"}}</td><td class="text-center" style="vertical-align: middle;">{{item.code}}</td><td class="text-center" style="vertical-align: middle" ng-style="getValueStyle(item.profitRate)">{{item.profitRate == "----" ? item.profitRate : (((item.profitRate * 100) | number:3) + \'%\')}}</td><td class="text-center" style="vertical-align: middle" ng-style="getValueStyle(item.profitAmount)">{{item.profitAmount == "----" ? item.profitAmount : (item.profitAmount | currency:\'\uFFE5\')}}</td></tr></tbody><tbody ng-show="!isLoading && isFailed"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u5931\u8D25 ... {{errorMessage ? \' \u5931\u8D25\u539F\u56E0\uFF1A\' + errorMessage : ""}}</td></tr><tbody><tbody ng-show="isLoading"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u4E2D ...</td></tr></tbody></tbody></tbody></table></div></div><div class="container border-container" ng-if="filterArgs.supportCodes.length > 0"><form class="form-horizontal" role="form"><div class="form-group filter-form"><div style="float: left"><label for="code" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u8BC1\u5238\u4EE3\u7801\uFF1A</label><div class="form-item-inline" style="width: 120px"><ui-select id="code" ng-model="filterArgs.selectCode" class="bootstrap-select form-control" ng-disabled="false" search-enabled="false" ng-change="onSelectCodeChanged()"><ui-select-match placeholder="\u5168\u90E8"><span>{{filterArgs.selectCode.code}}</span></ui-select-match><ui-select-choices repeat="code in filterArgs.supportCodes"><span ng-bind-html="code.code"></span></ui-select-choices></ui-select></div></div><div style="float: left"><label for="period" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u7EDF\u8BA1\u5468\u671F\uFF1A</label><div class="form-item-inline" style="width: 120px"><ui-select id="period" ng-model="filterArgs.selectPeriod" class="bootstrap-select form-control" ng-disabled="false" search-enabled="false" ng-change="onSelectPeriodChanged()"><ui-select-match placeholder="\u5168\u90E8"><span>{{filterArgs.selectPeriod}}</span></ui-select-match><ui-select-choices repeat="period in filterArgs.supportPeriods"><span ng-bind-html="period"></span></ui-select-choices></ui-select></div></div><div style="float: left" ng-if="filterArgs.selectPeriod != \'\u6240\u6709\'"><label for="selectDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u9009\u62E9\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline datepicker" style="width: 160px"><input type="text" readonly="" class="form-control" id="selectDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.selectDate" is-open="filterArgs.openPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1px" ng-click="openPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button class="btn btn-action search-btn" ng-click="getDetailData()">\u67E5\u8BE2<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></form><div ng-if="displayedData.isLoading"><h2 class="text-center">\u52A0\u8F7D\u4E2D ...</h2></div><div ng-if="displayedData.isFailed"><h2 class="text-center" ng-if="displayedData.errorMessage">{{displayedData.errorMessage}}</h2></div><div ng-if="!displayedData.isFailed && !displayedData.isLoading"><div class="section-nav"><div><div class="li-container no-arrow li-container5"><div class="nav-li nav-li-5" ng-repeat="item in displayedNavigation" ng-class="getNavClass(item.index)"><a ng-click="selectNavigation(item.index)">{{item.title}}<span class="nav-arrow"></span></a></div></div></div></div><div class="tab-container col-md-12" ng-if="navIndex == 0"><ul class="show-data-list clearfix"><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u8BC1\u5238\u4EE3\u7801</span> <span class="data-content">{{displayedData.detail.code}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u4EA4\u6613\u8D77\u59CB\u65E5\u671F</span> <span class="data-content">{{filterArgs.selectCode.firstTradeDay}}</span></li><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type == 6"><span class="data-title">\u6700\u540E\u4EA4\u6613\u65E5\u671F</span> <span class="data-content">{{displayedData.detail.createDate}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6536\u76CA\u7387</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.profitRate)">{{displayedData.detail.profitRate * 100 | number:3}}%</span></li><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type != 1"><span class="data-title">\u5B9E\u9645\u4EA4\u6613\u5929\u6570</span> <span class="data-content">{{displayedData.detail.tradeCountDays}} \u5929</span></li><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type != 6"><span class="data-title">\u6536\u76CA\u7387\u6392\u540D</span> <span class="data-content">\u7B2C <span style="color: #c52d2f; font-weight: bold">{{displayedData.detail.rank}} / {{displayedData.detail.rankCount}}</span> \u540D</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6536\u76CA</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.profitAmount)">{{displayedData.detail.profitAmount | currency:\'\uFFE5\'}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6210\u4EA4\u91D1\u989D</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.matchAmount)">{{displayedData.detail.matchAmount | currency:\'\uFFE5\'}}</span></li></ul><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u6536\u76CA\u7387\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartProfitRate"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartProfitRate"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u64CD\u4F5C\u76C8\u4E8F\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartProfitAmount"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartProfitAmount"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u6210\u4EA4\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartMatchAmount"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartMatchAmount"></highchart></div></div><div class="tab-container col-md-12" ng-if="navIndex == 1"><ul class="show-data-list clearfix"><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6301\u4ED3\u5E02\u503C</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.posMarketValue)">{{displayedData.detail.posMarketValue | currency:\'\uFFE5\'}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6536\u76CA</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.profitAmount)">{{displayedData.detail.profitAmount | currency:\'\uFFE5\'}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6536\u76CA\u7387</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.profitRate)">{{displayedData.detail.profitRate * 100 | number:3}}%</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u5E74\u5316\u6536\u76CA\u7387</span> <span class="data-content" ng-style="getValueStyle(displayedData.detail.yearProfitRate)">{{displayedData.detail.yearProfitRate * 100 | number:2}}%</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u4E8F\u76C8\u6BD4</span> <span class="data-content" ng-style="getValueStyle(-1)" ng-if="displayedData.detail.loseWinRate == -1">----</span> <span class="data-content" ng-style="getRatioValueStyle(displayedData.detail.loseWinRate)" ng-if="displayedData.detail.loseWinRate != -1">{{displayedData.detail.loseWinRate | number:2}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u80DC\u7387</span> <span class="data-content" ng-style="getPercentageValueStyle(displayedData.detail.winRate)">{{displayedData.detail.winRate * 100 | number:2}}%</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u5468\u8F6C\u7387</span> <span class="data-content">{{displayedData.detail.turnoverRate * 100 | number:2}}%</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u7D2F\u8BA1\u76C8\u5229\u5929\u6570</span> <span class="data-content" ng-style="getValueStyle(1)">{{displayedData.detail.totalWinDays}} \u5929</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u7D2F\u8BA1\u4E8F\u635F\u5929\u6570</span> <span class="data-content" ng-style="getValueStyle(-1)">{{displayedData.detail.totalLoseDays}} \u5929</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u6700\u5927\u8FDE\u76C8\u5929\u6570</span> <span class="data-content" ng-style="getValueStyle(1)">{{displayedData.detail.maxWinDays}} \u5929</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u6700\u5927\u8FDE\u4E8F\u5929\u6570</span> <span class="data-content" ng-style="getValueStyle(-1)">{{displayedData.detail.maxLoseDays}} \u5929</span></li></ul><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u64CD\u4F5C\u76C8\u4E8F\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartProfitAmount"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartProfitAmount"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u6536\u76CA\u7387\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartProfitRate"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartProfitRate"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u80DC\u7387\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartWinRate"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartWinRate"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u5468\u8F6C\u7387\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartTurnoverRate"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartTurnoverRate"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u8FDE\u76C8\u5929\u6570</h4></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartWinDays"></highchart></div><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u8FDE\u4E8F\u5929\u6570</h4></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartLoseDays"></highchart></div></div><div class="tab-container col-md-12 show-data-list-oneline" ng-if="navIndex == 2"><ul class="show-data-list clearfix"><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type == 1"><span class="data-title">\u672A\u5E73\u5934\u5BF8</span> <span class="data-content" ng-style="getEqualValueStyle(displayedData.detail.changeVolume)">{{displayedData.detail.changeVolume | currency:\'\':0}}</span></li><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type != 1"><span class="data-title">\u672A\u5E73\u5934\u5BF8\u5929\u6570</span> <span class="data-content" ng-style="getEqualValueStyle(displayedData.detail.changeVolumeDays, 0)">{{displayedData.detail.changeVolumeDays}} \u5929</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u5E73\u5747\u76C8\u5229\u65F6\u95F4</span> <span class="data-content">{{displayedData.detail.avgWinDuration | number:1}} \u5206\u949F</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u5E73\u5747\u4E8F\u635F\u65F6\u95F4</span> <span class="data-content">{{displayedData.detail.avgLoseDuration | number:1}} \u5206\u949F</span></li><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type != 1"><span class="data-title">\u590F\u666E\u6BD4\u7387</span> <span class="data-content">{{displayedData.detail.sharpeRate | number:2}}</span></li><li class="col-md-2 col-sm-3 col-xs-4" ng-if="searchArgs.type != 1"><span class="data-title">VaR</span> <span class="data-content">{{displayedData.detail.profitVar | number:3}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u6700\u5927\u56DE\u64A4</span> <span class="data-content" style="color: #0e6eb8">{{displayedData.detail.drawDown * 100 | number:2}}%</span></li></ul></div><div class="tab-container col-md-12 show-data-list-oneline" ng-if="navIndex == 3"><ul class="show-data-list clearfix"><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6302\u5355\u7B14\u6570</span> <span class="data-content">{{displayedData.detail.orderCount | currency:\'\':0}} \u7B14</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u64A4\u5355\u7B14\u6570</span> <span class="data-content">{{displayedData.detail.cancelCount | currency:\'\':0}} \u7B14</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u65E5\u5747\u6210\u4EA4\u7B14\u6570</span> <span class="data-content">{{displayedData.detail.matchCount | currency:\'\':0}} \u7B14</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u76C8\u5229\u5BF9\u65E5\u5747\u76C8\u5229\u91D1\u989D</span> <span class="data-content" ng-style="getValueStyle(1)">{{displayedData.detail.winAmount | currency:\'\uFFE5\'}}</span></li><li class="col-md-2 col-sm-3 col-xs-4"><span class="data-title">\u4E8F\u635F\u5BF9\u65E5\u5747\u4E8F\u635F\u91D1\u989D</span> <span class="data-content" ng-style="getValueStyle(-1)">{{displayedData.detail.loseAmount | currency:\'\uFFE5\'}}</span></li></ul><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>\u6302\u5355\u7B14\u6570\u7EDF\u8BA1</h4></div><div class="detail-content col-md-12" ng-if="displayedData.detail.chart"><highchart class="chart" config="displayedData.lineChartOrderCount"></highchart></div><div class="detail-content col-md-12"><highchart class="chart" config="displayedData.barChartOrderCount"></highchart></div></div><div class="tab-container col-md-12" ng-if="navIndex == 4"><div id="chartcontainer" style="width: 100%;height: 600px"><div style="width: 100%;height: 34px;margin-top: -16px"><label class="radio-box"><input type="radio" ng-value="1" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u59D4\u6258\u548C\u6210\u4EA4</label> <label class="radio-box"><input type="radio" ng-value="2" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u59D4\u6258</label> <label class="radio-box"><input type="radio" ng-value="3" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u6210\u4EA4</label></div><highchart id="myhighchart" class="chart" config="chartConfig"></highchart></div></div></div></div></section></div>');
$templateCache.put('app/pages/exam/paper/paper.html','<header class="main-header"><nav class="fixed clearfix navbar navbar-inverse navbar-fixed-top" style="background-color: #1D232C;height: 70px;opacity: 0.8"><div class="container navbar-container"><div style="position: absolute;margin-top: 20px;float:left;height: 29px;font-size: 17px;"><span ng-if="item.type == 1">\u5269\u4F59\u65F6\u95F4\uFF1A<span style="color: red">{{timeLeft}}</span> &nbsp;&nbsp;</span> <span>\u5171{{item.papers.length}}\u4EFD</span></div><div class="center" style="margin-top: 18px;text-align: center;font-size: 20px;">{{item.name}}</div><div style="float:right;font-size: 17px;margin-top: -30px"><button id="loginBtn" class="btn btn-action search-btn" style="width: 100px;height: 36px" ng-click="exitExam()">\u9000\u51FA\u6D4B\u8BC4</button> <button class="btn btn-action search-btn" style="width: 100px;height: 36px" ng-click="submitExam()">\u63D0\u4EA4\u6D4B\u8BC4</button></div></div></nav></header><div class="main_page secend_page"><section class="page-detail"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6; box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div ng-repeat="paper in item.papers"><div style="margin-left: 70px;margin-right: 70px;"><div class="row center page-detail-title" style="margin-bottom: -20px"><div class="center col-md-12" style="font-size: 20px;color: #333333;"><span>{{paper.name}}</span></div></div><hr style="width:100%;height: 1px"><div style="margin-bottom: 40px"></div><div ng-repeat="question in paper.questions"><p>{{$index + 1 + \'\u3001\' + question.content}}<span ng-if="item.type != 2" class="undo-flag">\uFF08{{getQuestionType(question.type)}}\uFF09</span></p><div ng-if="question.type != 2 && item.type == 1"><label ng-style="getCheckColor(1,question.answer)"><input type="radio" ng-value="1" ng-model="question.answer"> {{question.type == 1 ? "\u6B63\u786E" : \'A\u3001\' + question.answerA}}</label><br><label ng-style="getCheckColor(2,question.answer)"><input type="radio" ng-value="2" ng-model="question.answer"> {{question.type == 1 ? "\u9519\u8BEF" : \'B\u3001\' + question.answerB}}</label><br><label ng-style="getCheckColor(4,question.answer)" ng-show="question.answerC != null && question.answerC != \'\'"><input type="radio" ng-value="4" ng-model="question.answer"> {{\'C\u3001\' + question.answerC}}</label><br ng-show="question.answerC != null && question.answerC != \'\'"><label ng-style="getCheckColor(8,question.answer)" ng-show="question.answerD != null && question.answerD != \'\'"><input type="radio" ng-value="8" ng-model="question.answer"> {{\'D\u3001\' + question.answerD}}</label><br ng-show="question.answerD != null && question.answerD != \'\'"></div><div ng-if="question.type == 2 || item.type == 2"><label ng-style="getCheckColor(true,question.respA)"><input type="checkbox" ng-value="1" ng-model="question.respA"> {{question.type == 1 ? "\u6B63\u786E" : \'A\u3001\' + question.answerA}}</label><br><label ng-style="getCheckColor(true,question.respB)"><input type="checkbox" ng-value="2" ng-model="question.respB"> {{question.type == 1 ? "\u9519\u8BEF" : \'B\u3001\' + question.answerB}}</label><br><label ng-style="getCheckColor(true,question.respC)" ng-show="question.answerC != null && question.answerC != \'\'"><input type="checkbox" ng-value="4" ng-model="question.respC"> {{\'C\u3001\' + question.answerC}}</label><br ng-show="question.answerC != null && question.answerC != \'\'"><label ng-style="getCheckColor(true,question.respD)" ng-show="question.answerD != null && question.answerD != \'\'"><input type="checkbox" ng-value="8" ng-model="question.respD"> {{\'D\u3001\' + question.answerD}}</label><br ng-show="question.answerD != null && question.answerD != \'\'"></div><br></div></div></div></div></section></div>');
$templateCache.put('app/pages/exam/result/examResult.html','<div class="main_page secend_page"><section class="page-detail"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6; box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div ng-repeat="paper in item.examRoom.papers"><div style="margin-left: 70px;margin-right: 70px;"><div class="row center page-detail-title" style="margin-bottom: -20px"><div class="center col-md-12" style="font-size: 20px;color: #333333;"><span>{{paper.name}}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;\u603B\u5F97\u5206\uFF1A{{paper.totalScore}}\u5206</span></div></div><hr style="width:100%;height: 1px"><div style="margin-bottom: 40px"></div><div ng-repeat="question in paper.questions"><p>{{$index + 1 + \'\u3001\' + question.content}}</p><div ng-if="question.type != 2 && item.examRoom.type == 1"><label><input type="radio" ng-disabled="true" ng-checked="question.answer == 1"> {{question.type == 1 ? "\u6B63\u786E" : \'A\u3001\' + question.answerA}}</label> <label ng-if="paper.type == 2">&nbsp;&nbsp;&nbsp;&nbsp;{{question.scoreA}}\u5206</label><br><label><input type="radio" ng-disabled="true" ng-checked="question.answer == 2"> {{question.type == 1 ? "\u9519\u8BEF" : \'B\u3001\' + question.answerB}}</label> <label ng-if="paper.type == 2">&nbsp;&nbsp;&nbsp;&nbsp;{{question.scoreB}}\u5206</label><br><label ng-show="question.answerC != null && question.answerC != \'\'"><input type="radio" ng-disabled="true" ng-checked="question.answer == 4"> {{\'C\u3001\' + question.answerC}}</label> <label ng-if="paper.type == 2 && question.answerC != null && question.answerC != \'\'">&nbsp;&nbsp;&nbsp;&nbsp;{{question.scoreC}}\u5206</label><br ng-show="question.answerC != null && question.answerC != \'\'"><label ng-show="question.answerD != null && question.answerD != \'\'"><input type="radio" ng-disabled="true" ng-checked="question.answer == 8"> {{\'D\u3001\' + question.answerD}}</label> <label ng-if="paper.type == 2 && question.answerD != null && question.answerD != \'\'">&nbsp;&nbsp;&nbsp;&nbsp;{{question.scoreD}}\u5206</label><br ng-show="question.answerD != null && question.answerD != \'\'"><label ng-style="getCheckColor(question.correct,question.answer)" style="font-weight: bold" ng-if="paper.type == 1">{{\'[\u7B54\u6848]\' + getAnswerStr(question.type, question.correct)}} <strong>{{\'&nbsp&nbsp(\' + question.userScore + \'/\'+ question.score + \'\u5206)\'}}</strong></label></div><div ng-if="question.type == 2 || item.examRoom.type == 2"><label><input type="checkbox" name="{{$index+1}}" ng-value="1" ng-model="question.respA" ng-disabled="true"> {{question.type == 1 ? "\u6B63\u786E" : \'A\u3001\' + question.answerA}}</label><br><label><input type="checkbox" name="{{$index+1}}" ng-value="2" ng-model="question.respB" ng-disabled="true"> {{question.type == 1 ? "\u9519\u8BEF" : \'B\u3001\' + question.answerB}}</label><br><label ng-show="question.answerC != null && question.answerC != \'\'"><input type="checkbox" name="{{$index+1}}" ng-value="4" ng-model="question.respC" ng-disabled="true"> {{\'C\u3001\' + question.answerC}}</label><br ng-show="question.answerC != null && question.answerC != \'\'"><label ng-show="question.answerD != null && question.answerD != \'\'"><input type="checkbox" name="{{$index+1}}" ng-value="8" ng-model="question.respD" ng-disabled="true"> {{\'D\u3001\' + question.answerD}}</label><br ng-show="question.answerD != null && question.answerD != \'\'"><label ng-style="getCheckColor(question.correct,question.answer)" style="font-weight: bold" ng-if="paper.type == 1">{{\'[\u7B54\u6848]\' + getAnswerStr(question.type, question.correct)}} <strong>{{\'&nbsp&nbsp(\' + question.userScore + \'/\'+ question.score + \'\u5206)\'}}</strong></label></div><br></div></div></div></div></section></div>');
$templateCache.put('app/pages/resources/jobs/jobdetailsposter.html','<div class="container secend_page"><p class="marginpape"></p><div class="panel panel-default"><div class="panel-heading"><div class="container"><div class="col-sm-4" style="font-size:24px; cursor: pointer;"><a>&laquo;\u8FD4\u56DE</a></div><div class="col-sm-4 text-center"><p u_\u6BB5\u843D\u6807\u9898="">{{TabName}}</p></div></div></div><div class="panel-body"><video width="100%" controls=""><source ng-src="http://192.168.15.199:8080/resources/courses/video.mp4"></video></div></div></div>');
$templateCache.put('app/pages/resources/jobs/jobs.html','<div class="main_page"><div class="banner-title"><div class="back-fix" style="background-image: url(images/class/class-bg2.jpg)"></div><h1 class="banner-title-text scroll-hidden" when-visible="fadeIn1">\u4F01\u4E1A\u62DB\u52DF</h1></div><section class="job-poster"><div class="container"><div class="section-nav"><div class="li-container li-container2 no-arrow"><div class="nav-li" ng-class="getNavClass(1)"><a ng-click="chooseNav(1)">\u62DB\u8058\u6D77\u62A5<span class="nav-arrow"></span></a></div><div class="nav-li" ng-class="getNavClass(2)"><a ng-click="chooseNav(2)">\u62DB\u8058\u5C97\u4F4D<span class="nav-arrow"></span></a></div></div></div><div ng-if="currentTab == 1"><div class="list-content"><ul class="list-items" ng-repeat="item in posters.displayed"><li class="list-item"><div class="img-box"><img src="images/class/doc_bg_0.jpg"></div><div class="desc-box"><h5 class="desc-title"><a ng-click="showPoster(item)">{{item.title}}</a></h5><ul class="item-icons"><li><span class="glyphicon glyphicon-time"></span><span>&nbsp;{{getDateStr(item.updateTime)}}</span></li><li><span class="glyphicon glyphicon-user"></span><span>&nbsp;1000\u4EBA</span></li></ul><div class="desc-content-container"><p class="desc-content">{{item.description}}</p></div></div></li><li class="list-line" ng-if="posters.displayed.indexOf(item) < posters.displayed.length - 1"></li></ul></div><table style="width: 100%" st-pipe="posterCallServer" st-table="posters.displayed"><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></table></div><div ng-if="currentTab == 2"><div class="list-content"><ul class="list-items" ng-repeat="item in jobs.displayed"><li class="list-item"><div class="img-box"><img src="images/class/doc_bg_1.jpg"></div><div class="desc-box"><h5 class="desc-title"><a ng-click="showPoster(item)">{{item.title}}</a></h5><ul class="item-icons"><li><span class="glyphicon glyphicon-time"></span><span>&nbsp;{{getDateStr(item.updateTime)}}</span></li><li><span class="glyphicon glyphicon-user"></span><span>&nbsp;1000\u4EBA</span></li></ul><div class="desc-content-container"><p class="desc-content">{{item.description}}</p></div></div></li><li class="list-line" ng-if="jobs.displayed.indexOf(item) < jobs.displayed.length - 1"></li></ul></div><table style="width: 100%" st-pipe="jobCallServer" st-table="jobs.displayed"><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></table></div></div></section></div>');
$templateCache.put('app/pages/resources/ruleDetails/ruleDetails.html','<div class="main_page secend_page"><section class="page-detail"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6; box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div style="margin-left: 70px;margin-right: 70px"><div class="row center page-detail-title"><div><img src="images/logo.png" style="width: 77px;height: 51px;margin-bottom: 10px"></div><div class="col-md-12" style="font-size: 22px;">{{showItem.title}}</div></div><div class="title-line" style="background-color: red"></div><div class="embbed-html" ng-bind-html="showItem.content"></div></div></div></section></div>');
$templateCache.put('app/pages/simulation/diary/diary.html','<div class="main_page secend_page big-data-page"><section id="main-slider" class="no-margin"><div class="top-banner" style="background-image: url(images/diary_log_banner.png);"><div id="main-top-cover"></div><div class="container"><div class="center" style="margin-top: 138px;"><div style="position:absolute;left:50%;margin-left:-80px;"><div style="color: #FFFFFF;font-size: 30px;">\u4EA4\u6613\u65E5\u5FD7</div><div style="color: #FFFFFF;font-size: 17px;opacity: 0.5">Trade log</div></div></div></div></div></section><section class="page-detail" style="padding-top: 30px;"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6;box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div class="title-line"></div><form class="form-horizontal" role="form" style="margin-left: 40px;margin-right: 40px"><div class="form-group score-filter-form"><div style="float: left"><label for="fromDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u8D77\u59CB\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px"><input type="text" readonly="" class="form-control" id="fromDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.fromDate" is-open="filterArgs.openFromPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1.5px" ng-click="openFromPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div style="float: left"><label for="toDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u622A\u6B62\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px"><input type="text" readonly="" class="form-control" id="toDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.toDate" is-open="filterArgs.openToPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats" ng-change="onToDateChanged()"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1.5px" ng-click="openToPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><a id="loginBtn" class="btn btn-action search-btn" style="width: 100px;height: 36px" ng-href="{{getAddDiaryHref()}}" ng-if="canSubmit">\u6DFB\u52A0\u65E5\u5FD7</a> <button class="btn btn-action search-btn" style="width: 100px;height: 36px" ng-click="getData(true)">\u67E5\u8BE2</button></div></form><div class="horizontal-scroll" style="margin-left: 40px;margin-right: 40px"><hr style="width: 100%;height:1px;"><table class="table table-hover table-striped" st-pipe="callServer" st-table="displayed" style="text-align: center"><thead><tr class="black-muted-bg"><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u65E5\u5FD7\u65E5\u671F</th><th style="text-align: center">\u63D0\u4EA4\u72B6\u6001</th><th style="text-align: center">\u65E5\u5FD7\u5F97\u5206</th><th style="text-align: center">\u4FEE\u6539/\u67E5\u770B</th></tr></thead><tbody ng-show="!isFailed"><tr ng-repeat="item in displayed"><td><b>{{item.index}}</b></td><td>{{item.updateTime}}</td><td ng-style="getStatusStyle(item.type)">{{getStatusString(item.type)}}</td><td>{{item.score < 0 ? "----" : item.score}}</td><td><a ng-href="{{getItemHref(item)}}" target="_blank" id="misDiary" class="btn btn-action" style="width: 80px;height: 30px;padding-top: 3px">{{getActionString(item)}}</a></td></tr></tbody><tbody ng-show="!isLoading && isFailed"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u5931\u8D25 ...</td></tr><tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></tbody></tbody></table></div></div></section></div>');
$templateCache.put('app/pages/simulation/mark/mark.html','<div class="main_page secend_page"><div class="page-detail mark-page-container" style="margin-bottom: 0px"><div class="container mark-page"><div style="float: left;width: 230px;height: 40px"><label class="first-label">\u8BC1\u5238\u4EE3\u7801\uFF1A</label><div style="width: 130px;height: 28px;float: left;margin-top: 2px;margin-bottom: 0px"><ui-select ng-model="minuteTicks.code" class="ui-select"><ui-select-match placeholder="">{{$select.selected}}</ui-select-match><ui-select-choices repeat="scode in getSecurityCode($select.search) | filter: $select.search"><div ng-bind="scode"></div></ui-select-choices></ui-select></div></div><div style="float: left;width: 230px;height: 40px"><label for="toDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right;float: left;margin-left: 14px">\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px;float: left;margin-left: 6px;margin-top: 2px"><input type="text" readonly="" class="form-control" id="toDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.toDate" is-open="filterArgs.openToPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats"> <span class="input-group-btn" style="margin-top: 4px"><button type="button" class="btn btn-default" style="margin-top: -1px" ng-click="openToPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button class="btn btn-default form-control-static" ng-click="getData()" style="float: left;margin-top: 2px">\u751F\u6210</button><div style="float: left;width: 100px;height: 40px"><label class="radio-box"><input type="radio" ng-value="1" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u59D4\u6258\u548C\u6210\u4EA4</label></div><div style="float: left;width: 60px;height: 40px"><label class="radio-box"><input type="radio" ng-value="2" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u59D4\u6258</label></div><div style="float: left;width: 60px;height: 40px"><label class="radio-box"><input type="radio" ng-value="3" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u6210\u4EA4</label></div><div style="width: 65px;float: left;margin-left: 10px;height: 40px"><span style="font-size: 24px;float: left;margin:2px 0 0 0px;color: red">\u25C6</span><label class="first-label" style="margin-left: 0px">\u4E70\u6210\u4EA4;&nbsp</label></div><div style="width: 65px;float: left;margin-left: 10px;height: 40px"><span style="font-size: 24px;float: left;margin:2px 0 0 0px;color: green">\u25C6</span><label class="first-label" style="margin-left: 0px">\u5356\u6210\u4EA4;&nbsp</label></div><div style="width: 65px;float: left;margin-left: 10px;height: 40px"><span style="font-size: 24px;float: left;margin:2px 0 0 0px;color: red">\u25CF</span><label class="first-label" style="margin-left: 0px">\u4E70\u59D4\u6258;</label></div><div style="width: 65px;float: left;margin-left: 10px;height: 40px"><span style="font-size: 24px;float: left;margin:2px 0 0 0px;color: green">\u25CF</span><label class="first-label" style="margin-left: 0px">\u5356\u59D4\u6258;</label></div></div><div class="container"><div id="chartcontainer" style="width: 100%;height: 100%" ng-style="chartsHeight"><highchart id="myhighchart" class="chart" config="chartConfig"></highchart></div></div></div></div>');
$templateCache.put('app/pages/simulation/mistake/mistake.html','<div class="main_page secend_page big-data-page"><section id="main-slider" class="no-margin"><div class="top-banner" style="background-image: url(images/mistake_banner.png);"><div id="main-top-cover"></div><div class="container"><div class="center" style="margin-top: 138px;"><div style="position:absolute;left:50%;margin-left:-80px;"><div style="color: #FFFFFF;font-size: 30px;">\u8FC7\u5931\u5355</div><div style="color: #FFFFFF;font-size: 17px;opacity: 0.5">Fault</div></div></div></div></div></section><section class="page-detail" style="padding-top: 30px;"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6;box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div class="title-line"></div><form class="form-horizontal" role="form" style="margin-left: 40px;margin-right: 40px"><div class="form-group score-filter-form"><div style="float: left"><label for="fromDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u8D77\u59CB\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px"><input type="text" readonly="" class="form-control" id="fromDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.fromDate" is-open="filterArgs.openFromPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1.5px" ng-click="openFromPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div style="float: left"><label for="toDate" class="form-item-inline inline-label" style="line-height: 36px; text-align: right">\u622A\u6B62\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline" style="width: 160px"><input type="text" readonly="" class="form-control" id="toDate" uib-datepicker-popup="{{filterArgs.dateFormat}}" datepicker-options="filterArgs.dateOptions" ng-model="filterArgs.toDate" is-open="filterArgs.openToPicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="filterArgs.altDateInputFormats" ng-change="onToDateChanged()"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="margin-top: -1.5px" ng-click="openToPicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><a id="loginBtn" class="btn btn-action search-btn" style="width: 120px;height: 36px" ng-href="{{getAddDiaryHref()}}">\u6DFB\u52A0\u8FC7\u5931\u5355</a> <button class="btn btn-action search-btn" style="width: 100px;height: 36px" ng-click="getData(true)">\u67E5\u8BE2</button></div></form><div class="horizontal-scroll" style="margin-left: 40px;margin-right: 40px"><hr style="width: 100%;height:1px;"><table class="table table-hover table-striped" st-pipe="callServer" st-table="displayed" style="text-align: center"><thead><tr class="black-muted-bg"><th style="text-align: center">\u5E8F\u53F7</th><th style="text-align: center">\u63D0\u4EA4\u65E5\u671F</th><th style="text-align: center">\u8FC7\u5931\u4EA4\u6613\u65E5\u671F</th><th style="text-align: center">\u8FC7\u5931\u63CF\u8FF0</th><th style="text-align: center">\u8FC7\u5931\u7B49\u7EA7</th><th style="text-align: center">\u4FEE\u6539/\u67E5\u770B</th></tr></thead><tbody ng-show="!isFailed"><tr ng-repeat="item in displayed"><td><b>{{item.index}}</b></td><td>{{item.createDate}}</td><td>{{item.misDate}}</td><td>{{item.description}}</td><td>{{item.level == 0 ? "----" : item.level}}</td><td><a id="misDiary" class="btn btn-action" style="width: 80px;height: 30px;padding-top: 3px" ng-href="{{getItemHref(item)}}">{{getActionString(item)}}</a></td></tr></tbody><tbody ng-show="!isLoading && isFailed"><tr><td colspan="20" class="text-center">\u52A0\u8F7D\u5931\u8D25 ...</td></tr><tbody><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></tbody></tbody></table></div></div></section></div>');
$templateCache.put('app/pages/simulation/trade/codeEditModal.html','<div class="modal-content"><div class="modal-header bg-{{modalOptions.alertStyle}}"><i class="ion-android-{{modalOptions.alertStyle}} modal-icon"></i><span>{{modalOptions.headerText}}</span></div><div class="modal-body"><div class="row"><div style="margin-left: 10px;margin-right: 10px;margin-top: -10px;font-size: 12px;"><div style="max-height: 500px; overflow-y: auto;"><table id="selected" class="table table-bordered" st-table="displayed" style="margin-bottom: 0px"><thead><tr class="sortable black-muted-bg"><th>\u9009\u62E9</th><th>\u8BC1\u5238\u4EE3\u7801</th><th>\u8BC1\u5238\u540D\u79F0</th></tr></thead><tbody><tr ng-repeat="item in itemInformation.codes"><td><input type="radio" ng-checked="item.selected" ng-click="selectCode(item)" ng-disabled="itemInformation.selectCodes.length >=3 && item.selected == false"></td><td>{{item.code}}</td><td>{{item.codeName}}</td></tr></tbody></table></div></div><div style="font-size: 12px;margin-left: 10px;margin-bottom: -10px"><span>{{itemInformation.selectTitle}}</span> <span ng-repeat="item in itemInformation.selectCodes">{{item.code}}&nbsp;</span></div></div></div><div class="modal-footer"><button class="btn btn-{{modalOptions.alertStyle}} btn-action" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}} <span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></div>');
$templateCache.put('app/pages/simulation/trade/orderVolumeEditModal.html','<div class="modal-content"><div class="modal-header bg-{{modalOptions.alertStyle}}"><i class="ion-android-{{modalOptions.alertStyle}} modal-icon"></i><span>{{modalOptions.headerText}}</span></div><div class="modal-body"><div class="row"><div style="width: 100%; height: 40px; padding-left: 12px; padding-right: 12px"><input type="text" class="form-control pending-textbox text-center" ng-model="volumes.v1" required="" maxlength="7" style="float: left;width: 90px;margin-top: 5px;margin-right: 20px" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"> <input type="text" class="form-control pending-textbox text-center" ng-model="volumes.v2" required="" maxlength="7" style="float: left;width: 90px;margin-top: 5px;margin-right: 20px" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"> <input type="text" class="form-control pending-textbox text-center" ng-model="volumes.v3" required="" maxlength="7" style="float: left;width: 90px;margin-top: 5px;margin-right: 20px" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"> <input type="text" class="form-control pending-textbox text-center" ng-model="volumes.v4" required="" maxlength="7" style="float: left;width: 90px;margin-top: 5px;margin-right: 20px" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"> <input type="text" class="form-control pending-textbox text-center" ng-model="volumes.v5" required="" maxlength="7" style="float: left;width: 90px;margin-top: 5px;" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"></div></div></div><div class="modal-footer"><button type="button" class="btn" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button> <button class="btn btn-{{modalOptions.alertStyle}} btn-action" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}} <span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></div>');
$templateCache.put('app/pages/simulation/trade/trade.html','<div class="main_page trade-page" style="background-color: #272727;min-width: 1206px;"><div class="simulation-trade" ng-style="myMarginLeft"><div class="trade-head"><a class="backward" style="width:100px;float:left" ng-click="goHome()"><span class="glyphicon glyphicon-chevron-left"></span>\u9000\u51FA\u4EA4\u6613</a> <span class="col-md-8 col-sm-8 col-xs-8 center">\u6A21\u62DF\u4EA4\u6613</span> <a class="backward" style="width:80px;float:right" ng-click="getTradeProtocolHref()" target="_blank">\u4EA4\u6613\u89C4\u5219</a></div><div class="trade-panel"><div class="sm-trade-pending sm-trade-pading-right"><div class="trade-group-box"><label class="first-label">\u8BC1\u5238\u4EE3\u7801\uFF1A</label><ui-select ng-model="pendingArgs.code" class="ui-select" ng-change="clearProfit()"><ui-select-match placeholder="">{{$select.selected}}</ui-select-match><ui-select-choices repeat="scode in getSecurityCode($select.search) | filter: $select.search"><div ng-bind="scode"></div></ui-select-choices></ui-select><label class="glyphicon glyphicon-cog" style="margin-left: 5px;margin-top: 8px;color: #fcfcfc;cursor: pointer;" ng-click="commCodeSet()"></label> <label class="first-label">\u8BC1\u5238\u540D\u79F0\uFF1A</label> <label class="second-label">{{pendingArgs.name}}</label></div><div class="trade-group-box"><label class="first-label" style="width: 200px;">\u5E38\u7528\u59D4\u6258\u6570\u91CF\uFF1A</label> <label class="volume-label text-center" ng-repeat="(kk, vol) in commVolume" ng-click="volumeClick(vol)">{{vol}}</label> <label class="glyphicon glyphicon-cog volume-setting" ng-click="commVolumeSet()"></label></div><div class="trade-group-box" ng-style="getBsStyle(\'s\')" ng-click="bsSwitch(\'s\')"><label class="first-label">\u53EF\u5356\u6570\u91CF\uFF1A</label> <label class="second-label">{{getCanSellVolume() | currency:\'\':0}}</label> <label class="first-label">\u59D4\u6258\u4EF7\u683C\uFF1A</label> <input type="text" class="form-control pending-textbox" name="sell_price" id="sell_price" placeholder="\u8BF7\u8F93\u5165\u59D4\u6258\u4EF7\u683C ..." ng-model="pendingArgs.sellPrice" required="" maxlength="7" onkeyup="this.value=this.value.replace(/[^0-9.]/,\'\')"><div class="small-updown"><span class="glyphicon glyphicon-chevron-up" ng-click="pendingPriceAdd(\'s\', \'up\', 10)"></span> <span class="glyphicon glyphicon-chevron-down" ng-click="pendingPriceAdd(\'s\', \'down\', 10)"></span></div><div class="middle-updown"><span class="glyphicon glyphicon-chevron-up" ng-click="pendingPriceAdd(\'s\', \'up\', 1)"></span> <span class="glyphicon glyphicon-chevron-down" ng-click="pendingPriceAdd(\'s\', \'down\', 1)"></span></div><label class="first-label">\u59D4\u6258\u6570\u91CF\uFF1A</label> <input type="text" class="form-control pending-textbox text-center" name="sell_volume" id="sell_volume" placeholder="\u8BF7\u8F93\u5165\u59D4\u6258\u6570\u91CF ..." ng-model="pendingArgs.sellVolume" required="" maxlength="7" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"><div class="small-updown"><span class="glyphicon glyphicon-chevron-up" ng-click="pendingVolumeAdd(\'s\', \'up\')"></span> <span class="glyphicon glyphicon-chevron-down" ng-click="pendingVolumeAdd(\'s\', \'down\')"></span></div><button class="btn btn-pending form-control-static btn-sell-pending text-left" ng-click="sellAction()">\u5356\u51FA</button></div><div class="trade-group-box" ng-style="getBsStyle(\'b\')" ng-click="bsSwitch(\'b\')"><label class="first-label">\u53EF\u7528\u8D44\u91D1\uFF1A</label> <label class="second-label">{{getRestCapital() | currency:\'\uFFE5\'}}</label> <label class="first-label">\u59D4\u6258\u4EF7\u683C\uFF1A</label> <input type="text" class="form-control pending-textbox" name="buy_price" id="buy_price" placeholder="" ng-model="pendingArgs.buyPrice" required="" maxlength="7" onkeyup="this.value=this.value.replace(/[^0-9.]/,\'\')"><div class="small-updown"><span class="glyphicon glyphicon-chevron-up" ng-click="pendingPriceAdd(\'b\', \'up\', 10)"></span> <span class="glyphicon glyphicon-chevron-down" ng-click="pendingPriceAdd(\'b\', \'down\', 10)"></span></div><div class="middle-updown"><span class="glyphicon glyphicon-chevron-up" ng-click="pendingPriceAdd(\'b\', \'up\', 1)"></span> <span class="glyphicon glyphicon-chevron-down" ng-click="pendingPriceAdd(\'b\', \'down\', 1)"></span></div><label class="first-label">\u59D4\u6258\u6570\u91CF\uFF1A</label> <input type="text" class="form-control pending-textbox text-center" name="buy_volume" id="buy_volume" placeholder="\u8BF7\u8F93\u5165\u59D4\u6258\u6570\u91CF ..." ng-model="pendingArgs.buyVolume" required="" maxlength="7" onkeyup="this.value=this.value.replace(/[^0-9]/,\'\')"><div class="small-updown"><span class="glyphicon glyphicon-chevron-up" ng-click="pendingVolumeAdd(\'b\', \'up\')"></span> <span class="glyphicon glyphicon-chevron-down" ng-click="pendingVolumeAdd(\'b\', \'down\')"></span></div><button class="btn btn-pending form-control-static" ng-click="buyAction()">\u4E70\u5165</button></div></div><div class="div-quota"><table class="table table-quota table-top"><thead><tr><th class="text-center quota-right-left-width"><label style="float: right;color: #ff0000;padding-top: 6px;margin-bottom: 0px;width: 66px;min-height: 20px">{{getOrderCount(\'b\')}}</label> <label style="padding-top: 6px;margin-bottom: 0px">\u4E70\u59D4\u6258</label> <label style="float: left;color: #00ff00;padding-top: 6px;margin-bottom: 0px;width: 66px;min-height: 20px"></label></th><th class="col-md-2 text-center quota-middle-width">\u76D8\u53E3\u884C\u60C5</th><th class="col-md-5 text-center quota-right-left-width"><label style="float: left;color: #00ff00;padding-top: 6px;margin-bottom: 0px;width: 66px;min-height: 20px">{{getOrderCount(\'s\')}}</label> <label style="padding-top: 6px;margin-bottom: 0px">\u5356\u59D4\u6258</label> <label style="float: right;color: #00ff00;padding-top: 6px;margin-bottom: 0px;width: 66px;min-height: 20px"></label></th></tr></thead><tbody><tr ng-repeat="(kk, vv) in priceLevelSellOrders track by $index"><td class="quota-right-left-width" style="background-color:rgba(197, 45, 47, 0.15);"><button class="btn-padding" style="width: 100%;" ng-dblclick="quickPendOrder(\'b\', vv.price)"></button></td><td class="quota-middle-width" ng-style="getQuotaBorderStyle(kk)"><button class="btn-quota-title" ng-style="getPriceLevelColor(vv.price)">{{getLevelTitle(kk)}}</button> <button class="btn-quota-msg" ng-style="getPriceLevelColor(vv.price)" ng-click="priceLevelClick(vv.price)">{{getPriceStr(vv.price)}}</button> <button class="btn-quota-right">{{getHands(vv.volume)}}</button></td><td class="quota-right-left-width"><button class="btn-pending-small btn-pending-sell-total" ng-dblclick="dblCancelLevelOrders(vv.price, \'s\')" ng-if="getTotalOrderVolume(vv.orders) > 0">{{getTotalOrderVolume(vv.orders)/100}}</button> <button class="btn-pending-small btn-pending-sell-detail" ng-repeat="xx in orderProcess(vv.orders) track by $index" ng-dblclick="quickCancelOrder(xx.orderNo, \'s\')">{{xx.volume/100}}</button> <button class="btn-padding" ng-style="getPaddingWidth(vv.orders)" ng-dblclick="quickPendOrder(\'s\', vv.price)">{{getMoreFlag(vv.orders)}}</button></td></tr></tbody></table><div style="float: left;width: 100%;height: 26px"><div style="float: left;width: 414px;height: 26px"></div><button class="btn-quota-msg" ng-style="getPriceLevelColor(matchPrice)" ng-click="priceLevelClick(matchPrice)">{{getPriceStr(matchPrice)}}</button><div style="float: left; width: 69px;height: 26px"><button class="btn-quota-right" ng-style="getPricePercentColor()">{{pricePercent}}</button></div></div><table class="table table-quota table-bottom"><tbody><tr ng-repeat="(kk, vv) in priceLevelOrders track by $index"><td class="quota-right-left-width"><button class="btn-pending-small btn-float-right btn-pending-buy-total" ng-dblclick="dblCancelLevelOrders(vv.price, \'b\')" ng-if="getTotalOrderVolume(vv.orders) > 0">{{getTotalOrderVolume(vv.orders)/100}}</button> <button class="btn-pending-small btn-float-right btn-pending-buy-detail" ng-repeat="xx in orderProcess(vv.orders) track by $index" ng-dblclick="quickCancelOrder(xx.orderNo, \'b\')">{{xx.volume/100}}</button> <button class="btn-padding btn-float-right" ng-style="getPaddingWidth(vv.orders)" ng-dblclick="quickPendOrder(\'b\', vv.price)">{{getMoreFlag(vv.orders)}}</button></td><td class="quota-middle-width" ng-style="getQuotaBorderStyle(kk)"><button class="btn-quota-title" ng-style="getPriceLevelColor(vv.price)">{{getLevelTitle(kk)}}</button> <button class="btn-quota-msg" ng-style="getPriceLevelColor(vv.price)" ng-click="priceLevelClick(vv.price)">{{getPriceStr(vv.price)}}</button> <button class="btn-quota-right">{{getHands(vv.volume)}}</button></td><td class="quota-right-left-width" style="background-color: rgba(10, 190, 00, 0.15)"><button class="btn-padding" style="width: 100%;" ng-dblclick="quickPendOrder(\'s\', vv.price)"></button></td></tr></tbody></table><label class="form-control-static pending-checkbox-label"><input class="pending-checkbox" type="checkbox" ng-change="" ng-model="quickPendNotice" style="vertical-align:top;">&nbsp\u53CC\u51FB\u4E0B\u5355\u786E\u8BA4\u63D0\u793A</label> <label class="form-control-static pending-checkbox-label"><input class="pending-checkbox" type="checkbox" ng-change="" ng-model="quickCancelNotice" style="vertical-align:top;">&nbsp\u53CC\u51FB\u64A4\u5355\u786E\u8BA4\u63D0\u793A</label> <label class="form-control-static pending-info-label" ng-style="getLongPositionStyle()">\u5B9E\u65F6\u5934\u5BF8\uFF1A{{getLongPosition()}}</label> <label class="form-control-static pending-info-label" ng-style="getProfitStyle()">\u5B9E\u65F6\u76C8\u4E8F\uFF1A{{profit | number:2}}</label><label class="form-control-static pending-info-label">\u5934\u5BF8\u9608\u503C\uFF1A{{getMaxLongPosition()}}</label><div style="width: 165px; position: absolute; left: 383px; top: 397px;"><div class="pending-info-label-absolute">\u7533IOPV\uFF1A{{iopv.sellIopv | number:4}}</div><div class="pending-info-label-absolute">\u8D4EIOPV\uFF1A{{iopv.buyIopv | number:4}}</div></div><div style="width: 100%;float: left" class="fuck-btn-container"><button class="btn btn-default" style="margin-left: 8px;" ng-click="cancelAll(0)">\u4E70\u5355\u5168\u64A4</button> <button class="btn btn-default" style="margin-left: 8px;" ng-click="cancelAll(1)">\u5356\u5355\u5168\u64A4</button></div></div></div><div class="trade-panel-table"><div class="uib-tabset-right"><div class="table-counter-div order-counter-height" style="overflow: hidden"><table class="table table-hover trade-table table-striped" st-search-outside="filterCode.code" st-table="accountDisplay.orderDisplayedCollection" st-safe-src="accountDisplay.orders"><caption style="padding-bottom: 0px; padding-top: 0px"><label style="color: #dcdcdc;font-size: 16px;margin-left: 16px;margin-top: 3px">\u59D4\u6258\u4FE1\u606F</label> <label class="form-control-static" style="margin-right: 15px; float: right;cursor:pointer"><input checkbox-search="status" type="checkbox" ng-true-value="0" ng-false-value="" style="cursor: pointer;vertical-align:top;">&nbsp\u53EA\u663E\u793A\u53EF\u64A4\u59D4\u6258</label><div style="float: right;width: 102px; margin-right: 15px;height: 28px;margin-top: 4px"><ui-select ng-model="filterCode.code" class="ui-select" append-to-body="true"><ui-select-match placeholder="\u5168\u90E8" ng-click="clickFilter()">{{$select.selected}}</ui-select-match><ui-select-choices repeat="scode in getSecurityCodeEx($select.search) | filter: $select.search"><div ng-bind="scode"></div></ui-select-choices></ui-select></div></caption><thead><tr style="margin-top: 0px;padding-top: 0px"><th st-sort="id" st-skip-natural="true" st-sort-default="reverse">\u59D4\u6258\u53F7</th><th st-sort="code" st-skip-natural="true">\u8BC1\u5238\u4EE3\u7801</th><th st-sort="direction" st-skip-natural="true">\u4E70\u5356\u65B9\u5411</th><th st-sort="price" st-skip-natural="true">\u59D4\u6258\u4EF7\u683C</th><th st-sort="status" st-skip-natural="true">\u59D4\u6258\u72B6\u6001</th><th st-sort="quantity" st-skip-natural="true">\u5DF2\u6210/\u59D4\u6258\u6570\u91CF</th></tr></thead><tbody><tr ng-repeat="order in accountDisplay.orderDisplayedCollection" ng-dblclick="cancelOrder(order.id)" ng-style="order.status==0?(order.direction== 0?{\'color\':\'#ff0000\'}:{\'color\':\'#00ff00\'}):{}"><td class="text-center"><b>{{order.id}}</b></td><td>{{order.codeKey.substring(2)}}</td><td>{{order.direction== 0 ? \'\u4E70\u5165\' : \'\u5356\u51FA\'}}</td><td>{{order.price}}</td><td>{{getOrderStatus(order)}}</td><td>{{order.status != 1 ? 0 : order.quantity}} / {{order.quantity}}</td></tr></tbody><tfoot><tr><td colspan="20" class="text-right" ng-if="isArrayNull(accountDisplay.orders)"><div st-pagination="" st-items-by-page="10" st-displayed-pages="3" st-template="app/theme/components/trade.pagination.html"></div></td></tr></tfoot></table><h2 class="text-center" ng-if="!isArrayNull(accountDisplay.orders)" style="margin-bottom: 22px">\u65E0\u6570\u636E</h2></div></div><uib-tabset active="" justified="" class="uib-tabset-left"><uib-tab index="0" heading="\u6210\u4EA4\u660E\u7EC6"><div class="table-counter-div knock-counter-height"><table class="table table-hover trade-table table-striped" st-search-outside="filterCode.code" st-table="knockDisplayedCollection" st-safe-src="accountDisplay.orders"><thead><tr><th st-sort="id" st-skip-natural="true" style="min-width: 60px">\u59D4\u6258\u53F7</th><th st-sort="code" st-skip-natural="true" style="min-width: 72px">\u8BC1\u5238\u4EE3\u7801</th><th st-sort="updateTime" st-skip-natural="true" st-sort-default="reverse" style="min-width: 72px">\u6210\u4EA4\u65F6\u95F4</th><th st-sort="direction" st-skip-natural="true" style="min-width: 72px">\u4E70\u5356\u65B9\u5411</th><th st-sort="matchPrice" st-skip-natural="true" style="min-width: 72px">\u6210\u4EA4\u4EF7\u683C</th><th st-sort="price" st-skip-natural="true" style="min-width: 72px">\u59D4\u6258\u4EF7\u683C</th><th st-sort="quantity" st-skip-natural="true" style="min-width: 110px">\u5DF2\u6210/\u59D4\u6258\u603B\u6570</th><th st-sort="commission" st-skip-natural="true" style="min-width: 72px">\u624B\u7EED\u8D39</th><th st-sort="status" ng-show="false" style="min-width: 50px">\u72B6\u6001</th></tr><tr ng-show="false"><th><input st-search="status" type="text" value="1"></th></tr></thead><tbody><tr ng-repeat="order in knockDisplayedCollection" ng-style="order.direction== 0 ?{\'color\':\'#ff0000\'}:{\'color\':\'#00ff00\'}"><td class="text-center"><b>{{order.id}}</b></td><td>{{order.codeKey.substring(2)}}</td><td>{{getDayTime(order.updateTime)}}</td><td>{{order.direction== 0 ? \'\u4E70\u5165\' : \'\u5356\u51FA\'}}</td><td>{{order.matchPrice}}</td><td>{{order.price}}</td><td>{{order.quantity}} / {{order.quantity}}</td><td>{{order.commission}}</td><td ng-show="false">{{order.status}}</td></tr></tbody><tfoot><tr><td colspan="20" class="text-right" ng-if="isArrayNull(accountDisplay.orders)"><div st-pagination="" st-items-by-page="10" st-displayed-pages="3" st-template="app/theme/components/trade.pagination.html"></div></td></tr></tfoot></table><h2 class="text-center" ng-if="!isArrayNull(accountDisplay.orders)" style="margin-bottom: 22px">\u65E0\u6570\u636E</h2></div></uib-tab><uib-tab index="1" heading="\u8D44\u4EA7\u4E0E\u6301\u4ED3" class=""><div class="table-counter-div knock-counter-height"><table class="table table-hover trade-table table-striped" st-table="positionDisplayedCollection" st-safe-src="accountDisplay.positions"><thead><tr><th>\u8BC1\u5238\u4EE3\u7801</th><th>\u5F53\u524D\u6301\u4ED3</th><th>\u53EF\u5356\u6570</th><th>\u5F53\u524D\u5934\u5BF8</th><th>\u603B\u5E02\u503C</th><th>\u8BBE\u7F6E\u6301\u4ED3</th><th>\u5355\u7B14\u9600\u503C</th><th>\u5934\u5BF8\u9600\u503C</th></tr></thead><tbody><tr ng-repeat="position in positionDisplayedCollection"><td class="text-center"><b>{{position.codeKey.substring(2)}}</b></td><td>{{position.baseVolume + position.changedVolume}}</td><td>{{position.baseVolume - position.totalSellVolume - position.curSellVolume}}</td><td>{{position.changedVolume}}</td><td>{{(position.baseVolume + position.changedVolume) * position.lastPrice | currency:\'\'}}</td><td>{{position.baseVolume}}</td><td>{{position.maxOrderVolume}}</td><td>{{position.maxLongPosition}}</td></tr></tbody></table><h2 class="text-center" ng-if="!isArrayNull(accountDisplay.positions)" style="margin-bottom: 22px">\u65E0\u6570\u636E</h2></div></uib-tab></uib-tabset></div><div class="minute-panel-table"><label class="radio-box"><input type="radio" ng-value="1" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u59D4\u6258\u548C\u6210\u4EA4</label> <label class="radio-box"><input type="radio" ng-value="2" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u59D4\u6258</label> <label class="radio-box"><input type="radio" ng-value="3" ng-model="minuteTicks.tagMode" class="radio-box-input"> \u6210\u4EA4</label> <label class="first-label">\u8BC1\u5238\u4EE3\u7801\uFF1A</label><div style="width: 130px;height: 28px;float: left"><ui-select ng-model="minuteTicks.code" class="ui-select" append-to-body="true"><ui-select-match placeholder="">{{$select.selected}}</ui-select-match><ui-select-choices repeat="scode in getSecurityCode($select.search) | filter: $select.search"><div ng-bind="scode"></div></ui-select-choices></ui-select></div><span style="font-size: 24px;float: left;margin:2px 0 0 16px;color: red">\u25C6</span><label class="first-label" style="margin-left: 0;color: red;">\u4E70\u6210\u4EA4;&nbsp</label> <span style="font-size: 24px;float: left;margin:2px 0 0 16px;color: green">\u25C6</span><label class="first-label" style="margin-left: 0;color: green">\u5356\u6210\u4EA4;&nbsp</label> <span style="font-size: 24px;float: left;margin:2px 0 0 16px;color: red">\u25CF</span><label class="first-label" style="margin-left: 0;color: red;">\u4E70\u59D4\u6258;</label> <span style="font-size: 24px;float: left;margin:2px 0 0 16px;color: green">\u25CF</span><label class="first-label" style="margin-left: 0;color: green">\u5356\u59D4\u6258;</label><highchart id="myhighchart" class="chart" config="chartConfig"></highchart></div></div></div>');
$templateCache.put('app/pages/turtle/forum/forum.html','<div class="main_page"><div class="banner-title"><div class="back-fix" style="background-image: url(images/class/class-bg2.jpg)"></div><h1 class="banner-title-text scroll-hidden" when-visible="fadeIn1">\u5C0F\u725B\u95EE\u7B54</h1><div class="wiki-title-search" ng-style="getSearchWidth()"><input type="text" class="search-input form-control wiki-search-weight" placeholder="\u6807\u9898\u5185\u5BB9" ng-model="filterArgs.filter" ng-keyup="checkEnter($event)"> <span class="glyphicon glyphicon-search wiki-search-btn wiki-search-weight" ng-click="getData(true)"></span></div></div><section class="turtle"><div class="container"><div class="row title-container"><div class="right-container"><div class="container-item"><button class="btn btn-plain sort-btn container-item title-sort-btn" ng-click="changeSortOrder()" ng-if="!lastFilter">{{getSortContent()}}&nbsp;<span class="glyphicon glyphicon-arrow-down"></span></button></div><div class="container-item"><a ng-href="{{getWriteHref()}}"><button class="btn btn-action sort-btn">\u6211\u8981\u63D0\u95EE<span class="glyphicon glyphicon-circle-arrow-right"></span></button></a></div></div></div><div class="title-line"></div><div class="row text-center" ng-show="isFailed"><h2 ng-if="failedMsg != \'\'">\u5F88\u62B1\u6B49\uFF0C\u6CA1\u6709\u627E\u5230\u4E0E&nbsp"<strong style="color: #0000cc">{{failedMsg}}</strong>"&nbsp\u76F8\u5173\u7684\u8D44\u6E90</h2><h2 ng-if="failedMsg == \'\'">\u5F88\u62B1\u6B49\uFF0C\u6682\u65F6\u672A\u6709\u8D44\u6E90</h2></div><div class="row forum-container"><div class="list-content"><ul class="list-items" ng-repeat="item in displayed"><li class="list-item"><div class="user-box"><img ng-src="{{item.headPicUrl==\'\'?\'images/turtle/default_header.png\':item.headPicUrl}}"><p title="{{item.author}}">{{item.userName}}</p></div><div class="desc-box"><div class="desc-title"><h5 title="{{item.title}}"><span class="top-flag" ng-if="item.topFlag">\u7F6E\u9876</span><a ng-href="{{getItemHref(item)}}">{{item.title}}</a></h5></div><ul class="item-icons" ng-if="canAction(item)"><li class="item-btn"><a ng-href="{{getEditHref(item)}}"><span class="glyphicon glyphicon-edit"></span><span>&nbsp;\u7F16\u8F91</span></a></li><li class="item-btn"><a ng-click="deleteItem(item)"><span class="glyphicon glyphicon-remove"></span><span>&nbsp;\u5220\u9664</span></a></li></ul><ul class="item-icons"><li><span class="glyphicon glyphicon-time" style="color: #777"></span><span>&nbsp;\u53D1\u8868\u4E8E\uFF1A{{showInterval(item.createTime)}}</span></li><li><span class="glyphicon glyphicon-comment" style="color: #777"></span><span>&nbsp;\u56DE\u590D\uFF1A{{item.answerCount}}</span></li><li><span class="glyphicon glyphicon-user" style="color: #777"></span><span>&nbsp;\u6D4F\u89C8\uFF1A{{item.clicks}}</span></li></ul></div></li><li class="list-line" ng-if="displayed.indexOf(item) < displayed.length - 1"></li></ul></div></div><table style="width: 100%" st-pipe="callServer" st-table="displayed"><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></table></div></section></div>');
$templateCache.put('app/pages/turtle/wiki/wiki.html','<div class="main_page secend_page"><div class="banner-title"><div class="back-fix" style="background-image: url(images/class/class-bg2.jpg)"></div><h1 class="banner-title-text scroll-hidden" when-visible="fadeIn1">\u5C0F\u725B\u8BCD\u5178</h1><div class="wiki-title-search" ng-style="getSearchWidth()"><input type="text" class="search-input form-control wiki-search-weight" placeholder="\u6807\u9898\u5185\u5BB9\uFF0C\u5173\u952E\u5B57" ng-model="filter" ng-keyup="checkEnter($event)" ng-change="textChange()"> <span class="glyphicon glyphicon-search wiki-search-btn wiki-search-weight" ng-click="getFirstData()"></span></div></div><section class="turtle"><div class="container"><div class="row"><div class="wiki-features"><div class="col-md-2 col-sm-3 col-xs-6 wiki-feature-padding" style="width: 182px; height: 180px" ng-repeat="gp in wikiGroups"><div class="wiki-feature-wrap wiki-feature-wrap1" ng-style="getItemBackColor(gp.id)" ng-click="itemClick(gp.id)"><div class="img-container"><img class="img-rounded scroll-hidden" when-visible="fadeInIcon" ng-src="{{gp.url}}"></div></div><p class="text-center scroll-hidden" when-visible="fadeIn2" ng-style="getItemColor(gp.id)" ng-click="itemClick(gp.id)">{{gp.name}}</p></div></div></div><div class="title-line col-md-12"></div><div class="row wiki-container"><div class="col-md-3 col-sm-6 scroll-hidden item-container" when-visible="fadeIn1" ng-repeat="item in displayed"><div class="wiki-item" style="background-image: url(images/turtle/backup.jpg)"><a ng-href="{{getItemUrl(item)}}"><div class="item-content"><h5>{{item.title}}</h5></div></a><div class="key-word-container-wrap"><div class="key-word-container" overflow-hide=""><ul><li ng-repeat="keyword in item.keyWords track by $index" ng-if="keyword" ng-click="filterKeyword(keyword)">{{keyword}}</li></ul></div></div><div class="item-info-container"><div class="item-info"><span class="pull-right">&nbsp;{{item.clicks}}\u4EBA\u6D4F\u89C8</span><span class="glyphicon glyphicon-user pull-right"></span></div></div></div></div></div><div class="row text-center" ng-show="isFailed"><h2>\u5F88\u62B1\u6B49\uFF0C\u6CA1\u6709\u627E\u5230\u4E0E&nbsp"<strong style="color: #0000cc">{{failedMsg}}</strong>"&nbsp\u76F8\u5173\u7684\u8D44\u6E90</h2></div></div><table style="width: 100%" st-pipe="callServer" st-table="displayed"><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></table></section></div>');
$templateCache.put('app/pages/user/edit/edit.html','<div class="main_page"><section class="user-section"><div class="container loginBorder" style="height:700px;width: 500px"><div class="center"></div><div class="row" style="margin-top: -30px;"><div class="login_content"><form name="myForm" class="form-horizontal" role="form" novalidate=""><div class="form-group has-feedback center"><label class="user-img" style="margin-top: 25px" for="xFile" ng-style="getImgStyle()"></label><div id="inputFile"><input accept="image/png, image/jpeg, image/icon, image/gif, image/bmp" type="file" id="xFile" style="display:none" nv-file-select="" uploader="uploader" multiple=""></div><div class="center">\u4FEE\u6539\u5934\u50CF</div></div><div class="form-group"><label class="control-label col-sm-3 col-md-3">\u624B\u673A\u53F7</label><div class="col-sm-7 col-md-7"><label class="control-label">{{editArgs.phoneNumber}}</label></div></div><div class="form-group"><label for="nickName" class="control-label col-sm-3 col-md-3">\u6635\u79F0<span class="required-flag">{{editArgs.nickName ? "" : "\uFF08\u5FC5\u586B\uFF09"}}</span></label><div class="col-sm-8 col-md-8"><input type="text" name="nickName" class="form-control" id="nickName" placeholder="\u5FC5\u586B\uFF0C18\u4E2A\u5B57\u7B26\u4EE5\u5185" ng-model="editArgs.nickName" required="" maxlength="10" ng-change="textChange()"></div></div><div class="form-group"><label for="sex" class="control-label col-sm-3 col-md-3">\u6027\u522B</label><div id="sex" class="col-sm-8 col-md-8"><label class="form-control-static radio-button"><input type="radio" name="sex" id="optRadiosMan" ng-value="1" ng-model="editArgs.sex" ng-change="textChange()"> \u7537</label> <label class="form-control-static radio-button"><input type="radio" name="sex" id="optRadiosWoman" ng-value="2" ng-model="editArgs.sex" ng-change="textChange()"> \u5973</label></div></div><div class="form-group"><label for="birth" class="control-label col-sm-3 col-md-3">\u51FA\u751F\u65E5\u671F</label><div class="col-sm-8 col-md-8"><div class="input-group form-item-inline datepicker"><input type="text" readonly="" class="form-control" style="background-color: #ffffff" id="birth" uib-datepicker-popup="{{dataPickerArgs.dateFormat}}" datepicker-options="dataPickerArgs.dateOptions" ng-model="dataPickerArgs.selectDateBirth" is-open="dataPickerArgs.openDatePicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="dataPickerArgs.altDateInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="height: 42px" ng-click="openDatePicker()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label for="star" class="control-label col-sm-3 col-md-3">\u661F\u5EA7</label><div class="col-sm-8 col-md-8"><span class="form-control" style="border:none;box-shadow:none" id="star">{{getStar()}}</span></div></div><div class="form-group"><label for="sign" class="control-label col-sm-3 col-md-3">\u7B7E\u540D</label><div class="col-sm-8 col-md-8"><textarea name="sign" class="form-control" style="height: 65px" id="sign" placeholder="30\u4E2A\u5B57\u7B26\u4EE5\u5185" ng-model="editArgs.sign" required="" maxlength="30" ng-change="textChange()"></textarea></div></div><div class="form-group"><div class="col-sm-10 col-md-10"><div class="form-control-static error-detail-container" ng-if="totalError"><span>{{totalError}}</span></div></div></div><div class="form-group"><div class="col-md-offset-1 col-sm-offset-1 col-sm-10 col-md-10"><button id="loginBtn" class="form-control" style="margin-bottom: 10px" ng-click="submit()" ng-disabled="myForm.nickName.$invalid">\u4FEE\u6539\u4E2A\u4EBA\u4FE1\u606F</button> <button class="btn btn-default btn-cancel form-control-static" ng-click="cancel()">\u53D6\u6D88</button></div></div></form></div></div></div></section></div>');
$templateCache.put('app/pages/user/edit/headImageEditModal.html','<div class="modal-content"><div class="modal-body"><div class="row"><div class="cropArea" style="width: 100%; height: 400px; padding-left: 12px; padding-right: 12px"><img-crop image="currentImageItem.image" result-image="currentImageItem.croppedImage" style="height: 400px; width: 100%" result-image-size="200" result-image-format="image/jpeg"></img-crop></div></div></div><div style="float: left"><button id="loginBtn" class="btn btn-{{modalOptions.alertStyle}} btn-action" style="width: 200px;height: 40px;margin-left: 60px" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}}</button></div><div style="float: right"><button class="btn btn-cancel form-control-static" style="width: 200px;height: 40px;margin-right:60px" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button></div><div class="modal-footer center"></div></div>');
$templateCache.put('app/pages/user/login/login.html','<div class="main_page"><section class="user-section"><div class="container loginBorder"><div class="center"><a href="#/main/"><img id="logo" class="login_logo" src="images/logo.png" alt="\u6D77\u9F9F\u5B9E\u4E60\u751F"></a><div style="font-size: 17px;color: #333333">\u4F7F\u7528\u5C0F\u725B\u8D26\u53F7\u767B\u5F55</div></div><div class="row"><div class="login_content"><form role="form"><div class="form-group" ng-class="{\'has-error\': loginArgs.phoneNumber && (!isPhoneNumberValid() || errorMsg)}"><input type="text" class="form-control" id="name" name="name" placeholder="\u624B\u673A\u53F7" ng-model="loginArgs.phoneNumber" maxlength="11" ng-change="phoneNumberInput()"> <span class="help-block error-block basic-block xxx-show" style="float:right;color: #0C263E" ng-show="loginArgs.phoneNumber && (!isPhoneNumberValid() || errorMsg)">{{errorMsg}}</span></div><div class="form-group"><div class="horizontal-container"><input type="password" name="password" placeholder="\u5BC6\u7801" class="form-control password-input" id="password" ng-model="loginArgs.password" maxlength="12" ng-change="textChange()"> <a class="form-control-static password-forget" style="color: #0C263E;font-size: 12px" ng-href="{{\'#/user/get_password/\' + forgetPasswordLink}}">{{forgetPasswordLink == 1 ? "\u5FD8\u8BB0\u5BC6\u7801" : "\u672A\u8BBE\u7F6E\u5BC6\u7801\uFF0C\u53BB\u8BBE\u7F6E"}}\uFF1F</a></div></div><div class="form-group" style="margin-top: -30px">\u6D4B\u8BC4\u4E2D\u5FC3<div class="horizontal-container"><input id="auth_code" name="auth_code" placeholder="\u9A8C\u8BC1\u7801" type="text" class="form-control auth-code-input" ng-model="loginArgs.code" ng-change="textChange()"> <img class="auth-code-img" ng-src="{{auth_code.image_url}}" ng-click="requestAuthCode()"></div></div><div class="form-group"><div class="form-control-static error-detail-container" ng-if="totalError"><span>{{totalError}}</span></div></div><div class="form-group" style="margin-bottom: 0px"><button id="loginBtn" class="form-control" ng-click="login()" style="margin-top: 45px">\u767B\u5F55</button></div><div class="form-group"><div class="btn-forget form-control-static"><a href="#/user/register" style="font-size: 12px;color: #0C263E;margin-top: -25px">\u6CE8\u518C\u5E10\u53F7</a></div></div></form></div></div></div></section></div>');
$templateCache.put('app/pages/user/getPassword/getPassword.html','<div class="main_page"><section class="user-section"><div class="container loginBorder"><div class="center"><a href="#/main/"><img id="logo" class="login_logo" src="images/logo.png" alt="\u6D77\u9F9F\u5B9E\u4E60\u751F"></a></div><div class="row"><div class="login_content" style="margin-top: 0px"><form name="myForm" role="form" novalidate=""><div class="form-group" ng-class="{\'has-error\': registerArgs.phoneNumber && (!isPhoneNumberValid() || errorMsg)}"><input type="text" class="form-control" name="phone_number" id="phone_number" placeholder="\u624B\u673A\u53F7" ng-model="registerArgs.phoneNumber" required="" maxlength="11" ng-change="phoneNumberInput()"> <span class="help-block error-block basic-block xxx-show" style="float:right;color: #0C263E" ng-show="registerArgs.phoneNumber && (!isPhoneNumberValid() || errorMsg)">{{errorMsg}}</span></div><div class="form-group" ng-class="{\'has-error\': registerArgs.password && (!isPasswdValid() || errorPwdMsg)}"><input type="password" class="form-control" id="password" name="passwd" placeholder="\u65B0\u5BC6\u7801\uFF088-12\u4F4D\u6570\u5B57\u3001\u5B57\u6BCD\u7EC4\u5408\uFF09" ng-model="registerArgs.password" maxlength="12" required="" ng-change="isPasswdValid()"> <span class="help-block error-block basic-block xxx-show" style="float:right;color: #0C263E" ng-show="registerArgs.password && (!isPasswdValid() || errorPwdMsg)">{{errorPwdMsg}}</span></div><div class="form-group" ng-class="{\'has-error\': registerArgs.password2 && (!checkRePwd() || errorRePwdMsg)}"><input type="password" class="form-control" id="password2" name="passwd2" placeholder="\u786E\u8BA4\u5BC6\u7801" ng-model="registerArgs.password2" maxlength="12" required="" ng-change="checkRePwd()"> <span class="help-block error-block basic-block xxx-show" style="float:right;color: #0C263E" ng-show="registerArgs.password2 && (!checkRePwd() || errorRePwdMsg)">{{errorRePwdMsg}}</span></div><div class="form-group"><div class="horizontal-container"><input id="auth_code" name="auth_code" placeholder="\u77ED\u4FE1\u9A8C\u8BC1\u7801" type="text" class="form-control auth-code-input" ng-model="registerArgs.code" required="" ng-change="textChange()"> <button class="btn btn-default auth-code-btn" ng-click="shortMsgClick()" ng-disabled="holdForTimeOut || !phoneAvailable">{{getTimeBtnText()}}</button></div></div><div class="form-group"><div class="form-control-static error-detail-container" ng-if="totalError"><span>{{totalError}}</span></div></div><div class="form-group"><button id="loginBtn" class="form-control" style="margin-top: 25px" ng-click="submit()">{{forgetPasswordLink == 1 ? "\u627E\u56DE\u5BC6\u7801" : "\u8BBE\u7F6E\u5BC6\u7801"}}</button></div><div class="form-group" ng-show="forgetPasswordLink == 1"><button class="btn btn-default btn-cancel form-control-static" ng-click="cancel()">\u53D6\u6D88</button></div></form></div></div></div></section></div>');
$templateCache.put('app/pages/user/register/register.html','<div class="main_page"><section class="user-section"><div class="container loginBorder" style="height:650px;"><div class="center"><a href="#/main/"><img id="logo" class="login_logo" src="images/logo.png" alt="\u6D77\u9F9F\u5B9E\u4E60\u751F"></a></div><div class="row"><div class="login_content" style="margin-top: 0px"><div><form class="form-horizontal" role="form" name="registerForm" novalidate=""><div class="form-group" ng-class="{\'has-error\': registerArgs.phoneNumber && (!isPhoneNumberValid() || errorMsg)}"><input type="text" class="form-control" name="phone_number" id="phone_number" placeholder="\u624B\u673A\u53F7" ng-model="registerArgs.phoneNumber" required="" maxlength="11" ng-change="phoneNumberInput()"> <span class="help-block error-block basic-block xxx-show" ng-show="registerArgs.phoneNumber && (!isPhoneNumberValid() || errorMsg)">{{errorMsg}}</span></div><div class="form-group"><input type="text" name="name" class="form-control" id="name" placeholder="\u6635\u79F0\uFF0818\u4E2A\u5B57\u7B26\u4EE5\u5185\uFF09" ng-model="registerArgs.name" required="" maxlength="18" ng-change="textChange()"></div><div class="form-group" ng-class="{\'has-error\': registerArgs.password && !isPasswdValid()}"><input type="password" class="form-control" id="password" name="passwd" placeholder="\u5BC6\u7801\uFF088-12\u4F4D\u6570\u5B57\u3001\u5B57\u6BCD\u7EC4\u5408\uFF09" ng-model="registerArgs.password" maxlength="12" required="" ng-change="textChange()"> <span class="help-block error-block basic-block" ng-show="registerArgs.password && !isPasswdValid()">\u5BC6\u7801\u9700\u89818\u523012\u6570\u5B57\u3001\u5B57\u6BCD\u7EC4\u5408</span></div><div class="form-group" ng-class="{\'has-error\': registerArgs.password2 && registerArgs.password != registerArgs.password2}"><input type="password" class="form-control" id="password2" name="passwd2" placeholder="\u786E\u8BA4\u5BC6\u7801" ng-model="registerArgs.password2" maxlength="12" required="" ng-change="textChange()"> <span class="help-block error-block basic-block" ng-show="registerArgs.password2 && registerArgs.password != registerArgs.password2">\u5BC6\u7801\u9A8C\u8BC1\u4E0D\u5339\u914D</span></div><div class="form-group"><div class="horizontal-container"><input id="auth_code" type="text" name="auth_code" class="form-control auth-code-input" placeholder="\u77ED\u4FE1\u9A8C\u8BC1\u7801" ng-model="registerArgs.code" required="" ng-change="textChange()"><button class="btn btn-default auth-code-btn" ng-click="shortMsgClick()" ng-disabled="holdForTimeOut||errorMsg||registerArgs.phoneNumber==\'\'">{{getTimeBtnText()}}</button></div></div><div class="form-group" style="margin-bottom: 0"><div class="form-control-static error-detail-container" ng-if="totalError"><span>{{totalError}}</span></div></div><div class="form-group"><div class="form-control-static" style="float:right;font-size: 12px;color:#666666;margin-top: -15px;"><span>\u70B9\u51FB"\u6CE8\u518C"\u4EE3\u8868\u60A8\u540C\u610F<a ng-href="{{getProtocolHref()}}" target="_blank">\u300A\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B</a></span></div></div><div class="form-group"><button id="loginBtn" class="form-control" style="margin-bottom: 0px" ng-disabled="registerForm.$invalid || registerArgs.password != registerArgs.password2 || !isPasswdValid() || !isPhoneNumberValid() || errorMsg" ng-click="register()">\u6CE8\u518C</button></div><div class="form-group"><div class="btn-forget form-control-static" style="font-size: 12px;margin-top: -15px">\u5DF2\u6709\u5E10\u53F7\uFF1F <a href="#/user/login">\u767B\u5F55</a></div></div></form></div></div></div></div></section></div>');
$templateCache.put('app/pages/user/personalStyle/personalStyle.html','<div class="main_page"><section class="user-section"><div class="container"><div class="center"><a href="#/main/"><img id="logo" src="images/logo2.png" style="height: 96px; margin-bottom: 24px" alt="\u6D77\u9F9F\u5B9E\u4E60\u751F"></a></div><div class="section-nav"><div class="li-container li-container2 no-arrow"><div class="nav-li"><a>1\u3001\u6CE8\u518C\u4E2A\u4EBA\u4FE1\u606F<span class="nav-arrow"></span></a></div><div class="nav-li active"><a>2\u3001\u7B14\u8BD5<span class="nav-arrow"></span></a></div></div></div><div class="row user-columns"><div class="col-sm-10 col-sm-offset-1"><div ng-repeat="item in randomOrderExam.questions"><p>{{$index + 1 + \'\u3001\' + item.question}}<span class="undo-flag">{{item.answer ? "" : "&nbsp;&nbsp;\uFF08\u672A\u7B54\uFF09"}}</span></p><label ng-style="getCheckColor(1,item.answer)"><input type="radio" name="{{$index+1}}" ng-value="1" ng-model="item.answer"> {{\'A\u3001\' + item.answerA}}</label><br><label ng-style="getCheckColor(2,item.answer)"><input type="radio" name="{{$index+1}}" ng-value="2" ng-model="item.answer"> {{\'B\u3001\' + item.answerB}}</label><br><label ng-style="getCheckColor(3,item.answer)" ng-show="item.answerC != null && item.answerC != \'\'"><input type="radio" name="{{$index+1}}" ng-value="3" ng-model="item.answer"> {{\'C\u3001\' + item.answerC}}</label><br ng-show="item.answerC != null && item.answerC != \'\'"><label ng-style="getCheckColor(4,item.answer)" ng-show="item.answerD != null && item.answerD != \'\'"><input type="radio" name="{{$index+1}}" ng-value="4" ng-model="item.answer"> {{\'D\u3001\' + item.answerD}}</label><br ng-show="item.answerD != null && item.answerD != \'\'"><br></div></div></div><div class="row"><div class="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6"><form class="form-horizontal" role="form" name="registerForm" novalidate=""><div class="form-group"><div class="col-xs-12 col-sm-6 col-md-6 pull-right" style="padding: 8px 15px"><button class="btn btn-action form-control-static" ng-disabled="!isAllCompleted()" ng-click="commit()">\u4EA4\u5377<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div><div class="col-xs-12 col-sm-6 col-md-6 pull-right" style="padding: 8px 16px"><button class="btn btn-default btn-cancel form-control-static" ng-click="cancel()">\u53D6\u6D88</button></div></div></form></div></div></div></section></div>');
$templateCache.put('app/pages/user/interview/interview.html','<div class="main_page"><section class="user-section"><div class="container"><div class="center"><a href="#/main/"><img id="logo" src="images/logo2.png" style="height: 96px; margin-bottom: 24px" alt="\u6D77\u9F9F\u5B9E\u4E60\u751F"></a></div><div class="section-nav"><div class="li-container li-container3 no-arrow"><div class="nav-li"><a>1\u3001\u6CE8\u518C\u4E2A\u4EBA\u4FE1\u606F<span class="nav-arrow"></span></a></div><div class="nav-li"><a>2\u3001\u6027\u683C\u8272\u5F69\u6D4B\u8BD5<span class="nav-arrow"></span></a></div><div class="nav-li active"><a>3\u3001\u9884\u7EA6\u9762\u8BD5<span class="nav-arrow"></span></a></div></div></div><div class="row user-columns"><div class="col-xs-offset-2 col-xs-8 col-sm-offset-3 col-sm-6 col-md-offset-4 col-md-4"><form class="form-horizontal" role="form" name="registerForm" novalidate=""><div class="form-group"><button class="btn disabled btn-default btn-cancel form-control-static" ng-show="appointment">\u9884\u7EA6\u9762\u8BD5\uFF08\u5DF2\u9884\u7EA6\uFF09</button></div><div class="form-group"><button class="btn btn-default btn-interview form-control-static" ng-click="commit()" ng-hide="appointment" ng-disabled="isLoading || isFailed">\u9884\u7EA6\u9762\u8BD5</button></div><div class="form-group"><button class="btn btn-action btn-finish form-control-static" ng-click="finish()">\u5B8C\u6210<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></form></div></div></div></section></div>');
$templateCache.put('app/pages/bigData/scoreData/details/scoreDetails.html','<div class="main_page secend_page big-data-page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-href="{{getGobackHref()}}"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">\u79EF\u5206\u660E\u7EC6{{itemDisplayed ? (": " + itemDisplayed.createDate) : ""}}</h2></div><div class="title-line"></div><div ng-repeat="parent_item in displayed" ng-if="!isFailed"><div class="detail-title col-md-12"><h4><span class="glyphicon glyphicon-th"></span>{{parent_item.title}}&nbsp;&nbsp;<span ng-style="getValueStyle(parent_item.totalScore)">{{(parent_item.totalScore >= 0 ? "+" : "") + parent_item.totalScore}}</span></h4></div><div class="detail-content-list col-md-12"><table class="table table-hover table-striped table-bordered" st-table="parent_item.data"><tbody><tr ng-repeat="item in parent_item.data"><td class="table-id"><b>{{item.index}}</b></td><td>{{item.content}}</td><td class="table-score" ng-style="getValueStyle(item.score)">{{(item.score >= 0 ? "+" : "") + item.score}}</td></tr></tbody></table></div></div><div ng-if="isFailed"><h2 class="text-center">\u83B7\u53D6\u5931\u8D25\uFF1A{{errorMessage}}</h2></div></div></section></div>');
$templateCache.put('app/pages/resources/jobs/details/details.html','<div class="main_page secend_page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-click="goBack()"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">{{showItem.title}}</h2></div><div class="title-line"></div><div class="embbed-html" ng-bind-html="showItem.content"></div></div></section></div>');
$templateCache.put('app/pages/simulation/diary/edit/diaryEdit.html','<div class="main_page secend_page"><section class="page-detail"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6; box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div style="margin-left: 70px;margin-right: 70px;"><div class="row center page-detail-title" style="margin-bottom: -20px"><div class="center col-md-12" style="font-size: 20px;color: #333333;"><span>\u4EA4\u6613\u65E5\u5FD7</span><div ng-if="isEditable()" style="width: 100px;float: right;"><button class="btn navbar-button btn-action" style="width: 100px;height:36px" ng-click="submit()" ng-disabled="isLoading || isLoading">{{itemId > 0 ? "\u4FEE\u6539\u65E5\u5FD7" : "\u63D0\u4EA4\u65E5\u5FD7"}}</button></div></div></div><div class="title-line" style="background-color: red"></div><div><h3 ng-if="updateTime">\u65E5\u5FD7\u65E5\u671F\uFF1A{{updateTime}}</h3></div><div ckeditor="options" ng-model="content" ng-readonly="!isEditable()"></div><div ng-if="!isEditable()"><div><h3>\u70B9\u8BC4\uFF1A</h3></div><div ckeditor="options" ng-model="comment" ng-readonly="true"></div></div><div style="margin-bottom: 40px"></div></div></div></section></div>');
$templateCache.put('app/pages/simulation/mistake/edit/mistakeEdit.html','<div class="main_page secend_page"><section class="page-detail"><div class="container border-container" style="background: #FFFFFF;border: 1px solid #D6D6D6; box-shadow: 0 2px 13px 0 rgba(166,166,166,0.50);border-radius: 10px;"><div style="margin-left: 70px;margin-right: 70px;"><div class="row center page-detail-title" style="margin-bottom: -20px"><div class="center col-md-12" style="font-size: 20px;color: #333333;"><span>\u8FC7\u5931\u5355</span><div ng-if="isEditable()" style="width: 100px;float: right;"><button class="btn navbar-button btn-action" style="width: 100px;height:36px" ng-click="submit()" ng-disabled="isLoading || isLoading">{{itemId > 0 ? "\u4FEE\u6539\u8FC7\u5931\u5355" : "\u63D0\u4EA4\u8FC7\u5931\u5355"}}</button></div></div></div><div class="title-line" style="background-color: red"></div><label for="misDate">\u8FC7\u5931\u4EA4\u6613\u65E5\u671F\uFF1A</label><div class="input-group form-item-inline datepicker" ng-show="isEditable()"><input type="text" readonly="" class="form-control" style="background-color: #ffffff" id="misDate" uib-datepicker-popup="{{dataPickerArgs.dateFormat}}" datepicker-options="dataPickerArgs.dateOptions" ng-model="dataPickerArgs.selectMisDate" is-open="dataPickerArgs.openDatePicker" ng-required="true" show-button-bar="false" close-text="\u5173\u95ED" clear-text="\u6E05\u7A7A" current-text="\u4ECA\u5929" alt-input-formats="dataPickerArgs.altDateInputFormats"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="height: 34px" ng-click="openDatePicker()" ng-disabled="!isEditable()"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="!isEditable()">{{misDate}}</div><label ng-show="!isEditable()" style="margin-top: 20px">\u8FC7\u5931\u7B49\u7EA7\uFF1A</label><div ng-show="!isEditable()">{{level}}\u7EA7</div><label for="description" style="margin-top: 20px">\u8FC7\u5931\u63CF\u8FF0\uFF1A</label> <textarea name="description" class="form-control" style="height: 250px" id="description" placeholder="512\u4E2A\u5B57\u7B26\u4EE5\u5185" ng-model="description" ng-show="isEditable()" required="" maxlength="512"></textarea><div ng-show="!isEditable()">{{description}}</div></div><div style="margin-bottom: 40px"></div></div></section></div>');
$templateCache.put('app/pages/turtle/forum/details/details.html','<div class="main_page secend_page forum-details-page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-href="{{getGobackHref()}}"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">{{questionItem.title}}</h2></div><div class="title-line"></div><div class="answer-container"><div class="user-box"><div class="img-container"><img ng-src="{{questionItem.headPicUrl==\'\'?\'images/turtle/default_header.png\':questionItem.headPicUrl}}"></div><p title="{{questionItem.userName}}">{{questionItem.userName}}</p></div><div class="answer-content-container"><div class="item-icons" style="margin-top: 24px; margin-bottom: 24px"><div class="item-icon"><span class="glyphicon glyphicon-time"></span><span>&nbsp;\u53D1\u5E03\u4E8E&nbsp;{{questionItem.createTime}}</span></div><div class="item-icon"><span class="glyphicon glyphicon-comment"></span><span>&nbsp;\u56DE\u590D\uFF1A{{questionItem.answerCount}}</span></div><div class="item-icon"><span class="glyphicon glyphicon-user"></span><span>&nbsp;\u6D4F\u89C8\uFF1A{{questionItem.clicks}}</span></div></div><div class="embbed-html" ng-bind-html="questionItem.content"></div></div></div></div><div class="container border-container" id="answers"><div class="answers-title clearfix"><div class="left-container"><span class="container-item">{{questionItem.answerCount}} \u4E2A\u56DE\u7B54</span></div><div class="right-container"><div class="container-item"><button class="btn btn-plain sort-btn" ng-click="changeSortOrder()">{{getSortContent()}}&nbsp;<span class="glyphicon glyphicon-arrow-down"></span></button></div><div class="container-item"><button class="btn btn-action" ng-click="gotoReply()">\u6211\u8981\u56DE\u7B54 <span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></div></div><div class="title-line"></div><div ng-repeat="answer in answersDisplayed.answers"><div class="title-line" ng-if="answersDisplayed.answers.indexOf(answer) > 0"></div><div class="answer-container" id="{{\'answer_\' + answer.id}}"><div class="user-box"><div class="img-container"><img ng-src="{{answer.headPicUrl==\'\'?\'images/turtle/default_header.png\':answer.headPicUrl}}"></div><p title="{{answer.userName}}">{{answer.userName}}</p></div><div class="answer-content-container"><div class="embbed-html" ng-bind-html="answer.content"></div><div class="item-icons" ng-if="isAnswerEditable(answer)"><div class="item-btn"><a ng-click="editAnswer(answer)"><span class="glyphicon glyphicon-edit"></span><span>&nbsp;\u7F16\u8F91</span></a></div></div><div class="item-icons"><div class="item-icon"><span class="glyphicon glyphicon-time"></span><span>&nbsp;\u56DE\u590D\u4E8E&nbsp;{{answer.createTime}}</span></div><div class="item-icon" ng-click="voteAnswer(answer)" ng-style="{cursor: canVoteAnswer(answer) ? \'pointer\' : \'normal\'}"><span class="glyphicon glyphicon-thumbs-up" ng-class="isAnswerVoted(answer) ? \'voted\': \'no-vote\'"></span><span>&nbsp;\u70B9\u8D5E\uFF1A{{answer.starMarkCount}}</span></div></div></div></div></div><div ng-if="answersDisplayed.answers.length == 0" class="no-reply-desc"><h3>\u6682\u65E0\u56DE\u590D\uFF0C\u56DE\u590D\u62A2\u6C99\u53D1</h3></div><table style="width: 100%; margin-top: 24px" st-pipe="callServer" st-table="answersDisplayed.answers"><tfoot><tr><td colspan="20" class="text-center"><div st-pagination="" st-items-by-page="answersDisplayed.itemsByPage" st-displayed-pages="5" st-template="app/theme/components/pagination.custom.html"></div></td></tr></tfoot></table></div></section><section class="reply-section" id="reply"><div class="container border-container"><div class="reply-title clearfix"><div class="pull-left"><div class="help-container" ng-if="getHelp()" ng-class="getHelpClass()" ng-bind-html="getHelp()"></div></div><div class="pull-right"><button class="btn btn-plain" ng-click="cancelReply()" ng-if="replyId > 0"><span class="glyphicon glyphicon-remove"></span>&nbsp;\u53D6\u6D88\u7F16\u8F91</button> <button class="btn btn-action" ng-click="submitReply()">{{replyId > 0 ? "\u4FEE\u6539" : "\u63D0\u4EA4"}}\u56DE\u7B54<span class="glyphicon glyphicon-circle-arrow-right"></span></button></div></div><div ckeditor="options" ng-model="replyContent" ready="onReady()" ng-readonly="!isReplyEditable()"></div></div></section></div>');
$templateCache.put('app/pages/turtle/forum/write/write.html','<div class="main_page"><header class="write-header"><nav class="navbar navbar-default"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse" ng-init="navCollapsed = true" aria-controls="navbar" ng-click="navCollapsed = !navCollapsed"><span class="sr-only">\u5207\u6362\u5BFC\u822A</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="collapse navbar-collapse" ng-class="{\'in\':!navCollapsed}"><ul class="nav navbar-nav"><li><a class="backward" ng-href="{{getGobackHref()}}"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></li><li ng-if="getHelp()" ng-class="getHelpClass()"><a ng-class="getHelpClass()">{{getHelp()}}</a></li></ul><ul class="nav navbar-nav navbar-right"><li><button class="btn navbar-button btn-action" ng-click="submit()">\u53D1\u5E03\u95EE\u9898 <span class="glyphicon glyphicon-circle-arrow-right"></span></button></li></ul></div></div></nav></header><section class="forum-write"><div class="container"><div class="title-container"><textarea class="title-input" onfocus="this.placeholder=\'\'" onblur="this.placeholder=\'\u8BF7\u8F93\u5165\u6807\u9898\'" placeholder="\u8BF7\u8F93\u5165\u6807\u9898" textarea-autogrow="" ng-model="title" ng-disabled="itemId > 0"></textarea></div><div class="title-line"></div><div ckeditor="options" ng-model="content"></div><div class="embbed-html"></div></div></section></div>');
$templateCache.put('app/pages/turtle/wiki/details/details.html','<div class="main_page secend_page"><section class="page-detail"><div class="container"><div class="row back-container"><a class="backward" ng-click="goBack()"><span class="glyphicon glyphicon-chevron-left"></span>\u8FD4\u56DE\u5217\u8868</a></div></div><div class="container border-container"><div class="row center page-detail-title"><h2 class="col-md-12">{{showItem.title}}</h2></div><div class="title-line"></div><div class="embbed-html" ng-bind-html="showItem.content"></div></div></section></div>');}]);